<template>
  <div
    style="padding: 12px"
    class="member-view"
    v-if="
      selectedPlan !== null &&
      selectedPlan !== undefined &&
      options !== null &&
      options !== undefined
    "
  >
    <v-dialog
      v-model="dialogs.eligibilityBankWarning"
      max-width="600"
      persistent
      scrollable
    >
      <material-card
        :title="$t('globals.warning')"
        :color="$vuetify.theme.themes.light.warning"
        icon="warning"
      >
        <v-card-text>
          {{ $t("components.memberview.eligibility_bank_warning") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.eligibilityBankWarning = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.untrackedCoverage"
      persistent
      max-width="400"
    >
      <material-card
        v-if="dialogs.untrackedCoverage"
        :title="$t('components.memberview.edit_coverage_info_{0}', [getName()])"
        icon="spellcheck"
        :color="$vuetify.theme.themes.light.warning"
      >
        <v-card-text>
          {{ $t("components.memberview.untracked_coverage_warning") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.untrackedCoverage = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="saveUntrackedCoverage"
          >
            {{ $t("components.memberview.change_coverage_effective_date") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.editCoverageInfo"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="dialogs.editCoverageInfo"
        :title="$t('components.memberview.edit_coverage_info_{0}', [getName()])"
        icon="spellcheck"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.untrackedCoverage" ref="untrackedCoverageForm">
            <div class="row">
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  planIdentity.CurrentPlanMemberEligibility &&
                  planIdentity.CurrentPlanMemberEligibility
                    .IncludeWaitingPeriod &&
                  Object.keys(untrackedCoverageHeadersDictionary).indexOf(
                    'Hire Date'
                  ) > -1
                "
              >
                <pbas-date-picker
                  :disabled="
                    (memberIdentity.CurrentTerminationMembershipEvent &&
                      memberIdentity.CurrentTerminationMembershipEvent
                        .IsTerminated) ||
                    !(
                      role.indexOf('Broker Plan Manager') > -1 ||
                      role.indexOf('Broker Plan Admin') > -1 ||
                      role.indexOf('Employer Plan Admin') > -1
                    )
                  "
                  :label="$t('headers.members_management.Hire Date')"
                  :value="
                    editedUntrackedItemCoverage.CurrentEmploymentInformation
                      .HireDate
                  "
                  @update-date="
                    editedUntrackedItemCoverage.CurrentEmploymentInformation.HireDate =
                      $event
                  "
                  :class="
                    untrackedCoverageHeadersDictionary['Hire Date']
                      .isOptional === false
                      ? 'required'
                      : []
                  "
                  :rules="
                    untrackedCoverageHeadersDictionary['Hire Date']
                      .isOptional === false
                      ? [$rules.required]
                      : []
                  "
                ></pbas-date-picker>
              </div>
              <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :label="$t('components.memberview.coverage_effective_date')"
                  :value="
                    editedUntrackedItemCoverage.CurrentMembershipStatus
                      .EffectiveDate
                  "
                  @update-date="
                    editedUntrackedItemCoverage.CurrentMembershipStatus.EffectiveDate =
                      $event
                  "
                  :allowedDates="coverageUntrackedAllowedDates"
                  class="required"
                  :rules="[
                    $rules.required,
                    rules.coverageUntrackedEffectiveDate,
                  ]"
                ></pbas-date-picker>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  planIdentity.CurrentPlanMemberEligibility &&
                  planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod
                "
              >
                <v-checkbox
                  :label="$t('components.addmemberwizard.waive_waiting_period')"
                  v-model="waiveWaitingPeriod"
                ></v-checkbox>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.editCoverageInfo = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="!valid.untrackedCoverage"
            color="primary"
            @click="dialogs.untrackedCoverage = true"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.confirmCorrectPlanEntryDate"
      persistent
      max-width="400"
    >
      <material-card
        v-if="dialogs.confirmCorrectPlanEntryDate"
        :title="
          $t('components.memberview.confirm_correct_plan_entry_date_{0}', [
            getName(),
          ])
        "
        icon="spellcheck"
        :color="$vuetify.theme.themes.light.warning"
      >
        <v-card-text>
          {{ $t("components.memberview.correct_plan_entry_date_warning") }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="dialogs.confirmCorrectPlanEntryDate = false"
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="saveCorrectPlanEntryDate"
          >
            {{ $t("components.memberview.correct_plan_entry_date") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.correctPlanEntryDate"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="dialogs.correctPlanEntryDate"
        :title="
          $t('components.memberview.correct_plan_entry_date_{0}', [getName()])
        "
        icon="spellcheck"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form
            v-model="valid.correctPlanEntryDate"
            ref="correctPlanEntryDateForm"
          >
            <div class="row" v-if="isPlanType === '1'">
              <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :label="$t('globals.plan_entry_date')"
                  :value="editedUntrackedItemCoverage.PlanEntryDate"
                  @update-date="
                    editedUntrackedItemCoverage.PlanEntryDate = $event
                  "
                  :allowedDates="coverageUntrackedAllowedDates"
                  class="required"
                  :rules="[
                    $rules.required,
                    rules.coverageUntrackedEffectiveDate,
                  ]"
                ></pbas-date-picker>
              </div>
            </div>
            <div
              class="row"
              v-else-if="
                isPlanType === '2' || isPlanType === '3' || isPlanType === '6'
              "
            >
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedCoverageHeadersDictionary).indexOf(
                    'Hire Date'
                  ) > -1
                "
              >
                <pbas-date-picker
                  :disabled="
                    (memberIdentity.CurrentTerminationMembershipEvent &&
                      memberIdentity.CurrentTerminationMembershipEvent
                        .IsTerminated) ||
                    !(
                      role.indexOf('Broker Plan Manager') > -1 ||
                      role.indexOf('Broker Plan Admin') > -1 ||
                      role.indexOf('Employer Plan Admin') > -1
                    )
                  "
                  :label="$t('headers.members_management.Hire Date')"
                  :value="
                    editedUntrackedItemCoverage.CurrentEmploymentInformation
                      .HireDate
                  "
                  @update-date="
                    editedUntrackedItemCoverage.CurrentEmploymentInformation.HireDate =
                      $event
                  "
                  :class="
                    untrackedCoverageHeadersDictionary['Hire Date']
                      .isOptional === false
                      ? 'required'
                      : []
                  "
                  :rules="
                    untrackedCoverageHeadersDictionary['Hire Date']
                      .isOptional === false
                      ? [$rules.required]
                      : []
                  "
                ></pbas-date-picker>
              </div>
              <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :label="$t('globals.plan_entry_date')"
                  :value="editedUntrackedItemCoverage.PlanEntryDate"
                  @update-date="
                    editedUntrackedItemCoverage.PlanEntryDate = $event
                  "
                  :allowedDates="coverageUntrackedAllowedDates"
                  class="required"
                  :rules="[
                    $rules.required,
                    rules.coverageUntrackedEffectiveDate,
                  ]"
                ></pbas-date-picker>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  planIdentity.CurrentPlanMemberEligibility &&
                  planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod
                "
              >
                <v-checkbox
                  :label="$t('components.addmemberwizard.waive_waiting_period')"
                  v-model="waiveWaitingPeriod"
                ></v-checkbox>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.editCoverageInfo = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="!valid.correctPlanEntryDate"
            color="primary"
            @click="dialogs.confirmCorrectPlanEntryDate = true"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="confirmBankAccountDialog"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t('components.addmemberwizard.confirm_bank_account_dialog_title')
        "
        :color="$vuetify.theme.themes.light.success"
        icon="done"
      >
        <v-card-actions>
          <v-btn color text @click="confirmBankAccountDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              confirmBankAccountDialog = false;
              saveDirectDeposit();
            "
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="notAvailableDialog"
      max-width="600"
      persistent
      scrollable
    >
      <material-card
        v-if="notAvailableDialog"
        :title="$t('components.memberview.not_available')"
        :color="$vuetify.theme.themes.light.error"
        icon="engineering"
      >
        <v-card-text>
          {{ $t("components.memberview.not_available_for_demo") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="notAvailableDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <benefit-cards-dialog
      :cards="cards"
      :memberIdentity="memberIdentity"
      :model="dialogs.showBenefitCardDialog"
      :title="$t('components.memberview.benefit_cards_{0}', [getName()])"
      @close="dialogs.showBenefitCardDialog = false"
      :memberOdataQuery="memberOdataQuery"
    ></benefit-cards-dialog>

    <v-dialog scrollable v-model="loadingMember" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="Object.keys(headersDictionary).indexOf('Enrolment Form') > -1"
      v-model="addEnrolmentFormDialog"
      max-width="800"
      persistent
      scrollable
    >
      <material-card
        :title="$t('components.memberview.add_enrolment_form')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <v-form>
            <v-row row no-gutters class="flex-nowrap" align="center">
              <v-col xs12 sm12 md8 lg6>
                <multi-file-upload2
                  id="addEnrollmentId"
                  @emit-upload-start="saving = true"
                  @emit-upload-end="saving = false"
                  :label="$t('headers.members_management.Enrolment Form')"
                  :tags="[selectedPlan.UniqueIdentifier]"
                  :categories="['Enrolment']"
                  :currentFolder="selectedPlan.Name"
                  :zipDownloadUrl="
                    settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                  "
                  :fileUploadUrl="
                    settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                  "
                  @emit-files="
                    bindEnrolmentForm($event);
                    saving = false;
                  "
                  @emit-upload-error="
                    error = $event;
                    saving = false;
                  "
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              addEnrolmentFormDialog = false;
              enrolmentForm = null;
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="saveEnrolmentForm"
            :disabled="enrolmentForm === null || enrolmentForm === undefined"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="addOtherFileDialog"
      max-width="800"
      persistent
      scrollable
    >
      <material-card
        :title="$t('components.memberview.add_other_file')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <v-form>
            <v-row row no-gutters class="flex-nowrap" align="center">
              <v-col xs12 sm12 md8 lg6>
                <multi-file-upload2
                  id="addOtherId"
                  @emit-upload-start="saving = true"
                  @emit-upload-end="saving = false"
                  :label="$t('headers.members_management.Other File')"
                  :tags="[selectedPlan.UniqueIdentifier]"
                  :categories="['Other']"
                  :currentFolder="selectedPlan.Name"
                  :zipDownloadUrl="
                    settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                  "
                  :fileUploadUrl="
                    settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                  "
                  @emit-files="
                    bindOtherFile($event);
                    saving = false;
                  "
                  @emit-upload-error="
                    error = $event;
                    saving = false;
                  "
                />
              </v-col>
            </v-row>
            <v-row row no-gutters class="flex-nowrap" align="center">
              <v-textarea
                :label="$t('components.memberview.change_notes')"
                clearable
                counter
                v-model="otherFileNotes"
              ></v-textarea>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              addOtherFileDialog = false;
              otherFile = null;
              otherFileNotes = null;
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="saveOtherFile"
            :disabled="otherFile === null || otherFile === undefined"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="addChangeFormDialog"
      max-width="800"
      persistent
      scrollable
    >
      <material-card
        :title="$t('components.memberview.add_change_form')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <v-form>
            <v-row row no-gutters class="flex-nowrap" align="center">
              <v-col xs12 sm12 md8 lg6>
                <multi-file-upload2
                  id="addChangeId"
                  @emit-upload-start="saving = true"
                  @emit-upload-end="saving = false"
                  :label="$t('headers.members_management.Change Form')"
                  :tags="[selectedPlan.UniqueIdentifier]"
                  :categories="['ChangeForm']"
                  :currentFolder="selectedPlan.Name"
                  :zipDownloadUrl="
                    settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                  "
                  :fileUploadUrl="
                    settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                  "
                  @emit-files="
                    bindChangeForm($event);
                    saving = false;
                  "
                  @emit-upload-error="
                    error = $event;
                    saving = false;
                  "
                />
              </v-col>
            </v-row>
            <v-row row no-gutters class="flex-nowrap" align="center">
              <v-textarea
                :label="$t('components.memberview.change_notes')"
                clearable
                counter
                v-model="changeFormNotes"
              ></v-textarea>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              addChangeFormDialog = false;
              changeForm = null;
              changeFormNotes = null;
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="saveChangeForm"
            :disabled="changeForm === null || changeForm === undefined"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <member-files
      :memberIdentityId="id"
      :model="dialogs.showFilesDialog"
      :title="$t('components.memberview.benefit_cards_{0}', [getName()])"
      @close="dialogs.showFilesDialog = false"
    ></member-files>
    <v-dialog v-model="flagDialog" max-width="600" persistent scrollable>
      <member-flags-form
        v-if="flagDialog"
        :title="$t('components.memberview.flags_{0}', [getName()])"
        :memberId="id"
        @close="flagDialog = false"
        @save="
          flagDialog = false;
          reloadMemberIdentity();
        "
      />
    </v-dialog>

    <v-dialog v-model="addNoteDialog" max-width="800" persistent scrollable>
      <member-notes-form
        v-if="addNoteDialog"
        :title="$t('components.memberview.add_note_{0}', [getName()])"
        :note="note"
        @save="
          addNoteDialog = false;
          reloadActiveNotesCount();
        "
        @close="addNoteDialog = false"
      />
    </v-dialog>
    <v-dialog
      v-model="activeNotesDialog"
      max-width="1200"
      persistent
      scrollable
    >
      <material-card
        v-if="activeNotesDialog"
        :title="$t('components.memberview.active_notes_{0}', [getName()])"
        :color="$vuetify.theme.themes.light.success"
        icon="sticky_note_2"
      >
        <v-card-text>
          <member-notes-table
            :memberId="id"
            @load-data="reloadActiveNotesCount()"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="activeNotesDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="archivedNotesDialog"
      max-width="1200"
      persistent
      scrollable
    >
      <material-card
        v-if="archivedNotesDialog"
        :title="$t('components.memberview.archived_notes_{0}', [getName()])"
        :color="$vuetify.theme.themes.light.secondary"
        icon="find_in_page"
      >
        <v-card-text>
          <member-notes-table :memberId="id" :showActive="false" />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="archivedNotesDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.beneficiaries"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="dialogs.beneficiaries"
        :title="
          $t('components.membersmanagementtable.view_edit_beneficiaries_{0}', [
            getName(),
          ])
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="share"
      >
        <v-card-text>
          <beneficiaries-form
            :files="enrolmentFiles"
            @file-upload-start="saving = true"
            @file-upload-end="saving = false"
            ref="beneficiariesForm"
            :disabled="
              memberIdentity.CurrentTerminationMembershipEvent &&
              memberIdentity.CurrentTerminationMembershipEvent.IsTerminated
            "
            :previousBeneficiaryPayload="previousBeneficiaryPayload"
            :beneficiaryStatements="beneficiaryStatements"
            :policyIdentities="policyIdentities"
            :memberIdentityId="id"
            :newStatement="newBeneficiaryStatement"
            @previous-declaration-date="
              hasPreviousDeclarationDate = $event !== null
            "
            @valid="beneficiariesFormIsValid($event)"
            @submit-beneficiaries="submitBeneficiaries"
            @delete-statement="tryDeleteBeneficiaryStatement($event)"
            :dependantIdentities="dependantIdentities"
          ></beneficiaries-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="cancelBeneficiaries">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            v-if="hasPreviousDeclarationDate"
            :loading="saving"
            :disabled="!beneficiariesSaveEnabled"
            color="primary"
            @click="trySubmitBeneficiaries"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.addDependant"
      persistent
      max-width="1200"
    >
      <dependant-form
        :title="
          selectedPlan.PlanType === 'Pension'
            ? $t('components.memberview.add_spouse_{0}', [getName()])
            : $t('components.memberview.add_dependant_{0}', [getName()])
        "
        v-if="memberIdentity"
        :editedIndex="editedDependantIndex"
        :memberId="memberIdentity.Id"
        @save="saveDependant"
        @close="closeDependant"
        :coverageEffectiveDate="memberIdentity.PlanEntryDate"
        :policyIdentities="policyIdentities"
        :beneficiaryStatements="beneficiaryStatements"
      />
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.vieweditDependants"
      persistent
      max-width="1200"
    >
      <material-card
        :title="
          selectedPlan.PlanType === 'Pension'
            ? $t(
                'components.membersmanagementtable.view_spouse_information_{0}',
                [getName()]
              )
            : $t('components.membersmanagementtable.view_dependants_{0}', [
                getName(),
              ])
        "
        icon="family_restroom"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <dependants
            v-if="memberIdentity"
            :formTitle="
              selectedPlan.PlanType === 'Pension'
                ? $t('components.memberview.edit_spouse_{0}', [getName()])
                : $t('components.memberview.edit_dependant_{0}', [getName()])
            "
            :disabled="dependantsDisabled()"
            :provider="odataDependantsProvider"
            :memberId="memberIdentity.Id"
            :identifier="'dependants'"
            :coverageEffectiveDate="memberIdentity.PlanEntryDate"
            :policyIdentities="policyIdentities"
            :beneficiaryStatements="beneficiaryStatements"
          ></dependants>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.vieweditDependants = false;
              odataDependantsProvider = undefined;
              reloadDependants();
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.untracked" persistent max-width="400">
      <material-card
        v-if="dialogs.untracked"
        :title="
          $t('components.membersmanagementtable.edit_info_{0}', [getName()])
        "
        icon="spellcheck"
        :color="$vuetify.theme.themes.light.warning"
      >
        <v-card-text>
          {{
            $t(
              "components.membersmanagementtable.attention!_if_you_choose_to_proceed_the_changes_will_be"
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.untracked = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :loading="saving" color="primary" @click="editInfo">
            {{ $t("components.membersmanagementtable.edit_info") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.editInfo" persistent max-width="1200">
      <material-card
        v-if="dialogs.editInfo"
        :title="
          editedUntrackedItem.FirstName
            ? $t('components.membersmanagementtable.edit_member_info_{0}', [
                editedUntrackedItem.FirstName +
                  ' ' +
                  editedUntrackedItem.LastName,
              ])
            : $t('components.membersmanagementtable.edit_member_info_{0}', [
                editedUntrackedItem.Certificate,
              ])
        "
        icon="spellcheck"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.untracked" ref="untrackedForm">
            <div class="row">
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf('Title') > -1
                "
              >
                <trans-select
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :clearable="
                    untrackedSectionHeaders['Title'].isOptional !== false
                  "
                  :item="editedUntrackedItem.CurrentMember"
                  propertyName="Title"
                  :items="sortedTitle"
                  :label="$t('headers.members_management.Title')"
                  :class="
                    untrackedSectionHeaders['Title'].isOptional === false
                      ? 'required'
                      : []
                  "
                  :rules="
                    untrackedSectionHeaders['Title'].isOptional === false
                      ? [$rules.required]
                      : []
                  "
                ></trans-select>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf('First Name') >
                  -1
                "
              >
                <no-autocomplete-textfield
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :label="$t('headers.members_management.First Name')"
                  v-model="editedUntrackedItem.CurrentMember.FirstName"
                  :rules="columnRules(untrackedSectionHeaders['First Name'])"
                  :class="
                    untrackedSectionHeaders['First Name'].isOptional === false
                      ? 'required'
                      : []
                  "
                ></no-autocomplete-textfield>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf('Middle Name') >
                  -1
                "
              >
                <no-autocomplete-textfield
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :label="$t('headers.members_management.Middle Name')"
                  v-model="editedUntrackedItem.CurrentMember.MiddleName"
                  :rules="columnRules(untrackedSectionHeaders['Middle Name'])"
                  :class="
                    untrackedSectionHeaders['Middle Name'].isOptional === false
                      ? 'required'
                      : []
                  "
                ></no-autocomplete-textfield>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf('Last Name') > -1
                "
              >
                <no-autocomplete-textfield
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :label="$t('headers.members_management.Last Name')"
                  v-model="editedUntrackedItem.CurrentMember.LastName"
                  :rules="columnRules(untrackedSectionHeaders['Last Name'])"
                  :class="
                    untrackedSectionHeaders['Last Name'].isOptional === false
                      ? 'required'
                      : []
                  "
                ></no-autocomplete-textfield>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf('Pronoun') > -1
                "
              >
                <trans-select
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :clearable="
                    untrackedSectionHeaders['Pronoun'].isOptional !== false
                  "
                  :item="editedUntrackedItem.CurrentMember"
                  propertyName="Pronoun"
                  :items="sortedPronoun"
                  :label="$t('headers.members_management.Pronoun')"
                  :class="
                    untrackedSectionHeaders['Pronoun'].isOptional === false
                      ? 'required'
                      : []
                  "
                  :rules="
                    untrackedSectionHeaders['Pronoun'].isOptional === false
                      ? [$rules.required]
                      : []
                  "
                ></trans-select>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf('Suffix') > -1
                "
              >
                <trans-select
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :clearable="
                    untrackedSectionHeaders['Suffix'].isOptional !== false
                  "
                  :item="editedUntrackedItem.CurrentMember"
                  propertyName="Suffix"
                  :items="sortedSuffix"
                  :label="$t('headers.members_management.Suffix')"
                  :class="
                    untrackedSectionHeaders['Suffix'].isOptional === false
                      ? 'required'
                      : []
                  "
                  :rules="
                    untrackedSectionHeaders['Suffix'].isOptional === false
                      ? [$rules.required]
                      : []
                  "
                ></trans-select>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf(
                    'Date Of Birth'
                  ) > -1
                "
              >
                <pbas-date-picker
                  :disabled="
                    (memberIdentity.CurrentTerminationMembershipEvent &&
                      memberIdentity.CurrentTerminationMembershipEvent
                        .IsTerminated) ||
                    !(
                      role.indexOf('Broker Plan Manager') > -1 ||
                      role.indexOf('Broker Plan Admin') > -1 ||
                      role.indexOf('Employer Plan Admin') > -1
                    )
                  "
                  :label="$t('headers.members_management.Date Of Birth')"
                  :value="editedUntrackedItem.CurrentMember.DateOfBirth"
                  @update-date="
                    editedUntrackedItem.CurrentMember.DateOfBirth = $event
                  "
                  :rules="
                    headersDictionary['Date Of Birth'].isOptional === false
                      ? [$rules.required, $rules.dateOfBirth]
                      : [$rules.dateOfBirth]
                  "
                  :class="
                    headersDictionary['Date Of Birth'].isOptional === false
                      ? 'required'
                      : []
                  "
                  :allowedDates="dateOfBirthDates"
                ></pbas-date-picker>
              </div>
              <template
                v-if="Object.keys(untrackedSectionHeaders).indexOf('SIN') > -1"
              >
                <div class="col-12 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :disabled="
                      memberIdentity.CurrentTerminationMembershipEvent &&
                      memberIdentity.CurrentTerminationMembershipEvent
                        .IsTerminated
                    "
                    :label="$t('headers.members_management.SIN')"
                    :value="editedUntrackedItem.MemberIdentification.SIN"
                    @input="updateSin"
                    :rules="
                      [$rules.sin].concat(
                        columnRules(untrackedSectionHeaders['SIN'])
                      )
                    "
                    :class="
                      untrackedSectionHeaders['SIN'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
              </template>
              <template
                v-if="Object.keys(untrackedSectionHeaders).indexOf('SIN') > -1"
              >
                <div class="col-12 col-md-4 col-lg-3">
                  <no-autocomplete-textfield
                    :disabled="
                      memberIdentity.CurrentTerminationMembershipEvent &&
                      memberIdentity.CurrentTerminationMembershipEvent
                        .IsTerminated
                    "
                    :label="$t('headers.members_management.TemporarySIN')"
                    :value="
                      editedUntrackedItem.MemberIdentification.TemporarySIN
                    "
                    @input="updateTemporarySin"
                    :rules="
                      [$rules.sin].concat(
                        columnRules(untrackedSectionHeaders['SIN'])
                      )
                    "
                    :class="
                      untrackedSectionHeaders['SIN'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
              </template>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf('Certificate') >
                  -1
                "
              >
                <no-autocomplete-textfield
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :label="$t('headers.members_management.Certificate')"
                  v-model="editedUntrackedItem.MemberIdentification.Certificate"
                  :rules="columnRules(untrackedSectionHeaders['Certificate'])"
                  :class="
                    untrackedSectionHeaders['Certificate'].isOptional === false
                      ? 'required'
                      : []
                  "
                ></no-autocomplete-textfield>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf(
                    'Membership Id'
                  ) > -1
                "
              >
                <no-autocomplete-textfield
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :label="$t('headers.members_management.Membership Id')"
                  v-model="
                    editedUntrackedItem.MemberIdentification.PensionMembershipId
                  "
                  :rules="
                    [$rules.pensionId].concat(
                      columnRules(untrackedSectionHeaders['Membership Id'])
                    )
                  "
                  :class="
                    untrackedSectionHeaders['Membership Id'].isOptional ===
                    false
                      ? 'required'
                      : []
                  "
                ></no-autocomplete-textfield>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  Object.keys(untrackedSectionHeaders).indexOf(
                    'Employee Number'
                  ) > -1
                "
              >
                <no-autocomplete-textfield
                  :disabled="
                    memberIdentity.CurrentTerminationMembershipEvent &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated
                  "
                  :label="$t('headers.members_management.Employee Number')"
                  v-model="
                    editedUntrackedItem.CurrentEmploymentInformation
                      .EmployeeNumber
                  "
                  :rules="
                    columnRules(untrackedSectionHeaders['Employee Number'])
                  "
                  :class="
                    untrackedSectionHeaders['Employee Number'].isOptional ===
                    false
                      ? 'required'
                      : []
                  "
                ></no-autocomplete-textfield>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.editInfo = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="!valid.untracked"
            color="primary"
            @click="saveUntracked"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.createAccount"
      persistent
      max-width="800"
    >
      <material-card
        :title="
          $t('components.membersmanagementtable.create_account_title_{0}', [
            getName(),
          ])
        "
        icon="person_add_alt"
        :color="$vuetify.theme.themes.light.success"
        v-if="dialogs.createAccount"
      >
        <v-card-text>
          <v-form v-model="valid.createAccount" ref="contactInfoForm2">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col>
                  <no-autocomplete-textfield
                    ref="email"
                    :label="$t('headers.members_management.Email')"
                    v-model="editedItem.Email"
                    :rules="[$rules.email, rules.confirmEmail2]"
                    @paste="onEmailPaste"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col>
                  <no-autocomplete-textfield
                    :label="$t('components.addmemberwizard.confirm_email')"
                    v-model="confirmEmail"
                    :rules="[$rules.email, rules.confirmEmail2]"
                    @paste="onConfirmEmailPaste"
                  ></no-autocomplete-textfield>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.createAccount = false;
              editedIndex = -1;
              editedItem = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.createAccount"
            :loading="saving"
            color="primary"
            @click="tryCreateAccount()"
          >
            {{ $t("components.membersmanagementtable.create_account") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.changeEmail"
      persistent
      max-width="800"
    >
      <material-card
        :title="
          $t('components.membersmanagementtable.change_email_title_{0}', [
            getName(),
          ])
        "
        icon="alternate_email"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.changeEmail"
      >
        <v-card-text>
          <v-form v-model="valid.changeEmail" ref="contactInfoForm2">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col>
                  <!-- <no-autocomplete-textfield
                    v-if="memberIdentity.CurrentContactInformation.PrimaryEmail === 'Home'"
                    :label="$t('headers.members_management.Home Email')"
                    v-model="editedItem.HomeEmail"
                    :rules="[$rules.email, rules.confirmHomeEmail]"
                  ></no-autocomplete-textfield>
                  <no-autocomplete-textfield
                    v-if="memberIdentity.CurrentContactInformation.PrimaryEmail === 'Work'"
                    :label="$t('headers.members_management.Work Email')"
                    v-model="editedItem.WorkEmail"
                    :rules="[$rules.email, rules.confirmWorkEmail]"
                  ></no-autocomplete-textfield> -->
                  <no-autocomplete-textfield
                    ref="email"
                    :label="$t('headers.members_management.Email')"
                    v-model="editedItem.Email"
                    :rules="[$rules.email, rules.confirmEmail2]"
                    @paste="onEmailPaste"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col>
                  <!-- <no-autocomplete-textfield
                    :label="$t('components.addmemberwizard.confirm_email')"
                    v-model="confirmEmail"
                    :rules="memberIdentity.CurrentContactInformation.PrimaryEmail === 'Home'?[$rules.email, rules.confirmHomeEmail]:[$rules.email, rules.confirmWorkEmail]"
                    @paste="onConfirmEmailPaste"
                  ></no-autocomplete-textfield> -->
                  <no-autocomplete-textfield
                    :label="$t('components.addmemberwizard.confirm_email')"
                    v-model="confirmEmail"
                    :rules="[$rules.email, rules.confirmEmail2]"
                    @paste="onConfirmEmailPaste"
                  ></no-autocomplete-textfield>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.changeEmail = false;
              editedItem = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.changeEmail"
            :loading="saving"
            color="primary"
            @click="tryChangeMemberEmail()"
          >
            {{ $t("components.membersmanagementtable.change_email") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.resendEmail"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t(
            'components.membersmanagementtable.send_registration_email_title_{0}',
            [getName()]
          )
        "
        icon="forward_to_inbox"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.resendEmail"
      >
        <v-card-text>
          {{
            $t(
              "components.membersmanagementtable.send_registration_email_confirm_{0}",
              [getName()]
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.resendEmail = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="resendRegistrationEmail()"
          >
            {{ $t("components.membersmanagementtable.send_email") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.resendConfirmationEmail"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t(
            'components.membersmanagementtable.send_confirmation_email_title_{0}',
            [getName()]
          )
        "
        icon="mark_email_read"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.resendConfirmationEmail"
      >
        <v-card-text>
          {{
            $t(
              "components.membersmanagementtable.send_confirmation_email_confirm_{0}",
              [getName()]
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.resendConfirmationEmail = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="resendConfirmationEmail()"
          >
            {{ $t("components.membersmanagementtable.send_email") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.deleteAccount"
      persistent
      max-width="400"
      scrollable
    >
      <material-card
        :title="
          $t('components.membersmanagementtable.confirm_delete_account_{0}', [
            getName(),
          ])
        "
        icon="person_remove"
        :color="$vuetify.theme.themes.light.error"
        v-if="dialogs.deleteAccount"
      >
        <v-card-text>
          {{ $t("components.membersmanagementtable.confirm_delete_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.deleteAccount = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="tryDeleteMemberPortalAccount()"
          >
            {{ $t("components.membersmanagementtable.delete_account") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.resetPassword"
      persistent
      max-width="400"
      scrollable
    >
      <material-card
        :title="
          $t('components.membersmanagementtable.confirm_reset_password_{0}', [
            getName(),
          ])
        "
        icon="person_remove"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.resetPassword"
      >
        <v-card-text>
          {{
            $t("components.membersmanagementtable.confirm_reset_password_text")
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.resetPassword = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="tryResetMemberPortalPassword"
          >
            {{ $t("components.membersmanagementtable.reset_password") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.activityStatus"
      persistent
      max-width="800"
    >
      <material-card
        v-if="dialogs.activityStatus"
        :title="
          $t(`components.memberview.change_activity_status_title_{0}`, [
            getName(),
          ])
        "
        icon="published_with_changes"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.activityStatus">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col>
                  <pbas-date-picker
                    :label="$t('headers.members_management.Effective Date')"
                    :value="effectiveDate"
                    @update-date="effectiveDate = $event"
                    :rules="[$rules.required, rules.coverageEffectiveDate]"
                    class="required"
                    :allowedDates="coverageAllowedDates"
                  ></pbas-date-picker>
                </v-col>
                <v-col v-if="selectedPlan.PlanType === 'Pension'">
                  <trans-select
                    :item="editedItem"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </v-col>
                <v-col>
                  <trans-select2
                    :clearable="headersDictionary['Activity Status'].isOptional"
                    v-model="editedItem"
                    propertyName="ActivityStatus"
                    :items="sortedActivityStatus"
                    :label="$t('headers.members_management.Activity Status')"
                    field="Name"
                    itemValue="Id"
                    :class="
                      headersDictionary['Activity Status'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Activity Status'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                    :displayFunc="(item, str) => `${item.Code} - ${str}`"
                  ></trans-select2>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.activityStatus = false;
              editedItem = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.activityStatus"
            :loading="saving"
            color="primary"
            @click="tryChangeActivityStatus()"
          >
            {{ $t("components.memberview.change_activity_status") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.class" persistent max-width="800">
      <material-card
        v-if="dialogs.class"
        :title="$t(`components.memberview.change_class_title_{0}`, [getName()])"
        icon="class"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.class">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col>
                  <pbas-date-picker
                    :label="$t('headers.members_management.Effective Date')"
                    :value="effectiveDate"
                    @update-date="effectiveDate = $event"
                    :rules="[$rules.required, rules.coverageEffectiveDate]"
                    class="required"
                    :allowedDates="coverageAllowedDates"
                  ></pbas-date-picker>
                </v-col>
                <template v-if="editedItem && effectiveDate">
                  <v-col v-if="selectedPlan.PlanType === 'Pension'">
                    <trans-select
                      :item="editedItem"
                      propertyName="SourceOfInformation"
                      :items="options.Models.SourceOfInformation"
                      :label="$t('globals.source_of_information')"
                    ></trans-select>
                  </v-col>
                  <v-col>
                    <auto-select
                      clear-icon="clear"
                      :clearable="headersDictionary['Class'].isOptional"
                      :label="$t('headers.members_management.Class')"
                      :value.sync="editedItem.Class"
                      :items="classes"
                      :class="
                        headersDictionary['Class'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Class'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></auto-select>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.class = false;
              editedItem = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.class"
            :loading="saving"
            color="primary"
            @click="tryChangeClass()"
          >
            {{ $t("components.memberview.change_class") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.benefitYear"
      persistent
      max-width="800"
    >
      <material-card
        v-if="dialogs.benefitYear"
        :title="
          $t(`components.memberview.view_edit_benefit_year_title_{0}`, [
            getName(),
          ])
        "
        icon="beach_access"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.benefitYear">
            <div class="row">
              <div class="col-12 col-sm-6">
                <pbas-date-picker
                  :label="$t('headers.members_management.Effective Date')"
                  :value="benefitYear.EffectiveDate"
                  @update-date="benefitYear.EffectiveDate = $event"
                  :rules="[
                    $rules.required,
                    rules.coverageEffectiveDate,
                    rules.benefitYearEffectiveDate,
                  ]"
                  class="required"
                  :allowedDates="benefitYearAllowedDates"
                  :disabled="loading"
                ></pbas-date-picker>
              </div>
              <div class="col-12 col-sm-6">
                <v-autocomplete
                  :label="$t('components.addmemberwizard.benefit_year')"
                  v-model="benefitYear.StartMonth"
                  :rules="[$rules.requiredInteger]"
                  class="required"
                  :items="$helpers.months()"
                  :item-text="(item) => $t('months.' + item.text)"
                ></v-autocomplete>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="saving"
            text
            @click="
              dialogs.benefitYear = false;
              benefitYear = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.benefitYear"
            :loading="saving || loading"
            color="primary"
            @click="saveBenefitYear"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.coverage" persistent max-width="1380">
      <material-card
        v-if="dialogs.coverage"
        :title="
          $t(`components.memberview.view_edit_coverage_title_{0}`, [getName()])
        "
        icon="beach_access"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.coverage" ref="coverageForm">
            <div class="row">
              <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :label="$t('headers.members_management.Effective Date')"
                  :value="coverageEffectiveDate"
                  @update-date="coverageEffectiveDate = $event"
                  :rules="planIdentity.HasEligibilityBank?[$rules.required, rules.coverageEffectiveDate]:[$rules.required, rules.coverageEffectiveDate2]"
                  class="required"
                  :allowedDates="planIdentity.HasEligibilityBank?coverageAllowedDates:coverageAllowedDates2"
                  :disabled="loading"
                ></pbas-date-picker>
              </div>
              <template v-if="coverageEffectiveDate">
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="planIdentity.Current.HasBenefitYears"
                >
                  <v-row no-gutters>
                    <div class="col-12 col-sm-10">
                      <v-autocomplete
                        :label="$t('components.addmemberwizard.benefit_year')"
                        v-model="
                          editedItemCoverage.CurrentMemberBenefitYear.StartMonth
                        "
                        :rules="[$rules.requiredInteger]"
                        class="required"
                        :items="$helpers.months()"
                        :item-text="(item) => $t('months.' + item.text)"
                        disabled
                      ></v-autocomplete>
                    </div>
                    <div class="col-12 col-sm-2">
                      <v-btn small color="primary" @click="editBenefitYear">
                        {{ $t("globals.edit") }}
                      </v-btn>
                    </div>
                  </v-row>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="selectedPlan.PlanType === 'Pension'"
                >
                  <trans-select
                    :item="editedItemCoverage.CurrentMembershipStatus"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                  !planIdentity.HasEligibilityBank &&
                    Object.keys(headersDictionary).indexOf('Termination Date') >
                    -1
                  "
                >
                  <pbas-date-picker
                    :disabled="hasCoverageCommencementRulesPlan"
                    :label="$t('headers.members_management.Termination Date')"
                    :value="
                      editedItemCoverage.CurrentTerminationMembershipEvent
                        .DateEffective
                    "
                    @update-date="
                      editedItemCoverage.CurrentTerminationMembershipEvent.DateEffective =
                        $event;
                      $forceUpdate();
                    "
                    :allowedDates="coverageExpireAllowedDates"
                    :class="
                      headersDictionary['Termination Date'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Termination Date'].isOptional === false
                        ? [$rules.required, rules.coverageExpireDate]
                        : [rules.coverageExpireDate]
                    "
                  ></pbas-date-picker>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                   !planIdentity.HasEligibilityBank &&
                    editedItemCoverage.CurrentTerminationMembershipEvent
                      .DateEffective !== null &&
                    editedItemCoverage.CurrentTerminationMembershipEvent
                      .DateEffective !== undefined &&
                    editedItemCoverage.CurrentTerminationMembershipEvent
                      .DateEffective !== '' &&
                    Object.keys(headersDictionary).indexOf(
                      'Termination Status'
                    ) > -1
                  "
                >
                  <trans-enum
                    :value.sync="
                      editedItemCoverage.CurrentTerminationMembershipEvent
                        .TerminationStatus
                    "
                    :items="options.Enums.TerminationStatus"
                    :label="
                      $t('components.addmemberwizard.coverage_expiry_reason')
                    "
                    class="required"
                    :rules="[$rules.required]"
                  ></trans-enum>
                </div>
              </template>
            </div>
            <template v-if="coverageEffectiveDate">
              <v-card>
                <v-card-title>
                  {{ $t("components.memberview.coverage_choice") }}
                </v-card-title>
                <v-card-text>
                  <div class="row">
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        Object.keys(headersDictionary).indexOf(
                          'Default Coverage Status'
                        ) > -1
                      "
                    >
                      <trans-select
                        :disabled="
                        hasCoverageCommencementRulesPlan ||
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated && !planIdentity.HasEligibilityBank) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        :clearable="
                          headersDictionary['Default Coverage Status']
                            .isOptional
                        "
                        :item="editedItemCoverage.CurrentMembershipStatus"
                        propertyName="DefaultCoverageStatus"
                        :items="sortedFamilyStatus"
                        :label="
                          $t(
                            'headers.members_management.Default Coverage Status'
                          )
                        "
                        :class="
                          headersDictionary['Default Coverage Status']
                            .isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="
                          headersDictionary['Default Coverage Status']
                            .isOptional === false
                            ? [$rules.required]
                            : []
                        "
                      ></trans-select>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        Object.keys(headersDictionary).indexOf('Class') > -1
                      "
                    >
                      <auto-select
                        :disabled="
                          hasCoverageCommencementRulesPlan ||
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated && !planIdentity.HasEligibilityBank) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        clear-icon="clear"
                        :clearable="headersDictionary['Class'].isOptional"
                        :label="$t('headers.members_management.Class')"
                        :value.sync="
                          editedItemCoverage.CurrentMembershipStatus.Class
                        "
                        :items="classes"
                        :class="
                          headersDictionary['Class'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="
                          headersDictionary['Class'].isOptional === false
                            ? [$rules.required]
                            : []
                        "
                      ></auto-select>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        Object.keys(headersDictionary).indexOf('Member Group') >
                        -1
                      "
                    >
                      <trans-select2
                        :disabled="
                          hasCoverageCommencementRulesPlan ||
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated && !planIdentity.HasEligibilityBank) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        v-model="
                          editedItemCoverage.CurrentMembershipStatus
                            .MemberGroupIdentity
                        "
                        propertyName="Current"
                        :items="memberGroups"
                        :label="$t('headers.members_management.Member Group')"
                        :rules="[$rules.required]"
                        field="Name"
                        itemValue="IdentityId"
                        class="required"
                      ></trans-select2>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="optionalCoverage.length > 0"
                    >
                      <trans-multi-select2
                        :disabled="
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated && !planIdentity.HasEligibilityBank) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        v-model="selectedOptionalCoverage"
                        :items="optionalCoverage"
                        :label="
                          $t('components.addmemberwizard.optionalCoverage')
                        "
                        field="Name"
                        itemValue="Id"
                        transPropertyName="Current"
                        @change="optionalChanged"
                      ></trans-multi-select2>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <div class="row">
                <div class="col-12 col-md-8">
                  <v-card>
                    <v-card-title>
                      {{ $t("components.memberview.customizable_coverage") }}
                    </v-card-title>
                    <v-card-text>
                      <pbas-data-table
                        v-if="
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        ref="benefitsTable"
                        :dataProvider="benefitsProvider"
                        :noSearch="true"
                        :noActions="true"
                        :showSelect="false"
                        :showActionsBtn="true"
                        @error="error = $event"
                      ></pbas-data-table>
                      <pbas-data-table
                        v-else
                        ref="benefitsTable"
                        :dataProvider="benefitsProvider"
                        :rowActions="benefitsRowActions"
                        :noSearch="true"
                        :noActions="true"
                        :showSelect="false"
                        :showActionsBtn="true"
                        @error="error = $event"
                      ></pbas-data-table>
                    </v-card-text>
                  </v-card>
                </div>
                <div class="col-12 col-md-4">
                  <v-card>
                    <v-card-title>
                      {{
                        $t("components.memberview.non_customizable_coverage")
                      }}
                    </v-card-title>
                    <v-card-text>
                      <pbas-data-table
                        ref="nonCustomizedBenefitsTable"
                        :dataProvider="nonCustomizedBenefitsProvider"
                        :noSearch="true"
                        :noActions="true"
                        :showSelect="false"
                        @error="error = $event"
                      ></pbas-data-table>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="saving"
            color
            text
            @click="
              dialogs.coverage = false;
              editedItemCoverage = {
                CurrentMembershipStatus: {
                  MemberGroupIdentity: {
                    Current: {},
                  },
                },
              };
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="
              !valid.coverage ||
              !valid.coverageEdit() ||
              (memberIdentity.CurrentTerminationMembershipEvent &&
                memberIdentity.CurrentTerminationMembershipEvent
                  .IsTerminated && !planIdentity.HasEligibilityBank) ||
              !(
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              )
            "
            :loading="saving || loading"
            color="primary"
            @click="saveCoverage()"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <member-termination-dialog
      :model="dialogs.terminate"
      :memberIdentityId="id"
      :items="termination.Items"
      :fixedCoverageIdentities="fixedCoverageIdentities"
      :addEnabled="termination.AddEnabled"
      @close="
        dialogs.terminate = false;
        reloadMemberIdentity();
        reloadCoverage();
      "
      :memberName="getName()"
      @reload="loadTermination"
      :smartEligibility="planIdentity.TrackHours"
    />
    <v-dialog
      scrollable
      v-model="dialogs.personalInfo"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="dialogs.personalInfo"
        :title="
          $t('components.membersmanagementtable.edit_personal_info_{0}', [
            getName(),
          ])
        "
        icon="account_circle"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.personalInfo" ref="personalInfoForm">
            <div class="row">
              <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :disabled="loading"
                  :label="$t('headers.members_management.Effective Date')"
                  :value="personalInfoEffectiveDate"
                  @update-date="personalInfoEffectiveDate = $event"
                  :allowedDates="coverageAllowedDates"
                  :class="'required'"
                  :rules="[$rules.required, rules.coverageEffectiveDate]"
                ></pbas-date-picker>
              </div>
              <template v-if="personalInfo && personalInfoEffectiveDate">
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="selectedPlan.PlanType === 'Pension'"
                >
                  <trans-select
                    :item="personalInfo"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="Object.keys(headersDictionary).indexOf('Title') > -1"
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="headersDictionary['Title'].isOptional"
                    :item="personalInfo"
                    propertyName="Title"
                    :items="sortedTitle"
                    :label="$t('headers.members_management.Title')"
                    :class="
                      headersDictionary['Title'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Title'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('First Name') > -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.First Name')"
                    v-model="personalInfo.FirstName"
                    :rules="columnRules(headersDictionary['First Name'])"
                    :class="
                      headersDictionary['First Name'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Middle Name') > -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Middle Name')"
                    v-model="personalInfo.MiddleName"
                    :rules="columnRules(headersDictionary['Middle Name'])"
                    :class="
                      headersDictionary['Middle Name'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Last Name') > -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Last Name')"
                    v-model="personalInfo.LastName"
                    :rules="columnRules(headersDictionary['Last Name'])"
                    :class="
                      headersDictionary['Last Name'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="Object.keys(headersDictionary).indexOf('Pronoun') > -1"
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="headersDictionary['Pronoun'].isOptional"
                    :item="personalInfo"
                    propertyName="Pronoun"
                    :items="sortedPronoun"
                    :label="$t('headers.members_management.Pronoun')"
                    :class="
                      headersDictionary['Pronoun'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Pronoun'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="Object.keys(headersDictionary).indexOf('Suffix') > -1"
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="headersDictionary['Suffix'].isOptional"
                    :item="personalInfo"
                    propertyName="Suffix"
                    :items="sortedSuffix"
                    :label="$t('headers.members_management.Suffix')"
                    :class="
                      headersDictionary['Suffix'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Suffix'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <template
                  v-if="Object.keys(headersDictionary).indexOf('SIN') > -1"
                >
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="originalSIN !== null && originalSIN !== undefined"
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        originalSIN !== null && originalSIN !== undefined
                      "
                      :label="$t('headers.members_management.SIN')"
                      v-model="personalInfo.Identity.MemberIdentification.SIN"
                      :rules="
                        [$rules.sin].concat(
                          columnRules(headersDictionary['SIN'])
                        )
                      "
                      :class="
                        headersDictionary['SIN'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div class="col-12 col-md-4 col-lg-3" v-else>
                    <no-autocomplete-textfield
                      :disabled="
                        originalTemporarySIN !== null &&
                        originalTemporarySIN !== undefined
                      "
                      :label="$t('headers.members_management.SIN')"
                      v-model="
                        personalInfo.Identity.MemberIdentification.TemporarySIN
                      "
                      :rules="
                        [$rules.sin].concat(
                          columnRules(headersDictionary['SIN'])
                        )
                      "
                      :class="
                        headersDictionary['SIN'].isOptional === false
                          ? 'required'
                          : []
                      "
                    ></no-autocomplete-textfield>
                  </div>
                </template>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Drawbridge Id') > -1
                  "
                >
                  <no-autocomplete-textfield
                    disabled
                    :label="$t('headers.members_management.Drawbridge Id')"
                    v-model="
                      personalInfo.Identity.MemberIdentification.Certificate
                    "
                    :rules="columnRules(headersDictionary['Drawbridge Id'])"
                    :class="
                      headersDictionary['Drawbridge Id'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Membership Id') > -1
                  "
                >
                  <no-autocomplete-textfield
                    disabled
                    :label="$t('headers.members_management.Membership Id')"
                    v-model="
                      personalInfo.Identity.MemberIdentification
                        .PensionMembershipId
                    "
                    :rules="columnRules(headersDictionary['Membership Id'])"
                    :class="
                      headersDictionary['Membership Id'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-else-if="
                    Object.keys(headersDictionary).indexOf('Certificate') > -1
                  "
                >
                  <no-autocomplete-textfield
                    disabled
                    :label="$t('headers.members_management.Certificate')"
                    v-model="
                      personalInfo.Identity.MemberIdentification.Certificate
                    "
                    :rules="columnRules(headersDictionary['Certificate'])"
                    :class="
                      headersDictionary['Certificate'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Date Of Birth') > -1
                  "
                >
                  <pbas-date-picker
                    :disabled="true"
                    :label="$t('headers.members_management.Date Of Birth')"
                    :value="personalInfo.DateOfBirth"
                    @update-date="personalInfo.DateOfBirth = $event"
                    :rules="
                      headersDictionary['Date Of Birth'].isOptional === false
                        ? [$rules.required, $rules.dateOfBirth]
                        : [$rules.dateOfBirth]
                    "
                    :class="
                      headersDictionary['Date Of Birth'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :allowedDates="dateOfBirthDates"
                  ></pbas-date-picker>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="Object.keys(headersDictionary).indexOf('Gender') > -1"
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="headersDictionary['Gender'].isOptional"
                    :item="personalInfo"
                    propertyName="Gender"
                    :items="sortedGender"
                    :label="$t('headers.members_management.Gender')"
                    :class="
                      headersDictionary['Gender'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Gender'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="Object.keys(headersDictionary).indexOf('Smoker') > -1"
                >
                  <v-checkbox
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Smoker')"
                    v-model="personalInfo.IsSmoker"
                  ></v-checkbox>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Has Eligible Dependants'
                    ) > -1
                  "
                >
                  <v-checkbox
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="
                      $t('headers.members_management.Has Eligible Dependants')
                    "
                    v-model="personalInfo.HasEligibleDependants"
                  ></v-checkbox>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Marital Status') >
                    -1
                  "
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="headersDictionary['Marital Status'].isOptional"
                    :item="personalInfo"
                    propertyName="MaritalStatus"
                    :items="sortedMaritalStatus"
                    :label="$t('headers.members_management.Marital Status')"
                    :class="
                      headersDictionary['Marital Status'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Marital Status'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'ProvinceOfResidence'
                    ) > -1
                  "
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="
                      headersDictionary['ProvinceOfResidence'].isOptional
                    "
                    :item="personalInfo"
                    propertyName="ProvinceOfResidence"
                    :items="sortedProvince"
                    :label="
                      $t('headers.members_management.ProvinceOfResidence')
                    "
                    :class="
                      headersDictionary['ProvinceOfResidence'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['ProvinceOfResidence'].isOptional ===
                      false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'ProvinceOfEmployment'
                    ) > -1
                  "
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="
                      headersDictionary['ProvinceOfEmployment'].isOptional
                    "
                    :item="personalInfo"
                    propertyName="ProvinceOfEmployment"
                    :items="sortedProvince"
                    :label="
                      $t('headers.members_management.ProvinceOfEmployment')
                    "
                    :class="
                      headersDictionary['ProvinceOfEmployment'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['ProvinceOfEmployment'].isOptional ===
                      false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Tax Exemption') > -1
                  "
                >
                  <v-checkbox
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Tax Exemption')"
                    v-model="personalInfo.TaxExemption"
                  ></v-checkbox>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Enrollement Signed At'
                    ) > -1
                  "
                >
                  <pbas-date-picker
                    :disabled="
                      (originalEnrolmentSignedAt !== null &&
                        originalEnrolmentSignedAt !== undefined) ||
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="
                      $t('headers.members_management.Enrollement Signed At')
                    "
                    :value="
                      personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt
                    "
                    @update-date="updatePersonalInfoEnrolmentSignedAt"
                    :rules="
                      headersDictionary['Enrollement Signed At'].isOptional ===
                      false
                        ? [$rules.required, rules.bothCompleted]
                        : [rules.bothCompleted]
                    "
                    :class="
                      headersDictionary['Enrollement Signed At'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                  ></pbas-date-picker>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Enrollement Received At'
                    ) > -1
                  "
                >
                  <pbas-date-picker
                    :disabled="
                      (originalEnrolmentReceivedAt !== null &&
                        originalEnrolmentReceivedAt !== undefined) ||
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="
                      $t('headers.members_management.Enrollement Received At')
                    "
                    :value="
                      personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt
                    "
                    @update-date="updatePersonalInfoEnrolmentReceivedAt"
                    :rules="
                      headersDictionary['Enrollement Received At']
                        .isOptional === false
                        ? [$rules.required, rules.bothCompleted]
                        : [rules.bothCompleted]
                    "
                    :class="
                      headersDictionary['Enrollement Received At']
                        .isOptional === false
                        ? 'required'
                        : []
                    "
                  ></pbas-date-picker>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Union Initiation Date'
                    ) > -1
                  "
                >
                  <pbas-date-picker
                    :disabled="
                    (originalUnionInitiationDate !== null &&
                    originalUnionInitiationDate !== undefined) ||
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="
                      $t('headers.members_management.Union Initiation Date')
                    "
                    :value="
                      personalInfo.Identity.UnionInitiationDate
                    "
                    @update-date="personalInfo.Identity.UnionInitiationDate = $event"
                    :rules="
                      headersDictionary['Union Initiation Date'].isOptional ===
                      false
                        ? [$rules.required]
                        : []
                    "
                    :class="
                      headersDictionary['Union Initiation Date'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                  ></pbas-date-picker>
                </div>
              </template>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.personalInfo = false;
              personalInfo = {
                Identity: {
                  MemberIdentification: {},
                },
              };
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="
              !valid.personalInfo ||
              !personalInfoEffectiveDate ||
              (memberIdentity.CurrentTerminationMembershipEvent &&
                memberIdentity.CurrentTerminationMembershipEvent
                  .IsTerminated) ||
              !(
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              )
            "
            color="primary"
            @click="savePersonalInfo"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.employmentInfo"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="dialogs.employmentInfo"
        :title="
          $t('components.memberview.edit_employment_info_{0}', [getName()])
        "
        icon="work"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.employmentInfo" ref="employmentInfoForm">
            <div class="row">
              <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :disabled="loading"
                  :label="$t('headers.members_management.Effective Date')"
                  :value="employmentInfoEffectiveDate"
                  @update-date="employmentInfoEffectiveDate = $event"
                  :allowedDates="coverageAllowedDates"
                  :class="'required'"
                  :rules="[$rules.required, rules.coverageEffectiveDate]"
                ></pbas-date-picker>
              </div>
              <template v-if="employmentInfo && employmentInfoEffectiveDate">
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="selectedPlan.PlanType === 'Pension'"
                >
                  <trans-select
                    :item="employmentInfo"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="Object.keys(headersDictionary).indexOf('Employer') > -1"
                >
                  <trans-select2
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    v-model="employmentInfo"
                    propertyName="Employer"
                    transPropertyName="Current"
                    :items="employers"
                    :label="$t('headers.members_management.Employer')"
                    field="Name"
                    itemValue="Id"
                    :class="
                      headersDictionary['Employer'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Employer'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select2>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Store') > -1 &&
                    stores &&
                    stores.length > 0
                  "
                >
                  <trans-select2
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    v-model="employmentInfo"
                    propertyName="Store"
                    transPropertyName="Current"
                    :items="stores"
                    :label="$t('headers.members_management.Store')"
                    field="Name"
                    itemValue="Id"
                    :class="
                      headersDictionary['Store'].isOptional === false ||
                      (stores.length > 0 && planOptions.HasStores)
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Store'].isOptional === false ||
                      (stores.length > 0 && planOptions.HasStores)
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select2>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Hire Date') > -1
                  "
                >
                  <pbas-date-picker
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Hire Date')"
                    :value="employmentInfo.HireDate"
                    @update-date="employmentInfo.HireDate = $event"
                    :class="
                      headersDictionary['Hire Date'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Hire Date'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></pbas-date-picker>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Employer Contribution'
                    ) > -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="
                      $t('headers.members_management.Employer Contribution')
                    "
                    v-model="employmentInfo.EmployerContribution"
                    :rules="
                      columnRules(headersDictionary['Employer Contribution'])
                    "
                    :class="
                      headersDictionary['Employer Contribution'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Employee Number') >
                    -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Employee Number')"
                    v-model="employmentInfo.EmployeeNumber"
                    :rules="columnRules(headersDictionary['Employee Number'])"
                    :class="
                      headersDictionary['Employee Number'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Occupation') > -1
                  "
                >
                  <auto-select
                    ref="occupation"
                    @keydown="occupationKeyDown"
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    clear-icon="clear"
                    :clearable="headersDictionary['Occupation'].isOptional"
                    :label="$t('headers.members_management.Occupation')"
                    :value.sync="employmentInfo.Occupation"
                    :items="occupations"
                    :class="
                      headersDictionary['Occupation'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Occupation'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></auto-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Employment Type') >
                    -1
                  "
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="headersDictionary['Employment Type'].isOptional"
                    :item="employmentInfo"
                    propertyName="EmploymentType"
                    :items="sortedEmploymentType"
                    :label="$t('headers.members_management.Employment Type')"
                    :class="
                      headersDictionary['Employment Type'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Employment Type'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Employment Frequency'
                    ) > -1
                  "
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="
                      headersDictionary['Employment Frequency'].isOptional
                    "
                    :item="employmentInfo"
                    propertyName="EmploymentFrequency"
                    :items="sortedEmploymentFrequency"
                    :label="
                      $t('headers.members_management.Employment Frequency')
                    "
                    :class="
                      headersDictionary['Employment Frequency'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Employment Frequency'].isOptional ===
                      false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('WeeklyHours') > -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    type="text"
                    :label="$t('headers.members_management.WeeklyHours')"
                    v-model="employmentInfo.WeeklyHours"
                    :class="
                      headersDictionary['WeeklyHours'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="columnRules(headersDictionary['WeeklyHours'])"
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="Object.keys(headersDictionary).indexOf('Earnings') > -1"
                >
                  <currency-textfield
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    v-model="employmentInfo.Earnings"
                    :label="$t('headers.members_management.Earnings')"
                    :class="
                      headersDictionary['Earnings'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Earnings'].isOptional === false
                        ? [$rules.requiredNum, $rules.decimal]
                        : [$rules.decimal]
                    "
                  />
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Second Income Earnings Frequency'
                    ) > -1
                  "
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="
                      headersDictionary['Second Income Earnings Frequency']
                        .isOptional
                    "
                    :item="employmentInfo"
                    propertyName="SecondIncomeEarningsFrequency"
                    :items="options.Models.SecondIncomeEarningsFrequency"
                    :label="
                      $t(
                        'headers.members_management.Second Income Earnings Frequency'
                      )
                    "
                    :class="
                      headersDictionary['Second Income Earnings Frequency']
                        .isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Second Income Earnings Frequency']
                        .isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Second Income Type'
                    ) > -1
                  "
                >
                  <trans-select
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="
                      headersDictionary['Second Income Type'].isOptional
                    "
                    :item="employmentInfo"
                    propertyName="SecondIncomeType"
                    :items="sortedSecondIncomeType"
                    :label="$t('headers.members_management.Second Income Type')"
                    :class="
                      headersDictionary['Second Income Type'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Second Income Type'].isOptional ===
                      false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Second Income Earnings'
                    ) > -1
                  "
                >
                  <currency-textfield
                    :disabled="
                      (memberIdentity.CurrentTerminationMembershipEvent &&
                        memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    v-model="employmentInfo.SecondIncomeEarnings"
                    :label="
                      $t('headers.members_management.Second Income Earnings')
                    "
                    :class="
                      headersDictionary['Second Income Earnings'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Second Income Earnings'].isOptional ===
                      false
                        ? [$rules.requiredNum]
                        : []
                    "
                  />
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Salary Evidence Provided'
                    ) > -1
                  "
                >
                  <v-checkbox
                    :label="
                      $t('headers.members_management.Salary Evidence Provided')
                    "
                    v-model="employmentInfo.SalaryEvidenceProvided"
                  ></v-checkbox>
                </div>
                <div
                  class="col-12 col-md-12 col-lg-12"
                  v-if="
                    useDocumentsManagement &&
                    Object.keys(headersDictionary).indexOf('Salary Evidence') >
                      -1 &&
                    employmentInfo.SalaryEvidenceProvided === true
                  "
                >
                  <multi-file-upload2
                    id="salaryId"
                    @emit-upload-end="saving = false"
                    @emit-upload-start="saving = true"
                    :label="$t('headers.members_management.Salary Information')"
                    :filesIds="salaryEvidenceIds"
                    :zipDownloadUrl="
                      settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                    "
                    :fileUploadUrl="
                      settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                    "
                    :getFilesUrl="settings.DOCUMENTSERVICEURL + 'api/Files'"
                    @emit-files="
                      bindSalaryInformation($event);
                      saving = false;
                    "
                    @emit-upload-error="
                      error = $event;
                      saving = false;
                    "
                    :tags="[selectedPlan.UniqueIdentifier]"
                    :categories="['SalaryEvidence']"
                    :currentFolder="selectedPlan.Name"
                  />
                </div>
              </template>
            </div>
          </v-form>
          <template v-if="employmentCoverage">
            <v-form v-model="valid.employmentInfoCoverage">
              <div class="row">
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="planIdentity.Current.HasBenefitYears"
                >
                  <!-- <v-row no-gutters>
                    <div class="col-12 col-sm-10"> -->
                  <v-autocomplete
                    :label="$t('components.addmemberwizard.benefit_year')"
                    v-model="
                      employmentInfo.Identity.CurrentMemberBenefitYear
                        .StartMonth
                    "
                    :rules="[$rules.requiredInteger]"
                    class="required"
                    :items="$helpers.months()"
                    :item-text="(item) => $t('months.' + item.text)"
                    disabled
                  ></v-autocomplete>
                  <!-- </div> -->
                  <!-- <div class="col-12 col-sm-2">
                      <v-btn
                      small
                        color="primary"
                        @click="
                          editBenefitYear
                        "
                      >
                        {{ $t("globals.edit") }}
                      </v-btn>
                    </div> -->
                  <!-- </v-row> -->
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="selectedPlan.PlanType === 'Pension'"
                >
                  <trans-select
                    :item="employmentInfo.Identity.CurrentMembershipStatus"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div>
              </div>
              <v-card>
                <v-card-title>
                  {{ $t("components.memberview.coverage_choice") }}
                </v-card-title>
                <v-card-text>
                  <div class="row">
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        Object.keys(headersDictionary).indexOf(
                          'Default Coverage Status'
                        ) > -1
                      "
                    >
                      <trans-select
                        :disabled="
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        :clearable="
                          headersDictionary['Default Coverage Status']
                            .isOptional
                        "
                        :item="employmentInfo.Identity.CurrentMembershipStatus"
                        propertyName="DefaultCoverageStatus"
                        :items="sortedFamilyStatus"
                        :label="
                          $t(
                            'headers.members_management.Default Coverage Status'
                          )
                        "
                        :class="
                          headersDictionary['Default Coverage Status']
                            .isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="
                          headersDictionary['Default Coverage Status']
                            .isOptional === false
                            ? [$rules.required]
                            : []
                        "
                      ></trans-select>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        Object.keys(headersDictionary).indexOf('Class') > -1
                      "
                    >
                      <auto-select
                        :disabled="
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        clear-icon="clear"
                        :clearable="headersDictionary['Class'].isOptional"
                        :label="$t('headers.members_management.Class')"
                        :value.sync="
                          employmentInfo.Identity.CurrentMembershipStatus.Class
                        "
                        :items="classes"
                        :class="
                          headersDictionary['Class'].isOptional === false
                            ? 'required'
                            : []
                        "
                        :rules="
                          headersDictionary['Class'].isOptional === false
                            ? [$rules.required]
                            : []
                        "
                      ></auto-select>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="
                        Object.keys(headersDictionary).indexOf('Member Group') >
                        -1
                      "
                    >
                      <trans-select2
                        :disabled="
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        v-model="
                          employmentInfo.Identity.CurrentMembershipStatus
                            .MemberGroupIdentity
                        "
                        propertyName="Current"
                        :items="employmentInfo.Employer.MemberGroups"
                        :label="$t('headers.members_management.Member Group')"
                        :rules="[$rules.required]"
                        field="Name"
                        itemValue="IdentityId"
                        class="required"
                      ></trans-select2>
                    </div>
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="optionalCoverage.length > 0"
                    >
                      <trans-multi-select2
                        :disabled="
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        v-model="selectedOptionalCoverage"
                        :items="optionalCoverage"
                        :label="
                          $t('components.addmemberwizard.optionalCoverage')
                        "
                        field="Name"
                        itemValue="Id"
                        transPropertyName="Current"
                        @change="optionalChangedEmploymentInfo"
                      ></trans-multi-select2>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <div class="row">
                <div class="col-12 col-md-8">
                  <v-card>
                    <v-card-title>
                      {{ $t("components.memberview.customizable_coverage") }}
                    </v-card-title>
                    <v-card-text>
                      <pbas-data-table
                        v-if="
                          (memberIdentity.CurrentTerminationMembershipEvent &&
                            memberIdentity.CurrentTerminationMembershipEvent
                              .IsTerminated) ||
                          !(
                            role.indexOf('Broker Plan Manager') > -1 ||
                            role.indexOf('Broker Plan Admin') > -1 ||
                            role.indexOf('Employer Plan Admin') > -1
                          )
                        "
                        ref="benefitsTable"
                        :dataProvider="benefitsProvider"
                        :noSearch="true"
                        :noActions="true"
                        :showSelect="false"
                        :showActionsBtn="true"
                        @error="error = $event"
                      ></pbas-data-table>
                      <pbas-data-table
                        v-else
                        ref="benefitsTable"
                        :dataProvider="benefitsProvider"
                        :rowActions="benefitsRowActions"
                        :noSearch="true"
                        :noActions="true"
                        :showSelect="false"
                        :showActionsBtn="true"
                        @error="error = $event"
                      ></pbas-data-table>
                    </v-card-text>
                  </v-card>
                </div>
                <div class="col-12 col-md-4">
                  <v-card>
                    <v-card-title>
                      {{
                        $t("components.memberview.non_customizable_coverage")
                      }}
                    </v-card-title>
                    <v-card-text>
                      <pbas-data-table
                        ref="nonCustomizedBenefitsTable"
                        :dataProvider="nonCustomizedBenefitsProvider"
                        :noSearch="true"
                        :noActions="true"
                        :showSelect="false"
                        @error="error = $event"
                      ></pbas-data-table>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-form>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.employmentInfo = false;
              employmentInfo = {};
              employmentCoverage = false;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving || loading"
            :disabled="
              !valid.employmentInfo ||
              (!valid.employmentInfoCoverage && employmentCoverage) ||
              (!valid.coverageEdit() && employmentCoverage) ||
              !employmentInfoEffectiveDate ||
              (memberIdentity.CurrentTerminationMembershipEvent &&
                memberIdentity.CurrentTerminationMembershipEvent
                  .IsTerminated) ||
              !(
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              )
            "
            color="primary"
            @click="saveEmploymentInfo"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.contactInfo"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="dialogs.contactInfo"
        :title="$t('components.memberview.edit_contact_info_{0}', [getName()])"
        icon="contact_mail"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.contactInfo" ref="contactInfoForm">
            <div class="row">
              <!-- <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :disabled="loading"
                  :label="$t('headers.members_management.Effective Date')"
                  :value="contactInfoEffectiveDate"
                  @update-date="contactInfoEffectiveDate = $event"
                  :allowedDates="coverageAllowedDates"
                  :class="'required'"
                  :rules="[$rules.required, rules.coverageEffectiveDate]"
                ></pbas-date-picker>
              </div> -->
              <template v-if="contactInfo && contactInfoEffectiveDate">
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="selectedPlan.PlanType === 'Pension'"
                >
                  <trans-select
                    :item="contactInfo"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'CommunicationPreference'
                    ) > -1
                  "
                >
                  <trans-select
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="
                      headersDictionary['CommunicationPreference'].isOptional
                    "
                    :item="contactInfo"
                    propertyName="CommunicationPreference"
                    :items="options.Models.CommunicationPreference"
                    :label="
                      $t('headers.members_management.CommunicationPreference')
                    "
                    :class="
                      headersDictionary['CommunicationPreference']
                        .isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['CommunicationPreference']
                        .isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('LanguageChoice') >
                    -1
                  "
                >
                  <trans-select
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="headersDictionary['LanguageChoice'].isOptional"
                    :item="contactInfo"
                    propertyName="LanguageChoice"
                    :items="options.Models.LanguageChoice"
                    :label="$t('headers.members_management.LanguageChoice')"
                    :class="
                      headersDictionary['LanguageChoice'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['LanguageChoice'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select>
                </div>
              </template>
            </div>
          </v-form>
          <template v-if="contactInfo && contactInfoEffectiveDate">
            <span class="text-h6 ml-1">
              {{ $t("globals.address") }}
            </span>
            <canada-post-address
              :address="contactInfo.Address"
              @update-address="contactInfo.Address = $event"
              @valid="valid.address = $event"
            />
            <!-- <v-form v-model="valid.address">
              <div class="row">
                <template
                  v-if="Object.keys(headersDictionary).indexOf('Country') > -1"
                >
                  <div class="col-12 col-md-4 col-lg-3">
                    <trans-select
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      @change="countryChanged"
                      :clearable="true"
                      :item="contactInfo.Address"
                      propertyName="Country"
                      :items="sortedCountry"
                      :label="$t('headers.members_management.Country')"
                      :class="
                        headersDictionary['Country'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Country'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      contactInfo.Address.Country &&
                        contactInfo.Address.Country.IsOther
                    "
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :label="$t('headers.members_management.OtherCountry')"
                      v-model="contactInfo.Address.OtherCountry"
                      :class="
                        headersDictionary['OtherCountry'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="columnRules(headersDictionary['OtherCountry'])"
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="contactInfo.Address.Country"
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :label="$t('headers.members_management.Street Number')"
                      v-model="contactInfo.Address.StreetNumber"
                      :class="
                        headersDictionary['Street Number'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Street Number'].isOptional === false
                          ? [$rules.required, $rules.streetNumber]
                          : [$rules.streetNumber]
                      "
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="contactInfo.Address.Country"
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :label="$t('headers.members_management.Street Name')"
                      v-model="contactInfo.Address.StreetName"
                      :class="
                        headersDictionary['Street Name'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="columnRules(headersDictionary['Street Name'])"
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="contactInfo.Address.Country"
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :label="$t('headers.members_management.Suite Number')"
                      v-model="contactInfo.Address.SuiteNumber"
                      :class="
                        headersDictionary['Suite Number'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="columnRules(headersDictionary['Suite Number'])"
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="contactInfo.Address.Country"
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :label="$t('headers.members_management.City')"
                      v-model="contactInfo.Address.City"
                      :class="
                        headersDictionary['City'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="columnRules(headersDictionary['City'])"
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      contactInfo.Address.Country &&
                        !contactInfo.Address.Country.IsOther
                    "
                  >
                    <trans-select
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :clearable="headersDictionary['Province'].isOptional"
                      :item="contactInfo.Address"
                      propertyName="Province"
                      :items="sortedProvince"
                      :label="$t('headers.members_management.Province')"
                      :class="
                        headersDictionary['Province'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="
                        headersDictionary['Province'].isOptional === false
                          ? [$rules.required]
                          : []
                      "
                    ></trans-select>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      contactInfo.Address.Country &&
                        contactInfo.Address.Country.IsOther
                    "
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :label="$t('headers.members_management.OtherProvince')"
                      v-model="contactInfo.Address.OtherProvince"
                      :class="
                        headersDictionary['OtherProvince'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="columnRules(headersDictionary['OtherProvince'])"
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      contactInfo.Address.Country &&
                        !contactInfo.Address.Country.IsOther
                    "
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :label="$t('headers.members_management.Postal Code')"
                      v-model="contactInfo.Address.PostalCode"
                      :class="
                        headersDictionary['Postal Code'].isOptional === false
                          ? 'required'
                          : []
                      "
                      :rules="columnRules(headersDictionary['Postal Code'])"
                    ></no-autocomplete-textfield>
                  </div>
                  <div
                    class="col-12 col-md-4 col-lg-3"
                    v-if="
                      contactInfo.Address.Country &&
                        contactInfo.Address.Country.IsOther
                    "
                  >
                    <no-autocomplete-textfield
                      :disabled="
                        !(
                          role.indexOf('Broker Plan Manager') > -1 ||
                          role.indexOf('Broker Plan Admin') > -1 ||
                          role.indexOf('Employer Plan Admin') > -1
                        )
                      "
                      :label="$t('headers.members_management.OtherPostalCode')"
                      v-model="contactInfo.Address.OtherPostalCode"
                      :class="
                        headersDictionary['OtherPostalCode'].isOptional ===
                        false
                          ? 'required'
                          : []
                      "
                      :rules="columnRules(headersDictionary['OtherPostalCode'])"
                    ></no-autocomplete-textfield>
                  </div>
                </template>
              </div>
            </v-form> -->
          </template>
          <template v-if="contactInfo && contactInfoEffectiveDate">
            <v-form v-model="valid.contactInfo2" ref="contactInfoForm2">
              <div class="row">
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Phone Number') > -1
                  "
                >
                  <!-- <no-autocomplete-textfield
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Phone Number')"
                    v-model="contactInfo.PhoneNumber"
                    :rules="columnRules(headersDictionary['Phone Number'], telephoneMask)"
                    :class="
                      headersDictionary['Phone Number'].isOptional === false
                        ? 'required'
                        : []
                    "
                    v-mask="telephoneMask"
                  ></no-autocomplete-textfield> -->
                  <no-autocomplete-textfield
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Phone Number')"
                    v-model="contactInfo.PhoneNumber"
                    :rules="columnRules(headersDictionary['Phone Number'])"
                    :class="
                      headersDictionary['Phone Number'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Home Email') > -1
                  "
                >
                  <no-autocomplete-textfield
                    ref="homeEmail"
                    :disabled="
                      (memberIdentity.PrimaryEmail === 'Home' &&
                        planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      (planIdentity.HasDrupalPortal &&
                        planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Home Email')"
                    v-model="contactInfo.HomeEmail"
                    :rules="
                      [rules.confirmContactInfoHomeEmail].concat(
                        columnRules(headersDictionary['Home Email'])
                      )
                    "
                    :class="
                      headersDictionary['Home Email'].isOptional === false
                        ? 'required'
                        : []
                    "
                    @paste="onHomeEmailPaste"
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Home Email') > -1 &&
                    !(
                      (memberIdentity.PrimaryEmail === 'Home' &&
                        planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      (planIdentity.HasDrupalPortal &&
                        planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    )
                  "
                >
                  <no-autocomplete-textfield
                    ref="homeEmail"
                    :label="$t('components.addmemberwizard.confirm_home_email')"
                    v-model="confirmHomeEmail"
                    :rules="
                      [rules.confirmContactInfoHomeEmail].concat(
                        columnRules(headersDictionary['Home Email'])
                      )
                    "
                    :class="
                      headersDictionary['Home Email'].isOptional === false
                        ? 'required'
                        : []
                    "
                    @paste="onConfirmEmailPaste"
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Work Email') > -1
                  "
                >
                  <no-autocomplete-textfield
                    ref="workEmail"
                    :disabled="
                      (memberIdentity.PrimaryEmail === 'Work' &&
                        planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      (planIdentity.HasDrupalPortal &&
                        planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Work Email')"
                    v-model="contactInfo.WorkEmail"
                    :rules="
                      [rules.confirmContactInfoWorkEmail].concat(
                        columnRules(headersDictionary['Work Email'])
                      )
                    "
                    :class="
                      headersDictionary['Work Email'].isOptional === false
                        ? 'required'
                        : []
                    "
                    @paste="onWorkEmailPaste"
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Work Email') > -1 &&
                    !(
                      (memberIdentity.PrimaryEmail === 'Work' &&
                        planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      (planIdentity.HasDrupalPortal &&
                        planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    )
                  "
                >
                  <no-autocomplete-textfield
                    :label="$t('components.addmemberwizard.confirm_work_email')"
                    v-model="confirmWorkEmail"
                    :rules="
                      [rules.confirmContactInfoWorkEmail].concat(
                        columnRules(headersDictionary['Work Email'])
                      )
                    "
                    :class="
                      headersDictionary['Work Email'].isOptional === false
                        ? 'required'
                        : []
                    "
                    @paste="onConfirmEmailPaste"
                  ></no-autocomplete-textfield>
                </div>

                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Home Email') ===
                      -1 &&
                    Object.keys(headersDictionary).indexOf('Work Email') ===
                      -1 &&
                    Object.keys(headersDictionary).indexOf('Email') > -1
                  "
                >
                  <no-autocomplete-textfield
                    ref="homeEmail"
                    :disabled="
                      (planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Email')"
                    v-model="contactInfo.HomeEmail"
                    :rules="
                      [rules.confirmContactInfoHomeEmail].concat(
                        columnRules(headersDictionary['Email'])
                      )
                    "
                    :class="
                      headersDictionary['Email'].isOptional === false
                        ? 'required'
                        : []
                    "
                    @paste="onHomeEmailPaste"
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Home Email') ===
                      -1 &&
                    Object.keys(headersDictionary).indexOf('Work Email') ===
                      -1 &&
                    Object.keys(headersDictionary).indexOf('Email') > -1 &&
                    !(
                      (planIdentity.MembersPortal !== undefined &&
                        planIdentity.MembersPortal !== null &&
                        planIdentity.MembersPortal.IsActive) ||
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    )
                  "
                >
                  <no-autocomplete-textfield
                    :label="$t('components.addmemberwizard.confirm_email')"
                    v-model="confirmHomeEmail"
                    :rules="
                      [rules.confirmContactInfoHomeEmail].concat(
                        columnRules(headersDictionary['Email'])
                      )
                    "
                    :class="
                      headersDictionary['Email'].isOptional === false
                        ? 'required'
                        : []
                    "
                    @paste="onConfirmEmailPaste"
                  ></no-autocomplete-textfield>
                </div>
              </div>
            </v-form>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.contactInfo = false;
              contactInfo = null;
              contactInfoEffectiveDate = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="
              !isContactInfoValid() ||
              !contactInfoEffectiveDate ||
              !(
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              )
            "
            color="primary"
            @click="saveContactInfo"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.unionLocal"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="dialogs.unionLocal"
        :title="$t('views.unionlocals.edit_union_local_{0}', [getName()])"
        icon="mdi-lan"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.unionLocal" ref="unionLocalForm">
            <div class="row">
              <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :disabled="loading"
                  :label="$t('headers.members_management.Effective Date')"
                  :value="unionLocalEffectiveDate"
                  @update-date="unionLocalEffectiveDate = $event"
                  :allowedDates="coverageAllowedDates"
                  :class="'required'"
                  :rules="[$rules.required, rules.coverageEffectiveDate]"
                ></pbas-date-picker>
              </div>
              <template v-if="unionLocal && unionLocalEffectiveDate">
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="selectedPlan.PlanType === 'Pension'"
                >
                  <trans-select
                    :item="unionLocal"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Union Local Home') >
                    -1
                  "
                >
                  <trans-select2
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="
                      headersDictionary['Union Local Home'].isOptional
                    "
                    v-model="unionLocal"
                    propertyName="UnionLocalHome"
                    transPropertyName="Current"
                    :items="unionLocals"
                    :label="$t('headers.members_management.Union Local Home')"
                    field="Name"
                    itemValue="Id"
                    :class="
                      headersDictionary['Union Local Home'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Union Local Home'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select2>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Union Local Work') >
                    -1
                  "
                >
                  <trans-select2
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :clearable="
                      headersDictionary['Union Local Work'].isOptional
                    "
                    v-model="unionLocal"
                    propertyName="UnionLocalWork"
                    transPropertyName="Current"
                    :items="unionLocals"
                    :label="$t('headers.members_management.Union Local Work')"
                    field="Name"
                    itemValue="Id"
                    :class="
                      headersDictionary['Union Local Work'].isOptional === false
                        ? 'required'
                        : []
                    "
                    :rules="
                      headersDictionary['Union Local Work'].isOptional === false
                        ? [$rules.required]
                        : []
                    "
                  ></trans-select2>
                </div>
              </template>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.unionLocal = false;
              unionLocal = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="
              !valid.unionLocal ||
              !unionLocalEffectiveDate ||
              !(
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              )
            "
            color="primary"
            @click="saveUnionLocal"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="dialogs.deleteDirectDeposit"
      persistent
      max-width="400"
      scrollable
    >
      <material-card
        :title="
          $t(
            'components.membersmanagementtable.confirm_delete_direct_deposit_{0}',
            [getName()]
          )
        "
        icon="person_remove"
        :color="$vuetify.theme.themes.light.error"
        v-if="dialogs.deleteDirectDeposit"
      >
        <v-card-text>
          {{
            $t(
              "components.membersmanagementtable.confirm_delete_direct_deposit"
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.deleteDirectDeposit = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="tryDeleteDirectDeposit()"
          >
            {{ $t("components.memberview.delete_direct_deposit_information") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="dialogs.directDeposit"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="dialogs.directDeposit"
        :title="
          $t('components.memberview.edit_direct_deposit_info_{0}', [getName()])
        "
        icon="edit"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid.directDeposit" ref="directDepositForm">
            <div class="row">
              <!-- <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :disabled="loading"
                  :label="$t('headers.members_management.Effective Date')"
                  :value="directDepositEffectiveDate"
                  @update-date="directDepositEffectiveDate = $event"
                  :allowedDates="coverageAllowedDates"
                  :class="'required'"
                  :rules="[$rules.required, rules.coverageEffectiveDate]"
                ></pbas-date-picker>
              </div> -->
              <template v-if="directDeposit && directDepositEffectiveDate">
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="selectedPlan.PlanType === 'Pension'"
                >
                  <trans-select
                    :item="directDeposit"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Institution Number'
                    ) > -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Institution Number')"
                    v-model="directDeposit.InstitutionNumber"
                    :rules="
                      [$rules.canadianBankInstitutionNumber].concat(
                        columnRules(headersDictionary['Institution Number'])
                      )
                    "
                    :class="
                      headersDictionary['Institution Number'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Account Number') >
                    -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Account Number')"
                    v-model="directDeposit.AccountNumber"
                    :rules="
                      [$rules.canadianBankAccountNumber].concat(
                        columnRules(headersDictionary['Account Number'])
                      )
                    "
                    :class="
                      headersDictionary['Account Number'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Transit Number') >
                    -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      !(
                        role.indexOf('Broker Plan Manager') > -1 ||
                        role.indexOf('Broker Plan Admin') > -1 ||
                        role.indexOf('Employer Plan Admin') > -1
                      )
                    "
                    :label="$t('headers.members_management.Transit Number')"
                    v-model="directDeposit.TransitNumber"
                    :rules="
                      [$rules.canadianBankTransitNumber].concat(
                        columnRules(headersDictionary['Transit Number'])
                      )
                    "
                    :class="
                      headersDictionary['Transit Number'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Verify Direct Deposit'
                    ) > -1
                  "
                >
                  <v-checkbox
                    :label="
                      $t('headers.members_management.Verify Direct Deposit')
                    "
                    v-model="directDeposit.VerifyDirectDeposit"
                  ></v-checkbox>
                </div>
              </template>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.directDeposit = false;
              directDeposit = null;
              directDepositEffectiveDate = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="
              !valid.directDeposit ||
              !directDepositEffectiveDate ||
              !(
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              )
            "
            color="primary"
            @click="validateDirectDeposit"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="cobDialog" persistent max-width="800">
      <material-card
        v-if="selectedBenefit && selectedBenefit.COB"
        :title="trans2(selectedBenefit.CoverageIdentity.Current, 'Name')"
        :color="$vuetify.theme.themes.light.success"
        icon="done"
      >
        <v-card-text>
          <v-form v-model="valid.cob">
            <div class="row">
              <div class="col-12 col-md-4">
                <no-autocomplete-textfield
                  :label="$t('globals.insurance_carrier')"
                  v-model="selectedBenefit.COB.InsuranceCarrier"
                ></no-autocomplete-textfield>
              </div>
              <div class="col-12 col-md-4">
                <no-autocomplete-textfield
                  :label="$t('components.addmemberwizard.policy_no')"
                  v-model="selectedBenefit.COB.PolicyNumber"
                ></no-autocomplete-textfield>
              </div>
              <div
                class="col-12 col-md-4"
                v-if="dialogs.employmentInfo === false"
              >
                <pbas-date-picker
                  :label="$t('components.inmemorydependants.effective_date')"
                  :value="selectedBenefit.COB.EffectiveDate"
                  @update-date="selectedBenefit.COB.EffectiveDate = $event"
                  class="required"
                  :rules="[$rules.required]"
                ></pbas-date-picker>
              </div>
              <!-- <div class="col-12 col-md-4" v-if="selectedPlan.PlanType === 'Pension'">
                  <trans-select
                    :item="selectedBenefit.COB"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div> -->
              <div
                class="col-12 col-md-4"
                v-if="
                  selectedBenefit.CoverageIdentity.CoverageType === 'Health'
                "
              >
                <v-autocomplete
                  v-model="selectedBenefit.COB.HealthCobTypes"
                  :items="options.Enums.HealthCobType"
                  :label="$t('components.addmemberwizard.covered_benefits')"
                  multiple
                  class="required"
                  :rules="[$rules.atLeastOne]"
                  :item-text="(item) => $t('enums.' + item)"
                >
                  <!-- <template v-slot:selection="data">
                      {{ $t("enums." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content
                        v-text="$t('enums.' + data.item)"
                      ></v-list-item-content>
                    </template> -->
                </v-autocomplete>
              </div>
              <div class="col-12 col-md-4">
                <trans-select
                  :item="selectedBenefit.COB"
                  propertyName="CoverageStatus"
                  :items="options.Models.FamilyStatus"
                  :label="$t('components.addmemberwizard.coverage_status')"
                  :multiple="false"
                ></trans-select>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="cobDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :disabled="!valid.cob" color="primary" @click="saveCob">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="removeCobDialog" persistent max-width="400">
      <material-card
        v-if="selectedBenefit"
        :title="$t('components.memberview.remove_cob')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="removeCobDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="removeCob">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="editCoverageDialog"
      persistent
      max-width="800"
    >
      <material-card
        v-if="selectedBenefit"
        :title="trans2(selectedBenefit.CoverageIdentity.Current, 'Name')"
        :color="$vuetify.theme.themes.light.success"
        icon="done"
      >
        <v-card-text>
          <v-form v-model="valid.editCoverage">
            <div class="row">
              <div
                class="col-12 col-md-4"
                v-if="
                  selectedBenefit &&
                  selectedBenefit.CoverageIdentity.Current.HasCoverageChoice
                "
              >
                <trans-select
                  :disabled="
                    selectedBenefit.CoverageIdentity.Current
                      .RestrictToDefaultCoverageStatus
                  "
                  :item="selectedBenefit"
                  propertyName="CoverageStatus"
                  :items="selectableFamilyStatuses"
                  :label="$t('headers.members_management.Family Status')"
                  :rules="[$rules.required]"
                  :multiple="false"
                  class="required"
                ></trans-select>
              </div>
              <div
                class="col-12 col-md-4"
                v-if="
                  selectedBenefit &&
                  selectedBenefit.CoverageStatus &&
                  selectedBenefit.CoverageStatus.Name !== 'Single' &&
                  tracksDependantsByNumber(selectedBenefit)
                "
              >
                <auto-select
                  :rules="[$rules.requiredNum]"
                  class="required"
                  :label="$t('headers.members_management.No Of Dependants')"
                  :value.sync="selectedBenefit.NoOfDependants"
                  :items="
                    selectableNoOfDependants(selectedBenefit.CoverageStatus)
                  "
                  return-object
                ></auto-select>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="
                  selectedBenefit &&
                  selectedBenefit.CoverageStatus &&
                  selectedBenefit.CoverageStatus.Name !== 'Single' &&
                  tracksDependantsByName(selectedBenefit)
                "
              >
                <auto-select
                  :value.sync="selectedBenefit.Dependants"
                  :items="dependantsProvider.items"
                  :label="$t('globals.dependants')"
                  :rules="[$rules.atLeastOne]"
                  class="required"
                  :slots="true"
                  :filter="filterFunc"
                  item-value="IdentityId"
                  multiple
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeDependant(data.item)"
                    >
                      {{ data.item.FirstName + " " + data.item.LastName }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="
                            data.item.FirstName + ' ' + data.item.LastName
                          "
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="trans(data.item.Relationship)"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                  <!-- <template v-slot:selection="data">{{ data.item.FirstName + ' ' + data.item.LastName }}</template>
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.FirstName + ' ' + data.item.LastName"></v-list-item-content>
                    </template> -->
                </auto-select>
              </div>
              <div
                class="col-12 col-md-4"
                v-if="selectedBenefit.CoverageIdentity.Current.HasVolumeChoice"
              >
                <currency-textfield
                  v-model="selectedBenefit.Volume"
                  :label="$t('components.plancreationwizard.volume')"
                  :rules="[$rules.required, rules.minmax(selectedBenefit)]"
                  class="required"
                />
                <!-- <no-autocomplete-textfield
                  :label="$t('components.plancreationwizard.volume')"
                  v-model="selectedBenefit.Volume"
                  prefix="$"
                  @keydown="currencyKeydown"
                  @keyup="currencyKeyUp"
                  :rules="[$rules.required, rules.minmax(selectedBenefit)]"
                  class="required"
                ></no-autocomplete-textfield> -->
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="editCoverageDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.editCoverage"
            color="primary"
            @click="saveCob"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.reinstate"
      persistent
      max-width="1380"
    >
      <material-card
        v-if="dialogs.reinstate"
        :title="
          isRehire && (hasCoverageCommencementRulesPlan || planIdentity.HasEligibilityBank)
            ? $t('components.memberview.rehire_{0}', [getName()])
            : $t('components.memberview.reinstate_{0}', [getName()])
        "
        icon="account_circle"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text style="padding: 0 !important">
          <v-stepper v-model="step" vertical class="elevation-0">
            <v-stepper-step :complete="step > 1" :step="1">
              {{ $t("components.memberview.select_effective_date") }}
            </v-stepper-step>
            <v-stepper-content :step="1">
              <v-card>
                <v-card-text>
                  <v-form v-model="reinstateEffectiveDateValid">
                    <div class="row">
                      <div class="col-12 col-md-4 col-lg-3">
                        <pbas-date-picker
                          :disabled="loading"
                          :label="
                            $t('headers.members_management.Effective Date')
                          "
                          :value="reinstateEffectiveDate"
                          @update-date="reinstateEffectiveDate = $event"
                          :allowedDates="coverageAllowedDates"
                          :class="'required'"
                          :rules="[
                            $rules.required,
                            rules.coverageEffectiveDate,
                          ]"
                        ></pbas-date-picker>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="selectedPlan.PlanType === 'Pension'"
                      >
                        <trans-select
                          :item="reinstateItem"
                          propertyName="SourceOfInformation"
                          :items="options.Models.SourceOfInformation"
                          :label="$t('globals.source_of_information')"
                        ></trans-select>
                      </div>
                    </div>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-flex>
                    <v-btn
                      :loading="loading"
                      :disabled="!reinstateEffectiveDateValid"
                      color="primary"
                      @click="step = 2"
                    >
                      {{ $t("globals.continue") }}
                    </v-btn>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-step :complete="step > 2" :step="2">
              {{ $t("components.memberview.edit_personal_info") }}
            </v-stepper-step>
            <v-stepper-content :step="2">
              <v-card>
                <v-card-text>
                  <v-form v-model="valid.personalInfo2" ref="personalInfoForm2">
                    <div class="row" v-if="reinstateItem.CurrentMember">
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Title') > -1
                        "
                      >
                        <trans-select
                          :clearable="headersDictionary['Title'].isOptional"
                          :item="reinstateItem.CurrentMember"
                          propertyName="Title"
                          :items="sortedTitle"
                          :label="$t('headers.members_management.Title')"
                          :class="
                            headersDictionary['Title'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Title'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('First Name') >
                          -1
                        "
                      >
                        <no-autocomplete-textfield
                          :label="$t('headers.members_management.First Name')"
                          v-model="reinstateItem.CurrentMember.FirstName"
                          :rules="columnRules(headersDictionary['First Name'])"
                          :class="
                            headersDictionary['First Name'].isOptional === false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Middle Name'
                          ) > -1
                        "
                      >
                        <no-autocomplete-textfield
                          :label="$t('headers.members_management.Middle Name')"
                          v-model="reinstateItem.CurrentMember.MiddleName"
                          :rules="columnRules(headersDictionary['Middle Name'])"
                          :class="
                            headersDictionary['Middle Name'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Last Name') >
                          -1
                        "
                      >
                        <no-autocomplete-textfield
                          :label="$t('headers.members_management.Last Name')"
                          v-model="reinstateItem.CurrentMember.LastName"
                          :rules="columnRules(headersDictionary['Last Name'])"
                          :class="
                            headersDictionary['Last Name'].isOptional === false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Pronoun') > -1
                        "
                      >
                        <trans-select
                          :clearable="headersDictionary['Pronoun'].isOptional"
                          :item="reinstateItem.CurrentMember"
                          propertyName="Pronoun"
                          :items="sortedPronoun"
                          :label="$t('headers.members_management.Pronoun')"
                          :class="
                            headersDictionary['Pronoun'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Pronoun'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Suffix') > -1
                        "
                      >
                        <trans-select
                          :clearable="headersDictionary['Suffix'].isOptional"
                          :item="reinstateItem.CurrentMember"
                          propertyName="Suffix"
                          :items="sortedSuffix"
                          :label="$t('headers.members_management.Suffix')"
                          :class="
                            headersDictionary['Suffix'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Suffix'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('SIN') > -1
                        "
                      >
                        <no-autocomplete-textfield
                          v-if="
                            reinstateItem.MemberIdentification.SIN === null ||
                            reinstateItem.MemberIdentification.SIN === undefined
                          "
                          disabled
                          :label="$t('headers.members_management.SIN')"
                          v-model="
                            reinstateItem.MemberIdentification.TemporarySIN
                          "
                          :rules="
                            [$rules.sin].concat(
                              columnRules(headersDictionary['SIN'])
                            )
                          "
                          :class="
                            headersDictionary['SIN'].isOptional === false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                        <no-autocomplete-textfield
                          v-else
                          disabled
                          :label="$t('headers.members_management.SIN')"
                          v-model="reinstateItem.MemberIdentification.SIN"
                          :rules="
                            [$rules.sin].concat(
                              columnRules(headersDictionary['SIN'])
                            )
                          "
                          :class="
                            headersDictionary['SIN'].isOptional === false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Membership Id'
                          ) > -1
                        "
                      >
                        <no-autocomplete-textfield
                          disabled
                          :label="
                            $t('headers.members_management.Membership Id')
                          "
                          v-model="
                            reinstateItem.MemberIdentification
                              .PensionMembershipId
                          "
                          :rules="
                            columnRules(headersDictionary['Membership Id'])
                          "
                          :class="
                            headersDictionary['Membership Id'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Certificate'
                          ) > -1
                        "
                      >
                        <no-autocomplete-textfield
                          disabled
                          :label="$t('headers.members_management.Certificate')"
                          v-model="
                            reinstateItem.MemberIdentification.Certificate
                          "
                          :rules="columnRules(headersDictionary['Certificate'])"
                          :class="
                            headersDictionary['Certificate'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Date Of Birth'
                          ) > -1
                        "
                      >
                        <pbas-date-picker
                          :label="
                            $t('headers.members_management.Date Of Birth')
                          "
                          :value="reinstateItem.CurrentMember.DateOfBirth"
                          @update-date="
                            reinstateItem.CurrentMember.DateOfBirth = $event
                          "
                          :rules="
                            headersDictionary['Date Of Birth'].isOptional ===
                            false
                              ? [$rules.required, $rules.dateOfBirth]
                              : [$rules.dateOfBirth]
                          "
                          :class="
                            headersDictionary['Date Of Birth'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                          :allowedDates="dateOfBirthDates"
                        ></pbas-date-picker>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Gender') > -1
                        "
                      >
                        <trans-select
                          :clearable="headersDictionary['Gender'].isOptional"
                          :item="reinstateItem.CurrentMember"
                          propertyName="Gender"
                          :items="sortedGender"
                          :label="$t('headers.members_management.Gender')"
                          :class="
                            headersDictionary['Gender'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Gender'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Smoker') > -1
                        "
                      >
                        <v-checkbox
                          :label="$t('headers.members_management.Smoker')"
                          v-model="reinstateItem.CurrentMember.IsSmoker"
                        ></v-checkbox>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Has Eligible Dependants'
                          ) > -1
                        "
                      >
                        <v-checkbox
                          :label="
                            $t(
                              'headers.members_management.Has Eligible Dependants'
                            )
                          "
                          v-model="
                            reinstateItem.CurrentMember.HasEligibleDependants
                          "
                        ></v-checkbox>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Marital Status'
                          ) > -1
                        "
                      >
                        <trans-select
                          :clearable="
                            headersDictionary['Marital Status'].isOptional
                          "
                          :item="reinstateItem.CurrentMember"
                          propertyName="MaritalStatus"
                          :items="sortedMaritalStatus"
                          :label="
                            $t('headers.members_management.Marital Status')
                          "
                          :class="
                            headersDictionary['Marital Status'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Marital Status'].isOptional ===
                            false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'ProvinceOfResidence'
                          ) > -1
                        "
                      >
                        <trans-select
                          :clearable="
                            headersDictionary['ProvinceOfResidence'].isOptional
                          "
                          :item="reinstateItem.CurrentMember"
                          propertyName="ProvinceOfResidence"
                          :items="sortedProvince"
                          :label="
                            $t('headers.members_management.ProvinceOfResidence')
                          "
                          :class="
                            headersDictionary['ProvinceOfResidence']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['ProvinceOfResidence']
                              .isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'ProvinceOfEmployment'
                          ) > -1
                        "
                      >
                        <trans-select
                          :clearable="
                            headersDictionary['ProvinceOfEmployment'].isOptional
                          "
                          :item="reinstateItem.CurrentMember"
                          propertyName="ProvinceOfEmployment"
                          :items="sortedProvince"
                          :label="
                            $t(
                              'headers.members_management.ProvinceOfEmployment'
                            )
                          "
                          :class="
                            headersDictionary['ProvinceOfEmployment']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['ProvinceOfEmployment']
                              .isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Tax Exemption'
                          ) > -1
                        "
                      >
                        <v-checkbox
                          :label="
                            $t('headers.members_management.Tax Exemption')
                          "
                          v-model="reinstateItem.CurrentMember.TaxExemption"
                        ></v-checkbox>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Enrollement Signed At'
                          ) > -1
                        "
                      >
                        <pbas-date-picker
                          disabled
                          :label="
                            $t(
                              'headers.members_management.Enrollement Signed At'
                            )
                          "
                          :value="
                            reinstateItem.MemberEnrolment.EnrollmentSignedAt
                          "
                          @update-date="
                            reinstateItem.MemberEnrolment.EnrollmentSignedAt =
                              $event
                          "
                          :rules="
                            headersDictionary['Enrollement Signed At']
                              .isOptional === false
                              ? [$rules.required, rules.bothCompletedReinstate]
                              : [rules.bothCompletedReinstate]
                          "
                          :class="
                            headersDictionary['Enrollement Signed At']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                        ></pbas-date-picker>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Enrollement Received At'
                          ) > -1
                        "
                      >
                        <pbas-date-picker
                          disabled
                          :label="
                            $t(
                              'headers.members_management.Enrollement Received At'
                            )
                          "
                          :value="
                            reinstateItem.MemberEnrolment.EnrollmentReceivedAt
                          "
                          @update-date="
                            reinstateItem.MemberEnrolment.EnrollmentReceivedAt =
                              $event
                          "
                          :rules="
                            headersDictionary['Enrollement Received At']
                              .isOptional === false
                              ? [$rules.required, rules.bothCompletedReinstate]
                              : [rules.bothCompletedReinstate]
                          "
                          :class="
                            headersDictionary['Enrollement Received At']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                        ></pbas-date-picker>
                      </div>
                    </div>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-flex>
                    <v-btn text @click="step = 1">
                      {{ $t("globals.back") }}
                    </v-btn>
                    <v-btn
                      :loading="loading"
                      :disabled="!valid.personalInfo2"
                      color="primary"
                      @click="step = 3"
                    >
                      {{ $t("globals.continue") }}
                    </v-btn>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-step :complete="step > 3" :step="3">
              {{ $t("components.memberview.edit_employment_info") }}
            </v-stepper-step>
            <v-stepper-content :step="3">
              <v-card>
                <v-card-text>
                  <v-form
                    v-model="valid.employmentInfo2"
                    ref="employmentInfoForm2"
                  >
                    <div
                      class="row"
                      v-if="reinstateItem.CurrentEmploymentInformation"
                    >
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Employer') >
                          -1
                        "
                      >
                        <auto-select
                          v-model="
                            reinstateItem.CurrentEmploymentInformation.Employer
                          "
                          :items="employers"
                          :label="$t('headers.members_management.Employer')"
                          item-value="Id"
                          :item-text="(item) => trans2(item.Current, 'Name')"
                          :class="
                            headersDictionary['Employer'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Employer'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></auto-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Store') >
                            -1 &&
                          stores &&
                          stores.length > 0
                        "
                      >
                        <auto-select
                          v-model="
                            reinstateItem.CurrentEmploymentInformation.Store
                          "
                          :items="stores"
                          :label="$t('headers.members_management.Store')"
                          item-value="Id"
                          :item-text="(item) => trans2(item.Current, 'Name')"
                          :class="
                            headersDictionary['Store'].isOptional === false ||
                            (stores.length > 0 && planOptions.HasStores)
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Store'].isOptional === false ||
                            (stores.length > 0 && planOptions.HasStores)
                              ? [$rules.required]
                              : []
                          "
                        ></auto-select>
                        <!-- <trans-select2
                          v-model="reinstateItem.CurrentEmploymentInformation"
                          propertyName="Store"
                          transPropertyName="Current"
                          :items="stores"
                          :label="$t('headers.members_management.Store')"
                          field="Name"
                          itemValue="IdentityId"
                          :class="
                            headersDictionary['Store'].isOptional === false ||
                            (stores.length > 0 && planOptions.HasStores)
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Store'].isOptional === false ||
                            (stores.length > 0 && planOptions.HasStores)
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select2> -->
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Hire Date') >
                          -1
                        "
                      >
                        <pbas-date-picker
                          :label="$t('headers.members_management.Hire Date')"
                          :value="
                            reinstateItem.CurrentEmploymentInformation.HireDate
                          "
                          @update-date="
                            reinstateItem.CurrentEmploymentInformation.HireDate =
                              $event
                          "
                          :class="
                            headersDictionary['Hire Date'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Hire Date'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                          :disabled="isRehire && (hasCoverageCommencementRulesPlan || planIdentity.HasEligibilityBank)"
                        ></pbas-date-picker>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Employer Contribution'
                          ) > -1
                        "
                      >
                        <no-autocomplete-textfield
                          :label="
                            $t(
                              'headers.members_management.Employer Contribution'
                            )
                          "
                          v-model="
                            reinstateItem.CurrentEmploymentInformation
                              .EmployerContribution
                          "
                          :rules="
                            columnRules(
                              headersDictionary['Employer Contribution']
                            )
                          "
                          :class="
                            headersDictionary['Employer Contribution']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Employee Number'
                          ) > -1
                        "
                      >
                        <no-autocomplete-textfield
                          :label="
                            $t('headers.members_management.Employee Number')
                          "
                          v-model="
                            reinstateItem.CurrentEmploymentInformation
                              .EmployeeNumber
                          "
                          :rules="
                            columnRules(headersDictionary['Employee Number'])
                          "
                          :class="
                            headersDictionary['Employee Number'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Occupation') >
                          -1
                        "
                      >
                        <auto-select
                          ref="occupation"
                          @keydown="occupationKeyDown"
                          clear-icon="clear"
                          :clearable="
                            headersDictionary['Occupation'].isOptional
                          "
                          :label="$t('headers.members_management.Occupation')"
                          :value.sync="
                            reinstateItem.CurrentEmploymentInformation
                              .Occupation
                          "
                          :items="occupations"
                          :class="
                            headersDictionary['Occupation'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Occupation'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></auto-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Employment Type'
                          ) > -1
                        "
                      >
                        <trans-select
                          :clearable="
                            headersDictionary['Employment Type'].isOptional
                          "
                          :item="reinstateItem.CurrentEmploymentInformation"
                          propertyName="EmploymentType"
                          :items="sortedEmploymentType"
                          :label="
                            $t('headers.members_management.Employment Type')
                          "
                          :class="
                            headersDictionary['Employment Type'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Employment Type'].isOptional ===
                            false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Employment Frequency'
                          ) > -1
                        "
                      >
                        <trans-select
                          :clearable="
                            headersDictionary['Employment Frequency'].isOptional
                          "
                          :item="reinstateItem.CurrentEmploymentInformation"
                          propertyName="EmploymentFrequency"
                          :items="sortedEmploymentFrequency"
                          :label="
                            $t(
                              'headers.members_management.Employment Frequency'
                            )
                          "
                          :class="
                            headersDictionary['Employment Frequency']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Employment Frequency']
                              .isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'WeeklyHours'
                          ) > -1
                        "
                      >
                        <no-autocomplete-textfield
                          type="text"
                          :label="$t('headers.members_management.WeeklyHours')"
                          v-model="
                            reinstateItem.CurrentEmploymentInformation
                              .WeeklyHours
                          "
                          :class="
                            headersDictionary['WeeklyHours'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                          :rules="columnRules(headersDictionary['WeeklyHours'])"
                        ></no-autocomplete-textfield>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Earnings') >
                          -1
                        "
                      >
                        <currency-textfield
                          v-model="
                            reinstateItem.CurrentEmploymentInformation.Earnings
                          "
                          :label="$t('headers.members_management.Earnings')"
                          :class="
                            headersDictionary['Earnings'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Earnings'].isOptional === false
                              ? [$rules.requiredNum]
                              : []
                          "
                        />
                        <!-- <no-autocomplete-textfield
                          @blur="earningsBlur"
                          :label="$t('headers.members_management.Earnings')"
                          v-model="
                            reinstateItem.CurrentEmploymentInformation.Earnings
                          "
                          prefix="$"
                          @keydown="currencyKeydown"
                          @keyup="currencyKeyUp"
                          :class="
                            headersDictionary['Earnings'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Earnings'].isOptional === false
                              ? [$rules.requiredNum, $rules.decimal]
                              : [$rules.decimal]
                          "
                        ></no-autocomplete-textfield> -->
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Second Income Earnings Frequency'
                          ) > -1
                        "
                      >
                        <trans-select
                          :clearable="
                            headersDictionary[
                              'Second Income Earnings Frequency'
                            ].isOptional
                          "
                          :item="reinstateItem.CurrentEmploymentInformation"
                          propertyName="SecondIncomeEarningsFrequency"
                          :items="options.Models.SecondIncomeEarningsFrequency"
                          :label="
                            $t(
                              'headers.members_management.Second Income Earnings Frequency'
                            )
                          "
                          :class="
                            headersDictionary[
                              'Second Income Earnings Frequency'
                            ].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary[
                              'Second Income Earnings Frequency'
                            ].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Second Income Type'
                          ) > -1
                        "
                      >
                        <trans-select
                          :clearable="
                            headersDictionary['Second Income Type'].isOptional
                          "
                          :item="reinstateItem.CurrentEmploymentInformation"
                          propertyName="SecondIncomeType"
                          :items="sortedSecondIncomeType"
                          :label="
                            $t('headers.members_management.Second Income Type')
                          "
                          :class="
                            headersDictionary['Second Income Type']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Second Income Type']
                              .isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Second Income Earnings'
                          ) > -1
                        "
                      >
                        <currency-textfield
                          v-model="
                            reinstateItem.CurrentEmploymentInformation
                              .SecondIncomeEarnings
                          "
                          :label="
                            $t(
                              'headers.members_management.Second Income Earnings'
                            )
                          "
                          :class="
                            headersDictionary['Second Income Earnings']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Second Income Earnings']
                              .isOptional === false
                              ? [$rules.requiredNum]
                              : []
                          "
                        />
                        <!-- <no-autocomplete-textfield
                          :label="
                            $t(
                              'headers.members_management.Second Income Earnings'
                            )
                          "
                          v-model="
                            reinstateItem.CurrentEmploymentInformation
                              .SecondIncomeEarnings
                          "
                          prefix="$"
                          @keydown="currencyKeydown"
                          @keyup="currencyKeyUp"
                          :class="
                            headersDictionary['Second Income Earnings']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Second Income Earnings']
                              .isOptional === false
                              ? [$rules.requiredNum, $rules.decimal2]
                              : [$rules.decimal2]
                          "
                        ></no-autocomplete-textfield> -->
                      </div>
                    </div>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-flex>
                    <v-btn text @click="step = 2">
                      {{ $t("globals.back") }}
                    </v-btn>
                    <v-btn
                      v-if="!(isRehire && (hasCoverageCommencementRulesPlan || planIdentity.HasEligibilityBank))"
                      :loading="loading"
                      :disabled="!valid.employmentInfo2"
                      color="primary"
                      @click="step = 4"
                    >
                      {{ $t("globals.continue") }}
                    </v-btn>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-step
              :complete="step > 4"
              :step="4"
              v-if="!(isRehire && (hasCoverageCommencementRulesPlan || planIdentity.HasEligibilityBank))"
            >
              {{ $t(`components.memberview.view_edit_coverage_title`) }}
            </v-stepper-step>
            <v-stepper-content
              :step="4"
              v-if="!(isRehire && (hasCoverageCommencementRulesPlan || planIdentity.HasEligibilityBank))"
            >
              <v-card>
                <v-card-title>
                  {{ $t("components.memberview.coverage_choice") }}
                </v-card-title>
                <v-card-text>
                  <v-form v-model="valid.coverage2" ref="coverageForm2">
                    <div
                      class="col-12 col-md-4 col-lg-3"
                      v-if="planIdentity.Current.HasBenefitYears"
                    >
                      <v-autocomplete
                        :label="$t('components.addmemberwizard.benefit_year')"
                        v-model="
                          reinstateItem.CurrentMemberBenefitYear.StartMonth
                        "
                        :rules="[$rules.requiredInteger]"
                        class="required"
                        :items="$helpers.months()"
                        :item-text="(item) => $t('months.' + item.text)"
                      ></v-autocomplete>
                    </div>
                    <div
                      class="row"
                      v-if="reinstateItem.CurrentMembershipStatus"
                    >
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Default Coverage Status'
                          ) > -1
                        "
                      >
                        <trans-select
                          :clearable="
                            headersDictionary['Default Coverage Status']
                              .isOptional
                          "
                          :item="reinstateItem.CurrentMembershipStatus"
                          propertyName="DefaultCoverageStatus"
                          :items="sortedFamilyStatus"
                          :label="
                            $t(
                              'headers.members_management.Default Coverage Status'
                            )
                          "
                          :class="
                            headersDictionary['Default Coverage Status']
                              .isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Default Coverage Status']
                              .isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></trans-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Termination Date'
                          ) > -1
                        "
                      >
                        <pbas-date-picker
                          :label="
                            $t('headers.members_management.Termination Date')
                          "
                          @update-date="
                            reinstateItem.CoverageExpiryDate = $event;
                            $forceUpdate();
                          "
                          :allowedDates="coverageExpireReinstateAllowedDates"
                          :class="
                            headersDictionary['Termination Date'].isOptional ===
                            false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Termination Date'].isOptional ===
                            false
                              ? [
                                  $rules.required,
                                  rules.coverageExpireReinstateDate,
                                ]
                              : [rules.coverageExpireReinstateDate]
                          "
                        ></pbas-date-picker>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          reinstateItem.CoverageExpiryDate !== null &&
                          reinstateItem.CoverageExpiryDate !== undefined &&
                          reinstateItem.CoverageExpiryDate !== '' &&
                          Object.keys(headersDictionary).indexOf(
                            'Termination Status'
                          ) > -1
                        "
                      >
                        <trans-enum
                          :value.sync="reinstateItem.CoverageExpiryReason"
                          :items="options.Enums.TerminationStatus"
                          :label="
                            $t(
                              'components.addmemberwizard.coverage_expiry_reason'
                            )
                          "
                          class="required"
                          :rules="[$rules.required]"
                        ></trans-enum>
                      </div>

                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf('Class') > -1
                        "
                      >
                        <auto-select
                          clear-icon="clear"
                          :clearable="headersDictionary['Class'].isOptional"
                          :label="$t('headers.members_management.Class')"
                          :value.sync="
                            reinstateItem.CurrentMembershipStatus.Class
                          "
                          :items="classes"
                          :class="
                            headersDictionary['Class'].isOptional === false
                              ? 'required'
                              : []
                          "
                          :rules="
                            headersDictionary['Class'].isOptional === false
                              ? [$rules.required]
                              : []
                          "
                        ></auto-select>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="
                          Object.keys(headersDictionary).indexOf(
                            'Member Group'
                          ) > -1
                        "
                      >
                        <trans-select2
                          v-model="
                            reinstateItem.CurrentMembershipStatus
                              .MemberGroupIdentity
                          "
                          propertyName="Current"
                          :items="memberGroups"
                          :label="$t('headers.members_management.Member Group')"
                          :rules="[$rules.required]"
                          field="Name"
                          itemValue="IdentityId"
                          class="required"
                        ></trans-select2>
                      </div>
                      <div
                        class="col-12 col-md-4 col-lg-3"
                        v-if="optionalCoverage.length > 0"
                      >
                        <trans-multi-select2
                          v-model="selectedOptionalCoverage"
                          :items="optionalCoverage"
                          :label="
                            $t('components.addmemberwizard.optionalCoverage')
                          "
                          field="Name"
                          itemValue="Id"
                          transPropertyName="Current"
                          @change="optionalChangedReinstate"
                        ></trans-multi-select2>
                      </div>
                    </div>
                  </v-form>
                  <div class="row">
                    <div class="col-12 col-md-8">
                      <v-card>
                        <v-card-title>
                          {{
                            $t("components.memberview.customizable_coverage")
                          }}
                        </v-card-title>
                        <v-card-text>
                          <pbas-data-table
                            ref="benefitsTable"
                            :dataProvider="benefitsProvider"
                            :rowActions="benefitsRowActions"
                            :noSearch="true"
                            :noActions="true"
                            :showSelect="false"
                            :showActionsBtn="true"
                            @error="error = $event"
                          ></pbas-data-table>
                        </v-card-text>
                      </v-card>
                    </div>
                    <div class="col-12 col-md-4">
                      <v-card>
                        <v-card-title>
                          {{
                            $t(
                              "components.memberview.non_customizable_coverage"
                            )
                          }}
                        </v-card-title>
                        <v-card-text>
                          <pbas-data-table
                            ref="nonCustomizedBenefitsTable"
                            :dataProvider="nonCustomizedBenefitsProvider"
                            :noSearch="true"
                            :noActions="true"
                            :showSelect="false"
                            @error="error = $event"
                          ></pbas-data-table>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-flex>
                    <v-btn text @click="step = 3">
                      {{ $t("globals.back") }}
                    </v-btn>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.reinstate = false;
              reinstateItem = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving || loading"
            :disabled="
              !reinstateEffectiveDate ||
              !valid.personalInfo2 ||
              !valid.employmentInfo2 ||
              !valid.coverage2
            "
            color="primary"
            @click="tryReinstate"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <div
      class="row"
      v-if="memberIdentity !== null && memberIdentity !== undefined"
    >
      <div class="col-12 col-md-9" style="padding-top: 0">
        <material-card
          icon="info"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('components.memberview.summary_information')"
          v-if="!showDetails"
        >
          <template v-slot:actions>
            <v-btn
              @click="showDetails = true"
              color="primary"
              class="mt-2 mr-4"
            >
              {{ $t("components.memberview.view_details") }}
            </v-btn>
          </template>
          <v-card-text>
            <div class="row no-gutters">
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('First Name') > -1"
              >
                {{ $t("headers.members_management.First Name") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.CurrentMember.FirstName }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Last Name') > -1"
              >
                {{ $t("headers.members_management.Last Name") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.CurrentMember.LastName }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Certificate') > -1"
              >
                {{ $t("headers.members_management.Certificate") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.MemberIdentification.Certificate }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Membership Id') > -1"
              >
                {{ $t("headers.members_management.Membership Id") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.MemberIdentification.PensionMembershipId }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Drawbridge Id') > -1"
              >
                {{ $t("headers.members_management.Drawbridge Id") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.MemberIdentification.Certificate }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('SIN') > -1"
              >
                {{ $t("headers.members_management.SIN") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.MemberIdentification.SIN !== null &&
                    memberIdentity.MemberIdentification.SIN !== undefined
                      ? memberIdentity.MemberIdentification.SIN
                      : memberIdentity.MemberIdentification.TemporarySIN
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Date Of Birth') > -1"
              >
                {{ $t("headers.members_management.Date Of Birth") }}
                <br />
                <span class="minfo">
                  {{ formatDate(memberIdentity.CurrentMember.DateOfBirth) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Tax Exemption') > -1"
              >
                {{ $t("headers.members_management.Tax Exemption") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentMember.TaxExemption
                      ? $t("globals.yes")
                      : $t("globals.no")
                  }}
                </span>
              </div>

              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Gender') > -1"
              >
                {{ $t("headers.members_management.Gender") }}
                <br />
                <span class="minfo">
                  {{ trans(memberIdentity.CurrentMember.Gender) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  personalSectionHeaders.indexOf('Has Eligible Dependants') > -1
                "
              >
                {{ $t("headers.members_management.Has Eligible Dependants") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentMember.HasEligibleDependants
                      ? $t("globals.yes")
                      : $t("globals.no")
                  }}
                </span>
              </div>
            </div>
            <div class="row no-gutters">
              <div
                class="col-12 col-md-4 col-lg-3"
                v-if="contactSectionHeaders.indexOf('Address') > -1"
              >
                {{ $t("headers.members_management.Address") }}
                <br />
                <span class="minfo">{{ displayAddress() }}</span>
              </div>

              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="contactSectionHeaders.indexOf('Phone Number') > -1"
              >
                {{ $t("headers.members_management.Phone Number") }}
                <br />
                <span
                  v-if="memberIdentity.CurrentContactInformation"
                  class="minfo"
                >
                  {{ memberIdentity.CurrentContactInformation.PhoneNumber }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="contactSectionHeaders.indexOf('Home Email') > -1"
              >
                <span v-if="memberIdentity.PrimaryEmail === 'Home'">
                  {{
                    $t("headers.members_management.Home Email") +
                    " (" +
                    $t("globals.primary") +
                    ")"
                  }}
                </span>
                <span v-else>
                  {{ $t("headers.members_management.Home Email") }}
                </span>
                <br />
                <span
                  class="minfo"
                  v-if="memberIdentity.CurrentContactInformation"
                >
                  <a
                    :href="
                      'mailto:' +
                      memberIdentity.CurrentContactInformation.HomeEmail
                    "
                  >
                    {{ memberIdentity.CurrentContactInformation.HomeEmail }}
                  </a>
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="contactSectionHeaders.indexOf('Work Email') > -1"
              >
                <span v-if="memberIdentity.PrimaryEmail === 'Work'">
                  {{
                    $t("headers.members_management.Work Email") +
                    " (" +
                    $t("globals.primary") +
                    ")"
                  }}
                </span>
                <span v-else>
                  {{ $t("headers.members_management.Work Email") }}
                </span>
                <br />
                <span
                  class="minfo"
                  v-if="memberIdentity.CurrentContactInformation"
                >
                  <a
                    :href="
                      'mailto:' +
                      memberIdentity.CurrentContactInformation.WorkEmail
                    "
                  >
                    {{ memberIdentity.CurrentContactInformation.WorkEmail }}
                  </a>
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  contactSectionHeaders.indexOf('Home Email') === -1 &&
                  contactSectionHeaders.indexOf('Work Email') === -1 &&
                  contactSectionHeaders.indexOf('Email') > -1
                "
              >
                <span>
                  {{ $t("headers.members_management.Email") }}
                </span>
                <br />
                <span class="minfo">
                  <a :href="'mailto:' + memberIdentity.Email">
                    {{ memberIdentity.Email }}
                  </a>
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="portalAccountSectionHeaders.indexOf('Registered At') > -1"
              >
                {{ $t("headers.members_management.Registered At") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.PortalAccount &&
                    memberIdentity.PortalAccount.RegisteredAt
                      ? formatDate(memberIdentity.PortalAccount.RegisteredAt)
                      : "-"
                  }}
                </span>
              </div>
            </div>
          </v-card-text>
        </material-card>
        <material-card
          icon="account_circle"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('components.memberview.personal_information')"
          v-if="showDetails && personalSectionHeaders.length > 0"
        >
          <template v-slot:actions>
            <v-btn
              @click="showDetails = false"
              color="primary"
              class="mt-2 mr-4"
            >
              {{ $t("components.memberview.show_less") }}
            </v-btn>
          </template>
          <v-card-text>
            <div class="row">
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Title') > -1"
              >
                {{ $t("headers.members_management.Title") }}
                <br />
                <span class="minfo">
                  {{ trans(memberIdentity.CurrentMember.Title) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('First Name') > -1"
              >
                {{ $t("headers.members_management.First Name") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.CurrentMember.FirstName }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Middle Name') > -1"
              >
                {{ $t("headers.members_management.Middle Name") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.CurrentMember.MiddleName }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Last Name') > -1"
              >
                {{ $t("headers.members_management.Last Name") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.CurrentMember.LastName }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Suffix') > -1"
              >
                {{ $t("headers.members_management.Suffix") }}
                <br />
                <span class="minfo">
                  {{ trans(memberIdentity.CurrentMember.Suffix) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Pronoun') > -1"
              >
                {{ $t("headers.members_management.Pronoun") }}
                <br />
                <span class="minfo">
                  {{ trans(memberIdentity.CurrentMember.Pronoun) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Gender') > -1"
              >
                {{ $t("headers.members_management.Gender") }}
                <br />
                <span class="minfo">
                  {{ trans(memberIdentity.CurrentMember.Gender) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Date Of Birth') > -1"
              >
                {{ $t("headers.members_management.Date Of Birth") }}
                <br />
                <span class="minfo">
                  {{ formatDate(memberIdentity.CurrentMember.DateOfBirth) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Certificate') > -1"
              >
                {{ $t("headers.members_management.Certificate") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.MemberIdentification.Certificate }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('SIN') > -1"
              >
                {{ $t("headers.members_management.SIN") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.MemberIdentification.SIN }}
                </span>
              </div>

              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  personalSectionHeaders.indexOf('Has Eligible Dependants') > -1
                "
              >
                {{ $t("headers.members_management.Has Eligible Dependants") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentMember.HasEligibleDependants
                      ? $t("globals.yes")
                      : $t("globals.no")
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Marital Status') > -1"
              >
                {{ $t("headers.members_management.Marital Status") }}
                <br />
                <span class="minfo">
                  {{ trans(memberIdentity.CurrentMember.MaritalStatus) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  personalSectionHeaders.indexOf('ProvinceOfResidence') > -1
                "
              >
                {{ $t("headers.members_management.ProvinceOfResidence") }}
                <br />
                <span class="minfo">
                  {{ trans(memberIdentity.CurrentMember.ProvinceOfResidence) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  personalSectionHeaders.indexOf('ProvinceOfEmployment') > -1
                "
              >
                {{ $t("headers.members_management.ProvinceOfEmployment") }}
                <br />
                <span class="minfo">
                  {{ trans(memberIdentity.CurrentMember.ProvinceOfEmployment) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Smoker') > -1"
              >
                {{ $t("headers.members_management.Smoker") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentMember.IsSmoker
                      ? $t("globals.yes")
                      : $t("globals.no")
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="personalSectionHeaders.indexOf('Tax Exemption') > -1"
              >
                {{ $t("headers.members_management.Tax Exemption") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentMember.TaxExemption
                      ? $t("globals.yes")
                      : $t("globals.no")
                  }}
                </span>
              </div>
            </div>
          </v-card-text>
        </material-card>

        <material-card
          icon="contact_mail"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('components.memberview.contact_information')"
          v-if="showDetails"
        >
          <v-card-text>
            <div class="row">
              <template v-if="contactSectionHeaders.indexOf('Address') > -1">
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("headers.members_management.Street Number") }}
                  <br />
                  <span
                    v-if="
                      memberIdentity.CurrentContactInformation &&
                      memberIdentity.CurrentContactInformation.Address
                    "
                    class="minfo"
                  >
                    {{
                      memberIdentity.CurrentContactInformation.Address
                        .StreetNumber
                    }}
                  </span>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("headers.members_management.Street Name") }}
                  <br />
                  <span
                    v-if="
                      memberIdentity.CurrentContactInformation &&
                      memberIdentity.CurrentContactInformation.Address
                    "
                    class="minfo"
                  >
                    {{
                      memberIdentity.CurrentContactInformation.Address
                        .StreetName
                    }}
                  </span>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("headers.members_management.Suite Number") }}
                  <br />
                  <span
                    v-if="
                      memberIdentity.CurrentContactInformation &&
                      memberIdentity.CurrentContactInformation.Address
                    "
                    class="minfo"
                  >
                    {{
                      memberIdentity.CurrentContactInformation.Address
                        .SuiteNumber
                    }}
                  </span>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("headers.members_management.City") }}
                  <br />
                  <span
                    v-if="
                      memberIdentity.CurrentContactInformation &&
                      memberIdentity.CurrentContactInformation.Address
                    "
                    class="minfo"
                  >
                    {{ memberIdentity.CurrentContactInformation.Address.City }}
                  </span>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("headers.members_management.Province") }}
                  <br />
                  <template
                    v-if="
                      memberIdentity.CurrentContactInformation &&
                      memberIdentity.CurrentContactInformation.Address
                    "
                  >
                    <span
                      v-if="
                        memberIdentity.CurrentContactInformation.Address
                          .Country &&
                        !memberIdentity.CurrentContactInformation.Address
                          .Country.IsOther
                      "
                      class="minfo"
                    >
                      {{
                        memberIdentity.CurrentContactInformation.Address
                          .Province.Code
                      }}
                    </span>
                    <span v-else class="minfo">
                      {{
                        memberIdentity.CurrentContactInformation.Address
                          .OtherProvince
                      }}
                    </span>
                  </template>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("headers.members_management.Postal Code") }}
                  <br />
                  <template
                    v-if="
                      memberIdentity.CurrentContactInformation &&
                      memberIdentity.CurrentContactInformation.Address
                    "
                  >
                    <span
                      v-if="
                        memberIdentity.CurrentContactInformation.Address
                          .Country &&
                        !memberIdentity.CurrentContactInformation.Address
                          .Country.IsOther
                      "
                      class="minfo"
                    >
                      {{
                        memberIdentity.CurrentContactInformation.Address
                          .PostalCode
                      }}
                    </span>
                    <span v-else class="minfo">
                      {{
                        memberIdentity.CurrentContactInformation.Address
                          .OtherPostalCode
                      }}
                    </span>
                  </template>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("headers.members_management.Country") }}
                  <br />
                  <span
                    v-if="
                      memberIdentity.CurrentContactInformation &&
                      memberIdentity.CurrentContactInformation.Address
                    "
                    class="minfo"
                  >
                    {{
                      trans(
                        memberIdentity.CurrentContactInformation.Address.Country
                      )
                    }}
                  </span>
                </div>
              </template>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="contactSectionHeaders.indexOf('Phone Number') > -1"
              >
                {{ $t("headers.members_management.Phone Number") }}
                <br />
                <span
                  v-if="memberIdentity.CurrentContactInformation"
                  class="minfo"
                >
                  {{ memberIdentity.CurrentContactInformation.PhoneNumber }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="contactSectionHeaders.indexOf('Email') > -1"
              >
                {{ $t("headers.members_management.Email") }}
                <br />
                <span v-if="memberIdentity" class="minfo">
                  <a href="mailto:malo@gmail.com">{{ memberIdentity.Email }}</a>
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  planIdentity.MembersPortal !== undefined &&
                  planIdentity.MembersPortal !== null &&
                  planIdentity.MembersPortal.IsActive
                "
              >
                {{ $t("headers.members_management.Registered At") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.PortalAccount &&
                    memberIdentity.PortalAccount.RegisteredAt
                      ? formatDate(memberIdentity.PortalAccount.RegisteredAt)
                      : "-"
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  contactSectionHeaders.indexOf('CommunicationPreference') > -1
                "
              >
                {{ $t("headers.members_management.CommunicationPreference") }}
                <br />
                <span
                  v-if="memberIdentity.CurrentContactInformation"
                  class="minfo"
                >
                  {{
                    trans(
                      memberIdentity.CurrentContactInformation
                        .CommunicationPreference
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="contactSectionHeaders.indexOf('LanguageChoice') > -1"
              >
                {{ $t("headers.members_management.LanguageChoice") }}
                <br />
                <span
                  v-if="memberIdentity.CurrentContactInformation"
                  class="minfo"
                >
                  {{
                    trans(
                      memberIdentity.CurrentContactInformation.LanguageChoice
                    )
                  }}
                </span>
              </div>
            </div>
          </v-card-text>
        </material-card>

        <material-card
          icon="work"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('components.memberview.employment_information')"
          v-if="employmentSectionHeaders.length > 0"
        >
          <v-card-text>
            <div class="row no-gutters">
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('Employer') > -1"
              >
                {{ $t("headers.members_management.Employer") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentEmploymentInformation.Employer
                      ? trans2(
                          memberIdentity.CurrentEmploymentInformation.Employer
                            .Current,
                          "Name"
                        )
                      : ""
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('Store') > -1"
              >
                {{ $t("headers.members_management.Store") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentEmploymentInformation.Store
                      ? trans2(
                          memberIdentity.CurrentEmploymentInformation.Store
                            .Current,
                          "Name"
                        )
                      : ""
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('Hire Date') > -1"
              >
                {{ $t("headers.members_management.Hire Date") }}
                <br />
                <span class="minfo">
                  {{
                    formatDate(
                      memberIdentity.CurrentEmploymentInformation.HireDate
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('Occupation') > -1"
              >
                {{ $t("headers.members_management.Occupation") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.CurrentEmploymentInformation.Occupation }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  employmentSectionHeaders.indexOf('Employment Frequency') > -1
                "
              >
                {{ $t("headers.members_management.Employment Frequency") }}
                <br />
                <span class="minfo">
                  {{
                    trans(
                      memberIdentity.CurrentEmploymentInformation
                        .EmploymentFrequency
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('Employment Type') > -1"
              >
                {{ $t("headers.members_management.Employment Type") }}
                <br />
                <span class="minfo">
                  {{
                    trans(
                      memberIdentity.CurrentEmploymentInformation.EmploymentType
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('WeeklyHours') > -1"
              >
                {{ $t("headers.members_management.WeeklyHours") }}
                <br />
                <span class="minfo">
                  {{ memberIdentity.CurrentEmploymentInformation.WeeklyHours }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('Earnings') > -1"
              >
                {{ $t("headers.members_management.Earnings") }}
                <br />
                <span class="minfo">
                  {{
                    $helpers.formatCurrency(
                      memberIdentity.CurrentEmploymentInformation.Earnings
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('Annual Salary') > -1"
              >
                {{ $t("headers.members_management.Annual Salary") }}
                <br />
                <span class="minfo">
                  {{
                    $helpers.formatCurrency(
                      memberIdentity.CurrentEmploymentInformation.AnnualSalary
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="employmentSectionHeaders.indexOf('Employee Number') > -1"
              >
                {{ $t("headers.members_management.Employee Number") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentEmploymentInformation.EmployeeNumber
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  employmentSectionHeaders.indexOf('Employer Contribution') > -1
                "
              >
                {{ $t("headers.members_management.Employer Contribution") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentEmploymentInformation
                      .EmployerContribution
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  employmentSectionHeaders.indexOf(
                    'Second Income Earnings Frequency'
                  ) > -1
                "
              >
                {{
                  $t(
                    "headers.members_management.Second Income Earnings Frequency"
                  )
                }}
                <br />
                <span class="minfo">
                  {{
                    trans(
                      memberIdentity.CurrentEmploymentInformation
                        .SecondIncomeEarningsFrequency
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  employmentSectionHeaders.indexOf('Second Income Type') > -1
                "
              >
                {{ $t("headers.members_management.Second Income Type") }}
                <br />
                <span class="minfo">
                  {{
                    trans(
                      memberIdentity.CurrentEmploymentInformation
                        .SecondIncomeType
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  employmentSectionHeaders.indexOf('Second Income Earnings') >
                  -1
                "
              >
                {{ $t("headers.members_management.Second Income Earnings") }}
                <br />
                <span class="minfo">
                  ${{
                    memberIdentity.CurrentEmploymentInformation
                      .SecondIncomeEarnings
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  employmentSectionHeaders.indexOf('Salary Evidence Provided') >
                  -1
                "
              >
                {{ $t("headers.members_management.Salary Evidence Provided") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentEmploymentInformation
                      .SalaryEvidenceProvided
                      ? $t("globals.yes")
                      : $t("globals.no")
                  }}
                </span>
              </div>
            </div>
            <v-expansion-panels style="margin-top: 10px">
              <v-expansion-panel v-if="planIdentity && planIdentity.TrackHours">
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        schedule
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{ $t("components.memberview.hours_history") }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <member-hours-table
                    :memberId="id"
                    :employerId="
                      memberIdentity.CurrentEmploymentInformation.Employer.Id
                    "
                    @refresh-eligible="reloadMemberIdentity"
                    :memberGroupIdentityId="
                      memberIdentity.CurrentMembershipStatus !== null &&
                      memberIdentity.CurrentMembershipStatus !== undefined
                        ? memberIdentity.CurrentMembershipStatus
                            .MemberGroupIdentity.Id
                        : null
                    "
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </material-card>

        <material-card
          icon="mdi-lan"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('components.memberview.union_local_information')"
          v-if="unionLocalSectionHeaders.length > 0"
        >
          <v-card-text>
            <div class="row no-gutters">
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="unionLocalSectionHeaders.indexOf('Union Local Home') > -1"
              >
                {{ $t("headers.members_management.Union Local Home") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentUnionMembership &&
                    memberIdentity.CurrentUnionMembership.UnionLocalHome
                      ? trans2(
                          memberIdentity.CurrentUnionMembership.UnionLocalHome
                            .Current,
                          "Name"
                        )
                      : ""
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="unionLocalSectionHeaders.indexOf('Union Local Work') > -1"
              >
                {{ $t("headers.members_management.Union Local Work") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentUnionMembership &&
                    memberIdentity.CurrentUnionMembership.UnionLocalWork
                      ? trans2(
                          memberIdentity.CurrentUnionMembership.UnionLocalWork
                            .Current,
                          "Name"
                        )
                      : ""
                  }}
                </span>
              </div>
            </div>
            <v-expansion-panels style="margin-top: 10px">
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        schedule
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{ $t("components.memberview.union_local_history") }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <union-local-history-table
                    ref="unionLocalHistoryTable"
                    :memberId="id"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </material-card>

        <material-card
          :icon="memberIdentity.IsEligible ? 'check' : 'clear'"
          :color="memberIdentity.IsEligible ? '#00bf36' : '#bf2000'"
          :title="eligibleTitle"
        >
          <v-card-text>
            <div class="row no-gutters">
              <!-- <div class="col-12 ">
                {{ $t("components.memberview.current_coverage") }}
                <br />
                <span class="minfo">{{ displayCoverage() }}</span>
              </div> -->
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="planIdentity.Current.HasBenefitYears"
              >
                {{ $t("components.addmemberwizard.benefit_year") }}
                <br />
                <span class="minfo">
                  {{ getBenefitYearStartMonth() }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("headers.members_management.Member Group") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentMembershipStatus !== null &&
                    memberIdentity.CurrentMembershipStatus !== undefined
                      ? trans2(
                          memberIdentity.CurrentMembershipStatus
                            .MemberGroupIdentity.Current,
                          "Name"
                        )
                      : ""
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  Object.keys(eligibleSectionHeaders).indexOf(
                    'Default Coverage Status'
                  ) > -1
                "
              >
                {{ $t("headers.members_management.Default Coverage Status") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentMembershipStatus !== null &&
                    memberIdentity.CurrentMembershipStatus !== undefined
                      ? trans(
                          memberIdentity.CurrentMembershipStatus
                            .DefaultCoverageStatus
                        )
                      : ""
                  }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("globals.plan_entry_date") }}
                <br />
                <span class="minfo">
                  {{ formatDate(memberIdentity.PlanEntryDate) }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("components.memberview.coverage_effective_date") }}
                <br />
                <span class="minfo">
                  {{ formatDate(memberIdentity.CoverageEffectiveDate) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  Object.keys(eligibleSectionHeaders).indexOf(
                    'Coverage Expiry Date'
                  ) > -1
                "
              >
                {{ $t("headers.members_management.Coverage Expiry Date") }}
                <br />
                <span class="minfo">
                  {{ formatDate(memberIdentity.CoverageExpiryDate) }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="Object.keys(eligibleSectionHeaders).indexOf('Class') > -1"
              >
                {{ $t("headers.members_management.Class") }}
                <br />
                <span class="minfo">
                  {{
                    memberIdentity.CurrentMembershipStatus !== null &&
                    memberIdentity.CurrentMembershipStatus !== undefined
                      ? memberIdentity.CurrentMembershipStatus.Class
                      : ""
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  Object.keys(eligibleSectionHeaders).indexOf(
                    'Activity Status'
                  ) > -1
                "
              >
                {{ $t("headers.members_management.Activity Status") }}
                <br />
                <span
                  class="minfo"
                  v-if="
                    memberIdentity.LastExtensionTerminationDate !== null &&
                    memberIdentity.LastExtensionTerminationDate !== undefined &&
                    memberIdentity.LastExtensionTerminationDate >
                      memberIdentity.CurrentEmploymentInformation.HireDate
                  "
                >
                  {{ showExtensionOfBenefits() }}
                </span>
                <v-tooltip
                  bottom
                  v-else-if="
                    memberIdentity.CurrentMembershipStatus !== null &&
                    memberIdentity.CurrentMembershipStatus !== undefined &&
                    memberIdentity.CurrentMembershipStatus.ActivityStatus !==
                      null &&
                    memberIdentity.CurrentMembershipStatus.ActivityStatus !==
                      undefined
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters class="test">
                        <v-col>
                          <span class="minfo">
                            {{
                              `${
                                memberIdentity.CurrentMembershipStatus
                                  .ActivityStatus.Code
                              } - ${trans2(
                                memberIdentity.CurrentMembershipStatus
                                  .ActivityStatus,
                                "Name"
                              )}`
                            }}
                          </span>
                        </v-col>
                        <v-col
                          style="margin-top: 20px; margin-left: 3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{
                      trans2(
                        memberIdentity.CurrentMembershipStatus.ActivityStatus,
                        "Description"
                      )
                    }}
                  </span>
                </v-tooltip>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("components.memberview.terminated") }}
                <br />
                <span class="minfo">
                  {{ terminatedInfo }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("headers.members_management.Termination Date") }}
                <br />
                <span class="minfo">
                  {{ terminatedDate }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  memberIdentity.LastExtensionTerminationDate !== null &&
                  memberIdentity.LastExtensionTerminationDate !== undefined &&
                  memberIdentity.LastExtensionTerminationDate >
                    memberIdentity.CurrentEmploymentInformation.HireDate
                "
              >
                {{ $t("components.memberview.extension_termination_date") }}
                <br />
                <span class="minfo">
                  {{ formatDate(memberIdentity.LastExtensionTerminationDate) }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("headers.members_management.Flags") }}
                <br />
                <template v-for="flag in memberIdentity.Flags">
                  <v-chip :color="flag.Color" class="text-white" :key="flag.Id">
                    {{ trans2(flag, "Name") }}
                  </v-chip>
                </template>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  Object.keys(eligibleSectionHeaders).indexOf(
                    'Enrollement Signed At'
                  ) > -1
                "
              >
                {{ $t("headers.members_management.Enrollement Signed At") }}
                <br />
                <span class="minfo" v-if="memberIdentity.MemberEnrolment">
                  {{
                    formatDate(
                      memberIdentity.MemberEnrolment.EnrollmentSignedAt
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  Object.keys(eligibleSectionHeaders).indexOf(
                    'Enrollement Received At'
                  ) > -1
                "
              >
                {{ $t("headers.members_management.Enrollement Received At") }}
                <br />
                <span class="minfo" v-if="memberIdentity.MemberEnrolment">
                  {{
                    formatDate(
                      memberIdentity.MemberEnrolment.EnrollmentReceivedAt
                    )
                  }}
                </span>
              </div>
              <div
                class="col-12 col-md-4 col-lg-3 col-xl-2"
                v-if="
                  Object.keys(eligibleSectionHeaders).indexOf(
                    'Union Initiation Date'
                  ) > -1
                "
              >
                {{ $t("headers.members_management.Union Initiation Date") }}
                <br />
                <span class="minfo" v-if="memberIdentity.UnionInitiationDate">
                  {{
                    formatDate(
                      memberIdentity.UnionInitiationDate
                    )
                  }}
                </span>
              </div>
              <template v-if="planIdentity.IncludeSelfPayments">
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("components.memberview.total_self_payments_amount") }}
                  <br />
                  <span class="minfo" v-if="selfPayment">
                    {{ $helpers.formatCurrency(selfPayment.TotalAmount) }}
                  </span>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("components.memberview.total_self_payments") }}
                  <br />
                  <span class="minfo" v-if="selfPayment">
                    {{ selfPayment.TotalSelfPayments }}
                  </span>
                </div>
              </template>
            </div>
            <!-- <div class="row">
              <div class="col">
                <h4 style="text-align: center;">
                  {{ $t("components.memberview.coverage_information") }}
                </h4>
              </div>
            </div> -->
            <pbas-simple-table
              ref="coverageTable"
              :dataProvider="coverageProvider"
              fileNamePrefix="coverage"
              identifier="memberCoverageTable"
              @error="error = $event"
              v-if="
                memberIdentity.CurrentMembershipStatus !== null &&
                memberIdentity.CurrentMembershipStatus !== undefined &&
                memberIdentity.IsParticipant !== true
              "
            >
              <template v-slot:item.IsWaived="{ item }">
                <v-checkbox
                  v-if="item.CoverageIdentity.Current.IsWaivable"
                  style="margin: 0 auto"
                  v-model="item.IsWaived"
                  disabled
                />
              </template>
            </pbas-simple-table>
            <!-- <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <h4>
                        {{ $t("components.memberview.coverage_information") }}
                      </h4>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <pbas-data-table
                    :exporters="$exporters"
                    ref="coverageTable"
                    :dataProvider="coverageProvider"
                    fileNamePrefix="coverage"
                    identifier="memberCoverageTable"
                    :show-select="false"
                    @error="error = $event"
                  >
                    <template v-slot:item.IsWaived="{ item }">
                      <v-checkbox
                        v-if="item.CoverageIdentity.Current.IsWaivable"
                        style="margin:0 auto"
                        v-model="item.IsWaived"
                        disabled
                      />
                    </template>
                  </pbas-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels> -->
            <v-expansion-panels style="margin-top: 10px">
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        schedule
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{ $t("components.memberview.membership_history") }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <membership-history-table
                    :memberId="id"
                    :hasClasses="
                      Object.keys(eligibleSectionHeaders).indexOf('Class') > -1
                    "
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="planIdentity.HasEligibilityBank">
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        schedule
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{
                          $t(
                            "components.member_view.eligibility_card.bank_history"
                          )
                        }}
                        - {{ $t("headers.plan_balance.current_balance") }} :
                        <span
                          class="minfo"
                          v-if="
                            eligibilityBankBalance !== null &&
                            eligibilityBankBalance !== undefined
                          "
                        >
                          {{ parseFloat(eligibilityBankBalance).toFixed(2) }}
                        </span>
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <eligibility-bank-history-table
                    v-if="eligibilityBankId"
                    :memberIdentityId="id"
                    :eligibilityBankId="eligibilityBankId"
                    ref="eligibilityBankTable"
                    :planEntryDate="memberIdentity.PlanEntryDate"
                    :memberName="getName()"
                    @reload="reloadMemberIdentity"
                    :isEligible="memberIdentity.IsEligible"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="planIdentity.IncludeSelfPayments">
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        payments
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{ $t("components.memberview.self_payments_history") }}
                        - {{ $t("headers.adjustments.total") }} :
                        <span
                          class="minfo"
                          v-if="
                            selfPayment !== null &&
                            selfPayment !== undefined
                          "
                        >
                          {{ parseFloat(selfPayment.TotalAmount).toFixed(2) }}
                        </span>
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <member-self-payments-table
                    :memberId="id"
                    :employerId="
                      memberIdentity.CurrentEmploymentInformation.Employer.Id
                    "
                    :eligibilityBankId="eligibilityBankId"
                    @reload="reloadMemberIdentity"
                    :coverageEffectiveDate="memberIdentity.CoverageEffectiveDate"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </material-card>

        <material-card
          v-if="
            planIdentity.HasHSA && hasHSA && hsa !== null && hsa !== undefined
          "
          icon="account_balance_wallet"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('components.memberview.hsa')"
        >
          <v-card-text>
            <div class="row no-gutters">
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("headers.plan_balance.current_balance") }}
                <br />
                <span class="minfo">
                  {{ $helpers.formatCurrency(hsa.CurrentBalance) }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("components.memberview.upcoming_credits_to_expire") }}
                <br />
                <span
                  class="minfo"
                  v-if="
                    hsa.HSACreditToExpire !== null &&
                    hsa.HSACreditToExpire !== undefined &&
                    hsa.HSACreditToExpire.Amount !== null &&
                    hsa.HSACreditToExpire.Amount !== undefined
                  "
                >
                  {{
                    $helpers.formatCurrency(hsa.HSACreditToExpire.Amount) +
                    ` (${hsa.HSACreditToExpire.Year})`
                  }}
                </span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("components.memberview.upcoming_expiry_date") }}
                <br />
                <span
                  class="minfo"
                  v-if="
                    hsa.HSACreditToExpire !== null &&
                    hsa.HSACreditToExpire !== undefined &&
                    hsa.HSACreditToExpire.ExpirationDate !== null &&
                    hsa.HSACreditToExpire.ExpirationDate !== undefined
                  "
                >
                  {{ formatDate(hsa.HSACreditToExpire.ExpirationDate) }}
                </span>
              </div>
            </div>
            <v-expansion-panels style="margin-top: 10px">
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        schedule
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{ $t("components.memberview.balance_history") }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <member-balance-history-table
                    :memberIdentity="memberIdentity"
                    @reload="reloadHsa"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <v-icon class="member-expansion-panel-header-icon">
                        payments
                      </v-icon>
                      <span class="member-expansion-panel-header">
                        {{ $t("components.memberview.transactions") }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <member-transactions-table
                    ref="transactions"
                    :memberIdentityId="id"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </material-card>
        <!-- <eligibility-bank-card
          v-if="memberIdentity!==null && memberIdentity!==undefined && planIdentity.HasEligibilityBank"
          :memberIdentityId="id"
          :eligibilityBankId="eligibilityBankId"
          :balance="eligibilityBankBalance"
          ref="eligibilityBankCard"
          :planEntryDate="memberIdentity.PlanEntryDate"
          :memberName="getName()"
          @reload="reloadMemberIdentity"
          :isEligible="memberIdentity.IsEligible"
        /> -->
        <sick-payment-card
          v-if="planIdentity.HasSickPaymentBank"
          :memberIdentityId="id"
          :balance="sickPaymentBalance"
          ref="sickPaymentCard"
        />

        <material-card
          icon="family_restroom"
          :color="$vuetify.theme.themes.light.secondary"
          :title="
            selectedPlan.PlanType === 'Pension'
              ? $t('components.memberwizard.spousal_information')
              : $t('globals.dependants')
          "
          v-if="dependantsProvider"
        >
          <v-card-text>
            <pbas-simple-table
              ref="dependantsTable"
              :dataProvider="dependantsProvider"
              fileNamePrefix="dependants"
              identifier="memberDependantsTable"
              @error="error = $event"
            ></pbas-simple-table>
          </v-card-text>
        </material-card>

        <material-card
          icon="share"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('globals.beneficiaries')"
          v-if="
            beneficiariesProvider &&
            (role.indexOf('Broker Plan Manager') > -1 ||
              role.indexOf('Broker Plan Admin') > -1 ||
              role.indexOf('Employer Beneficiaries Administrator') > -1)
          "
        >
          <v-card-text>
            <pbas-simple-table
              ref="beneficiariesTable"
              :dataProvider="beneficiariesProvider"
              fileNamePrefix="beneficiaries"
              identifier="memberBeneficiariesTable"
              @error="error = $event"
            ></pbas-simple-table>
          </v-card-text>
        </material-card>

        <material-card
          icon="contact_page"
          :color="$vuetify.theme.themes.light.secondary"
          :title="$t('components.memberview.member_files')"
          v-if="memberFilesProvider"
        >
          <v-card-text>
            <pbas-data-table
              :exporters="$exporters"
              ref="memberFilesTable"
              :dataProvider="memberFilesProvider"
              fileNamePrefix="memberFiles"
              identifier="memberFilesTable"
              :show-select="false"
              @error="error = $event"
              :rowActions="memberFilesRowActions"
            ></pbas-data-table>
          </v-card-text>
        </material-card>
        <benefit-balances-component
          v-if="role.indexOf('Claims Administrator') > -1"
          :memberIdentity="memberIdentity"
          :dependants="dependantsProvider.items"
        />
        <claims-history-component
          v-if="
            !selectedPlan.UseISeriesClaims &&
            role.indexOf('Claims Administrator') > -1
          "
          :memberIdentityId="id"
          :memberHasHSA="hasHSA"
        />
        <!-- <redmine-table
          v-if="memberIdentity"
          :memberIdentityId="id"
          :memberCertificate="memberIdentity.MemberIdentification.Certificate"
          :planIdentityId="selectedPlan.Id"
          :planName="selectedPlan.UniqueIdentifier"
        /> -->
        <opt-outs-member-list
          :certificate="memberIdentity.MemberIdentification.Certificate"
        />
      </div>
      <div class="col-12 col-md-3" style="padding-top: 0">
        <v-card style="margin-top: 10px">
          <v-list :expand="true">
            <v-subheader>
              <v-icon style="margin-right: 6px">handyman</v-icon>
              {{ $t("globals.edit") }}
            </v-subheader>
            <v-list-group
              no-action
              prepend-icon="refresh"
              :value="true"
              v-if="
                memberIdentity.CurrentMembershipStatus !== null &&
                memberIdentity.CurrentMembershipStatus !== undefined &&
                memberIdentity.IsEditable !== false &&
                (role.indexOf('Broker Plan Manager') > -1 ||
                  role.indexOf('Broker Plan Admin') > -1 ||
                  role.indexOf('Employer Plan Admin') > -1)
              "
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.status_update") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="changeActivityStatusHandler"
                v-if="
                  Object.keys(eligibleSectionHeaders).indexOf(
                    'Activity Status'
                  ) > -1 &&
                  (memberIdentity.CurrentTerminationMembershipEvent === null ||
                    memberIdentity.CurrentTerminationMembershipEvent ===
                      undefined ||
                    !memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated)
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.change_activity_status") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="terminateHandler"
                v-if="
                  memberIdentity.CurrentMembershipStatus !== null &&
                  memberIdentity.CurrentMembershipStatus !== undefined
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.change_terminate_member") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="reinstateHandler"
                v-if="
                  (planIdentity.HasEligibilityBank && (
                    memberIdentity.CurrentTerminationMembershipEvent !== null &&
                    memberIdentity.CurrentTerminationMembershipEvent !==
                      undefined &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .TerminationStatus !== 'Deceased') && isRehire) ||
                  (
                    memberIdentity.CurrentTerminationMembershipEvent !== null &&
                    memberIdentity.CurrentTerminationMembershipEvent !==
                      undefined &&
                    memberIdentity.CurrentTerminationMembershipEvent
                      .TerminationStatus !== 'Deceased')
                "
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-if="isRehire && (hasCoverageCommencementRulesPlan || planIdentity.HasEligibilityBank)"
                  >
                    {{ $t("components.memberview.rehire_member") }}
                  </v-list-item-title>
                  <v-list-item-title v-else>
                    {{ $t("components.memberview.reinstate_member") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="changeClassHandler"
                v-if="
                  !hasCoverageCommencementRulesPlan &&
                  Object.keys(eligibleSectionHeaders).indexOf('Class') > -1 &&
                  (memberIdentity.CurrentTerminationMembershipEvent === null ||
                    memberIdentity.CurrentTerminationMembershipEvent ===
                      undefined ||
                    !memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated)
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.change_class") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-group
              no-action
              prepend-icon="info"
              :value="true"
              v-if="memberIdentity.IsEditable !== false"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.member_information") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="dialogs.untracked = true"
                v-if="
                  (memberIdentity.CurrentTerminationMembershipEvent === null ||
                    memberIdentity.CurrentTerminationMembershipEvent ===
                      undefined ||
                    !memberIdentity.CurrentTerminationMembershipEvent
                      .IsTerminated) &&
                  canEditUntracked &&
                  (role.indexOf('Broker Plan Manager') > -1 ||
                    role.indexOf('Broker Plan Admin') > -1 ||
                    role.indexOf('Employer Plan Admin') > -1)
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("globals.correct_information") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="editCoverageInfo('correctPlanEntryDate')"
                v-if="
                !planIdentity.HasEligibilityBank && (
                  (isPlanType === '1' ||
                    isPlanType === '2' ||
                    isPlanType === '3' ||
                    isPlanType === '6') &&
                  memberIdentity.CurrentMembershipStatus !== null &&
                  memberIdentity.CurrentMembershipStatus !== undefined &&
                  (memberIdentity.CurrentTerminationMembershipEvent === null ||
                    memberIdentity.CurrentTerminationMembershipEvent ===
                      undefined ||
                    !memberIdentity.CurrentMembershipStatus.IsTerminated) &&
                  (role.indexOf('Broker Plan Manager') > -1 ||
                    role.indexOf('Broker Plan Admin') > -1 ||
                    role.indexOf('Employer Plan Admin') > -1)
            )
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.correct_plan_entry_date") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="editCoverageInfo('editCoverageInfo')"
                v-if="
                (isPlanType === '3' ||
                    isPlanType === '4' ||
                    isPlanType === '5' ||
                    isPlanType === '6') &&
                  memberIdentity.CurrentMembershipStatus !== null &&
                  memberIdentity.CurrentMembershipStatus !== undefined &&
                  (memberIdentity.CurrentTerminationMembershipEvent === null ||
                    memberIdentity.CurrentTerminationMembershipEvent ===
                      undefined ||
                    !memberIdentity.CurrentMembershipStatus.IsTerminated) &&
                  (role.indexOf('Broker Plan Manager') > -1 ||
                    role.indexOf('Broker Plan Admin') > -1 ||
                    role.indexOf('Employer Plan Admin') > -1)
                "
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t(
                        "components.memberview.correct_coverage_effective_date"
                      )
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="editPersonalInfoHandler">
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      (memberIdentity.CurrentTerminationMembershipEvent ===
                        null ||
                        memberIdentity.CurrentTerminationMembershipEvent ===
                          undefined ||
                        !memberIdentity.CurrentTerminationMembershipEvent
                          .IsTerminated) &&
                      memberIdentity.IsEditable !== false &&
                      (role.indexOf("Broker Plan Manager") > -1 ||
                        role.indexOf("Broker Plan Admin") > -1 ||
                        role.indexOf("Employer Plan Admin") > -1)
                        ? $t(
                            "components.memberview.viewedit_personal_information"
                          )
                        : $t("components.memberview.view_personal_information")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="editEmploymentInfoHandler">
                <v-list-item-title>
                  {{
                    (memberIdentity.CurrentTerminationMembershipEvent ===
                      null ||
                      memberIdentity.CurrentTerminationMembershipEvent ===
                        undefined ||
                      !memberIdentity.CurrentTerminationMembershipEvent
                        .IsTerminated) &&
                    memberIdentity.IsEditable !== false &&
                    (role.indexOf("Broker Plan Manager") > -1 ||
                      role.indexOf("Broker Plan Admin") > -1 ||
                      role.indexOf("Employer Plan Admin") > -1)
                      ? $t(
                          "components.memberview.viewedit_employment_information"
                        )
                      : $t("components.memberview.view_employment_information")
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="editContactInfoHandler"
                v-if="contactSectionHeaders.length > 0"
              >
                <v-list-item-title>
                  {{
                    memberIdentity.IsEditable !== false &&
                    (role.indexOf("Broker Plan Manager") > -1 ||
                      role.indexOf("Broker Plan Admin") > -1 ||
                      role.indexOf("Employer Plan Admin") > -1)
                      ? $t("components.memberview.viewedit_contact_information")
                      : $t("components.memberview.view_contact_information")
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="editDirectDepositHandler"
                v-if="
                  hasBankAccount &&
                  (role.indexOf('Broker Plan Manager') > -1 ||
                    role.indexOf('Broker Plan Admin') > -1 ||
                    role.indexOf('Employer Direct Deposit Administrator') > -1)
                "
              >
                <v-list-item-title>
                  {{
                    memberIdentity.IsEditable !== false &&
                    (role.indexOf("Broker Plan Manager") > -1 ||
                      role.indexOf("Broker Plan Admin") > -1 ||
                      role.indexOf("Employer Plan Admin") > -1)
                      ? $t(
                          "components.memberview.viewedit_direct_deposit_information"
                        )
                      : $t(
                          "components.memberview.view_direct_deposit_information"
                        )
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="deleteDirectDepositHandler"
                v-if="
                  memberIdentity.CurrentBankAccount !== null &&
                  memberIdentity.CurrentBankAccount !== undefined &&
                  memberIdentity.IsEditable !== false &&
                  hasBankAccount &&
                  (role.indexOf('Broker Plan Manager') > -1 ||
                    role.indexOf('Broker Plan Admin') > -1)
                "
              >
                <v-list-item-title>
                  {{
                    $t(
                      "components.memberview.delete_direct_deposit_information"
                    )
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="editUnionLocalHandler"
                v-if="
                  unionLocalSectionHeaders.indexOf('Union Local Home') > -1 ||
                  unionLocalSectionHeaders.indexOf('Union Local Work') > -1
                "
              >
                <v-list-item-title>
                  {{
                    memberIdentity.IsEditable !== false &&
                    (role.indexOf("Broker Plan Manager") > -1 ||
                      role.indexOf("Broker Plan Admin") > -1 ||
                      role.indexOf("Employer Plan Admin") > -1)
                      ? $t(
                          "components.memberview.viewedit_union_local_information"
                        )
                      : $t("components.memberview.view_union_local_information")
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              no-action
              prepend-icon="beach_access"
              :value="true"
              v-if="
                memberIdentity.IsEditable !== false &&
                memberIdentity.CurrentMembershipStatus !== null &&
                memberIdentity.CurrentMembershipStatus !== undefined
              "
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.coverage_information") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="viewEditCoverageHandler"
                v-if="
                  memberIdentity.CurrentMembershipStatus !== null &&
                  memberIdentity.CurrentMembershipStatus !== undefined
                "
              >
                <v-list-item-title>
                  {{
                    memberIdentity.IsEditable !== false &&
                    memberIdentity.CurrentMembershipStatus !== null &&
                    memberIdentity.CurrentMembershipStatus !== undefined &&
                    (memberIdentity.CurrentTerminationMembershipEvent ===
                      null ||
                      memberIdentity.CurrentTerminationMembershipEvent ===
                        undefined ||
                      !memberIdentity.CurrentMembershipStatus.IsTerminated) &&
                    (role.indexOf("Broker Plan Manager") > -1 ||
                      role.indexOf("Broker Plan Admin") > -1 ||
                      role.indexOf("Employer Plan Admin") > -1)
                      ? $t(
                          "components.memberview.viewedit_coverage_information"
                        )
                      : $t("components.memberview.view_coverage_information")
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              no-action
              prepend-icon="family_restroom"
              :value="true"
              v-if="memberIdentity.IsEditable !== false"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      selectedPlan.PlanType === "Pension"
                        ? $t("components.memberwizard.spousal_information")
                        : $t("globals.dependants")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                @click="addDependantBtnClick"
                v-if="
                  ((selectedPlan.PlanType === 'Pension' &&
                    !this.spouseExists) ||
                    selectedPlan.PlanType === 'HW') &&
                  memberIdentity.IsEditable !== false &&
                  (role.indexOf('Broker Plan Manager') > -1 ||
                    role.indexOf('Broker Plan Admin') > -1 ||
                    role.indexOf('Employer Plan Admin') > -1)
                "
              >
                <v-list-item-title>
                  {{
                    selectedPlan.PlanType === "Pension"
                      ? $t("components.memberview.add_spouse")
                      : $t("components.memberview.add_dependant")
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="vieweditDependantsBtnClick">
                <v-list-item-title>
                  {{ vieweditDependantsBtnTitle }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-group
              no-action
              prepend-icon="share"
              :value="true"
              v-if="
                planOptions &&
                planOptions.HasBeneficiaries &&
                memberIdentity.IsEditable !== false &&
                ((policyIdentities && policyIdentities.length > 0) ||
                  (beneficiaryStatements &&
                    beneficiaryStatements.length > 0)) &&
                (role.indexOf('Broker Plan Manager') > -1 ||
                  role.indexOf('Broker Plan Admin') > -1 ||
                  role.indexOf('Employer Beneficiaries Administrator') > -1)
              "
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("globals.beneficiaries") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-if="policyIdentities && policyIdentities.length > 0"
                @click="addBeneficiaries"
              >
                <v-list-item-title>
                  {{ $t("components.memberview.add_beneficiary_statement") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="beneficiaryStatements && beneficiaryStatements.length > 0"
                @click="manageBeneficiaries"
              >
                <v-list-item-title>
                  {{
                    $t("components.memberview.view_edit_beneficiary_statement")
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              no-action
              prepend-icon="sticky_note_2"
              :value="true"
              v-if="
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              "
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.notes_flags") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="
                  note = {
                    Title: '',
                    Text: '',
                    Category: null,
                    MemberIdentityId: id,
                    IsActive: true,
                  };
                  addNoteDialog = true;
                "
              >
                <v-list-item-title>
                  {{ $t("components.memberview.add_note") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="activeNotesDialog = true">
                <v-list-item-title>
                  {{ $t("components.memberview.viewedit_active_notes") }}
                </v-list-item-title>
                <v-list-item-icon>
                  <v-badge
                    bordered
                    color="error"
                    :content="activeNotesCount.toString()"
                    offset-y="18"
                  ></v-badge>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item @click="archivedNotesDialog = true">
                <v-list-item-title>
                  {{ $t("components.memberview.view_notes_archive") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="flagDialog = true">
                <v-list-item-title>
                  {{ $t("components.memberview.viewedit_flags") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group
              no-action
              prepend-icon="folder_shared"
              :value="true"
              v-if="
                memberIdentity.IsEditable !== false &&
                (role.indexOf('Broker Plan Manager') > -1 ||
                  role.indexOf('Broker Plan Admin') > -1 ||
                  role.indexOf('Employer Plan Admin') > -1)
              "
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.documents") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-if="useDocumentsManagement">
                <v-list-item
                  @click="addEnrolmentFormHandler"
                  v-if="enrolmentFiles.length === 0"
                >
                  <v-list-item-title>
                    {{ $t("components.memberview.add_enrolment_form") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="addChangeFormHandler">
                  <v-list-item-title>
                    {{ $t("components.memberview.add_change_form") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="addOtherFileHandler">
                  <v-list-item-title>
                    {{ $t("components.memberview.add_other_file") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="viewEditFiles">
                  <v-list-item-title>
                    {{ $t("components.memberview.viewedit_file") }}
                  </v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                @click="printBenefitCard"
                v-if="
                  planIdentity.MembersPortal &&
                  planIdentity.MembersPortal.IsActive
                "
              >
                <v-list-item-title v-if="memberIdentity.Email">
                  {{ $t("components.memberview.viewprintsend_benefit_card") }}
                </v-list-item-title>
                <v-list-item-title v-else>
                  {{ $t("components.memberview.viewprint_benefit_card") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
            <!-- 
            <v-list-group
              no-action
              prepend-icon="bank"
              :value="true"
              v-if="
                planIdentity.HasEligibilityBank
              "
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.plancreationwizard.eligibility_bank") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="creditHoursHandler"
                v-if="
                  memberIdentity.IsEligible
                "
              >
                <v-list-item-title>
                  {{ $t("components.memberview.credit_hours") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group> -->

            <v-list-group
              no-action
              prepend-icon="assignment_ind"
              :value="true"
              v-if="
                planIdentity.MembersPortal !== undefined &&
                planIdentity.MembersPortal !== null &&
                planIdentity.MembersPortal.IsActive &&
                memberIdentity.IsEditable !== false &&
                (role.indexOf('Broker Plan Manager') > -1 ||
                  role.indexOf('Broker Plan Admin') > -1 ||
                  role.indexOf('Employer Plan Admin') > -1)
              "
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("components.memberview.members_portal_account") }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                @click="createAccountHandler"
                v-if="
                  memberIdentity.PortalAccount === undefined ||
                  memberIdentity.PortalAccount === null
                "
              >
                <v-list-item-title>
                  {{
                    welcomeKitExists
                      ? $t("components.membersmanagementtable.create_account")
                      : $t("components.memberview.add_email")
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="dialogs.resendEmail = true"
                v-if="
                  memberIdentity.PortalAccount !== undefined &&
                  memberIdentity.PortalAccount !== null &&
                  memberIdentity.Email !== undefined &&
                  memberIdentity.Email !== null &&
                  memberIdentity.Email !== '' &&
                  (memberIdentity.PortalAccount.RegisteredAt === undefined ||
                    memberIdentity.PortalAccount.RegisteredAt === null)
                "
              >
                <v-list-item-title>
                  {{ $t("components.memberview.resend_registration_email") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="dialogs.resendConfirmationEmail = true"
                v-if="
                  memberIdentity.PortalAccount !== undefined &&
                  memberIdentity.PortalAccount !== null &&
                  memberIdentity.PortalAccount.RegisteredAt !== undefined &&
                  memberIdentity.PortalAccount.RegisteredAt !== null &&
                  memberIdentity.Email !== undefined &&
                  memberIdentity.Email !== null &&
                  memberIdentity.Email !== '' &&
                  !memberIdentity.PortalAccount.EmailVerified
                "
              >
                <v-list-item-title>
                  {{ $t("components.memberview.resend_confirmation_email") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="changeMemberEmailHandler"
                v-if="
                  contactSectionHeaders.indexOf('Email') > -1 &&
                  memberIdentity.Email !== undefined &&
                  memberIdentity.Email !== null &&
                  memberIdentity.Email !== ''
                "
              >
                <v-list-item-title>
                  {{ $t("components.memberview.change_account_email") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="deleteAccountHandler"
                v-if="
                  memberIdentity.PortalAccount !== undefined &&
                  memberIdentity.PortalAccount !== null &&
                  memberIdentity.PortalAccount.RegisteredAt !== undefined &&
                  memberIdentity.PortalAccount.RegisteredAt !== null
                "
              >
                <v-list-item-title>
                  {{ $t("components.membersmanagementtable.delete_account") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="resetPasswordHandler"
                v-if="
                  !planIdentity.HasDrupalPortal &&
                  memberIdentity.PortalAccount !== undefined &&
                  memberIdentity.PortalAccount !== null &&
                  memberIdentity.PortalAccount.RegisteredAt !== undefined &&
                  memberIdentity.PortalAccount.RegisteredAt !== null
                "
              >
                <v-list-item-title>
                  {{ $t("components.membersmanagementtable.reset_password") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="portalViewHandler"
                v-if="
                  !planIdentity.HasDrupalPortal &&
                  memberIdentity.PortalAccount !== undefined &&
                  memberIdentity.PortalAccount !== null &&
                  memberIdentity.PortalAccount.RegisteredAt !== undefined &&
                  memberIdentity.PortalAccount.RegisteredAt !== null &&
                role.indexOf('Member Portal Viewer') > -1
                "
              >
                <v-list-item-title>
                  {{ $t("components.memberview.portal_view") }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
      </div>
    </div>
    <error-handler :error="error"></error-handler>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import getHeaders from "../headers/MemberCoverage";
import getDependantsHeaders from "../headers/Dependants";
import getMemberDependantsHeaders from "../headers/MemberDependants";
import getMemberBeneficiariesHeaders from "../headers/MemberBeneficiaries";
import MemberFilesHeaders from "../headers/InMemoryMemberFiles";
import { InMemoryProvider, ODataProvider } from "pbas-vue-components";
import { mapActions, mapGetters } from "vuex";
import { translate } from "../trans";
import { translate2 } from "../trans2";
import BeneficiariesForm from "../components/BeneficiariesForm";
import DependantForm from "./DependantForm";
import Dependants from "./Dependants";
import { locker } from "../mixins/locker";
import { planSetter } from "../mixins/planSetter";
import ErrorHandler from "../components/ErrorHandler";
import MemberNotesForm from "../components/MemberNotesForm.vue";
import OptOutsMemberList from "../components/OptOuts/OptOutsMemberList.vue";
import MemberNotesTable from "../components/MemberNotesTable.vue";
import MemberFlagsForm from "../components/MemberFlagsForm.vue";
import MemberFiles from "./MemberFiles.vue";
import TransSelect from "../components/TransSelect";
import TransSelect2 from "../components/TransSelect2";
import TransMultiSelect2 from "../components/TransMultiSelect2";
import ApiService from "../services/api.service";
import AutoSelect from "../components/AutoSelect";
import BenefitHeaders from "../headers/EditBenefits";
import NonCustomizedBenefitHeaders from "../headers/EditNonCustomizedBenefits";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import BenefitCardsDialog from "./BenefitCards/BenefitCardsDialog.vue";
import { createMemberFile } from "../makeMemberFile";
import MultiFileUpload2 from "../components/MultiFileUpload2.vue";
import axios from "axios";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import { mapFileSegmentIds } from "../makeMemberFile";
import { saveAs } from "file-saver";
import { base64ToArrayBuffer } from "../utils/file.js";
import MemberHoursTable from "@/components/MemberView/Hours/MemberHoursTable.vue";
import MemberSelfPaymentsTable from "./MemberSelfPaymentsTable.vue";
import CurrencyTextfield from "../components/CurrencyTextfield.vue";
import { sortAlphanum } from "../alphanumericSort";
import MembershipHistoryTable from "../components/MembershipHistoryTable.vue";
import UnionLocalHistoryTable from "../components/UnionLocalHistoryTable.vue";
import TransEnum from "../components/TransEnum.vue";
import CanadaPostAddress from "@/components/CanadaPostAddress";
import SettingsService from "@/services/settings.service.js";
import ClaimsHistoryComponent from "@/components/Claims/ClaimsHistoryComponent.vue";
import MemberBalanceHistoryTable from "./MemberBalanceHistoryTable.vue";
import MemberTransactionsTable from "./MemberTransactionsTable.vue";
import SickPaymentCard from "./MemberView/SickPaymentCard.vue";
import MemberTerminationDialog from "./MemberView/MemberTermination/MemberTerminationDialog.vue";
import RedmineTable from "@/components/Redmine/RedmineTable.vue";
import BenefitBalancesComponent from "@/components/MemberView/BenefitBalance/BenefitBalancesComponent.vue";
// import EligibilityBankCard from "./MemberView/EligibilityBank/EligibilityBankCard.vue";
import EligibilityBankHistoryTable from "./MemberView/EligibilityBank/EligibilityBankHistoryTable.vue";

export default {
  name: "member-view",
  components: {
    MemberFiles,
    BenefitCardsDialog,
    MemberFlagsForm,
    MemberNotesTable,
    MemberNotesForm,
    BeneficiariesForm,
    DependantForm,
    ErrorHandler,
    Dependants,
    TransSelect,
    TransSelect2,
    TransMultiSelect2,
    AutoSelect,
    NoAutocompleteTextfield,
    MultiFileUpload2,
    MemberHoursTable,
    MemberSelfPaymentsTable,
    CurrencyTextfield,
    MembershipHistoryTable,
    UnionLocalHistoryTable,
    TransEnum,
    CanadaPostAddress,
    ClaimsHistoryComponent,
    MemberBalanceHistoryTable,
    MemberTransactionsTable,
    SickPaymentCard,
    MemberTerminationDialog,
    RedmineTable,
    BenefitBalancesComponent,
    // EligibilityBankCard
    EligibilityBankHistoryTable,
    OptOutsMemberList
  },
  mixins: [locker, planSetter],
  directives: { mask },
  data() {
    return {
      eligibilityBankId: null,
      termination: [],
      waiveWaitingPeriod: false,
      untrackedCoverageHeadersDictionary: [],
      selfPayment: null,
      fixedCoverageIdentities: [],
      memberFilesRowActions: [
        {
          name: "downloadFiles",
          icon: "file_download",
          title: "globals.download",
          handler: (item) => this.downloadFiles(item),
        },
      ],
      postalCodeMask: "A#A #A#",
      telephoneMask: "(###) ### - ####",
      confirmBankAccountDialog: false,
      enrolmentForm: null,
      addEnrolmentFormDialog: false,
      enrolmentFiles: [],
      salaryEvidenceIds: null,
      cards: [],
      reinstateQuery: "",
      reinstateItem: {},
      step: 0,
      reinstateEffectiveDateValid: false,
      reinstateEffectiveDate: null,
      beneficiariesSaveEnabled: false,
      hasPreviousDeclarationDate: false,
      editCoverageDialog: false,
      selectedDependants: [],
      cobDialog: false,
      removeCobDialog: false,
      selectedBenefit: null,
      benefitsProvider: undefined,
      nonCustomizedBenefitsProvider: undefined,
      newBeneficiaryStatement: false,
      benefitsRowActions: [
        {
          name: "waive",
          icon: "done",
          title: "components.addmemberwizard.waive",
          handler: (item) => {
            let coverageEffectiveDate = this.coverageEffectiveDate;
            if (
              coverageEffectiveDate === null ||
              coverageEffectiveDate === undefined
            ) {
              coverageEffectiveDate = this.reinstateEffectiveDate;
            }
            const selected = this.benefitsProvider.items.filter(
              (o) => o.CoverageIdentityId === item.CoverageIdentityId
            )[0];
            const index = this.benefitsProvider.items.indexOf(selected);
            this.benefitsProvider.items[index].IsWaived = true;
            this.benefitsProvider.items[index].EffectiveDate =
              coverageEffectiveDate;
            this.$refs.benefitsTable.getDataAsync();
          },
          visible: (item) => {
            return (
              item.CoverageIdentity.Current.IsWaivable === true &&
              (item.IsWaived === false ||
                item.IsWaived === undefined ||
                item.IsWaived === null)
            );
          },
        },
        {
          name: "unwaive",
          icon: "remove_done",
          title: "components.addmemberwizard.unwaive",
          handler: (item) => {
            let coverageEffectiveDate = this.coverageEffectiveDate;
            if (
              coverageEffectiveDate === null ||
              coverageEffectiveDate === undefined
            ) {
              coverageEffectiveDate = this.reinstateEffectiveDate;
            }
            const selected = this.benefitsProvider.items.filter(
              (o) => o.CoverageIdentityId === item.CoverageIdentityId
            )[0];
            const index = this.benefitsProvider.items.indexOf(selected);
            this.benefitsProvider.items[index].IsWaived = false;
            this.benefitsProvider.items[index].EffectiveDate =
              coverageEffectiveDate;
            this.$refs.benefitsTable.getDataAsync();
          },
          visible: (item) => {
            return (
              item.CoverageIdentity.Current.IsWaivable === true &&
              item.IsWaived === true
            );
          },
        },
        {
          name: "cob",
          icon: "deck",
          title: "components.memberview.edit_cob",
          handler: (item) => {
            // this.$router.push({ name: "memberView", params: { id: item.Id } });
            this.selectedBenefit = JSON.parse(JSON.stringify(item));
            if (
              this.selectedBenefit.COB === null ||
              this.selectedBenefit.COB === undefined
            ) {
              this.selectedBenefit.COB = {};
            }
            this.cobDialog = true;
          },
          visible: (item) => {
            //console.log(item);
            if (item.IsWaived === true) {
              return false;
            }
            return item.CoverageIdentity.Current.HasCOB;
          },
        },
        {
          name: "removeCob",
          icon: "remove",
          title: "components.memberview.remove_cob",
          handler: (item) => {
            // this.$router.push({ name: "memberView", params: { id: item.Id } });
            this.selectedBenefit = JSON.parse(JSON.stringify(item));
            this.removeCobDialog = true;
          },
          visible: (item) => {
            return (
              item.COB !== null &&
              item.COB !== undefined &&
              Object.keys(item.COB).length > 0
            );
          },
        },
        {
          name: "editCoverage",
          icon: "beach_access",
          title: "components.memberview.view_edit_coverage_title",
          handler: (item) => {
            this.selectedBenefit = JSON.parse(JSON.stringify(item));
            console.log(this.selectedBenefit);
            if (
              this.selectedBenefit.DependantIdentities !== null &&
              this.selectedBenefit.DependantIdentities !== undefined
            ) {
              this.selectedBenefit.Dependants =
                this.selectedBenefit.DependantIdentities.map((o) => o.Id);
            }
            this.editCoverageDialog = true;
          },
          visible: (item) => {
            if (item.IsWaived === true) {
              return false;
            }
            if (
              this.editedItemCoverage &&
              this.editedItemCoverage.CurrentMembershipStatus &&
              this.editedItemCoverage.CurrentMembershipStatus
                .DefaultCoverageStatus
            ) {
              return (
                (item.CoverageIdentity.Current.HasCoverageChoice &&
                  !item.CoverageIdentity.Current
                    .RestrictToDefaultCoverageStatus &&
                  this.editedItemCoverage.CurrentMembershipStatus
                    .DefaultCoverageStatus.Id !== this.singleFamilyStatus.Id) ||
                item.CoverageIdentity.Current.HasVolumeChoice
              );
            } else if (
              this.reinstateItem &&
              this.reinstateItem.CurrentMembershipStatus &&
              this.reinstateItem.CurrentMembershipStatus.DefaultCoverageStatus
            ) {
              return (
                (item.CoverageIdentity.Current.HasCoverageChoice &&
                  !item.CoverageIdentity.Current
                    .RestrictToDefaultCoverageStatus &&
                  this.reinstateItem.CurrentMembershipStatus
                    .DefaultCoverageStatus.Id !== this.singleFamilyStatus.Id) ||
                item.CoverageIdentity.Current.HasVolumeChoice
              );
            } else {
              return item.CoverageIdentity.Current.HasVolumeChoice;
            }
          },
        },
      ],
      optionalCoverage: [],
      selectedOptionalCoverage: [],
      confirmEmail: null,
      confirmHomeEmail: null,
      confirmWorkEmail: null,
      // sortedAccountType: [],
      sortedCountry: [],
      sortedSecondIncomeType: [],
      sortedEmploymentFrequency: [],
      sortedEmploymentType: [],
      sortedProvince: [],
      sortedMaritalStatus: [],
      sortedFamilyStatus: [],
      sortedGender: [],
      sortedActivityStatus: [],
      sortedSuffix: [],
      sortedPronoun: [],
      sortedTitle: [],
      notAvailableDialog: false,
      headers: null,
      card: null,
      loadingMember: false,
      flagDialog: false,
      loading: false,
      headersDictionary: [],
      activeOdataQuery: "",
      activeDialog: "",
      effectiveDate: null,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      error: null,
      memberIdentity: null,
      coverageProvider: undefined,
      dependantsProvider: undefined,
      odataDependantsProvider: undefined,
      beneficiariesProvider: undefined,
      memberFilesProvider: undefined,
      eligibleSectionHeaders: {},
      personalSectionHeaders: [],
      employmentSectionHeaders: [],
      unionLocalSectionHeaders: [],
      contactSectionHeaders: [],
      directDepositHeaders: [],
      coverageSectionHeaders: [],
      dependantsSectionHeaders: [],
      beneficiariesSectionHeaders: [],
      portalAccountSectionHeaders: [],
      dialogs: {
        confirmCorrectPlanEntryDate: false,
        correctPlanEntryDate: false,
        untrackedCoverage: false,
        editCoverageInfo: false,
        reinstate: false,
        showBenefitCardDialog: false,
        showFilesDialog: false,
        vieweditDependants: false,
        addDependant: false,
        beneficiaries: false,
        untracked: false,
        editInfo: false,
        createAccount: false,
        changeEmail: false,
        resendEmail: false,
        resendConfirmationEmail: false,
        deleteAccount: false,
        activityStatus: false,
        class: false,
        terminate: false,
        coverage: false,
        personalInfo: false,
        employmentInfo: false,
        contactInfo: false,
        directDeposit: false,
        unionLocal: false,
        spouseAsBeneficiary: false,
        resetPassword: false,
        benefitYear: false,
        deleteDirectDeposit: false,
        eligibilityBankWarning: false
      },
      editedUntrackedItemCoverage: null,
      untrackedCoverageQuery: "",
      policyIdentities: [],
      beneficiaryStatements: [],
      previousBeneficiaryPayload: null,
      editedDependant: null,
      editedDependantIndex: null,
      canEditUntracked: false,
      editedUntrackedItem: null,
      untrackedSectionHeaders: {},
      untrackedQuery: "",
      memberOdataQuery: "",
      saving: false,
      valid: {
        correctPlanEntryDate: true,
        untrackedCoverage: true,
        untracked: true,
        createAccount: true,
        changeEmail: true,
        activityStatus: true,
        class: true,
        terminate: true,
        coverage: true,
        personalInfo: true,
        employmentInfo: true,
        contactInfo: true,
        contactInfo2: true,
        directDeposit: true,
        coverage2: true,
        personalInfo2: true,
        employmentInfo2: true,
        coverageEdit: () => {
          let valid = true;
          for (let benefit of this.benefitsProvider.items) {
            valid = this.isValidBenefit(benefit);
            if (!valid) {
              break;
            }
          }
          return valid;
        },
        unionLocal: false,
        benefitYear: false,
        address: true,
        employmentInfoCoverage: true,
      },
      editedItem: {},
      editedItemCoverage: {
        CurrentMembershipStatus: {
          MemberGroupIdentity: {
            Current: {},
          },
        },
        CurrentMemberBenefitYear: {},
        CurrentTerminationMembershipEvent: {},
      },
      hasBankAccount: false,
      classes: [],
      rules: {
        coverageUntrackedEffectiveDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.editedUntrackedItemCoverage === null ||
            this.editedUntrackedItemCoverage === undefined
          ) {
            return true;
          }
          let firstRenewalTimestamps = Date.parse(
            this.planIdentity.FirstRenewalDate
          );
          let hireTimestamps = null;
          if (
            this.planIdentity.CurrentPlanMemberEligibility &&
            this.planIdentity.CurrentPlanMemberEligibility
              .IncludeWaitingPeriod &&
            !this.waiveWaitingPeriod
          ) {
            if (
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation ===
                null ||
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation ===
                undefined ||
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation
                .HireDate === null ||
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation
                .HireDate === undefined
            ) {
              return true;
            }
            hireTimestamps = Date.parse(
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation
                .HireDate
            );
            if (
              this.planIdentity.CurrentPlanMemberEligibility
                .WaitingPeriodUnit === "Day"
            ) {
              hireTimestamps = this.addDays(
                hireTimestamps,
                this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
              );
            } else if (
              this.planIdentity.CurrentPlanMemberEligibility
                .WaitingPeriodUnit === "Week"
            ) {
              hireTimestamps = this.addWeeks(
                hireTimestamps,
                this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
              );
            } else if (
              this.planIdentity.CurrentPlanMemberEligibility
                .WaitingPeriodUnit === "Month"
            ) {
              hireTimestamps = this.addMonths(
                hireTimestamps,
                this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
              );
            }
          } else if (
            Object.keys(this.headersDictionary).indexOf("Hire Date") > -1
          ) {
            if (
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation ===
                null ||
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation ===
                undefined ||
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation
                .HireDate === null ||
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation
                .HireDate === undefined
            ) {
              return true;
            }
            hireTimestamps = Date.parse(
              this.editedUntrackedItemCoverage.CurrentEmploymentInformation
                .HireDate
            );
          }
          const firstRenewalDate = new Date(firstRenewalTimestamps);
          let currentDate = null;
          if (hireTimestamps !== null) {
            const hireDate = new Date(hireTimestamps);
            if (hireDate > firstRenewalDate) {
              currentDate = hireDate;
            }
          }
          if (currentDate === null) {
            currentDate = firstRenewalDate;
          }

          if (!this.$helpers.isDate(v)) {
            return this.$t("validation.not_a_date");
          }
          return (
            this.coverageUntrackedAllowedDates(v) ||
            this.$t("validation.date_{0}", [this.formatDate2(currentDate)])
          );
        },
        minmax: (customCoverage) => {
          //console.log(customCoverage);
          let valid = true;
          if (customCoverage.MinVolume) {
            valid =
              customCoverage.CoverageIdentity.Current.MinVolume <=
              customCoverage.Volume;
          }
          if (!valid) return false;
          if (customCoverage.MaxVolume) {
            valid =
              customCoverage.CoverageIdentity.Current.MaxVolume >=
              customCoverage.Volume;
          }
          return (
            valid ||
            `Value must be between ${customCoverage.CoverageIdentity.Current.MinVolume} and ${customCoverage.CoverageIdentity.Current.MaxVolume}`
          );
        },
        bothCompleted: () => {
          console.log(
            this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt
          );
          console.log(
            this.personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt
          );
          if (
            this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt ===
              null ||
            this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt ===
              undefined
          ) {
            console.log("1");
            return (
              this.personalInfo.Identity.MemberEnrolment
                .EnrollmentReceivedAt === null ||
              this.personalInfo.Identity.MemberEnrolment
                .EnrollmentReceivedAt === undefined ||
              "Enrolment Signed Date and Enrolment Received Date must be both completed or empty"
            );
          } else if (
            this.personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt ===
              null ||
            this.personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt ===
              undefined
          ) {
            console.log("2");
            return (
              this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt ===
                null ||
              this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt ===
                undefined ||
              "Enrolment Signed Date and Enrolment Received Date must be both completed or empty"
            );
          } else {
            console.log("3");
            return true;
          }
        },
        bothCompletedReinstate: () => {
          if (
            this.reinstateItem.MemberEnrolment.EnrollmentSignedAt === null ||
            this.reinstateItem.MemberEnrolment.EnrollmentSignedAt === undefined
          ) {
            return (
              this.reinstateItem.MemberEnrolment.EnrollmentReceivedAt ===
                null ||
              this.reinstateItem.MemberEnrolment.EnrollmentReceivedAt ===
                undefined ||
              "Enrolment Signed Date and Enrolment Received Date must be both completed or empty"
            );
          } else if (
            this.reinstateItem.MemberEnrolment.EnrollmentReceivedAt === null ||
            this.reinstateItem.MemberEnrolment.EnrollmentReceivedAt ===
              undefined
          ) {
            return (
              this.reinstateItem.MemberEnrolment.EnrollmentSignedAt === null ||
              this.reinstateItem.MemberEnrolment.EnrollmentSignedAt ===
                undefined ||
              "Enrolment Signed Date and Enrolment Received Date must be both completed or empty"
            );
          } else {
            return true;
          }
        },
        confirmContactInfoHomeEmail: () => {
          if (this.contactInfo === null || this.contactInfo === undefined) {
            return false;
          }
          if (
            (this.confirmHomeEmail === null ||
              this.confirmHomeEmail === undefined) &&
            (this.contactInfo.HomeEmail === null ||
              this.contactInfo.HomeEmail === undefined)
          ) {
            return true;
          }
          return (
            this.confirmHomeEmail === this.contactInfo.HomeEmail ||
            this.$t("validation.emails_must_match")
          );
        },
        // confirmHomeEmail: () => {
        //   if (
        //     (this.confirmHomeEmail === null || this.confirmHomeEmail === undefined) &&
        //     (this.editedItem.HomeEmail === null ||
        //       this.editedItem.HomeEmail === undefined)
        //   ) {
        //     return true;
        //   }
        //   return (
        //     this.confirmHomeEmail === this.editedItem.HomeEmail ||
        //     this.$t("validation.emails_must_match")
        //   );
        // },
        confirmContactInfoWorkEmail: () => {
          if (this.contactInfo === null || this.contactInfo === undefined) {
            return false;
          }
          if (
            (this.confirmWorkEmail === null ||
              this.confirmWorkEmail === undefined) &&
            (this.contactInfo.WorkEmail === null ||
              this.contactInfo.WorkEmail === undefined)
          ) {
            return true;
          }
          return (
            this.confirmWorkEmail === this.contactInfo.WorkEmail ||
            this.$t("validation.emails_must_match")
          );
        },
        // confirmWorkEmail: () => {
        //   if (
        //     (this.confirmWorkEmail === null || this.confirmWorkEmail === undefined) &&
        //     (this.editedItem.WorkEmail === null ||
        //       this.editedItem.WorkEmail === undefined)
        //   ) {
        //     return true;
        //   }
        //   return (
        //     this.confirmWorkEmail === this.editedItem.WorkEmail ||
        //     this.$t("validation.emails_must_match")
        //   );
        // },
        confirmEmail: () => {
          if (this.contactInfo === null || this.contactInfo === undefined) {
            return false;
          }
          if (
            (this.confirmEmail === null || this.confirmEmail === undefined) &&
            (this.contactInfo.Identity.Email === null ||
              this.contactInfo.Identity.Email === undefined)
          ) {
            return true;
          }
          return (
            this.confirmEmail === this.contactInfo.Identity.Email ||
            this.$t("validation.emails_must_match")
          );
        },
        confirmEmail2: () => {
          if (
            (this.confirmEmail === null || this.confirmEmail === undefined) &&
            (this.editedItem.Email === null ||
              this.editedItem.Email === undefined)
          ) {
            return true;
          }
          return (
            this.confirmEmail === this.editedItem.Email ||
            this.$t("validation.emails_must_match")
          );
        },
        coverageEffectiveDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.memberIdentity === null ||
            this.memberIdentity === undefined ||
            this.memberIdentity.PlanEntryDate === null ||
            this.memberIdentity.PlanEntryDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.memberIdentity.PlanEntryDate);
          const d = new Date(n);
          if (!this.$helpers.isDate(v)) {
            return this.$t("validation.not_a_date");
          }
          const val = new Date(Date.parse(v));
          return (
            val >= d ||
            this.$t("validation.date_{0}", [
              this.$helpers.formatValidationDate(d),
            ])
          );
        },
        coverageEffectiveDate2: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.memberIdentity === null ||
            this.memberIdentity === undefined ||
            this.memberIdentity.CoverageEffectiveDate === null ||
            this.memberIdentity.CoverageEffectiveDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.memberIdentity.CoverageEffectiveDate);
          const d = new Date(n);
          if (!this.$helpers.isDate(v)) {
            return this.$t("validation.not_a_date");
          }
          const val = new Date(Date.parse(v));
          return (
            val >= d ||
            this.$t("validation.date_{0}", [
              this.$helpers.formatValidationDate(d),
            ])
          );
        },
        enrollmentSignedAt: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.personalInfo === null ||
            this.personalInfo === undefined ||
            this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt ===
              null ||
            this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt ===
              undefined
          ) {
            return true;
          }
          const n = Date.parse(
            this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt
          );
          const d = new Date(n);
          if (!this.$helpers.isDate(v)) {
            return this.$t("validation.not_a_date");
          }
          const val = new Date(Date.parse(v));
          return (
            val >= d ||
            this.$t("validation.date_{0}", [
              this.$helpers.formatValidationDate(d),
            ])
          );
        },
        coverageExpireDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.editedItemCoverage === null ||
            this.editedItemCoverage === undefined ||
            this.coverageEffectiveDate === null ||
            this.coverageEffectiveDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.coverageEffectiveDate);
          const d = new Date(n);
          if (!this.$helpers.isDate(v)) {
            return this.$t("validation.not_a_date");
          }
          return (
            this.coverageExpireAllowedDates(v) ||
            this.$t("validation.date_greater_{0}", [
              this.formatDate(this.coverageEffectiveDate),
            ])
          );
        },
        // coverageUntrackedExpireDate: (v) => {
        //   if (v === undefined || v === null || v === "") {
        //     return true;
        //   }
        //   if (
        //     this.editedUntrackedItemCoverage === null ||
        //     this.editedUntrackedItemCoverage === undefined ||
        //     this.editedUntrackedItemCoverage.CurrentMembershipStatus
        //       .EffectiveDate === null ||
        //     this.editedUntrackedItemCoverage.CurrentMembershipStatus
        //       .EffectiveDate === undefined
        //   ) {
        //     return true;
        //   }
        //   const n = Date.parse(
        //     this.editedUntrackedItemCoverage.CurrentMembershipStatus
        //       .EffectiveDate
        //   );
        //   const d = new Date(n);
        //   if (!this.isDate(v)) {
        //     return this.$t("validation.date_{0}", [this.formatDate2(d)]);
        //   }
        //   return (
        //     this.coverageUntrackedExpireAllowedDates(v) ||
        //     this.$t("validation.date_{0}", [this.formatDate2(d)])
        //   );
        // },
        coverageExpireReinstateDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.reinstateItem === null ||
            this.reinstateItem === undefined ||
            this.reinstateEffectiveDate === null ||
            this.reinstateEffectiveDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.reinstateEffectiveDate);
          const d = new Date(n);
          if (!this.$helpers.isDate(v)) {
            return this.$t("validation.not_a_date");
          }
          return (
            this.coverageExpireReinstateAllowedDates(v) ||
            this.$t("validation.date_{0}", [this.formatDate(d)])
          );
        },
        coverageExpireEmploymentInfoDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.employmentInfo === null ||
            this.employmentInfo === undefined ||
            this.employmentInfoEffectiveDate === null ||
            this.employmentInfoEffectiveDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.employmentInfoEffectiveDate);
          const d = new Date(n);
          if (!this.$helpers.isDate(v)) {
            return this.$t("validation.not_a_date");
          }
          return (
            this.coverageExpireEmploymentInfoAllowedDates(v) ||
            this.$t("validation.date_{0}", [this.formatDate(d)])
          );
        },
        benefitYearEffectiveDate: (v) => {
          if (v === undefined || v === null || v === "") {
            return true;
          }
          if (
            this.coverageEffectiveDate === null ||
            this.coverageEffectiveDate === undefined
          ) {
            return true;
          }
          const n = Date.parse(this.coverageEffectiveDate);
          const d = new Date(n);
          if (!this.$helpers.isDate(v)) {
            return this.$t("validation.not_a_date");
          }
          const val = new Date(Date.parse(v));
          return (
            val <= d ||
            this.$t("validation.date_lower_{0}", [
              this.$helpers.formatValidationDate(d),
            ])
          );
        },
        requiredSIN: () => {
          console.log("requiredSIN: ", this.editedUntrackedItem.MemberIdentification.SIN, this.editedUntrackedItem.MemberIdentification.TemporarySIN)
          let valid = false;
          if (this.editedUntrackedItem === null || this.editedUntrackedItem === undefined) {
            return true;
          }
          if (this.editedUntrackedItem.MemberIdentification === null || this.editedUntrackedItem.MemberIdentification === undefined) {
            return true;
          }
          // if (this.editedUntrackedItem.MemberIdentification.SIN === null || this.editedUntrackedItem.MemberIdentification.SIN === undefined) {
            valid =  (this.editedUntrackedItem.MemberIdentification.TemporarySIN !== null && this.editedUntrackedItem.MemberIdentification.TemporarySIN !== undefined);
          // }
          // else if (this.editedUntrackedItem.MemberIdentification.TemporarySIN === null || this.editedUntrackedItem.MemberIdentification.TemporarySIN === undefined) {
          if (!valid) {
            valid =  (this.editedUntrackedItem.MemberIdentification.SIN !== null && this.editedUntrackedItem.MemberIdentification.SIN !== undefined);
          }
          // }

          if (valid) {
            return true;
          }
          return this.$t("validation.required_sin");
        }
      },
      customizedCoverages: [],
      customizedCoveragesVolumeChoice: [],
      selectableFamilyStatuses: [],
      coverageConfigurationHeaders: [
        {
          text: "Description",
          value: "Description",
        },
        {
          text: "Type",
          value: "ParameterType",
          align: "center",
        },
        {
          text: "Rates",
          value: "ConfigurationParameterValues",
          align: "right",
        },
        {
          text: "Rates Mode",
          value: "isCustom",
          align: "center",
        },
        {
          value: "Reset",
        },
      ],
      coverageConfiguration: [],
      editedValue: -1.0,
      parameterValid: false,
      memberGroups: [],
      enableWatchers: true,
      coverageEffectiveDate: null,
      addNoteDialog: false,
      note: null,
      activeNotesDialog: false,
      archivedNotesDialog: false,
      originalCoveragePayload: {
        MemberBenefits: [],
        MembershipStatus: {},
        TerminationMembershipEvent: {},
      },
      personalInfo: {
        Identity: {
          MemberIdentification: {},
          MemberEnrolment: {},
        },
      },
      personalInfoEffectiveDate: null,
      personalInfoQuery: "",
      employmentInfo: null,
      employmentInfoEffectiveDate: null,
      employmentInfoQuery: "",
      occupations: [],
      stores: [],
      employers: [],
      contactInfo: null,
      unionLocal: {},
      contactInfoEffectiveDate: null,
      unionLocalEffectiveDate: null,
      contactInfoQuery: "",
      activeNotesCount: 0,
      directDeposit: {},
      directDepositEffectiveDate: null,
      directDepositQuery: "",
      benefitCardQuery: "",
      addOtherFileDialog: false,
      addChangeFormDialog: false,
      otherFile: null,
      changeForm: null,
      otherFiles: [],
      changeFiles: [],
      changeFormNotes: null,
      otherFileNotes: null,
      hasCoverageCommencementRules: false,
      hasCoverageCommencementRulesPlan: false,
      overrideCommencementRules: false,
      originalSIN: null,
      originalTemporarySIN: null,
      originalEnrolmentSignedAt: null,
      originalUnionInitiationDate: null,
      originalEnrolmentReceivedAt: null,
      spouseExists: true,
      dependantIdentities: [],
      showDetails: false,
      hsa: null,
      sickPaymentBalance: null,
      benefitYear: null,
      welcomeKitExists: false,
      employmentCoverage: false,
      originalMemberBenefits: [],
      hasHSA: true,
      eligibilityBankBalance: null,
      isPlanType: "-1"
    };
  },
  props: {
    id: String,
  },
  methods: {
    ...mapActions("plansMembers", [
      "getExtendableMemberBenefits",
      "getMembersManagementColumns",
      "getMemberInfo",
      "updateMemberUntracked",
      "createMemberPortalAccount",
      "changeMemberEmail",
      "resendMemberRegistrationEmail",
      "resendMemberConfirmationEmail",
      "deleteMemberPortalAccount",
      "resetMemberPortalPassword",
      "memberPortalViewImpersonate",
      "memberPortalImpersonateToken",
      "getMembershipStatusByEffectiveDate",
      "changeActivityStatus",
      "changeClass",
      "getPlanDetailsByDate",
      "getMemberGroupsWithDate",
      "getMemberCoverageByEffectiveDate",
      "getCoverageConfiguration",
      "updateMemberCoverage",
      "getPersonalInfoByEffectiveDate",
      "updateMemberPersonalInfo",
      "getEmploymentInfoByEffectiveDate",
      "updateMemberEmploymentInfo",
      "getContactInfoByEffectiveDate",
      "updateMemberContactInfo",
      "getActiveNotesCount",
      "getDirectDepositByEffectiveDate",
      "updateMemberDirectDeposit",
      "getByEffectiveDate",
      "saveBeneficiaries",
      "deleteBeneficiaryStatement",
      "getMemberByEffectiveDate",
      "reinstate",
      "addEnrolmentForm",
      "addOtherFile",
      "addChangeForm",
      "saveMemberNote",
      "validateBankAccount",
      "getPlanMemberFiles",
      "getMemberTermination",
      "getMemberSelfPaymentsInfo",
      "correctCoverageInformation",
      "checkHasCoverageCommencementRules",
      "getPolicyIdentitiesByMemberIdentityId",
      "getPolicyIdentitiesByCoverageIds",
      "getMemberUnionLocalByEffectiveDate",
      "getUnionLocalsByEffectiveDate",
      "updateMemberUnionLocal",
      "memberHasSpouse",
      "releaseCertificate",
      "getMemberCurrentSickPaymentBalance",
      "deleteMemberDirectDeposit",
      "getEmployersDropDown",
      "getMemberCurrentEligibilityBankBalance",
      "getMemberEligibilityBankId",
      "eligibilityBankCreditHoursMember",
      "correctPlanEntryDateAction",
      "checkHasCoverageCommencementRulesPlan",
      "eligibilityBankReevaluateMember"
    ]),
    ...mapActions("downloadCenter", [
      "getBenefitCardImage",
      "getMemberBenefitCards",
      "setBaseUrl",
      "setBaseOdataUrl",
      "setBaseOdataUrlMember",
      "getPlanWelcomeKit",
      "getPlanWelcomeKitNew",
    ]),
    ...mapActions("documentsService", ["downloadFile"]),
    ...mapActions("claims", ["getMemberHsa"]),
    saveCoverageDisabled() {
      console.log("save coverage disabled: ", this.valid.coverage, this.valid.coverageEdit(), this.memberIdentity.CurrentTerminationMembershipEvent, );
      return !this.valid.coverage ||
              !this.valid.coverageEdit() ||
              (this.memberIdentity.CurrentTerminationMembershipEvent &&
                this.memberIdentity.CurrentTerminationMembershipEvent
                  .IsTerminated) ||
              !(
                this.role.indexOf('Broker Plan Manager') > -1 ||
                this.role.indexOf('Broker Plan Admin') > -1 ||
                this.role.indexOf('Employer Plan Admin') > -1
              )
    },
    setPlanType() {
      console.log("-------------------------isPlanType #0: ");
      //plan types:
      //1. Without Waiting Period - Without Smart Coverage Eligibility
      //2. With Waiting Period - Without Smart Coverage Eligibility
      //3. With Waiting Period - With Smart Coverage Eligibility
      //4. Without Waiting Period - With Smart Coverage Eligibility
      //5. Without Waiting Period - With Hourbank eligibility
      //6. With Waiting Period - With Hourbank eligibility
      const hasWaitingPeriod = this.planIdentity.CurrentPlanMemberEligibility &&
                  this.planIdentity.CurrentPlanMemberEligibility
                    .IncludeWaitingPeriod;
      const hasSmartCoverageEligibility = this.hasCoverageCommencementRulesPlan;
      const hasHourBankEligibility = false; //TODO
      console.log("-------------------------isPlanType: ", hasWaitingPeriod, hasSmartCoverageEligibility);
      if (hasWaitingPeriod) {
        if (hasSmartCoverageEligibility) {
          return "3";
        } else if (hasHourBankEligibility) {
          return "6";
        }
        return "2";
      } else {
        if (hasSmartCoverageEligibility) {
          return "4";
        } else if (hasHourBankEligibility) {
          return "5";
        }
        return "1";
      }

      // if (hasWaitingPeriod && hasSmartCoverageEligibility) {
      //   return 3;
      // }
      // if (!hasWaitingPeriod && hasSmartCoverageEligibility) {
      //   return 4;
      // }
      // if (!hasWaitingPeriod && hasHourBankEligibility) {
      //   return 5;
      // }
      // if (hasWaitingPeriod && hasHourBankEligibility) {
      //   return 5;
      // }
      // if (!hasWaitingPeriod && !hasSmartCoverageEligibility) {
      //   return 1;
      // }
      // if (hasWaitingPeriod && !hasSmartCoverageEligibility) {
      //   return 2;
      // }
    },
    showExtensionOfBenefits() {
      const now = new Date();
      const extensionDate = Date.parse(
        "memberIdentity.LastExtensionTerminationDate"
      );
      if (extensionDate > now) {
        return this.$t("components.memberview.on_extension_of_benefits");
      }
      return this.$t("components.memberview.terminated");
    },
    async updatePersonalInfoEnrolmentSignedAt(val) {
      console.log(val);
      this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt = val;
      await this.$nextTick();
      this.$refs.personalInfoForm.validate();
    },
    async updatePersonalInfoEnrolmentReceivedAt(val) {
      console.log(val);
      this.personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt = val;
      await this.$nextTick();
      this.$refs.personalInfoForm.validate();
    },
    getBenefitYearStartMonth() {
      if (
        this.memberIdentity.CurrentMemberBenefitYear !== null &&
        this.memberIdentity.CurrentMemberBenefitYear !== undefined
      ) {
        const benefitYear = this.$helpers
          .months()
          .filter(
            (o) =>
              o.value ===
              this.memberIdentity.CurrentMemberBenefitYear.StartMonth
          )[0];
        return this.$t("months." + benefitYear.text);
      }
      return "";
    },
    saveBenefitYear() {
      this.editedItemCoverage.CurrentMemberBenefitYear.StartMonth =
        this.benefitYear.StartMonth;
      this.dialogs.benefitYear = false;
    },
    editBenefitYear() {
      this.benefitYear = {
        EffectiveDate: this.coverageEffectiveDate,
        StartMonth: this.editedItemCoverage.CurrentMemberBenefitYear.StartMonth,
      };
      this.dialogs.benefitYear = true;
    },
    async reloadHsa() {
      try {
        const hsa = (
          await this.getMemberHsa({
            planIdentityId: this.planIdentity.Id,
            memberIdentityId: this.id,
          })
        ).data.value;
        if (hsa && hsa.length > 0) {
          this.hsa = hsa[0];
        } else {
          this.hsa = {
            HSACreditToExpire: {},
          };
        }
        if (
          this.$refs.transactions !== null &&
          this.$refs.transactions !== undefined
        ) {
          this.$refs.transactions.reload();
        }
      } catch (error) {
        this.error = error;
      }
    },
    updateSin(v) {
      if (v === "") {
        this.editedUntrackedItem.MemberIdentification.SIN = null;
      } else {
        this.editedUntrackedItem.MemberIdentification.SIN = v;
      }
    },
    updateTemporarySin(v) {
      if (v === "") {
        this.editedUntrackedItem.MemberIdentification.TemporarySIN = null;
      } else {
        this.editedUntrackedItem.MemberIdentification.TemporarySIN = v;
      }
    },
    applyHireDate() {
      if (
        this.editedUntrackedItemCoverage === null ||
        this.editedUntrackedItemCoverage === undefined
      ) {
        return;
      }
      if (
        this.editedUntrackedItemCoverage.CurrentMembershipStatus &&
        this.editedUntrackedItemCoverage.CurrentMembershipStatus.EffectiveDate
      ) {
        this.editedUntrackedItemCoverage.CurrentMembershipStatus.EffectiveDate =
          this.computeCoverageEffectiveDate();
      }
    },
    computeCoverageEffectiveDate() {
      let d = null;
      if (
        this.planIdentity.CurrentPlanMemberEligibility &&
        this.planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod &&
        this.editedUntrackedItemCoverage.CurrentEmploymentInformation.HireDate
      ) {
        if (this.waiveWaitingPeriod) {
          //hireDate
          d =
            this.editedUntrackedItemCoverage.CurrentEmploymentInformation
              .HireDate;
        } else {
          //hireDate +waitingPeriod
          let n2 = Date.parse(
            this.editedUntrackedItemCoverage.CurrentEmploymentInformation
              .HireDate
          );

          if (
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
            "Month"
          ) {
            n2 = this.addMonths(
              n2,
              this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
            );
          } else if (
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
            "Week"
          ) {
            n2 = this.addWeeks(
              n2,
              this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
            );
          } else if (
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
            "Day"
          ) {
            n2 = this.addDays(
              n2,
              this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
            );
          }

          // new Date(n2)

          let dd = new Date(n2);
          const formatted = this.formatDate2(dd);

          d = formatted;
        }
      } else if (
        Object.keys(this.untrackedCoverageHeadersDictionary).indexOf(
          "Hire Date"
        ) > -1
      ) {
        //hireDate
        d =
          this.editedUntrackedItemCoverage.CurrentEmploymentInformation
            .HireDate;
      }

      if (d === null) {
        return this.planIdentity.FirstRenewalDate;
      }
      const n = Date.parse(d);
      const d1 = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      if (d1 < d2) {
        return this.planIdentity.FirstRenewalDate;
      }
      return d;
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setUTCDate(result.getUTCDate() + days);
      return result;
    },
    addWeeks(date, weeks) {
      var result = new Date(date);
      result.setUTCDate(result.getUTCDate() + weeks * 7);
      return result;
    },
    addMonths(date, months) {
      var result = new Date(date);
      result.setUTCMonth(result.getUTCMonth() + months);
      return result;
    },
    occupationKeyDown(keyboardEvent) {
      if (keyboardEvent.keyCode === 13) {
        let id = this.$refs.occupation.randomName;
        let newval = document.getElementById(id).value;
        this.occupations.push(newval);
      }
    },
    isValidBenefit(benefit) {
      console.log("isValidBenefit: ", benefit);
      let valid = true;
      if (benefit && benefit.IsWaived) {
        return true;
      }
      if (benefit && benefit.CoverageIdentity.Current.HasCoverageChoice) {
        valid =
          benefit.CoverageStatus !== null &&
          benefit.CoverageStatus !== undefined;
      }
      if (!valid) {
        return valid;
      }
      if (
        benefit &&
        benefit.CoverageStatus &&
        benefit.CoverageStatus.Name !== "Single" &&
        this.tracksDependantsByNumber(benefit)
      ) {
        valid =
          benefit.NoOfDependants !== null &&
          benefit.NoOfDependants !== undefined;
      }
      if (!valid) {
        return valid;
      }
      if (
        benefit &&
        benefit.CoverageStatus &&
        benefit.CoverageStatus.Name !== "Single" &&
        this.tracksDependantsByName(benefit)
      ) {
        valid =
          (benefit.Dependants !== null &&
            benefit.Dependants !== undefined &&
            Array.isArray(benefit.Dependants) &&
            benefit.Dependants.length > 0) ||
          (valid =
            benefit.DependantIdentities !== null &&
            benefit.DependantIdentities !== undefined &&
            Array.isArray(benefit.DependantIdentities) &&
            benefit.DependantIdentities.length > 0);
      }
      if (!valid) {
        return valid;
      }
      if (benefit && benefit.CoverageIdentity.Current.HasVolumeChoice) {
        valid = benefit.Volume !== null && benefit.Volume !== undefined;
      }
      return valid;
    },
    coverageExpireAllowedDates(val) {
      if (
        this.coverageEffectiveDate === null ||
        this.coverageEffectiveDate === undefined
      ) {
        return true;
      }
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.coverageEffectiveDate);
      const d2 = new Date(n2);
      return d > d2;
    },
    coverageExpireReinstateAllowedDates(val) {
      if (
        this.reinstateEffectiveDate === null ||
        this.reinstateEffectiveDate === undefined
      ) {
        return true;
      }
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.reinstateEffectiveDate);
      const d2 = new Date(n2);
      return d > d2;
    },
    coverageExpireEmploymentInfoAllowedDates(val) {
      if (
        this.employmentInfoEffectiveDate === null ||
        this.employmentInfoEffectiveDate === undefined
      ) {
        return true;
      }
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.employmentInfoEffectiveDate);
      const d2 = new Date(n2);
      return d > d2;
    },
    // coverageUntrackedExpireAllowedDates(val) {
    //   if (
    //     this.editedUntrackedItemCoverage.CurrentMembershipStatus
    //       .EffectiveDate === null ||
    //     this.editedUntrackedItemCoverage.CurrentMembershipStatus
    //       .EffectiveDate === undefined
    //   ) {
    //     return true;
    //   }
    //   const n = Date.parse(val);
    //   const d = new Date(n);
    //   const n2 = Date.parse(
    //     this.editedUntrackedItemCoverage.CurrentMembershipStatus.EffectiveDate
    //   );
    //   const d2 = new Date(n2);
    //   return d > d2;
    // },
    removeDependant(item) {
      console.log(this.selectedBenefit.Dependants, item);
      if (Array.isArray(this.selectedBenefit.Dependants)) {
        this.selectedBenefit.Dependants =
          this.selectedBenefit.Dependants.filter((o) => o !== item.IdentityId);
      } else {
        this.selectedBenefit.Dependants = null;
      }
      this.$forceUpdate();
    },

    async downloadFiles(item) {
      console.log("download: ", item);
      this.loadingMember = true;
      const ids = mapFileSegmentIds([item]);
      try {
        const res = (await this.downloadFile({ ids: ids })).data;
        const blob = this.$files.b64toBlob(res);
        const name =
          ids.length > 1 ? "files.zip" : item.FileSegments[0].FileName;
        saveAs(blob, name);
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingMember = false;
      }
    },
    unmask(v, mask) {
      // console.log(v, mask);
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    addEnrolmentFormHandler() {
      this.addEnrolmentFormDialog = true;
    },
    addOtherFileHandler() {
      this.addOtherFileDialog = true;
    },
    addChangeFormHandler() {
      this.addChangeFormDialog = true;
    },
    bindEnrolmentForm(memberFiles) {
      if (memberFiles.length > 0) {
        const files = createMemberFile(memberFiles, "Enrolment", this.id);
        this.enrolmentForm = files;
        this.enrolmentFiles = memberFiles;
      } else {
        this.enrolmentForm = null;
        this.enrolmentFiles = [];
      }
    },
    bindOtherFile(memberFiles) {
      if (memberFiles.length > 0) {
        const files = createMemberFile(memberFiles, "Other", this.id);
        this.otherFile = files;
        this.otherFile.Timestamp = this.otherFile.FileSegments[0].Timestamp;
        this.otherFiles = memberFiles;
      } else {
        this.otherFile = null;
        this.otherFiles = [];
      }
    },
    bindChangeForm(memberFiles) {
      if (memberFiles.length > 0) {
        const files = createMemberFile(memberFiles, "ChangeForm", this.id);
        this.changeForm = files;
        this.changeForm.Timestamp = this.changeForm.FileSegments[0].Timestamp;
        this.changeFiles = memberFiles;
      } else {
        this.changeForm = null;
        this.changeFiles = [];
      }
    },
    async saveEnrolmentForm() {
      this.saving = true;
      try {
        await this.addEnrolmentForm({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: this.enrolmentForm,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.addEnrolmentFormDialog = false;
        await this.reloadMemberFiles();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async saveOtherFile() {
      this.saving = true;
      this.otherFile.MemberIdentityId = this.id;
      this.otherFile.Note = {
        Text: this.otherFileNotes,
        Category: "Other",
        Title: "Other File",
        MemberIdentityId: this.id,
        IsActive: true,
      };
      try {
        await this.addOtherFile({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: this.otherFile,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.addOtherFileDialog = false;
        await this.reloadMemberFiles();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async saveChangeForm() {
      this.saving = true;
      this.changeForm.MemberIdentityId = this.id;
      this.changeForm.Note = {
        Text: this.changeFormNotes,
        Category: "Other",
        Title: "Change Form",
        MemberIdentityId: this.id,
        IsActive: true,
      };
      try {
        await this.addChangeForm({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: this.changeForm,
        });
        this.changeFormNotes = null;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.addChangeFormDialog = false;
        await this.reloadMemberFiles();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async loadPlanData() {
      try {
        this.loadingMember = true;
        if (
          this.planIdentity.HasDrupalPortal &&
          this.planIdentity.MembersPortal &&
          this.planIdentity.MembersPortal.IsActive
        ) {
          this.setBaseOdataUrl("cms/odata/");
          this.setBaseUrl("cms/");
          this.setBaseOdataUrlMember(
            "cms/odata/plans/" + this.selectedPlan.Id + "/"
          );
          this.welcomeKitExists =
            (
              await this.getPlanWelcomeKit({
                planIdentityId: this.selectedPlan.Id,
              })
            ).value.length > 0;
        } else if (
          !this.planIdentity.HasDrupalPortal &&
          this.planIdentity.MembersPortal &&
          this.planIdentity.MembersPortal.IsActive
        ) {
          this.setBaseOdataUrl("cms/plans/" + this.selectedPlan.Id + "/");
          this.setBaseUrl("cms/plans/" + this.selectedPlan.Id + "/");
          this.setBaseOdataUrlMember("cms/plans/" + this.selectedPlan.Id + "/");
          this.welcomeKitExists =
            (
              await this.getPlanWelcomeKitNew({
                planIdentityId: this.selectedPlan.Id,
              })
            ).value.length > 0;
        }

        this.hasCoverageCommencementRulesPlan =
            await this.checkHasCoverageCommencementRulesPlan({
              planId: this.selectedPlan.Id,
            });
            console.log("-----------------------memberIdentity #3: ");
            this.isPlanType = this.setPlanType();
            console.log("-----------------------memberIdentity #4:", this.isPlanType);

        this.spouseExists = (
          await this.memberHasSpouse({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
          })
        ).data;
        //console.log("id is ", this.id);
        const headers = (
          await this.getMembersManagementColumns(this.selectedPlan.Id)
        ).data.sort((a, b) => {
          return a.order - b.order;
        });
        this.headers = headers;
        const untrackedHeaders = headers.filter(
          (o) => o.canEditUntracked === true
        );
        this.untrackedQuery = this.createUntrackedQuery(untrackedHeaders);
        const untrackedCoverageHeaders = headers; /*.filter(
          (o) => o.canEditUntrackedCoverage === true
        );*/
        this.untrackedCoverageQuery = this.createUntrackedCoverageQuery(
          untrackedCoverageHeaders
        );
        this.personalInfoQuery = this.createPersonalInfoQuery(headers);
        this.employmentInfoQuery = this.createEmploymentInfoQuery(headers);
        this.contactInfoQuery = this.createContactInfoQuery(headers);
        this.directDepositQuery = this.createDirectDepositQuery(headers);
        this.benefitCardQuery = this.createBenefitCardQuery(headers);
        this.unionLocalQuery = this.createUnionLocalQuery(headers);

        this.reinstateQuery = this.createReinstateQuery(headers);

        this.hasBankAccount =
          headers.filter((o) => o.text === "Account Type").length > 0;

        for (const header of headers) {
          if (header.onEdit === "Edit" || header.onEdit === "View") {
            // console.log(header.text);
            this.headersDictionary[header.text] = header;
          }
        }

        this.memberOdataQuery = this.createMemberOdataQuery(headers);

        const memberIdentity = (
          await this.getMemberInfo({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: this.memberOdataQuery,
          })
        ).data;
        console.log("-----------------------memberIdentity: ", JSON.stringify(this.memberIdentity));
        if (
          memberIdentity === null ||
          memberIdentity === undefined ||
          Object.keys(memberIdentity).length === 0
        ) {
          console.log(
            "memberIdentity is null or undefined: ",
            this.memberIdentity
          );
          this.$router.push({
            name: "membersManagement",
            params: {
              planId: this.selectedPlan.Id,
            },
          });
        }

        if (
          memberIdentity.CurrentEmploymentInformation === null ||
          memberIdentity.CurrentEmploymentInformation === undefined
        ) {
          memberIdentity.CurrentEmploymentInformation = {};
        }

        this.memberIdentity = memberIdentity;

        this.canEditUntracked =
          untrackedHeaders.length > 0 &&
          this.memberIdentity &&
          this.memberIdentity.IsEditable !== false;

        // let query =
        //   "$select=Id&$expand=CurrentMembershipStatus($select=Id;$expand=DefaultCoverageStatus($select=Id,Name,AllowDependants,AllowSpouse,AllowChild;$expand=Translations($select=LanguageCode,DisplayValue)),CustomConfigurationParameterValueIdentities($expand=ConfigurationParameterIdentity($expand=Current($select=CoverageIdentityId)))),CurrentMemberBenefits($select=IsWaived,CurrentPolicy,ActiveVolume,NoOfDependants,CoverageIdentityId;$expand=CoverageIdentity($expand=Current($expand=Translations($select=LanguageCode,Name))))";
        // const resp = (await this.getMemberInfo({
        //   planIdentityId: this.selectedPlan.Id,
        //   memberIdentityId: this.id,
        //   odataQuery: query,
        // })).data;

        // let coverage = resp.CurrentMemberBenefits;
        // const currentMembershipStatus = resp.CurrentMembershipStatus;
        // for (let cov of coverage) {
        //   cov.HasCustomRates =
        //     currentMembershipStatus.CustomConfigurationParameterValueIdentities.filter(
        //       (o) =>
        //         o.ConfigurationParameterIdentity.Current.CoverageIdentityId ===
        //         cov.CoverageIdentityId
        //     ).length > 0;
        // }
        // this.coverageProvider = new InMemoryProvider(coverage, CoverageHeaders);

        this.reloadCoverage();
        // this.reloadHoursHistory();
        this.reloadDependants();

        if (this.planOptions && this.planOptions.HasBeneficiaries) {
          await this.reloadBeneficiaries();

          await this.fetchInsuranceCarriersAndBeneficiaries();
        }

        this.selfPayment = (
          await this.getMemberSelfPaymentsInfo({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
          })
        ).data;

        this.reloadMemberFiles();

        if (Object.keys(this.headersDictionary).indexOf("Employer") > -1) {
          console.log("-----------------------memberIdentity #2: ", JSON.stringify(this.memberIdentity));

          this.hasHSA =
            this.memberIdentity.CurrentEmploymentInformation.Employer.Current
              .HasHealthSpendingAccount !== false;
        }

        this.activeNotesCount = (
          await this.getActiveNotesCount({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery:
              "?$select=Id&$expand=Notes($top=0;$count=true;$filter=IsActive eq true)",
          })
        ).data["Notes@odata.count"];

        this.sortedTitle = this.options.Models.Title;
        this.sortedPronoun = this.options.Models.Pronoun;
        this.sortedSuffix = this.options.Models.Suffix;
        this.sortedGender = this.options.Models.Gender;
        this.sortedFamilyStatus = this.options.Models.FamilyStatus;
        this.sortedMaritalStatus = this.options.Models.MaritalStatus;
        this.sortedProvince = this.options.Models.Province;
        this.sortedEmploymentType = this.options.Models.EmploymentType;
        this.sortedEmploymentFrequency =
          this.options.Models.EmploymentFrequency;
        this.sortedSecondIncomeType = this.options.Models.SecondIncomeType;
        this.sortedCountry = this.options.Models.Country;
        // this.sortedAccountType = this.options.Models.AccountType;

        this.sortedActivityStatus = this.planOptions.ActivityStatuses;

        let occupations = JSON.parse(this.selectedPlan.Occupations);
        this.occupations = occupations
          ? occupations.sort((a, b) => {
              return a.localeCompare(b);
            })
          : [];

        const enrolmentIds =
          this.memberIdentity.MemberEnrolment !== null &&
          this.memberIdentity.MemberEnrolment !== undefined &&
          this.memberIdentity.MemberEnrolment.EnrolmentForm !== null &&
          this.memberIdentity.MemberEnrolment.EnrolmentForm !== undefined
            ? this.memberIdentity.MemberEnrolment.EnrolmentForm.FileSegments.map(
                (o) => o.PhysicalFileId
              )
            : [];
        if (enrolmentIds.length > 0) {
          const result = (
            await axios.post(
              `${this.settings.DOCUMENTSERVICEURL + "api/Files"}`,
              enrolmentIds
            )
          ).data;

          for (const item of result) {
            const newfile = await this.makeFile(item);
            const internalItem = { file: item, File: newfile };
            internalItem.description = this.createDescription(internalItem);
            this.enrolmentFiles.push(internalItem);
          }
        }

        // const changeFormIds =
        //   this.memberIdentity.CurrentMember !== null &&
        //   this.memberIdentity.CurrentMember !== undefined &&
        //   this.memberIdentity.CurrentMember.ChangeForm !== null &&
        //   this.memberIdentity.CurrentMember.ChangeForm !== undefined
        //     ? this.memberIdentity.CurrentMember.ChangeForm.FileSegments.map(
        //         (o) => o.PhysicalFileId
        //       )
        //     : [];
        // if (changeFormIds.length > 0) {
        //   const result = (await axios.post(
        //     `${this.settings.DOCUMENTSERVICEURL + "api/Files"}`,
        //     changeFormIds
        //   )).data;
        //   for (const item of result) {
        //     const newfile = await this.makeFile(item);
        //     const internalItem = { file: item, File: newfile };
        //     internalItem.description = this.createDescription(internalItem);
        //     this.changeFiles.push(internalItem);
        //   }
        // }

        // const otherFileIds =
        //   this.memberIdentity.OtherFiles !== null &&
        //   this.memberIdentity.OtherFiles !== undefined
        //     ? this.memberIdentity.OtherFiles.FileSegments.map(
        //         (o) => o.PhysicalFileId
        //       )
        //     : [];
        // if (otherFileIds.length > 0) {
        //   const result = (await axios.post(
        //     `${this.settings.DOCUMENTSERVICEURL + "api/Files"}`,
        //     otherFileIds
        //   )).data;
        //   for (const item of result) {
        //     const newfile = await this.makeFile(item);
        //     const internalItem = { file: item, File: newfile };
        //     internalItem.description = this.createDescription(internalItem);
        //     this.otherFiles.push(internalItem);
        //   }
        // }
        const hsa = (
          await this.getMemberHsa({
            planIdentityId: this.planIdentity.Id,
            memberIdentityId: this.id,
          })
        ).data.value;
        if (hsa && hsa.length > 0) {
          this.hsa = hsa[0];
        } else {
          this.hsa = {
            HSACreditToExpire: {},
          };
        }
        if (this.planIdentity.HasSickPaymentBank) {
          const sickPaymentBalance = (
            await this.getMemberCurrentSickPaymentBalance({
              planIdentityId: this.planIdentity.Id,
              memberIdentityId: this.id,
            })
          ).data;
          if (sickPaymentBalance) {
            this.sickPaymentBalance = sickPaymentBalance;
          } else {
            this.sickPaymentBalance = {};
          }
        }

        if (this.planIdentity.HasEligibilityBank) {
          this.eligibilityBankId = (
            await this.getMemberEligibilityBankId({
              planIdentityId: this.planIdentity.Id,
              memberIdentityId: this.id,
            })
          ).data;
          if (
            this.eligibilityBankId !== null &&
            this.eligibilityBankId !== undefined
          ) {
            this.eligibilityBankBalance = (
              await this.getMemberCurrentEligibilityBankBalance({
                planIdentityId: this.planIdentity.Id,
                memberIdentityId: this.id,
              })
            ).data;
          }
        }

      } catch (error) {
        // this.error = error;
        this.sickPaymentBalance = {};
        this.eligibilityBankBalance = null;
      }
      this.loadingMember = false;
      this.$forceUpdate();
    },
    beneficiariesFormIsValid(e) {
      this.beneficiariesSaveEnabled = e;
    },
    bindSalaryInformation(memberFile) {
      delete this.employmentInfo.SalaryEvidence;
      this.employmentInfo.SalaryEvidence = createMemberFile(
        memberFile,
        "SalaryEvidence",
        this.id
      );
    },
    dependantsDisabled() {
      if (this.memberIdentity === null || this.memberIdentity === undefined) {
        return;
      }
      if (
        this.memberIdentity.CurrentMembershipStatus === null ||
        this.memberIdentity.CurrentMembershipStatus === undefined
      ) {
        return;
      }
      let a =
        (this.memberIdentity.CurrentTerminationMembershipEvent !== null &&
          this.memberIdentity.CurrentTerminationMembershipEvent !== undefined &&
          this.memberIdentity.CurrentTerminationMembershipEvent.IsTerminated) ||
        !(
          this.role.indexOf("Broker Plan Manager") > -1 ||
          this.role.indexOf("Broker Plan Admin") > -1 ||
          this.role.indexOf("Employer Plan Admin") > -1
        );
      // console.log(
      //   this.role,
      //   !(
      //     this.role.indexOf("Broker Plan Manager") > -1 ||
      //     this.role.indexOf("Broker Plan Admin") > -1 ||
      //     this.role.indexOf("Employer Plan Admin") > -1
      //   ),
      //   a
      // );
      return a;
    },
    async setCustomizableCoverages(date, item) {
      let itemCoverage = this.editedItemCoverage;
      if (item) {
        itemCoverage = item;
      }
      if (
        itemCoverage &&
        itemCoverage.CurrentMembershipStatus &&
        itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current
      ) {
        if (
          itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current
            .CoverageIdentities
        ) {
          let optionalCoverage =
            itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current.CoverageIdentities.filter(
              (o) =>
                o.Current !== null &&
                o.Current !== undefined &&
                o.Current.IsOptional === true
              // (o) => true
            );
          this.optionalCoverage = [];
          for (let coverage of optionalCoverage) {
            console.log(coverage);
            let classes = null;
            if (coverage.CurrentCoverageEligibility) {
              classes = JSON.parse(coverage.CurrentCoverageEligibility.Classes);
            }
            if (classes === null || classes === undefined) {
              classes = [];
            }
            if (
              (!coverage.CurrentCoverageEligibility ||
                !coverage.CurrentCoverageEligibility.DependsOnHasDependants ||
                (coverage.CurrentCoverageEligibility.DependsOnHasDependants &&
                  itemCoverage.CurrentMember.HasEligibleDependants === true)) &&
              (!coverage.CurrentCoverageEligibility ||
                !coverage.CurrentCoverageEligibility.DependsOnCoverageStatus ||
                coverage.CurrentCoverageEligibility.CoverageStatuses.filter(
                  (o) =>
                    o.Id ===
                    itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus
                      .Id
                ).length > 0) &&
              (!coverage.CurrentCoverageEligibility ||
                !coverage.CurrentCoverageEligibility.DependsOnClass ||
                classes.filter(
                  (o) => o === this.memberIdentity.CurrentMembershipStatus.Class
                ).length > 0) &&
              (!coverage.CurrentCoverageEligibility ||
                !(
                  coverage.CurrentCoverageEligibility.BenefitParty === "Spouse"
                ) ||
                this.dependantsProvider.items.filter(
                  (o) => o.Relationship.IsSpouse
                ).length > 0) &&
              (!coverage.CurrentCoverageEligibility ||
                !(
                  coverage.CurrentCoverageEligibility.BenefitParty === "Child"
                ) ||
                this.dependantsProvider.items.filter(
                  (o) => o.Relationship.IsChild
                ).length > 0)
            ) {
              this.optionalCoverage.push(coverage);
            }
          }
          this.selectedOptionalCoverage = this.optionalCoverage.filter(
            (o) =>
              itemCoverage.CurrentMemberBenefits.filter(
                (b) => b.CoverageIdentityId === o.Current.IdentityId
              ).length > 0
          );
        }

        let customizableCoverages =
          itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current &&
          itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current
            .CoverageIdentities
            ? itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current.CoverageIdentities.filter(
                (c) =>
                  c.Current !== null &&
                  c.Current !== undefined &&
                  (c.Current.IsOptional !== true ||
                    itemCoverage.CurrentMemberBenefits.filter(
                      (b) => b.CoverageIdentityId === c.Current.IdentityId
                    ).length > 0)
              )
            : [];

        let oldCov = JSON.parse(JSON.stringify(this.customizedCoverages));
        this.customizedCoverages = [];
        // console.log(customizableCoverages);
        for (let coverage of customizableCoverages) {
          console.log(coverage);
          let classes = null;
          if (coverage.CurrentCoverageEligibility) {
            classes = JSON.parse(coverage.CurrentCoverageEligibility.Classes);
          }
          if (classes === null || classes === undefined) {
            classes = [];
          }
          if (
            (!coverage.CurrentCoverageEligibility ||
              !coverage.CurrentCoverageEligibility.DependsOnHasDependants ||
              (coverage.CurrentCoverageEligibility.DependsOnHasDependants &&
                itemCoverage.CurrentMember.HasEligibleDependants === true)) &&
            (!coverage.CurrentCoverageEligibility ||
              !coverage.CurrentCoverageEligibility.DependsOnCoverageStatus ||
              coverage.CurrentCoverageEligibility.CoverageStatuses.filter(
                (o) =>
                  o.Id ===
                  itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus.Id
              ).length > 0) &&
            (!coverage.CurrentCoverageEligibility ||
              !coverage.CurrentCoverageEligibility.DependsOnClass ||
              classes.filter(
                (o) => o === this.memberIdentity.CurrentMembershipStatus.Class
              ).length > 0) &&
            (!coverage.CurrentCoverageEligibility ||
              !(
                coverage.CurrentCoverageEligibility.BenefitParty === "Spouse"
              ) ||
              this.dependantsProvider.items.filter(
                (o) => o.Relationship.IsSpouse
              ).length > 0) &&
            (!coverage.CurrentCoverageEligibility ||
              !(coverage.CurrentCoverageEligibility.BenefitParty === "Child") ||
              this.dependantsProvider.items.filter(
                (o) => o.Relationship.IsChild
              ).length > 0)
          ) {
            //console.log(coverage);
            let existing = oldCov.filter(
              (o) => o.CoverageIdentityId === coverage.Id
            );
            if (existing.length > 0) {
              let existingCov = JSON.parse(JSON.stringify(existing[0]));
              if (itemCoverage.CurrentMemberBenefits) {
                existing = itemCoverage.CurrentMemberBenefits.filter(
                  (o) => o.CoverageIdentityId === coverage.Id
                );
                if (existing.length > 0) {
                  this.customizedCoverages.push(
                    JSON.parse(JSON.stringify(existingCov))
                  );
                } else {
                  this.customizedCoverages.push({
                    CoverageIdentity: coverage,
                    CoverageIdentityId: coverage.Id,
                    CoverageStatus: existingCov.CoverageStatus,
                    CoverageStatusId: existingCov.CoverageStatusId,
                    EffectiveDate: date ? date : this.coverageEffectiveDate,
                    Volume: existingCov.Volume,
                    COB: existingCov.COB,
                    DependantIdentities: existingCov.DependantIdentities,
                    Dependants: existingCov.Dependants,
                  });
                }
              } else {
                this.customizedCoverages.push({
                  CoverageIdentity: coverage,
                  CoverageIdentityId: coverage.Id,
                  CoverageStatus: existingCov.CoverageStatus,
                  CoverageStatusId: existingCov.CoverageStatusId,
                  EffectiveDate: date ? date : this.coverageEffectiveDate,
                  Volume: existingCov.Volume,
                  COB: existingCov.COB,
                  DependantIdentities: existingCov.DependantIdentities,
                  Dependants: existingCov.Dependants,
                });
              }
            } else if (itemCoverage.CurrentMemberBenefits) {
              existing = itemCoverage.CurrentMemberBenefits.filter(
                (o) => o.CoverageIdentityId === coverage.Id
              );

              if (existing.length > 0) {
                this.customizedCoverages.push(
                  JSON.parse(JSON.stringify(existing[0]))
                );
              } else {
                this.customizedCoverages.push({
                  CoverageIdentity: coverage,
                  CoverageIdentityId: coverage.Id,
                  CoverageStatus: {},
                  CoverageStatusId: null,
                  EffectiveDate: date ? date : this.coverageEffectiveDate,
                  Volume: null,
                  COB: {},
                  DependantIdentities: [],
                  Dependants: [],
                });
              }
            } else {
              this.customizedCoverages.push({
                CoverageIdentity: coverage,
                CoverageIdentityId: coverage.Id,
                CoverageStatus: {},
                CoverageStatusId: null,
                EffectiveDate: date ? date : this.coverageEffectiveDate,
                Volume: null,
                COB: {},
                DependantIdentities: [],
                Dependants: [],
              });
            }
          }
        }

        for (let benefit of this.customizedCoverages) {
          // benefit.cobBool =
          //   benefit.COB &&
          //   benefit.COB.InsuranceCarrier !== null &&
          //   benefit.COB.InsuranceCarrier !== undefined;

          if (benefit.CoverageIdentity.Current.HasCoverageChoice) {
            // console.log(itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus);
            if (
              itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus.Id ===
              this.singleFamilyStatus.Id
            ) {
              if (
                benefit.CoverageStatus === null ||
                benefit.CoverageStatus === undefined ||
                (!benefit.IsWaived &&
                  benefit.CoverageStatus.Id !==
                    itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus
                      .Id)
              ) {
                date
                  ? (benefit.EffectiveDate = date)
                  : (benefit.EffectiveDate = this.coverageEffectiveDate);
              }
              benefit.CoverageStatus = this.singleFamilyStatus;
            }
            if (
              benefit.CoverageIdentity.Current.RestrictToDefaultCoverageStatus
            ) {
              if (
                benefit.CoverageStatus === null ||
                benefit.CoverageStatus === undefined ||
                (!benefit.IsWaived &&
                  benefit.CoverageStatus.Id !==
                    itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus
                      .Id)
              ) {
                date
                  ? (benefit.EffectiveDate = date)
                  : (benefit.EffectiveDate = this.coverageEffectiveDate);
              }
              benefit.CoverageStatus = this.options.Models.FamilyStatus.filter(
                (o) =>
                  o.Id ===
                  itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus.Id
              )[0];
            }
            if (
              benefit.CoverageStatus &&
              benefit.CoverageStatus.Id === this.singleFamilyStatus.Id &&
              this.tracksDependantsByNumber(benefit)
            ) {
              benefit.NoOfDependants = 0;
            } else if (
              benefit.CoverageStatus &&
              benefit.CoverageStatus.Id === this.coupleFamilyStatus.Id &&
              this.tracksDependantsByNumber(benefit)
            ) {
              benefit.NoOfDependants = 1;
            }
          }
        }
        if (this.benefitsProvider === undefined) {
          this.benefitsProvider = new InMemoryProvider(
            this.customizedCoverages.filter(
              (o) =>
                o.CoverageIdentity.Current.IsWaivable ||
                o.CoverageIdentity.Current.HasCOB ||
                o.CoverageIdentity.Current.HasCoverageChoice ||
                o.CoverageIdentity.Current.HasVolumeChoice
            ),
            BenefitHeaders
          );
          this.nonCustomizedBenefitsProvider = new InMemoryProvider(
            this.customizedCoverages.filter(
              (o) =>
                !o.CoverageIdentity.Current.IsWaivable &&
                !o.CoverageIdentity.Current.HasCOB &&
                !o.CoverageIdentity.Current.HasCoverageChoice &&
                !o.CoverageIdentity.Current.HasVolumeChoice
            ),
            NonCustomizedBenefitHeaders
          );
        } else {
          this.benefitsProvider.items = this.customizedCoverages.filter(
            (o) =>
              o.CoverageIdentity.Current.IsWaivable ||
              o.CoverageIdentity.Current.HasCOB ||
              o.CoverageIdentity.Current.HasCoverageChoice ||
              o.CoverageIdentity.Current.HasVolumeChoice
          );
          this.nonCustomizedBenefitsProvider.items =
            this.customizedCoverages.filter(
              (o) =>
                !o.CoverageIdentity.Current.IsWaivable &&
                !o.CoverageIdentity.Current.HasCOB &&
                !o.CoverageIdentity.Current.HasCoverageChoice &&
                !o.CoverageIdentity.Current.HasVolumeChoice
            );

          this.$nextTick(() => {
            if (this.$refs.benefitsTable) {
              this.$refs.benefitsTable.getDataAsync();
            }
            if (this.$refs.nonCustomizedBenefitsTable) {
              this.$refs.nonCustomizedBenefitsTable.getDataAsync();
            }
          });
        }
      }
    },
    refreshBenefits(item, date) {
      if (
        (this.benefitsProvider === null ||
          this.benefitsProvider === undefined) &&
        (this.nonCustomizedBenefitsProvider === null ||
          this.nonCustomizedBenefitsProvider === undefined)
      ) {
        return;
      }
      let itemCoverage = this.editedItemCoverage;
      if (item) {
        itemCoverage = item;
      }
      if (
        itemCoverage === null ||
        itemCoverage === undefined ||
        itemCoverage.CurrentMembershipStatus === null ||
        itemCoverage.CurrentMembershipStatus === undefined
      ) {
        return;
      }
      console.log("R e f r e s h   B e n e f i t s");
      this.customizedCoverages = this.customizedCoverages.filter((c) => {
        let classes = null;
        if (c.CoverageIdentity.CurrentCoverageEligibility) {
          classes = JSON.parse(
            c.CoverageIdentity.CurrentCoverageEligibility.Classes
          );
        }
        if (classes === null || classes === undefined) {
          classes = [];
        }
        return (
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !c.CoverageIdentity.CurrentCoverageEligibility
              .DependsOnHasDependants ||
            (c.CoverageIdentity.CurrentCoverageEligibility
              .DependsOnHasDependants &&
              itemCoverage.CurrentMember.HasEligibleDependants === true)) &&
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !c.CoverageIdentity.CurrentCoverageEligibility
              .DependsOnCoverageStatus ||
            c.CoverageIdentity.CurrentCoverageEligibility.CoverageStatuses.filter(
              (o) =>
                o.Id ===
                itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus.Id
            ).length > 0) &&
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !c.CoverageIdentity.CurrentCoverageEligibility.DependsOnClass ||
            classes.filter(
              (o) => o === itemCoverage.CurrentMembershipStatus.Class
            ).length > 0) &&
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !(
              c.CoverageIdentity.CurrentCoverageEligibility.BenefitParty ===
              "Spouse"
            ) ||
            this.dependantsProvider.items.filter((o) => o.Relationship.IsSpouse)
              .length > 0) &&
          (!c.CoverageIdentity.CurrentCoverageEligibility ||
            !(
              c.CoverageIdentity.CurrentCoverageEligibility.BenefitParty ===
              "Child"
            ) ||
            this.dependantsProvider.items.filter((o) => o.Relationship.IsChild)
              .length > 0)
        );
      });
      let customizableCoverages =
        itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current &&
        itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current
          .CoverageIdentities
          ? itemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current.CoverageIdentities.filter(
              (c) => {
                let classes = null;
                if (c.CurrentCoverageEligibility) {
                  classes = JSON.parse(c.CurrentCoverageEligibility.Classes);
                }
                if (classes === null || classes === undefined) {
                  classes = [];
                }
                //console.log(c);
                return (
                  (!c.CurrentCoverageEligibility ||
                    !c.CurrentCoverageEligibility.DependsOnHasDependants ||
                    (c.CurrentCoverageEligibility.DependsOnHasDependants &&
                      itemCoverage.CurrentMember.HasEligibleDependants ===
                        true)) &&
                  c.Current.IsOptional !== true &&
                  (!c.CurrentCoverageEligibility ||
                    !c.CurrentCoverageEligibility.DependsOnCoverageStatus ||
                    c.CurrentCoverageEligibility.CoverageStatuses.filter(
                      (o) =>
                        o.Id ===
                        itemCoverage.CurrentMembershipStatus
                          .DefaultCoverageStatus.Id
                    ).length > 0) &&
                  (!c.CurrentCoverageEligibility ||
                    !c.CurrentCoverageEligibility.DependsOnClass ||
                    classes.filter(
                      (o) => o === itemCoverage.CurrentMembershipStatus.Class
                    ).length > 0) &&
                  (!c.CurrentCoverageEligibility ||
                    !(c.CurrentCoverageEligibility.BenefitParty === "Spouse") ||
                    this.dependantsProvider.items.filter(
                      (o) => o.Relationship.IsSpouse
                    ).length > 0) &&
                  (!c.CurrentCoverageEligibility ||
                    !(c.CurrentCoverageEligibility.BenefitParty === "Child") ||
                    this.dependantsProvider.items.filter(
                      (o) => o.Relationship.IsChild
                    ).length > 0)
                );
              }
            )
          : [];
      // console.log(JSON.stringify(customizableCoverages));
      customizableCoverages = customizableCoverages.filter(
        (c) =>
          this.customizedCoverages.filter(
            (o) => o.CoverageIdentityId === c.Current.IdentityId
          ).length === 0
      );

      for (const coverage of customizableCoverages) {
        this.customizedCoverages.push({
          CoverageIdentity: coverage,
          CoverageIdentityId: coverage.Current.IdentityId,
          CoverageStatus: null,
          CoverageStatusId: null,
          EffectiveDate: date ? date : this.coverageEffectiveDate,
          Volume: null,
          COB: {},
          DependantIdentities: [],
          Dependants: [],
        });
      }
      for (let benefit of this.customizedCoverages) {
        // benefit.cobBool =
        //   benefit.COB &&
        //   benefit.COB.InsuranceCarrier !== null &&
        //   benefit.COB.InsuranceCarrier !== undefined;

        if (benefit.CoverageIdentity.Current.HasCoverageChoice) {
          if (
            itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus.Id ===
            this.singleFamilyStatus.Id
          ) {
            if (
              benefit.CoverageStatus === null ||
              benefit.CoverageStatus === undefined ||
              (!benefit.IsWaived &&
                benefit.CoverageStatus.Id !==
                  itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus.Id)
            ) {
              date
                ? (benefit.EffectiveDate = date)
                : (benefit.EffectiveDate = this.coverageEffectiveDate);
            }
            benefit.CoverageStatus = this.singleFamilyStatus;
          }
          if (
            benefit.CoverageIdentity.Current.RestrictToDefaultCoverageStatus
          ) {
            if (
              benefit.CoverageStatus === null ||
              benefit.CoverageStatus === undefined ||
              (!benefit.IsWaived &&
                benefit.CoverageStatus.Id !==
                  itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus.Id)
            ) {
              date
                ? (benefit.EffectiveDate = date)
                : (benefit.EffectiveDate = this.coverageEffectiveDate);
            }
            benefit.CoverageStatus = this.options.Models.FamilyStatus.filter(
              (o) =>
                o.Id ===
                itemCoverage.CurrentMembershipStatus.DefaultCoverageStatus.Id
            )[0];
          }
          if (
            benefit.CoverageStatus &&
            benefit.CoverageStatus.Id === this.singleFamilyStatus.Id &&
            this.tracksDependantsByNumber(benefit)
          ) {
            benefit.NoOfDependants = 0;
          } else if (
            benefit.CoverageStatus &&
            benefit.CoverageStatus.Id === this.coupleFamilyStatus.Id &&
            this.tracksDependantsByNumber(benefit)
          ) {
            benefit.NoOfDependants = 1;
          }
        }
      }

      this.benefitsProvider.items = this.customizedCoverages.filter(
        (o) =>
          o.CoverageIdentity.Current.IsWaivable ||
          o.CoverageIdentity.Current.HasCOB ||
          o.CoverageIdentity.Current.HasCoverageChoice ||
          o.CoverageIdentity.Current.HasVolumeChoice
      );
      this.nonCustomizedBenefitsProvider.items =
        this.customizedCoverages.filter(
          (o) =>
            !o.CoverageIdentity.Current.IsWaivable &&
            !o.CoverageIdentity.Current.HasCOB &&
            !o.CoverageIdentity.Current.HasCoverageChoice &&
            !o.CoverageIdentity.Current.HasVolumeChoice
        );
      this.$nextTick(() => {
        if (this.$refs.benefitsTable) {
          this.$refs.benefitsTable.getDataAsync();
        }
        if (this.$refs.nonCustomizedBenefitsTable) {
          this.$refs.nonCustomizedBenefitsTable.getDataAsync();
        }
      });
    },
    optionalChanged($event) {
      let v = $event;

      this.customizedCoverages = this.customizedCoverages.filter(
        (o) =>
          !o.CoverageIdentity.Current.IsOptional ||
          (o.CoverageIdentity.Current.IsOptional &&
            v.filter((c) => c.Current.IdentityId === o.CoverageIdentityId)
              .length > 0)
      );
      for (const cov of v) {
        if (
          this.customizedCoverages.filter(
            (o) => o.CoverageIdentityId === cov.Current.IdentityId
          ).length === 0
        ) {
          let classes = null;
          if (cov.CurrentCoverageEligibility) {
            classes = JSON.parse(cov.CurrentCoverageEligibility.Classes);
          }
          if (classes === null || classes === undefined) {
            classes = [];
          }
          if (
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnHasDependants ||
              (cov.CurrentCoverageEligibility.DependsOnHasDependants &&
                this.editedItemCoverage.CurrentMember.HasEligibleDependants ===
                  true)) &&
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnCoverageStatus ||
              cov.CurrentCoverageEligibility.CoverageStatuses.filter(
                (o) =>
                  o.Id ===
                  this.editedItemCoverage.CurrentMembershipStatus
                    .DefaultCoverageStatus.Id
              ).length > 0) &&
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnClass ||
              classes.filter(
                (o) => o === this.memberIdentity.CurrentMembershipStatus.Class
              ).length > 0)
          ) {
            // console.log("!@!@!@!@!@!@!@!@");
            this.customizedCoverages.push({
              CoverageIdentity: cov,
              CoverageIdentityId: cov.Current.IdentityId,
              CoverageStatus: null,
              CoverageStatusId: null,
              EffectiveDate: this.coverageEffectiveDate,
              Volume: null,
              COB: {},
              DependantIdentities: [],
              Dependants: [],
            });
          }
        }
      }
      for (let c of this.customizedCoverages) {
        // c.cobBool =
        //   c.COB &&
        //   c.COB.InsuranceCarrier !== null &&
        //   c.COB.InsuranceCarrier !== undefined;

        if (
          this.editedItemCoverage.CurrentMembershipStatus.DefaultCoverageStatus
            .Id === this.singleFamilyStatus.Id
        ) {
          c.CoverageStatus = this.singleFamilyStatus;
        }
      }
      this.benefitsProvider.items = this.customizedCoverages.filter(
        (o) =>
          o.CoverageIdentity.Current.IsWaivable ||
          o.CoverageIdentity.Current.HasCOB ||
          o.CoverageIdentity.Current.HasCoverageChoice ||
          o.CoverageIdentity.Current.HasVolumeChoice
      );
      this.nonCustomizedBenefitsProvider.items =
        this.customizedCoverages.filter(
          (o) =>
            !o.CoverageIdentity.Current.IsWaivable &&
            !o.CoverageIdentity.Current.HasCOB &&
            !o.CoverageIdentity.Current.HasCoverageChoice &&
            !o.CoverageIdentity.Current.HasVolumeChoice
        );
      this.$nextTick(() => {
        if (this.$refs.benefitsTable) {
          this.$refs.benefitsTable.getDataAsync();
        }
        if (this.$refs.nonCustomizedBenefitsTable) {
          this.$refs.nonCustomizedBenefitsTable.getDataAsync();
        }
      });
    },
    optionalChangedReinstate($event) {
      let v = $event;

      this.customizedCoverages = this.customizedCoverages.filter(
        (o) =>
          !o.CoverageIdentity.Current.IsOptional ||
          (o.CoverageIdentity.Current.IsOptional &&
            v.filter((c) => c.Current.IdentityId === o.CoverageIdentityId)
              .length > 0)
      );
      for (const cov of v) {
        if (
          this.customizedCoverages.filter(
            (o) => o.CoverageIdentityId === cov.Current.IdentityId
          ).length === 0
        ) {
          let classes = null;
          if (cov.CurrentCoverageEligibility) {
            classes = JSON.parse(cov.CurrentCoverageEligibility.Classes);
          }
          if (classes === null || classes === undefined) {
            classes = [];
          }
          if (
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnHasDependants ||
              (cov.CurrentCoverageEligibility.DependsOnHasDependants &&
                this.reinstateItem.CurrentMember.HasEligibleDependants ===
                  true)) &&
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnCoverageStatus ||
              cov.CurrentCoverageEligibility.CoverageStatuses.filter(
                (o) =>
                  o.Id ===
                  this.reinstateItem.CurrentMembershipStatus
                    .DefaultCoverageStatus.Id
              ).length > 0) &&
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnClass ||
              classes.filter(
                (o) => o === this.memberIdentity.CurrentMembershipStatus.Class
              ).length > 0)
          ) {
            // console.log("!@!@!@!@!@!@!@!@");
            this.customizedCoverages.push({
              CoverageIdentity: cov,
              CoverageIdentityId: cov.Current.IdentityId,
              CoverageStatus: null,
              CoverageStatusId: null,
              EffectiveDate: this.reinstateEffectiveDate,
              Volume: null,
              COB: {},
              DependantIdentities: [],
              Dependants: [],
            });
          }
        }
      }
      for (let c of this.customizedCoverages) {
        // c.cobBool =
        //   c.COB &&
        //   c.COB.InsuranceCarrier !== null &&
        //   c.COB.InsuranceCarrier !== undefined;
      }
      // this.benefitsProvider.items = this.customizedCoverages;
      // this.$refs.benefitsTable.getDataAsync();
      this.benefitsProvider.items = this.customizedCoverages.filter(
        (o) =>
          o.CoverageIdentity.Current.IsWaivable ||
          o.CoverageIdentity.Current.HasCOB ||
          o.CoverageIdentity.Current.HasCoverageChoice ||
          o.CoverageIdentity.Current.HasVolumeChoice
      );
      this.nonCustomizedBenefitsProvider.items =
        this.customizedCoverages.filter(
          (o) =>
            !o.CoverageIdentity.Current.IsWaivable &&
            !o.CoverageIdentity.Current.HasCOB &&
            !o.CoverageIdentity.Current.HasCoverageChoice &&
            !o.CoverageIdentity.Current.HasVolumeChoice
        );
      this.$nextTick(() => {
        if (this.$refs.benefitsTable) {
          this.$refs.benefitsTable.getDataAsync();
        }
        if (this.$refs.nonCustomizedBenefitsTable) {
          this.$refs.nonCustomizedBenefitsTable.getDataAsync();
        }
      });
    },
    optionalChangedEmploymentInfo($event) {
      let v = $event;

      this.customizedCoverages = this.customizedCoverages.filter(
        (o) =>
          !o.CoverageIdentity.Current.IsOptional ||
          (o.CoverageIdentity.Current.IsOptional &&
            v.filter((c) => c.Current.IdentityId === o.CoverageIdentityId)
              .length > 0)
      );
      for (const cov of v) {
        if (
          this.customizedCoverages.filter(
            (o) => o.CoverageIdentityId === cov.Current.IdentityId
          ).length === 0
        ) {
          let classes = null;
          if (cov.CurrentCoverageEligibility) {
            classes = JSON.parse(cov.CurrentCoverageEligibility.Classes);
          }
          if (classes === null || classes === undefined) {
            classes = [];
          }
          if (
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnHasDependants ||
              (cov.CurrentCoverageEligibility.DependsOnHasDependants &&
                this.employmentInfo.Identity.CurrentMember
                  .HasEligibleDependants === true)) &&
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnCoverageStatus ||
              cov.CurrentCoverageEligibility.CoverageStatuses.filter(
                (o) =>
                  o.Id ===
                  this.employmentInfo.Identity.CurrentMembershipStatus
                    .DefaultCoverageStatus.Id
              ).length > 0) &&
            (!cov.CurrentCoverageEligibility ||
              !cov.CurrentCoverageEligibility.DependsOnClass ||
              classes.filter(
                (o) => o === this.memberIdentity.CurrentMembershipStatus.Class
              ).length > 0)
          ) {
            // console.log("!@!@!@!@!@!@!@!@");
            this.customizedCoverages.push({
              CoverageIdentity: cov,
              CoverageIdentityId: cov.Current.IdentityId,
              CoverageStatus: null,
              CoverageStatusId: null,
              EffectiveDate: this.reinstateEffectiveDate,
              Volume: null,
              COB: {},
              DependantIdentities: [],
              Dependants: [],
            });
          }
        }
      }
      for (let c of this.customizedCoverages) {
        // c.cobBool =
        //   c.COB &&
        //   c.COB.InsuranceCarrier !== null &&
        //   c.COB.InsuranceCarrier !== undefined;
      }
      // this.benefitsProvider.items = this.customizedCoverages;
      // this.$refs.benefitsTable.getDataAsync();
      this.benefitsProvider.items = this.customizedCoverages.filter(
        (o) =>
          o.CoverageIdentity.Current.IsWaivable ||
          o.CoverageIdentity.Current.HasCOB ||
          o.CoverageIdentity.Current.HasCoverageChoice ||
          o.CoverageIdentity.Current.HasVolumeChoice
      );
      this.nonCustomizedBenefitsProvider.items =
        this.customizedCoverages.filter(
          (o) =>
            !o.CoverageIdentity.Current.IsWaivable &&
            !o.CoverageIdentity.Current.HasCOB &&
            !o.CoverageIdentity.Current.HasCoverageChoice &&
            !o.CoverageIdentity.Current.HasVolumeChoice
        );
      this.$nextTick(() => {
        if (this.$refs.benefitsTable) {
          this.$refs.benefitsTable.getDataAsync();
        }
        if (this.$refs.nonCustomizedBenefitsTable) {
          this.$refs.nonCustomizedBenefitsTable.getDataAsync();
        }
      });
    },
    filterFunc(item, search) {
      console.log(item);
      return (
        this.$t("enums." + item)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    async tryDeleteBeneficiaryStatement(options) {
      try {
        await this.deleteBeneficiaryStatement(options);
        this.dialogs.beneficiaries = false;
        this.beneficiariesSubmitted();
      } catch (error) {
        this.beneficiariesSubmitted(error);
      }
    },
    cancelBeneficiaries() {
      // console.log(this.$refs.beneficiariesForm.beneficiaryPayload);
      // console.log(this.beneficiaryStatements);
      // const oldBeneficiaries = this.beneficiaryStatements.map(o=>o.Beneficiaries).flat();
      if (this.selectedPlan.PlanType === "Pension") {
        const newBeneficiaries =
          this.$refs.beneficiariesForm.beneficiaryPayload.Beneficiaries.filter(
            (o) => o.Id === null || o.Id === undefined
          );
        const cert = newBeneficiaries.map((o) => o.PensionBeneficiaryId);
        if (cert.length > 0) {
          this.releaseCertificate({
            planIdentityId: this.selectedPlan.Id,
            payload: {
              Certificates: cert,
            },
          });
        }
      }
      this.dialogs.beneficiaries = false;
    },
    trySubmitBeneficiaries() {
      if (this.hasUnrevocable()) {
        this.$refs.beneficiariesForm.dialogs.unrevocable = true;
      } else {
        this.submitBeneficiaries();
      }
    },
    hasUnrevocable() {
      if (
        this.$refs.beneficiariesForm === null ||
        this.$refs.beneficiariesForm === undefined
      ) {
        return false;
      }
      return (
        this.$refs.beneficiariesForm.beneficiaryPayload.Beneficiaries.filter(
          (b) => !b.IsRevocable
        ).length > 0
      );
    },
    async submitBeneficiaries() {
      if (
        this.$refs.beneficiariesForm === null ||
        this.$refs.beneficiariesForm === undefined
      ) {
        return;
      }
      this.saving = true;
      try {
        var nItem = JSON.parse(
          JSON.stringify(this.$refs.beneficiariesForm.beneficiaryPayload)
        );
        console.log(JSON.stringify(nItem));
        nItem.Beneficiaries.map((b) => {
          b.Percentage = parseFloat(b.Percentage);
          b.Percentage = parseFloat((b.Percentage / 100).toFixed(4));
          return b;
        });
        var primaryPercentages = this.$refs.beneficiariesForm.percentages(
          true,
          nItem
        );
        if (primaryPercentages != 1 && primaryPercentages != null) {
          this.error = {
            customMessage: "Total primary beneficiary percentage must be 100%",
          };
          return false;
        }
        var nonPrimaryPercentages = this.$refs.beneficiariesForm.percentages(
          false,
          nItem
        );
        if (nonPrimaryPercentages != 1 && nonPrimaryPercentages != null) {
          this.error = {
            customMessage:
              "Total contingent beneficiary percentage must be 100%",
          };
          return false;
        }
        nItem.memberIdentityId = this.id;
        // delete nItem.copyFrom;
        nItem.Beneficiaries.forEach((b) => {
          if (b.AddTrustee == false) {
            b.Trustee = null;
          }
          this.$refs.beneficiariesForm.fixIds(b);
          this.$refs.beneficiariesForm.fixIds(b.Trustee);
          if (
            b.DependantIdentity !== null &&
            b.DependantIdentity !== undefined
          ) {
            b.DependantIdentityId = b.DependantIdentity.Id;
            delete b.DependantIdentity;
          }
          b.BeneficiaryStatementId = nItem.Id;
        });
        // nItem.PlanInsuranceCarriers.forEach((p) => {
        //   if (p.PolicyIdentity) {
        //     delete p.PolicyIdentity;
        //   }
        // });
        console.log(JSON.stringify(nItem));
        var options = {
          planIdentityId: this.selectedPlan.Id,
          payload: nItem,
        };
        await this.saveBeneficiaries(options);
        // this.$emit("submitted");
        this.beneficiariesSubmitted();
      } catch (e) {
        console.log(e);
        // this.$emit("submitted", e);
        this.beneficiariesSubmitted(e);
      } finally {
        // if (this.$refs.beneficiaryTable) {
        //   this.$refs.beneficiaryTable.getDataAsync();
        // }
        // if (this.$refs.trusteeEditForm) {
        //   this.$refs.trusteeEditForm.resetValidation();
        // }
        // if (this.$refs.beneficiaryEditForm) {
        //   this.$refs.beneficiaryEditForm.resetValidation();
        // }
        this.saving = false;
      }
    },
    saveCob() {
      console.log(
        "save cob: benefit: start of method",
        JSON.stringify(this.selectedBenefit)
      );
      if (
        this.selectedBenefit.Dependants !== null &&
        this.selectedBenefit.Dependants !== undefined
      ) {
        this.selectedBenefit.DependantIdentities =
          this.selectedBenefit.Dependants.map((o) => {
            return {
              Id: o,
            };
          });
      }
      if (
        this.selectedBenefit.DependantIdentities &&
        this.tracksDependantsByName(this.selectedBenefit)
      ) {
        console.log(
          "save cob: benefit: tracksDependantsByName is true",
          this.selectedBenefit.DependantIdentities.length
        );
        this.selectedBenefit.NoOfDependants =
          this.selectedBenefit.DependantIdentities.length;
      } /*else if (this.tracksDependantsByNumber(this.selectedBenefit)) {
        this.selectedBenefit.NoOfDependants = 0;
      } else {
        this.selectedBenefit.NoOfDependants = null;
      }*/
      this.selectedBenefit.EffectiveDate = this.coverageEffectiveDate;
      const item = this.benefitsProvider.items.filter(
        (o) => o.CoverageIdentityId === this.selectedBenefit.CoverageIdentityId
      )[0];
      const index = this.benefitsProvider.items.indexOf(item);
      // this.selectedBenefit.cobBool =
      //   this.selectedBenefit.COB &&
      //   this.selectedBenefit.COB.InsuranceCarrier !== null &&
      //   this.selectedBenefit.COB.InsuranceCarrier !== undefined;
      this.benefitsProvider.items[index] = JSON.parse(
        JSON.stringify(this.selectedBenefit)
      );
      console.log(
        "save cob: benefit: end of method",
        JSON.stringify(this.selectedBenefit)
      );
      this.$refs.benefitsTable.getDataAsync();
      this.cobDialog = false;
      this.editCoverageDialog = false;
      // console.log(
      //   this.selectedBenefit,
      //   this.benefitsProvider.items,
      //   index,
      //   item
      // );
    },
    removeCob() {
      this.selectedBenefit.COB.IsRemoved = true;
      const item = this.benefitsProvider.items.filter(
        (o) => o.CoverageIdentityId === this.selectedBenefit.CoverageIdentityId
      )[0];
      const index = this.benefitsProvider.items.indexOf(item);
      this.benefitsProvider.items[index] = JSON.parse(
        JSON.stringify(this.selectedBenefit)
      );
      this.$refs.benefitsTable.getDataAsync();
      this.removeCobDialog = false;
    },
    coverageUntrackedAllowedDates(currentDateString) {
      const currentTimestamps = Date.parse(currentDateString);
      const currentDate = new Date(currentTimestamps);
      let firstRenewalTimestamps = Date.parse(
        this.planIdentity.FirstRenewalDate
      );
      let hireTimestamps = null;
      if (
        this.planIdentity.CurrentPlanMemberEligibility &&
        this.planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod &&
        !this.waiveWaitingPeriod
      ) {
        hireTimestamps = Date.parse(
          this.editedUntrackedItemCoverage.CurrentEmploymentInformation.HireDate
        );
        if (
          this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
          "Month"
        ) {
          hireTimestamps = this.addMonths(
            hireTimestamps,
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
          );
        } else if (
          this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
          "Week"
        ) {
          hireTimestamps = this.addWeeks(
            hireTimestamps,
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
          );
        } else if (
          this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit ===
          "Day"
        ) {
          hireTimestamps = this.addDays(
            hireTimestamps,
            this.planIdentity.CurrentPlanMemberEligibility.WaitingPeriod
          );
        }
      } else if (
        Object.keys(this.untrackedCoverageHeadersDictionary).indexOf(
          "Hire Date"
        ) > -1
      ) {
        //hireDate
        hireTimestamps = Date.parse(
          this.editedUntrackedItemCoverage.CurrentEmploymentInformation.HireDate
        );
      }
      const firstRenewalDate = new Date(firstRenewalTimestamps);

      if (hireTimestamps !== null) {
        const hireDate = new Date(hireTimestamps);
        if (hireDate > firstRenewalDate) {
          return currentDate >= hireDate;
        }
      }
      return currentDate >= firstRenewalDate;
    },
    coverageAllowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.memberIdentity.PlanEntryDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    coverageAllowedDates2(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.memberIdentity.CoverageEffectiveDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    benefitYearAllowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.coverageEffectiveDate);
      const d2 = new Date(n2);
      return d <= d2;
    },
    doSmth() {
      this.notAvailableDialog = true;
    },
    onConfirmEmailPaste(event) {
      // console.log("P A S T E: ", event);
      event.preventDefault();
      return false;
    },
    onHomeEmailPaste(event) {
      console.log("P A S T E: ", event, this.$refs.homeEmail);
      let paste = (event.clipboardData || window.clipboardData)
        .getData("text")
        .trim();
      event.preventDefault();
      // const selection = window.getSelection();
      // if (!selection.rangeCount) return;
      // selection.deleteFromDocument();
      // selection.getRangeAt(0).insertNode(document.createTextNode(paste));
      // selection.collapseToEnd();
      let validationResult = this.$rules.email(paste);
      if (validationResult === true) {
        this.contactInfo.HomeEmail = paste;
      } else {
        this.$refs.homeEmail.setErrorMessages(
          this.$t("validation.email_must_be_valid")
        );
        this.$nextTick(() => {
          this.$refs.homeEmail.setText(paste);
        });
      }
      return false;
    },
    onWorkEmailPaste(event) {
      console.log("P A S T E: ", event, this.$refs.workEmail);
      let paste = (event.clipboardData || window.clipboardData)
        .getData("text")
        .trim();
      event.preventDefault();
      // const selection = window.getSelection();
      // if (!selection.rangeCount) return;
      // selection.deleteFromDocument();
      // selection.getRangeAt(0).insertNode(document.createTextNode(paste));
      // selection.collapseToEnd();
      let validationResult = this.$rules.email(paste);
      if (validationResult === true) {
        this.contactInfo.WorkEmail = paste;
      } else {
        this.$refs.workEmail.setErrorMessages(
          this.$t("validation.email_must_be_valid")
        );
        this.$nextTick(() => {
          this.$refs.workEmail.setText(paste);
        });
      }
      return false;
    },
    onEmailPaste(event) {
      console.log("P A S T E: ", event, this.$refs.email);
      let paste = (event.clipboardData || window.clipboardData)
        .getData("text")
        .trim();
      event.preventDefault();
      // const selection = window.getSelection();
      // if (!selection.rangeCount) return;
      // selection.deleteFromDocument();
      // selection.getRangeAt(0).insertNode(document.createTextNode(paste));
      // selection.collapseToEnd();
      console.log(":" + paste + ":");
      let validationResult = this.$rules.email(paste);
      if (validationResult === true) {
        this.editedItem.Email = paste;
      } else {
        this.$refs.email.setErrorMessages(
          this.$t("validation.email_must_be_valid")
        );
        this.$nextTick(() => {
          this.$refs.email.setText(paste);
        });
      }
      return false;
    },
    isContactInfoValid() {
      // console.log(
      //   "isContactInfoValid: ",
      //   (Object.keys(this.contactInfo).length > 2 ||
      //     Object.keys(this.contactInfo.Identity).length > 0 ||
      //     Object.keys(this.contactInfo.Address).length > 0) &&
      //     this.valid.contactInfo &&
      //     this.isAddressValid() &&
      //     this.valid.contactInfo2
      // );
      // console.log(this.valid.contactInfo);
      // console.log(this.isAddressValid());
      // console.log(this.valid.contactInfo2);
      // console.log(Object.keys(this.contactInfo));
      // console.log(Object.keys(this.contactInfo.Address));
      // console.log(Object.keys(this.contactInfo.Identity));
      // if (
      //   this.contactInfoEffectiveDate === null ||
      //   this.contactInfoEffectiveDate === undefined
      // ) {
      //   return (
      //     Object.keys(this.contactInfo).length === 2 &&
      //     Object.keys(this.contactInfo.Address).length === 0
      //   );
      // }
      return (
        // (Object.keys(this.contactInfo).length > 2 ||
        //   Object.keys(this.contactInfo.Identity).length > 0) &&
        this.valid.contactInfo && this.valid.contactInfo2 && this.valid.address
      );
    },
    getName() {
      // console.log(this.memberIdentity);
      if (this.memberIdentity === null || this.memberIdentity === undefined) {
        return;
      }
      if (this.memberIdentity.CurrentMember) {
        if (
          this.memberIdentity.CurrentMember.FirstName &&
          this.memberIdentity.CurrentMember.LastName
        ) {
          return `${this.memberIdentity.CurrentMember.FirstName} ${this.memberIdentity.CurrentMember.LastName}`;
        } else if (this.memberIdentity.CurrentMember.FirstName) {
          return this.memberIdentity.CurrentMember.FirstName;
        } else if (this.memberIdentity.CurrentMember.LastName) {
          return this.memberIdentity.CurrentMember.LastName;
        }
      }
      if (this.memberIdentity.MemberIdentification.Certificate) {
        // console.log(
        //   "ela edw eisai: ",
        //   this.memberIdentity.MemberIdentification.Certificate
        // );
        return this.memberIdentity.MemberIdentification.Certificate;
      }
      return "";
    },
    printImage(card) {
      var myframe = document.createElement("IFRAME");
      myframe.domain = document.domain;
      myframe.style.position = "absolute";
      myframe.style.top = "-10000px";
      document.body.appendChild(myframe);
      const img = myframe.contentDocument.createElement(`img`);
      img.src = card.Source;
      img.style = `width: ${card.Width}in; height: ${card.Height}in`;
      myframe.contentDocument.body.appendChild(img);
      setTimeout(function () {
        myframe.focus();
        myframe.contentWindow.print();
        myframe.parentNode.removeChild(myframe); // remove frame
      }, 10); // wait for images to load inside iframe
      window.focus();
    },
    mergeDependants(depList1, depList2) {
      const res = [].concat(depList1);
      for (let dep of depList2) {
        if (
          depList1.filter((o) => o.IdentityId === dep.IdentityId).length === 0
        ) {
          res.push(dep);
        }
      }
      return res;
    },
    async printBenefitCard() {
      this.cards = null;
      this.dialogs.showBenefitCardDialog = true;
      // let date = new Date();
      // const offset = date.getTimezoneOffset();
      // date = new Date(date.getTime() - offset * 60 * 1000);
      const query =
        this.memberOdataQuery +
        ",CurrentActiveMemberBenefits($expand=CurrentBenefit($expand=Translations)),CurrentDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentHealthEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentMedicalEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentDentalEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentDrugsEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentTravelEligibleDependants($select=Id,IdentityId,FirstName,MiddleName,LastName;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible))";
      try {
        const member = (
          await this.getMemberInfo({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: query,
          })
        ).data;

        const ids = member.CurrentActiveMemberBenefits.map(
          (o) => o.CoverageIdentityId
        );
        const filters = [];
        for (const id of ids) {
          filters.push(`(Coverages/any(_e: _e/CoverageId eq ${id}))`);
        }
        if (filters.length > 0) {
          const cardsQuery = `?$expand=Coverages&$select=Id,Language&$filter=${filters.join(
            " or "
          )}`;
          const memberCards = (
            await this.getMemberBenefitCards({
              planIdentityId: this.selectedPlan.Id,
              odataQuery: cardsQuery,
            })
          ).data.value;

          let language = "en";
          if (member.CurrentContactInformation) {
            member.CurrentContactInformation.LanguageChoice &&
            member.CurrentContactInformation.LanguageChoice.Name === "French"
              ? "fr"
              : "en";
          }
          let currentDependants = {};
          member.CurrentDependants = member.CurrentDependants.filter(
            (o) => o.Identity.IsEligible
          ).sort(
            (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
          );

          currentDependants.Code = member.CurrentDependants.map(
            (o) => o.Identity.Code
          ).join("\r\n");
          currentDependants.Relationship = member.CurrentDependants.map(
            (o) =>
              o.Relationship.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].DisplayValue
          ).join("\r\n");
          currentDependants.FullName = member.CurrentDependants.map(
            (o) => o.FirstName + " " + Array.from(o.LastName)[0]
          ).join("\r\n");
          member.CurrentDependants = currentDependants;

          let transMember = JSON.parse(JSON.stringify(member));
          transMember.CurrentHealthAndDentalDependants = this.mergeDependants(
            transMember.CurrentHealthEligibleDependants,
            transMember.CurrentDentalEligibleDependants
          ).sort(
            (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
          );

          currentDependants.Code =
            transMember.CurrentHealthAndDentalDependants.map(
              (o) => o.Identity.Code
            ).join("\r\n");
          currentDependants.Relationship =
            transMember.CurrentHealthAndDentalDependants.map(
              (o) =>
                o.Relationship.Translations.filter(
                  (o) => o.LanguageCode === language
                )[0].DisplayValue
            ).join("\r\n");
          currentDependants.FullName =
            transMember.CurrentHealthAndDentalDependants.map(
              (o) => o.FirstName + " " + Array.from(o.LastName)[0]
            ).join("\r\n");

          for (let i = 0; i < 8; i++) {
            if (i < transMember.CurrentHealthAndDentalDependants.length) {
              currentDependants[`FullInfo${i + 1}`] = `${
                transMember.CurrentHealthAndDentalDependants[i].Identity.Code
              } ${transMember.CurrentHealthAndDentalDependants[i].FirstName} ${
                transMember.CurrentHealthAndDentalDependants[i].LastName
              }, ${
                transMember.CurrentHealthAndDentalDependants[
                  i
                ].Relationship.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].DisplayValue
              }`;

              if (
                transMember.CurrentHealthEligibleDependants.filter(
                  (o) =>
                    o.IdentityId ===
                    transMember.CurrentHealthAndDentalDependants[i].IdentityId
                ).length > 0 &&
                transMember.CurrentDentalEligibleDependants.filter(
                  (o) =>
                    o.IdentityId ===
                    transMember.CurrentHealthAndDentalDependants[i].IdentityId
                ).length > 0
              ) {
                currentDependants[`Status${i + 1}`] = "";
              } else if (
                transMember.CurrentDentalEligibleDependants.filter(
                  (o) =>
                    o.IdentityId ===
                    transMember.CurrentHealthAndDentalDependants[i].IdentityId
                ).length > 0
              ) {
                currentDependants[`Status${i + 1}`] = "Dental Only";
              } else {
                currentDependants[`Status${i + 1}`] = "Health Only";
              }
            } else {
              currentDependants[`FullInfo${i + 1}`] = "";
              currentDependants[`Status${i + 1}`] = "";
            }
          }
          transMember.CurrentHealthAndDentalDependants = JSON.parse(
            JSON.stringify(currentDependants)
          );
          console.log(
            JSON.stringify(transMember.CurrentHealthAndDentalDependants)
          );

          transMember.CurrentHealthDependants =
            transMember.CurrentHealthEligibleDependants.sort(
              (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
            );

          currentDependants = {};
          currentDependants.Code = transMember.CurrentHealthDependants.map(
            (o) => o.Identity.Code
          ).join("\r\n");
          currentDependants.Relationship =
            transMember.CurrentHealthDependants.map(
              (o) =>
                o.Relationship.Translations.filter(
                  (o) => o.LanguageCode === language
                )[0].DisplayValue
            ).join("\r\n");
          currentDependants.FullName = transMember.CurrentHealthDependants.map(
            (o) => o.FirstName + " " + Array.from(o.LastName)[0]
          ).join("\r\n");

          for (let i = 0; i < 8; i++) {
            if (i < transMember.CurrentHealthDependants.length) {
              currentDependants[`FullInfo${i + 1}`] = `${
                transMember.CurrentHealthDependants[i].Identity.Code
              } ${transMember.CurrentHealthDependants[i].FirstName} ${
                transMember.CurrentHealthDependants[i].LastName
              }, ${
                transMember.CurrentHealthDependants[
                  i
                ].Relationship.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].DisplayValue
              }`;
            } else {
              currentDependants[`FullInfo${i + 1}`] = "";
            }
          }
          transMember.CurrentHealthDependants = JSON.parse(
            JSON.stringify(currentDependants)
          );
          console.log(JSON.stringify(transMember.CurrentHealthDependants));

          transMember.CurrentMedicalDependants =
            transMember.CurrentMedicalEligibleDependants.sort(
              (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
            );

          currentDependants = {};
          currentDependants.Code = transMember.CurrentMedicalDependants.map(
            (o) => o.Identity.Code
          ).join("\r\n");
          currentDependants.Relationship =
            transMember.CurrentMedicalDependants.map(
              (o) =>
                o.Relationship.Translations.filter(
                  (o) => o.LanguageCode === language
                )[0].DisplayValue
            ).join("\r\n");
          currentDependants.FullName = transMember.CurrentMedicalDependants.map(
            (o) => o.FirstName + " " + Array.from(o.LastName)[0]
          ).join("\r\n");

          for (let i = 0; i < 8; i++) {
            if (i < transMember.CurrentMedicalDependants.length) {
              currentDependants[`FullInfo${i + 1}`] = `${
                transMember.CurrentMedicalDependants[i].Identity.Code
              } ${transMember.CurrentMedicalDependants[i].FirstName} ${
                transMember.CurrentMedicalDependants[i].LastName
              }, ${
                transMember.CurrentMedicalDependants[
                  i
                ].Relationship.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].DisplayValue
              }`;
            } else {
              currentDependants[`FullInfo${i + 1}`] = "";
            }
          }
          transMember.CurrentMedicalDependants = JSON.parse(
            JSON.stringify(currentDependants)
          );
          console.log(JSON.stringify(transMember.CurrentMedicalDependants));

          transMember.CurrentDentalDependants =
            transMember.CurrentDentalEligibleDependants.sort(
              (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
            );

          currentDependants = {};
          currentDependants.Code = transMember.CurrentDentalDependants.map(
            (o) => o.Identity.Code
          ).join("\r\n");
          currentDependants.Relationship =
            transMember.CurrentDentalDependants.map(
              (o) =>
                o.Relationship.Translations.filter(
                  (o) => o.LanguageCode === language
                )[0].DisplayValue
            ).join("\r\n");
          currentDependants.FullName = transMember.CurrentDentalDependants.map(
            (o) => o.FirstName + " " + Array.from(o.LastName)[0]
          ).join("\r\n");

          for (let i = 0; i < 8; i++) {
            if (i < transMember.CurrentDentalDependants.length) {
              currentDependants[`FullInfo${i + 1}`] = `${
                transMember.CurrentDentalDependants[i].Identity.Code
              } ${transMember.CurrentDentalDependants[i].FirstName} ${
                transMember.CurrentDentalDependants[i].LastName
              }, ${
                transMember.CurrentDentalDependants[
                  i
                ].Relationship.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].DisplayValue
              }`;
            } else {
              currentDependants[`FullInfo${i + 1}`] = "";
            }
          }
          transMember.CurrentDentalDependants = JSON.parse(
            JSON.stringify(currentDependants)
          );
          console.log(JSON.stringify(transMember.CurrentDentalDependants));

          transMember.CurrentTravelDependants =
            transMember.CurrentTravelEligibleDependants.sort(
              (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
            );

          currentDependants = {};
          currentDependants.Code = transMember.CurrentTravelDependants.map(
            (o) => o.Identity.Code
          ).join("\r\n");
          currentDependants.Relationship =
            transMember.CurrentTravelDependants.map(
              (o) =>
                o.Relationship.Translations.filter(
                  (o) => o.LanguageCode === language
                )[0].DisplayValue
            ).join("\r\n");
          currentDependants.FullName = transMember.CurrentTravelDependants.map(
            (o) => o.FirstName + " " + Array.from(o.LastName)[0]
          ).join("\r\n");

          for (let i = 0; i < 8; i++) {
            if (i < transMember.CurrentTravelDependants.length) {
              currentDependants[`FullInfo${i + 1}`] = `${
                transMember.CurrentTravelDependants[i].Identity.Code
              } ${transMember.CurrentTravelDependants[i].FirstName} ${
                transMember.CurrentTravelDependants[i].LastName
              }, ${
                transMember.CurrentTravelDependants[
                  i
                ].Relationship.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].DisplayValue
              }`;
            } else {
              currentDependants[`FullInfo${i + 1}`] = "";
            }
          }
          transMember.CurrentTravelDependants = JSON.parse(
            JSON.stringify(currentDependants)
          );
          console.log(JSON.stringify(transMember.CurrentTravelDependants));

          transMember.CurrentDrugsDependants =
            transMember.CurrentDrugsEligibleDependants.sort(
              (a, b) => parseInt(a.Identity.Code) - parseInt(b.Identity.Code)
            );

          currentDependants = {};
          currentDependants.Code = transMember.CurrentDrugsDependants.map(
            (o) => o.Identity.Code
          ).join("\r\n");
          currentDependants.Relationship =
            transMember.CurrentDrugsDependants.map(
              (o) =>
                o.Relationship.Translations.filter(
                  (o) => o.LanguageCode === language
                )[0].DisplayValue
            ).join("\r\n");
          currentDependants.FullName = transMember.CurrentDrugsDependants.map(
            (o) => o.FirstName + " " + Array.from(o.LastName)[0]
          ).join("\r\n");

          for (let i = 0; i < 8; i++) {
            if (i < transMember.CurrentDrugsDependants.length) {
              currentDependants[`FullInfo${i + 1}`] = `${
                transMember.CurrentDrugsDependants[i].Identity.Code
              } ${transMember.CurrentDrugsDependants[i].FirstName} ${
                transMember.CurrentDrugsDependants[i].LastName
              }, ${
                transMember.CurrentDrugsDependants[
                  i
                ].Relationship.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].DisplayValue
              }`;
            } else {
              currentDependants[`FullInfo${i + 1}`] = "";
            }
          }
          transMember.CurrentDrugsDependants = JSON.parse(
            JSON.stringify(currentDependants)
          );
          console.log(JSON.stringify(transMember.CurrentDrugsDependants));

          let currentActiveBenefits = [];
          for (const benefit of transMember.CurrentActiveMemberBenefits) {
            for (const card of memberCards) {
              if (
                card.Coverages.filter(
                  (c) => c.CoverageId === benefit.CoverageIdentityId
                ).length > 0
              ) {
                currentActiveBenefits.push(benefit);
                break;
              }
            }
          }
          console.log(currentActiveBenefits);
          transMember.ActiveMemberBenefits = currentActiveBenefits
            .map(
              (o) =>
                o.CurrentBenefit.Translations.filter(
                  (t) => t.LanguageCode === language
                )[0].Name
            )
            .join(", ");
          if (transMember.CurrentMember.FirstName) {
            transMember.CurrentMember.FirstName =
              transMember.CurrentMember.FirstName.toUpperCase();
          }
          if (transMember.CurrentMember.LastName) {
            transMember.CurrentMember.LastName =
              transMember.CurrentMember.LastName.toUpperCase();
          }
          if (transMember.CurrentMember.MiddleName) {
            transMember.CurrentMember.MiddleName =
              transMember.CurrentMember.MiddleName.toUpperCase();
          }

          this.cards = await this.getBenefitCardImage({
            args: transMember,
            language: language,
          });
          this.$forceUpdate();
        } else {
          this.error = {
            customMessage: "No cards assigned to member benefits",
          };
          this.cards = [];
        }
      } catch (e) {
        console.error(e);
      }
    },
    async viewEditFiles() {
      this.dialogs.showFilesDialog = true;
      console.log(this.dialogs.showFilesDialog);
      console.log(this.selectedPlan.Id);
    },
    allowedAfterFirstRenewalDate(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    allowedDates2(val) {
      if (
        this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt ===
          null ||
        this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt ===
          undefined
      ) {
        return true;
      }
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(
        this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt
      );
      const d2 = new Date(n2);
      return d >= d2;
    },
    dateOfBirthDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const d2 = new Date();
      return d <= d2;
    },
    displayCoverage() {
      return this.memberIdentity.CurrentMemberBenefits.map((o) => {
        const translations = o.CurrentBenefit.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        );
        if (translations.length > 0) {
          return translations[0].Name;
        }
        return o.CurrentBenefit.Name;
      }).join(", ");
    },
    displayAddress() {
      let res = "";
      // console.log(this.memberIdentity);
      if (
        this.memberIdentity.CurrentContactInformation &&
        this.memberIdentity.CurrentContactInformation.Address
      ) {
        // console.log("address:   -----------------------", this.memberIdentity);
        if (this.memberIdentity.CurrentContactInformation.Address.SuiteNumber) {
          res +=
            this.memberIdentity.CurrentContactInformation.Address.SuiteNumber;
        }
        if (
          this.memberIdentity.CurrentContactInformation.Address.StreetNumber
        ) {
          if (res.length > 0) {
            res += ", ";
          }
          res +=
            this.memberIdentity.CurrentContactInformation.Address.StreetNumber.toString();
        }
        if (this.memberIdentity.CurrentContactInformation.Address.StreetName) {
          if (res.length > 0) {
            res += ", ";
          }
          res +=
            this.memberIdentity.CurrentContactInformation.Address.StreetName;
        }
        if (res.length > 0) {
          res += ", ";
        }
        if (
          this.memberIdentity.CurrentContactInformation.Address.Country.IsOther
        ) {
          res += this.memberIdentity.CurrentContactInformation.Address.City;
          if (
            this.memberIdentity.CurrentContactInformation.Address.OtherProvince
          ) {
            res +=
              ", " +
              this.memberIdentity.CurrentContactInformation.Address
                .OtherProvince;
          }
          if (
            this.memberIdentity.CurrentContactInformation.Address
              .OtherPostalCode
          ) {
            res +=
              " " +
              this.memberIdentity.CurrentContactInformation.Address
                .OtherPostalCode;
          }
          res +=
            " " +
            this.memberIdentity.CurrentContactInformation.Address.OtherCountry;
        } else {
          res +=
            this.memberIdentity.CurrentContactInformation.Address.City +
            ", " +
            this.memberIdentity.CurrentContactInformation.Address.Province.Code;
          if (
            this.memberIdentity.CurrentContactInformation.Address.PostalCode
          ) {
            res +=
              " " +
              this.memberIdentity.CurrentContactInformation.Address.PostalCode;
          }
        }
      }
      return res;
    },

    trans(item) {
      return translate(item, this.language.language);
    },
    trans2(item, field, transPropertyName) {
      return transPropertyName !== null && transPropertyName !== undefined
        ? translate2(item[transPropertyName], field)
        : translate2(item, field);
    },
    createMemberOdataQuery(headers) {
      let query = "";
      const select = [];
      const expand = [];
      const currentMember = {
        select: [],
        expand: [],
      };
      const identification = {
        select: [],
        expand: [],
      };
      const enrolment = {
        select: [],
        expand: [],
      };
      const currentEmploymentInformation = {
        select: [],
        expand: [],
      };
      const currentContactInformation = {
        select: [],
        expand: [],
      };
      const currentBankAccount = {
        select: [],
        expand: [],
      };
      const currentMembershipStatus = {
        select: [],
        expand: [],
      };
      const currentUnionMembership = {
        select: [],
        expand: [],
      };
      const currentTerminationMembershipEvent = {
        select: [],
        expand: [],
      };

      let h;
      if (
        headers.filter((o) => o.text === "First Name" && o.onView === "View")
          .length > 0
      ) {
        currentMember.select.push("FirstName");
        this.personalSectionHeaders.push("First Name");
      }
      if (
        headers.filter((o) => o.text === "Last Name" && o.onView === "View")
          .length > 0
      ) {
        currentMember.select.push("LastName");
        this.personalSectionHeaders.push("Last Name");
      }
      if (
        headers.filter((o) => o.text === "Certificate" && o.onView === "View")
          .length > 0
      ) {
        identification.select.push("Certificate");
        this.personalSectionHeaders.push("Certificate");
      }
      if (
        headers.filter((o) => o.text === "Membership Id" && o.onView === "View")
          .length > 0
      ) {
        identification.select.push("PensionMembershipId");
        this.personalSectionHeaders.push("Membership Id");
      }
      if (
        headers.filter((o) => o.text === "Drawbridge Id" && o.onView === "View")
          .length > 0
      ) {
        identification.select.push("Certificate");
        this.personalSectionHeaders.push("Drawbridge Id");
      }
      if (
        headers.filter((o) => o.text === "Date Of Birth" && o.onView === "View")
          .length > 0
      ) {
        currentMember.select.push("DateOfBirth");
        this.personalSectionHeaders.push("Date Of Birth");
      }
      if (
        headers.filter((o) => o.text === "Tax Exemption" && o.onView === "View")
          .length > 0
      ) {
        currentMember.select.push("TaxExemption");
        this.personalSectionHeaders.push("Tax Exemption");
      }
      if (
        headers.filter((o) => o.text === "Gender" && o.onView === "View")
          .length > 0
      ) {
        currentMember.expand.push(
          "Gender($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.personalSectionHeaders.push("Gender");
      }
      if (
        headers.filter(
          (o) => o.text === "Has Eligible Dependants" && o.onView === "View"
        ).length > 0
      ) {
        currentMember.select.push("HasEligibleDependants");
        this.personalSectionHeaders.push("Has Eligible Dependants");
      }
      if (
        headers.filter((o) => o.text === "Title" && o.onView === "View")
          .length > 0
      ) {
        currentMember.expand.push(
          "Title($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.personalSectionHeaders.push("Title");
      }
      if (
        headers.filter((o) => o.text === "Middle Name" && o.onView === "View")
          .length > 0
      ) {
        currentMember.select.push("MiddleName");
        this.personalSectionHeaders.push("Middle Name");
      }
      if (
        headers.filter((o) => o.text === "Suffix" && o.onView === "View")
          .length > 0
      ) {
        currentMember.expand.push(
          "Suffix($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.personalSectionHeaders.push("Suffix");
      }
      if (
        headers.filter((o) => o.text === "Pronoun" && o.onView === "View")
          .length > 0
      ) {
        currentMember.expand.push(
          "Pronoun($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.personalSectionHeaders.push("Pronoun");
      }
      if (
        headers.filter((o) => o.text === "SIN" && o.onView === "View").length >
        0
      ) {
        identification.select.push("SIN");
        this.personalSectionHeaders.push("SIN");
        identification.select.push("TemporarySIN");
        this.personalSectionHeaders.push("TemporarySIN");
      }
      h = headers.filter(
        (o) => o.text === "Enrollement Signed At" && o.onView === "View"
      );
      if (h.length > 0) {
        enrolment.select.push("EnrollmentSignedAt");
        this.eligibleSectionHeaders["Enrollement Signed At"] = h[0];
      }
      h = headers.filter(
        (o) => o.text === "Enrollement Received At" && o.onView === "View"
      );
      if (h.length > 0) {
        enrolment.select.push("EnrollmentReceivedAt");
        this.eligibleSectionHeaders["Enrollement Received At"] = h[0];
      }
      enrolment.expand.push(
        "EnrolmentForm($select=Id,FileCategory;$expand=FileSegments($select=PhysicalFileId))"
      );
      if (
        headers.filter(
          (o) => o.text === "Marital Status" && o.onView === "View"
        ).length > 0
      ) {
        currentMember.expand.push(
          "MaritalStatus($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.personalSectionHeaders.push("Marital Status");
      }
      if (
        headers.filter(
          (o) => o.text === "ProvinceOfResidence" && o.onView === "View"
        ).length > 0
      ) {
        currentMember.expand.push(
          "ProvinceOfResidence($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.personalSectionHeaders.push("ProvinceOfResidence");
      }
      if (
        headers.filter(
          (o) => o.text === "ProvinceOfEmployment" && o.onView === "View"
        ).length > 0
      ) {
        currentMember.expand.push(
          "ProvinceOfEmployment($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.personalSectionHeaders.push("ProvinceOfEmployment");
      }
      if (
        headers.filter((o) => o.text === "Smoker" && o.onView === "View")
          .length > 0
      ) {
        currentMember.select.push("IsSmoker");
        this.personalSectionHeaders.push("Smoker");
      }
      if (
        headers.filter(
          (o) => o.text === "Union Local Home" && o.onView === "View"
        ).length > 0
      ) {
        currentUnionMembership.expand.push(
          "UnionLocalHome($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name))"
        );
        this.unionLocalSectionHeaders.push("Union Local Home");
      }
      if (
        headers.filter(
          (o) => o.text === "Union Local Work" && o.onView === "View"
        ).length > 0
      ) {
        currentUnionMembership.expand.push(
          "UnionLocalWork($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name))"
        );
        this.unionLocalSectionHeaders.push("Union Local Work");
      }
      if (
        headers.filter((o) => o.text === "Employer" && o.onView === "View")
          .length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "Employer($select=Id;$expand=MemberGroupHistory,Current($expand=Translations($select=LanguageCode,Name);$select=Id,IdentityId,Name,Classes,HasHealthSpendingAccount))"
        );
        this.employmentSectionHeaders.push("Employer");
      }
      if (
        headers.filter((o) => o.text === "Store" && o.onView === "View")
          .length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "Store($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name))"
        );
        this.employmentSectionHeaders.push("Store");
      }
      if (
        headers.filter((o) => o.text === "Hire Date" && o.onView === "View")
          .length > 0
      ) {
        currentEmploymentInformation.select.push("HireDate");
        this.employmentSectionHeaders.push("Hire Date");
      }
      if (
        headers.filter((o) => o.text === "Earnings" && o.onView === "View")
          .length > 0
      ) {
        currentEmploymentInformation.select.push("Earnings");
        this.employmentSectionHeaders.push("Earnings");
        currentEmploymentInformation.select.push("AnnualSalary");
        this.employmentSectionHeaders.push("Annual Salary");
      }
      if (
        headers.filter((o) => o.text === "Occupation" && o.onView === "View")
          .length > 0
      ) {
        currentEmploymentInformation.select.push("Occupation");
        this.employmentSectionHeaders.push("Occupation");
      }
      if (
        headers.filter(
          (o) => o.text === "Employment Frequency" && o.onView === "View"
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "EmploymentFrequency($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.employmentSectionHeaders.push("Employment Frequency");
      }
      if (
        headers.filter(
          (o) => o.text === "Employment Type" && o.onView === "View"
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "EmploymentType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.employmentSectionHeaders.push("Employment Type");
      }
      if (
        headers.filter((o) => o.text === "WeeklyHours" && o.onView === "View")
          .length > 0
      ) {
        currentEmploymentInformation.select.push("WeeklyHours");
        this.employmentSectionHeaders.push("WeeklyHours");
      }
      if (
        headers.filter(
          (o) => o.text === "Employee Number" && o.onView === "View"
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("EmployeeNumber");
        this.employmentSectionHeaders.push("Employee Number");
      }
      if (
        headers.filter(
          (o) => o.text === "Employer Contribution" && o.onView === "View"
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("EmployerContribution");
        this.employmentSectionHeaders.push("Employer Contribution");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Second Income Earnings Frequency" && o.onView === "View"
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "SecondIncomeEarningsFrequency($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.employmentSectionHeaders.push("Second Income Earnings Frequency");
      }
      if (
        headers.filter(
          (o) => o.text === "Second Income Type" && o.onView === "View"
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "SecondIncomeType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.employmentSectionHeaders.push("Second Income Type");
      }
      if (
        headers.filter(
          (o) => o.text === "Second Income Earnings" && o.onView === "View"
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("SecondIncomeEarnings");
        this.employmentSectionHeaders.push("Second Income Earnings");
      }
      if (
        headers.filter(
          (o) => o.text === "Salary Evidence Provided" && o.onView === "View"
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("SalaryEvidenceProvided");
        this.employmentSectionHeaders.push("Salary Evidence Provided");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Address" && (o.onView === "View" || o.onView === "Edit")
        ).length > 0
      ) {
        currentContactInformation.expand.push(
          "Address($select=ContactInformationId,SuiteNumber,StreetNumber,StreetName,OtherProvince,PostalCode,OtherPostalCode,City,OtherCountry;$expand=Country($select=Id,IsOther,Name;$expand=Translations($select=LanguageCode,DisplayValue)),Province($select=Id,Code,Name;$expand=Translations($select=LanguageCode,DisplayValue)))"
        );

        this.contactSectionHeaders.push("Address");
      }
      if (
        headers.filter((o) => o.text === "Phone Number" && o.onView === "View")
          .length > 0
      ) {
        currentContactInformation.select.push("PhoneNumber");
        this.contactSectionHeaders.push("Phone Number");
      }
      if (
        headers.filter(
          (o) => o.text === "CommunicationPreference" && o.onView === "View"
        ).length > 0
      ) {
        currentContactInformation.expand.push(
          "CommunicationPreference($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.contactSectionHeaders.push("CommunicationPreference");
      }
      if (
        headers.filter(
          (o) => o.text === "LanguageChoice" && o.onView === "View"
        ).length > 0
      ) {
        currentContactInformation.expand.push(
          "LanguageChoice($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.contactSectionHeaders.push("LanguageChoice");
      }
      // if (
      //   headers.filter((o) => o.text === "Email" && o.onView === "View")
      //     .length > 0
      // ) {
      select.push("Email");
      this.contactSectionHeaders.push("Email");
      // }
      if (
        headers.filter((o) => o.text === "Work Email" && o.onView === "View")
          .length > 0
      ) {
        currentContactInformation.select.push("WorkEmail");
        this.contactSectionHeaders.push("Work Email");
      }
      if (
        headers.filter((o) => o.text === "Home Email" && o.onView === "View")
          .length > 0
      ) {
        currentContactInformation.select.push("HomeEmail");
        this.contactSectionHeaders.push("Home Email");
      }
      select.push("PrimaryEmail");
      if (
        headers.filter(
          (o) => o.text === "Account Number" && o.onView === "View"
        ).length > 0
      ) {
        currentBankAccount.select.push("AccountNumber");
        this.directDepositHeaders.push("Account Number");
      }
      if (
        headers.filter(
          (o) => o.text === "Transit Number" && o.onView === "View"
        ).length > 0
      ) {
        currentBankAccount.select.push("TransitNumber");
        this.directDepositHeaders.push("Transit Number");
      }
      if (
        headers.filter(
          (o) => o.text === "Institution Number" && o.onView === "View"
        ).length > 0
      ) {
        currentBankAccount.select.push("InstitutionNumber");
        this.directDepositHeaders.push("Institution Number");
      }
      // if (
      //   headers.filter((o) => o.text === "Account Type" && o.onView === "View")
      //     .length > 0
      // ) {
      //   currentBankAccount.expand.push(
      //     "AccountType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
      //   );
      //   this.directDepositHeaders.push("Account Type");
      // }
      if (
        headers.filter(
          (o) => o.text === "Verify Direct Deposit" && o.onView === "View"
        ).length > 0
      ) {
        currentBankAccount.select.push("VerifyDirectDeposit");
        this.directDepositHeaders.push("Verify Direct Deposit");
      }
      h = headers.filter((o) => o.text === "Class" && o.onView === "View");
      if (h.length > 0) {
        currentMembershipStatus.select.push("Class");
        this.eligibleSectionHeaders["Class"] = h[0];
      }
      h = headers.filter(
        (o) => o.text === "Activity Status" && o.onView === "View"
      );
      if (h.length > 0) {
        currentMembershipStatus.expand.push(
          "ActivityStatus($select=Id,Name,Code,Description;$expand=Translations($select=LanguageCode,Name,Description))"
        );
        this.eligibleSectionHeaders["Activity Status"] = h[0];
      }
      currentTerminationMembershipEvent.select.push("TerminationStatus");
      currentTerminationMembershipEvent.select.push("DateEffective");
      h = headers.filter(
        (o) => o.text === "Coverage Expiry Date" && o.onView === "View"
      );
      if (h.length > 0) {
        select.push("CoverageExpiryDate");
        this.eligibleSectionHeaders["Coverage Expiry Date"] = h[0];
      }
      currentTerminationMembershipEvent.select.push("IsTerminated");
      select.push("TerminatedAt");
      select.push("LastExtensionTerminationDate");
      currentMembershipStatus.expand.push(
        "MemberGroupIdentity($select=Id;$expand=Current($select=Name,IdentityId,Id;$expand=Translations($select=LanguageCode,Name)))"
      );
      select.push("CoverageEffectiveDate");
      select.push("PlanEntryDate");
      select.push("IsParticipant");
      select.push("IsEligible");
      h = headers.filter(
        (o) => o.text === "Union Initiation Date" && o.onView === "View"
      );
      if (h.length > 0) {
        select.push("UnionInitiationDate");
        this.eligibleSectionHeaders["Union Initiation Date"] = h[0];
      }
      expand.push(
        "Flags($select=Id,Name,Color;$expand=Translations($select=Name,LanguageCode))"
      );
      expand.push(
        "CurrentMemberBenefits($expand=CurrentBenefit($select=Name;$expand=Translations($select=LanguageCode,Name)))"
      );
      select.push("Id");
      select.push("IsEditable");

      // if (
      //   this.planIdentity.HasDrupalPortal &&
      //   this.planIdentity.MembersPortal !== undefined &&
      //   this.planIdentity.MembersPortal !== null &&
      //   this.planIdentity.MembersPortal.IsActive
      // ) {
      expand.push("PortalAccount($select=RegisteredAt,EmailVerified)");

      if (this.planIdentity.Current.HasBenefitYears) {
        expand.push("CurrentMemberBenefitYear($select=StartMonth)");
      }
      // }

      h = headers.filter(
        (o) => o.text === "Registered At" && o.onView === "View"
      );
      if (h.length > 0) {
        // portalAccount.select.push(
        //   "RegisteredAt"
        // );
        this.portalAccountSectionHeaders["Registered At"] = h[0];
        this.portalAccountSectionHeaders.push("Registered At");
      }

      h = headers.filter(
        (o) => o.text === "Default Coverage Status" && o.onView === "View"
      );
      if (h.length > 0) {
        currentMembershipStatus.expand.push(
          "DefaultCoverageStatus($select=Id,Name,AllowDependants,AllowSpouse,AllowChild;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.eligibleSectionHeaders["Default Coverage Status"] = h[0];
      }

      // console.log(
      //   clauses,
      //   currentMember,
      //   identification,
      //   currentEmploymentInformation,
      //   currentContactInformation,
      //   currentBankAccount,
      //   currentMembershipStatus
      // );
      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }

      if (currentMember.select.length > 0 && currentMember.expand.length > 0) {
        expand.push(
          `CurrentMember($expand=${currentMember.expand.join(
            ","
          )};$select=${currentMember.select.join(",")})`
        );
      } else if (currentMember.select.length > 0) {
        expand.push(`CurrentMember($select=${currentMember.select.join(",")})`);
      } else if (currentMember.expand.length > 0) {
        expand.push(`CurrentMember($expand=${currentMember.expand.join(",")})`);
      }
      if (
        identification.select.length > 0 &&
        identification.expand.length > 0
      ) {
        expand.push(
          `MemberIdentification($expand=${identification.expand.join(
            ","
          )};$select=${identification.select.join(",")})`
        );
      } else if (identification.select.length > 0) {
        expand.push(
          `MemberIdentification($select=${identification.select.join(",")})`
        );
      } else if (identification.expand.length > 0) {
        expand.push(
          `MemberIdentification($expand=${identification.expand.join(",")})`
        );
      }
      if (enrolment.select.length > 0 && enrolment.expand.length > 0) {
        expand.push(
          `MemberEnrolment($expand=${enrolment.expand.join(
            ","
          )};$select=${enrolment.select.join(",")})`
        );
      } else if (enrolment.select.length > 0) {
        expand.push(`MemberEnrolment($select=${enrolment.select.join(",")})`);
      } else if (enrolment.expand.length > 0) {
        expand.push(`MemberEnrolment($expand=${enrolment.expand.join(",")})`);
      }
      if (
        currentUnionMembership.select.length > 0 &&
        currentUnionMembership.expand.length > 0
      ) {
        expand.push(
          `CurrentUnionMembership($expand=${currentUnionMembership.expand.join(
            ","
          )};$select=${currentUnionMembership.select.join(",")})`
        );
      } else if (currentUnionMembership.select.length > 0) {
        expand.push(
          `CurrentUnionMembership($select=${currentUnionMembership.select.join(
            ","
          )})`
        );
      } else if (currentUnionMembership.expand.length > 0) {
        expand.push(
          `CurrentUnionMembership($expand=${currentUnionMembership.expand.join(
            ","
          )})`
        );
      }
      if (
        currentEmploymentInformation.select.length > 0 &&
        currentEmploymentInformation.expand.length > 0
      ) {
        expand.push(
          `CurrentEmploymentInformation($expand=${currentEmploymentInformation.expand.join(
            ","
          )};$select=${currentEmploymentInformation.select.join(",")})`
        );
      } else if (currentEmploymentInformation.select.length > 0) {
        expand.push(
          `CurrentEmploymentInformation($select=${currentEmploymentInformation.select.join(
            ","
          )})`
        );
      } else if (currentEmploymentInformation.expand.length > 0) {
        expand.push(
          `CurrentEmploymentInformation($expand=${currentEmploymentInformation.expand.join(
            ","
          )})`
        );
      }
      if (
        currentContactInformation.select.length > 0 &&
        currentContactInformation.expand.length > 0
      ) {
        expand.push(
          `CurrentContactInformation($expand=${currentContactInformation.expand.join(
            ","
          )};$select=${currentContactInformation.select.join(",")})`
        );
      } else if (currentContactInformation.select.length > 0) {
        expand.push(
          `CurrentContactInformation($select=${currentContactInformation.select.join(
            ","
          )})`
        );
      } else if (currentContactInformation.expand.length > 0) {
        expand.push(
          `CurrentContactInformation($expand=${currentContactInformation.expand.join(
            ","
          )})`
        );
      }
      if (
        currentBankAccount.select.length > 0 &&
        currentBankAccount.expand.length > 0
      ) {
        expand.push(
          `CurrentBankAccount($expand=${currentBankAccount.expand.join(
            ","
          )};$select=${currentBankAccount.select.join(",")})`
        );
      } else if (currentBankAccount.select.length > 0) {
        expand.push(
          `CurrentBankAccount($select=${currentBankAccount.select.join(",")})`
        );
      } else if (currentBankAccount.expand.length > 0) {
        expand.push(
          `CurrentBankAccount($expand=${currentBankAccount.expand.join(",")})`
        );
      }
      if (
        currentMembershipStatus.select.length > 0 &&
        currentMembershipStatus.expand.length > 0
      ) {
        expand.push(
          `CurrentMembershipStatus($expand=${currentMembershipStatus.expand.join(
            ","
          )};$select=${currentMembershipStatus.select.join(",")})`
        );
      } else if (currentMembershipStatus.select.length > 0) {
        expand.push(
          `CurrentMembershipStatus($select=${currentMembershipStatus.select.join(
            ","
          )})`
        );
      } else if (currentMembershipStatus.expand.length > 0) {
        expand.push(
          `CurrentMembershipStatus($expand=${currentMembershipStatus.expand.join(
            ","
          )})`
        );
      }
      if (
        currentTerminationMembershipEvent.select.length > 0 &&
        currentTerminationMembershipEvent.expand.length > 0
      ) {
        expand.push(
          `CurrentTerminationMembershipEvent($expand=${currentTerminationMembershipEvent.expand.join(
            ","
          )};$select=${currentTerminationMembershipEvent.select.join(",")})`
        );
      } else if (currentTerminationMembershipEvent.select.length > 0) {
        expand.push(
          `CurrentTerminationMembershipEvent($select=${currentTerminationMembershipEvent.select.join(
            ","
          )})`
        );
      } else if (currentTerminationMembershipEvent.expand.length > 0) {
        expand.push(
          `CurrentTerminationMembershipEvent($expand=${currentTerminationMembershipEvent.expand.join(
            ","
          )})`
        );
      }
      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      query = clauses.join("&");
      console.log("------------------------------------------query is: ", query);

      return query;
    },
    formatDate2(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    formatDate(dateString) {
      console.log(dateString);
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    async fetchInsuranceCarriersAndBeneficiaries() {
      const query = `$select=Id&$expand=BeneficiaryStatements($expand=DeclarationForm($expand=FileSegments),PolicyIdentities($select=Id;$expand=Current($select=Number)),
        Beneficiaries($expand=Trustee($expand=BeneficiaryRelationship,BeneficiaryType),BeneficiaryRelationship($expand=Translations),BeneficiaryType($expand=Translations),Gender($expand=Translations),Title($expand=Translations),Suffix($expand=Translations),DependantIdentity($expand=Current($expand=Gender($expand=Translations),Title($expand=Translations),Suffix($expand=Translations))))),
        CurrentMemberBenefits($select=Id;$expand=CurrentBenefit($select=Id;))`;
      const member = (
        await this.getMemberInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          odataQuery: query,
        })
      ).data;
      this.beneficiaryStatements = member.BeneficiaryStatements;
      console.log(this.beneficiaryStatements);
      const usedPolicies = [];
      member.BeneficiaryStatements.forEach((bs) =>
        usedPolicies.push(...bs.PolicyIdentities.map((p) => p.Id))
      );
      let policies = (
        await this.getPolicyIdentitiesByMemberIdentityId({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
        })
      ).data.value;
      // (await this.getPolicyIdentitiesByCoverageIds({
      //   planIdentityId: this.selectedPlan.Id,
      //   payload: {
      //     Coverages: member.CurrentMemberBenefits.map(
      //       (o) => o.CurrentBenefit.Id
      //     ),
      //   },
      // })).data.value;

      console.log(policies);
      // const planInsuranceCarriers = [];
      // for (const c of member.CurrentMemberBenefits) {
      //   console.log(c);
      //   if (
      //     c.CurrentBenefit &&
      //     c.CurrentBenefit.PlanInsuranceCarrier &&
      //     c.CurrentBenefit.PlanInsuranceCarrier.HasBeneficiaries &&
      //     c.CurrentBenefit.PlanInsuranceCarrier.PolicyIdentity &&
      //     c.CurrentBenefit.PlanInsuranceCarrier.PolicyIdentity.Current
      //   ) {
      //     const id = c.CurrentBenefit.PlanInsuranceCarrier.Id;
      //     const name =
      //       c.CurrentBenefit.PlanInsuranceCarrier.PolicyIdentity.Current.Number;
      //     if (usedPolicies.indexOf(id) === -1) {
      //       planInsuranceCarriers.push({
      //         Id: id,
      //         Name: name,
      //       });
      //       usedPolicies.push(id);
      //     }
      //   }
      // }
      // this.planInsuranceCarriers = planInsuranceCarriers;
      this.policyIdentities = policies
        .map((o) => {
          // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$", o);
          return {
            Id: o.Id,
            Name: o.Current.Number,
          };
        })
        .filter((o) => usedPolicies.filter((oo) => oo === o.Id).length === 0);
      console.log(this.policyIdentities);
    },
    async addBeneficiaries() {
      await this.loadDependantIdentities();
      this.previousBeneficiaryPayload = {
        DeclarationDate: "", //Intl.DateTimeFormat("fr-CA").format(new Date()),
        Beneficiaries: [],
        PolicyIdentities: [],
      };
      this.newBeneficiaryStatement = true;
      this.dialogs.beneficiaries = true;
    },
    async manageBeneficiaries() {
      await this.loadDependantIdentities();
      this.previousBeneficiaryPayload = null;
      this.newBeneficiaryStatement = false;
      this.dialogs.beneficiaries = true;
    },
    async beneficiariesSubmitted(err) {
      this.dialogs.beneficiaries = false;
      await this.fetchInsuranceCarriersAndBeneficiaries();
      if (err) {
        this.color = "error";
        this.message = err;
        this.snackbar = true;
      } else {
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.reloadBeneficiaries();
      }
    },

    async reloadBeneficiaries() {
      const query = `$select=Id&$expand=BeneficiaryStatements($expand=Beneficiaries($select=Id,PensionBeneficiaryId,FirstName,LastName,MiddleName,DateOfBirth,DateOfDeath,IsPrimary,IsRevocable,AddTrustee,Percentage,DependantIdentityId;$expand=DependantIdentity($expand=Current($expand=Gender($expand=Translations),Title($expand=Translations),Suffix($expand=Translations))),Title($expand=Translations),Suffix($expand=Translations),Gender($expand=Translations),BeneficiaryType($expand=Translations),BeneficiaryRelationship($expand=Translations),Trustee($select=FirstName,LastName)))`;
      let response = (
        await this.getMemberInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          odataQuery: query,
        })
      ).data;
      let beneficiaries = response.BeneficiaryStatements.map((b) =>
        b.Beneficiaries.map((bb) => {
          bb.CurrentPolicy = b.CurrentPolicies;
          bb.DeclarationDate = b.DeclarationDate;
          return bb;
        })
      ).flat();
      this.beneficiariesProvider = null;
      const headers = getMemberBeneficiariesHeaders(this.selectedPlan.PlanType);
      this.$nextTick(() => {
        this.beneficiariesProvider = new InMemoryProvider(
          beneficiaries,
          headers
        );
        //console.log("WTF??????????????????????", beneficiaries);
      });
    },
    async reloadMemberFiles() {
      let memberFiles = (
        await this.getPlanMemberFiles({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
        })
      ).data.value;
      this.memberFilesProvider = null;
      this.$nextTick(() => {
        this.memberFilesProvider = new InMemoryProvider(
          memberFiles,
          MemberFilesHeaders
        );
        //console.log("WTF??????????????????????", beneficiaries);
      });
    },
    async loadDependantIdentities() {
      const query =
        "$select=Id&$expand=CurrentActiveDependants($select=Id;$expand=Identity($expand=Qualification,Current($select=FirstName,LastName;$expand=Relationship($select=Id,IsSpouse,IsChild))))";
      const dependants = (
        await this.getMemberInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          odataQuery: query,
        })
      ).data.CurrentActiveDependants;
      this.dependantIdentities = dependants.map((o) => o.Identity);
    },
    async reloadDependants() {
      const query =
        "$select=Id&$expand=CurrentDependants($select=Id,IdentityId,FirstName,MiddleName,LastName,DateOfBirth,DateOfDeath,SIN,IsRemoved,Student,Disabled,IsSmoker,Overage;$expand=Title($expand=Translations),Suffix($expand=Translations),Gender($expand=Translations),Relationship($expand=Translations),Identity($expand=Qualification))";
      let dependants = (
        await this.getMemberInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          odataQuery: query,
        })
      ).data.CurrentDependants;
      const membersDependantsHeaders = getMemberDependantsHeaders(
        this.selectedPlan.PlanType
      );
      if (
        this.dependantsProvider === null ||
        this.dependantsProvider === undefined
      ) {
        this.dependantsProvider = new InMemoryProvider(
          dependants,
          membersDependantsHeaders
        );
      } else {
        this.dependantsProvider.items = dependants;

        if (this.$refs.dependantsTable) {
          this.$refs.dependantsTable.getDataAsync();
        }
      }
      this.spouseExists = (
        await this.memberHasSpouse({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
        })
      ).data;
    },
    addDependantBtnClick() {
      //console.log("addDependantBtnClick");
      this.editedDependant = {};
      this.editedDependantIndex = -1;
      this.dialogs.addDependant = true;
    },
    saveDependant() {
      this.editedDependant = null;
      this.dialogs.addDependant = false;
      this.reloadDependants();
      this.reloadBeneficiaries();
      this.fetchInsuranceCarriersAndBeneficiaries();
    },
    closeDependant() {
      this.editedDependant = null;
      this.dialogs.addDependant = false;
    },
    vieweditDependantsBtnClick() {
      this.dialogs.vieweditDependants = true;
      //console.log(this.memberIdentity);
      const dependantsHeaders = getDependantsHeaders(
        this.selectedPlan.PlanType
      );
      this.odataDependantsProvider = new ODataProvider(
        this.$axiosHttp,
        this.dependantUrl,
        dependantsHeaders
      );
    },
    closeViewEditDependants() {
      this.dialogs.vieweditDependants = false;
      this.reloadDependants();
    },
    async editInfo() {
      this.saving = true;
      try {
        this.editedUntrackedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: this.untrackedQuery,
            dialogs: this.dialogs,
            dialog: "editInfo",
          },
          () => {
            this.dialogs.editInfo = false;
          }
        );
        this.dialogs.untracked = false;
        this.dialogs.editInfo = true;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async editCoverageInfo(dialogName) {
      this.saving = true;
      try {
        this.editedUntrackedItemCoverage = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: this.untrackedCoverageQuery,
            dialogs: this.dialogs,
            dialog: dialogName,
          },
          () => {
            this.dialogs[dialogName] = false;
          }
        );

        // if (
        //   item.CurrentMembershipStatus === null ||
        //   item.CurrentMembershipStatus === undefined
        // ) {
        //   item.CurrentMembershipStatus = {};
        // }
        // this.editedUntrackedItemCoverage = item;
        this.dialogs[dialogName] = true;
        this.$nextTick(() => {
          this.$refs.untrackedCoverageForm && this.$refs.untrackedCoverageForm.validate();
          this.$refs.correctPlanEntryDateForm && this.$refs.correctPlanEntryDateForm.validate();
        });
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    createUntrackedQuery(headers) {
      let query = "";
      const select = [];
      const expand = [];
      const currentMember = {
        select: [],
        expand: [],
      };
      const identification = {
        select: [],
        expand: [],
      };
      const currentEmploymentInformation = {
        select: [],
        expand: [],
      };
      const currentContactInformation = {
        select: [],
        expand: [],
      };
      const currentMembershipStatus = {
        select: [],
        expand: [],
      };
      let h = headers.filter(
        (o) => o.text === "First Name" && o.onView === "View"
      );
      if (h.length > 0) {
        currentMember.select.push("FirstName");
        this.untrackedSectionHeaders["First Name"] = h[0];
      }
      h = headers.filter((o) => o.text === "Last Name" && o.onView === "View");
      if (h.length > 0) {
        currentMember.select.push("LastName");
        this.untrackedSectionHeaders["Last Name"] = h[0];
      }
      h = headers.filter((o) => o.text === "Title" && o.onView === "View");
      if (h.length > 0) {
        currentMember.expand.push(
          "Title($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.untrackedSectionHeaders["Title"] = h[0];
      }
      h = headers.filter((o) => o.text === "Suffix" && o.onView === "View");
      if (h.length > 0) {
        currentMember.expand.push(
          "Suffix($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.untrackedSectionHeaders["Suffix"] = h[0];
      }
      h = headers.filter((o) => o.text === "Pronoun" && o.onView === "View");
      if (h.length > 0) {
        currentMember.expand.push(
          "Pronoun($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
        this.untrackedSectionHeaders["Pronoun"] = h[0];
      }
      h = headers.filter(
        (o) => o.text === "Middle Name" && o.onView === "View"
      );
      if (h.length > 0) {
        currentMember.select.push("MiddleName");
        this.untrackedSectionHeaders["Middle Name"] = h[0];
      }
      h = headers.filter(
        (o) => o.text === "Employee Number" && o.onView === "View"
      );
      if (h.length > 0) {
        currentEmploymentInformation.select.push("EmployeeNumber");
        this.untrackedSectionHeaders["Employee Number"] = h[0];
      }
      h = headers.filter(
        (o) => o.text === "Date Of Birth" && o.onView === "View"
      );
      if (h.length > 0) {
        currentMember.select.push("DateOfBirth");
        this.untrackedSectionHeaders["Date Of Birth"] = h[0];
      }
      h = headers.filter(
        (o) => o.text === "Certificate" && o.onView === "View"
      );
      if (h.length > 0) {
        identification.select.push("Certificate");
        this.untrackedSectionHeaders["Certificate"] = h[0];
      }
      h = headers.filter(
        (o) => o.text === "Membership Id" && o.onView === "View"
      );
      if (h.length > 0) {
        identification.select.push("PensionMembershipId");
        this.untrackedSectionHeaders["Membership Id"] = h[0];
      }
      h = headers.filter((o) => o.text === "SIN" && o.onView === "View");
      if (h.length > 0) {
        identification.select.push("SIN");
        this.untrackedSectionHeaders["SIN"] = h[0];
        let tempSinH = JSON.parse(JSON.stringify(h));
        h[0].value = "MemberIdentification/TemporarySIN";
        identification.select.push("TemporarySIN");
        this.untrackedSectionHeaders["TemporarySIN"] = tempSinH;
      }
      select.push("Id");

      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }
      if (currentMember.select.length > 0 && currentMember.expand.length > 0) {
        expand.push(
          `CurrentMember($expand=${currentMember.expand.join(
            ","
          )};$select=${currentMember.select.join(",")})`
        );
      } else if (currentMember.select.length > 0) {
        expand.push(`CurrentMember($select=${currentMember.select.join(",")})`);
      } else if (currentMember.expand.length > 0) {
        expand.push(`CurrentMember($expand=${currentMember.expand.join(",")})`);
      }
      if (
        identification.select.length > 0 &&
        identification.expand.length > 0
      ) {
        expand.push(
          `MemberIdentification($expand=${identification.expand.join(
            ","
          )};$select=${identification.select.join(",")})`
        );
      } else if (identification.select.length > 0) {
        expand.push(
          `MemberIdentification($select=${identification.select.join(",")})`
        );
      } else if (identification.expand.length > 0) {
        expand.push(
          `MemberIdentification($expand=${identification.expand.join(",")})`
        );
      }
      if (
        currentEmploymentInformation.select.length > 0 &&
        currentEmploymentInformation.expand.length > 0
      ) {
        expand.push(
          `CurrentEmploymentInformation($expand=${currentEmploymentInformation.expand.join(
            ","
          )};$select=${currentEmploymentInformation.select.join(",")})`
        );
      } else if (currentEmploymentInformation.select.length > 0) {
        expand.push(
          `CurrentEmploymentInformation($select=${currentEmploymentInformation.select.join(
            ","
          )})`
        );
      } else if (currentEmploymentInformation.expand.length > 0) {
        expand.push(
          `CurrentEmploymentInformation($expand=${currentEmploymentInformation.expand.join(
            ","
          )})`
        );
      }
      if (
        currentContactInformation.select.length > 0 &&
        currentContactInformation.expand.length > 0
      ) {
        expand.push(
          `CurrentContactInformation($expand=${currentContactInformation.expand.join(
            ","
          )};$select=${currentContactInformation.select.join(",")})`
        );
      } else if (currentContactInformation.select.length > 0) {
        expand.push(
          `CurrentContactInformation($select=${currentContactInformation.select.join(
            ","
          )})`
        );
      } else if (currentContactInformation.expand.length > 0) {
        expand.push(
          `CurrentContactInformation($expand=${currentContactInformation.expand.join(
            ","
          )})`
        );
      }
      if (
        currentMembershipStatus.select.length > 0 &&
        currentMembershipStatus.expand.length > 0
      ) {
        expand.push(
          `CurrentMembershipStatus($expand=${currentMembershipStatus.expand.join(
            ","
          )};$select=${currentMembershipStatus.select.join(",")})`
        );
      } else if (currentMembershipStatus.select.length > 0) {
        expand.push(
          `CurrentMembershipStatus($select=${currentMembershipStatus.select.join(
            ","
          )})`
        );
      } else if (currentMembershipStatus.expand.length > 0) {
        expand.push(
          `CurrentMembershipStatus($expand=${currentMembershipStatus.expand.join(
            ","
          )})`
        );
      }
      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      query = clauses.join("&");
      //console.log(query);
      return query;
    },
    createUntrackedCoverageQuery(headers) {
      console.log(
        "----------------------h e a d e r s : ----------------------",
        headers
      );
      let query = "";
      const select = [];
      const expand = [];
      const currentMember = {
        select: [],
        expand: [],
      };
      const currentEmploymentInformation = {
        select: [],
        expand: [],
      };
      const currentMembershipStatus = {
        select: [],
        expand: [],
      };
      const currentTerminationMembershipEvent = {
        select: [],
        expand: [],
      };
      this.untrackedCoverageHeadersDictionary = [];
      let h;
      h = headers.filter((o) => o.text === "Hire Date"); //&& o.onEdit === "Edit")
      if (h.length > 0) {
        currentEmploymentInformation.select.push("HireDate");
        currentEmploymentInformation.expand.push(
          "Employer($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=Id,IdentityId,Name))"
        )
        this.untrackedCoverageHeadersDictionary["Hire Date"] = h[0];
      }

      currentTerminationMembershipEvent.select.push("IsTerminated");
      currentMembershipStatus.select.push("EffectiveDate");
      select.push("TerminatedAt");
      select.push("LastExtensionTerminationDate");
      select.push("CoverageEffectiveDate");
      select.push("PlanEntryDate");
      select.push("IsParticipant");
      select.push("IsEligible");

      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }

      if (currentMember.select.length > 0 && currentMember.expand.length > 0) {
        expand.push(
          `CurrentMember($expand=${currentMember.expand.join(
            ","
          )};$select=${currentMember.select.join(",")})`
        );
      } else if (currentMember.select.length > 0) {
        expand.push(`CurrentMember($select=${currentMember.select.join(",")})`);
      } else if (currentMember.expand.length > 0) {
        expand.push(`CurrentMember($expand=${currentMember.expand.join(",")})`);
      }
      if (
        currentEmploymentInformation.select.length > 0 &&
        currentEmploymentInformation.expand.length > 0
      ) {
        expand.push(
          `CurrentEmploymentInformation($expand=${currentEmploymentInformation.expand.join(
            ","
          )};$select=${currentEmploymentInformation.select.join(",")})`
        );
      } else if (currentEmploymentInformation.select.length > 0) {
        expand.push(
          `CurrentEmploymentInformation($select=${currentEmploymentInformation.select.join(
            ","
          )})`
        );
      } else if (currentEmploymentInformation.expand.length > 0) {
        expand.push(
          `CurrentEmploymentInformation($expand=${currentEmploymentInformation.expand.join(
            ","
          )})`
        );
      }
      if (
        currentMembershipStatus.select.length > 0 &&
        currentMembershipStatus.expand.length > 0
      ) {
        expand.push(
          `CurrentMembershipStatus($expand=${currentMembershipStatus.expand.join(
            ","
          )};$select=${currentMembershipStatus.select.join(",")})`
        );
      } else if (currentMembershipStatus.select.length > 0) {
        expand.push(
          `CurrentMembershipStatus($select=${currentMembershipStatus.select.join(
            ","
          )})`
        );
      } else if (currentMembershipStatus.expand.length > 0) {
        expand.push(
          `CurrentMembershipStatus($expand=${currentMembershipStatus.expand.join(
            ","
          )})`
        );
      }
      if (
        currentTerminationMembershipEvent.select.length > 0 &&
        currentTerminationMembershipEvent.expand.length > 0
      ) {
        expand.push(
          `CurrentTerminationMembershipEvent($expand=${currentTerminationMembershipEvent.expand.join(
            ","
          )};$select=${currentTerminationMembershipEvent.select.join(",")})`
        );
      } else if (currentTerminationMembershipEvent.select.length > 0) {
        expand.push(
          `CurrentTerminationMembershipEvent($select=${currentTerminationMembershipEvent.select.join(
            ","
          )})`
        );
      } else if (currentTerminationMembershipEvent.expand.length > 0) {
        expand.push(
          `CurrentTerminationMembershipEvent($expand=${currentTerminationMembershipEvent.expand.join(
            ","
          )})`
        );
      }

      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      query = clauses.join("&");
      //console.log(query);

      return query;
    },
    columnRules(column, mask) {
      console.log(column);
      let rules = [];
      if (column.isOptional === false) {
        if (column.type === "double" || column.type === "int") {
          rules.push(this.$rules.requiredNum);
        } else {
          if (column.text==="SIN" || column.text === "TemporarySIN") {
            rules.push(this.rules.requiredSIN);
          } else {
            rules.push(this.$rules.required);
          }
        }
      }
      if (column.validationPattern)
        if (mask) {
          rules.push((v) => {
            let val = this.unmask(v, mask);
            // console.log("regex: ", val);
            return (
              !val ||
              new RegExp(column.validationPattern).test(String(val)) ||
              this.$t("components.memberwizard." + column.validationMessage)
            );
          });
        } else {
          rules.push((v) => {
            //console.log("regex: ",v)
            return (
              !v ||
              new RegExp(column.validationPattern).test(String(v)) ||
              this.$t("components.memberwizard." + column.validationMessage)
            );
          });
        }
      return rules;
    },
    getValue(object, path) {
      //console.log(JSON.stringify(object), path);
      let parts = path.split("/");
      //console.log(parts.length);
      if (parts.length === 1) {
        //console.log("return ", object[parts[0]]);
        // console.log("return 2 ", Object.keys(object[parts[0]]).length);
        if (
          typeof object[parts[0]] === "object" &&
          object[parts[0]] !== null &&
          Object.keys(object[parts[0]]).length > 0
        ) {
          return object[parts[0]].Id;
        }
        return object[parts[0]];
      } else {
        const newObj = object[parts[0]];
        parts.shift();
        const newParts = parts.join("/");
        return this.getValue(newObj, newParts);
      }
    },
    async saveUntracked() {
      this.saving = true;
      try {
        let fields = [];
        for (let h of Object.values(this.untrackedSectionHeaders)) {
          console.log(h, h.value);
          if (Array.isArray(h)) {
            h = h[0];
          }
          let v = h.value;
          if (h.foreignKey) {
            v = h.foreignKey;
          }
          fields.push({
            Name: v,
            Value: this.getValue(this.editedUntrackedItem, h.value),
          });
        }
        await this.updateMemberUntracked({
          plan: this.selectedPlan.Id,
          payload: {
            Fields: fields,
            MemberId: this.id,
          },
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.editInfo = false;
        this.reloadMemberIdentity();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async saveCorrectPlanEntryDate() {
      this.saving = true;
      try {
        let payload = {
          PlanEntryDate:
            this.editedUntrackedItemCoverage
              .PlanEntryDate,
        };
        if (
          Object.keys(this.untrackedCoverageHeadersDictionary).indexOf(
            "Hire Date"
          ) > -1
        ) {
          payload.HireDate =
            this.editedUntrackedItemCoverage.CurrentEmploymentInformation.HireDate;
        }
        await this.correctPlanEntryDateAction({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.correctPlanEntryDate = false;
        this.dialogs.confirmCorrectPlanEntryDate = false;
        this.reloadMemberIdentity();
        this.reloadCoverage();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async saveUntrackedCoverage() {
      this.saving = true;
      try {
        let payload = {
          CoverageEffectiveDate:
            this.editedUntrackedItemCoverage.CurrentMembershipStatus
              .EffectiveDate,
        };
        if (
          Object.keys(this.untrackedCoverageHeadersDictionary).indexOf(
            "Hire Date"
          ) > -1
        ) {
          payload.HireDate =
            this.editedUntrackedItemCoverage.CurrentEmploymentInformation.HireDate;
        }
        await this.correctCoverageInformation({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.editCoverageInfo = false;
        this.dialogs.untrackedCoverage = false;
        this.reloadMemberIdentity();
        this.reloadCoverage();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async reloadMemberIdentity() {
      this.loadingMember = true;
      try {
        this.memberIdentity = (
          await this.getMemberInfo({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: this.memberOdataQuery,
          })
        ).data;
        if (this.planIdentity.HasSickPaymentBank) {
          const sickPaymentBalance = (
            await this.getMemberCurrentSickPaymentBalance({
              planIdentityId: this.planIdentity.Id,
              memberIdentityId: this.id,
            })
          ).data;
          if (sickPaymentBalance) {
            this.sickPaymentBalance = sickPaymentBalance;
          } else {
            this.sickPaymentBalance = {};
          }
          if (this.$refs.sickPaymentCard) {
            this.$refs.sickPaymentCard.reload();
          }
        }
        if (this.planIdentity.HasEligibilityBank) {
          this.eligibilityBankId = (
            await this.getMemberEligibilityBankId({
              planIdentityId: this.planIdentity.Id,
              memberIdentityId: this.id,
            })
          ).data;
          if (
            this.eligibilityBankId !== null &&
            this.eligibilityBankId !== undefined
          ) {
            this.eligibilityBankBalance = (
              await this.getMemberCurrentEligibilityBankBalance({
                planIdentityId: this.planIdentity.Id,
                memberIdentityId: this.id,
              })
            ).data;
          }
          // if (this.$refs.eligibilityBankCard) {
          //   this.$refs.eligibilityBankCard.reload();
          // }
          if (this.$refs.eligibilityBankTable) {
            this.$refs.eligibilityBankTable.reload();
          }
        }
        this.selfPayment = (
          await this.getMemberSelfPaymentsInfo({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
          })
        ).data;
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingMember = false;
      }
    },
    changeActivityStatusHandler() {
      this.effectiveDate = null;
      this.activeOdataQuery =
        "?$select=Class&$expand=ActivityStatus($select=Id,Name,Code,Description;$expand=Translations($select=LanguageCode,Name,Description)),SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))";
      this.activeDialog = "activityStatus";
      this.dialogs.activityStatus = true;
    },
    async tryChangeActivityStatus() {
      this.saving = true;
      try {
        await this.changeActivityStatus({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            SourceOfInformationId:
              this.editedItem.SourceOfInformation !== null &&
              this.editedItem.SourceOfInformation !== undefined
                ? this.editedItem.SourceOfInformation.Id
                : null,
            MemberIdentityId: this.id,
            EffectiveDate: this.effectiveDate,
            ActivityStatusId:
              this.editedItem.ActivityStatus !== null &&
              this.editedItem.ActivityStatus !== undefined
                ? this.editedItem.ActivityStatus.Id
                : null,
          },
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.editedItem = {};
        this.dialogs.activityStatus = false;
        this.reloadMemberIdentity();
        this.reloadCoverage();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    changeClassHandler() {
      this.effectiveDate = null;
      this.activeOdataQuery =
        "?$select=Class&$expand=ActivityStatus($select=Id,Name,Code,Description;$expand=Translations($select=LanguageCode,Name,Description)),SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))";
      this.activeDialog = "class";
      this.dialogs.class = true;
    },
    async tryChangeClass() {
      this.saving = true;
      try {
        await this.changeClass({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            SourceOfInformationId:
              this.editedItem.SourceOfInformation !== null &&
              this.editedItem.SourceOfInformation !== undefined
                ? this.editedItem.SourceOfInformation.Id
                : null,
            MemberIdentityId: this.id,
            EffectiveDate: this.effectiveDate,
            Class: this.editedItem.Class,
          },
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.editedItem = {};
        this.dialogs.class = false;
        this.reloadMemberIdentity();
        this.reloadCoverage();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async terminateHandler() {
      await this.loadTermination();
      this.dialogs.terminate = true;
    },
    async loadTermination() {
      //klhsh get member termination
      //tpt disabled sth forma
      try {
        this.loading = true;
        let items = [];
        if (this.lockId) {
          items = (
            await this.getMemberTermination({
              planIdentityId: this.selectedPlan.Id,
              memberIdentityId: this.id,
            })
          ).data;
        } else {
          items = await this.lock(
            this.getMemberTermination,
            {
              planIdentityId: this.selectedPlan.Id,
              memberIdentityId: this.id,
              dialogs: this.dialogs,
              dialog: "terminate",
            },
            () => {
              this.dialogs.terminate = false;
            }
          );
        }
        this.termination = items;

        console.log(JSON.stringify(this.editedItem));
        this.fixedCoverageIdentities = (
          await this.getExtendableMemberBenefits({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
          })
        ).data.CurrentExtendableMemberBenefits.map((o) => o.CoverageIdentity);
        this.dialogs.terminate = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async reinstateHandler() {
      try {
        this.loadingMember = true;
        this.employers = (
            await this.getEmployersDropDown({
              plan: this.selectedPlan.Id,
              // url:
              //   "employers?$expand=Current($expand=Translations;$select=Name,IdentityId),Stores($expand=Current($expand=Translations;$select=Name,IdentityId,IsAssignable);$select=Id)&$select=Id",
            })
          ).data.sort((a, b) => {
            const translatedA = a.Current.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].Name;
            const translatedB = b.Current.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].Name;
            console.log(translatedA, translatedB);
            return sortAlphanum(translatedA, translatedB);
          });
          this.reinstateEffectiveDate = null;
          this.reinstateItem = {
            CurrentMemberBenefitYear: {
              StartMonth: null,
            },
          };
          this.step = 1;
          this.dialogs.reinstate = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingMember = false;
      }
    },
    async tryReinstate() {
      this.saving = true;
      try {
        const memberBenefits = JSON.parse(
          JSON.stringify(this.benefitsProvider.items)
        ).concat(
          JSON.parse(JSON.stringify(this.nonCustomizedBenefitsProvider.items))
        );
        const memberBenefitCOBs = [];
        if (
          !this.hasCoverageCommencementRules ||
          this.overrideCommencementRules
        ) {
          for (let c of memberBenefits) {
            if (c.CoverageIdentity) {
              c.CoverageIdentityId = c.CoverageIdentity.Id;
              delete c.CoverageIdentity;
            }
            if (c.CoverageStatus) {
              c.CoverageStatusId = c.CoverageStatus.Id;
              delete c.CoverageStatus;
            }
            c.MemberIdentityId = this.id;

            // delete c.cobBool;
            if (c.COB && Object.keys(c.COB).length === 0) {
              delete c.COB;
            } else if (c.COB) {
              const cob = JSON.parse(JSON.stringify(c.COB));
              cob.CoverageIdentityId = c.CoverageIdentityId;
              cob.MemberIdentityId = this.id;
              if (cob.CoverageStatus) {
                cob.CoverageStatusId = cob.CoverageStatus.Id;
                delete cob.CoverageStatus;
              }
              memberBenefitCOBs.push(cob);
              delete c.COB;
            }
            // c.EffectiveDate = this.reinstateEffectiveDate;
          }
        }
        const payload = {
          SourceOfInformationId:
            this.reinstateItem.SourceOfInformation !== null &&
            this.reinstateItem.SourceOfInformation !== undefined
              ? this.reinstateItem.SourceOfInformation.Id
              : null,
          MemberIdentityId: this.id,
          PersonalInfo: JSON.parse(
            JSON.stringify(this.reinstateItem.CurrentMember)
          ),
          EmploymentInfo: JSON.parse(
            JSON.stringify(this.reinstateItem.CurrentEmploymentInformation)
          ),
          MembershipStatus: JSON.parse(
            JSON.stringify(this.reinstateItem.CurrentMembershipStatus)
          ),
          MemberBenefits:
            !this.hasCoverageCommencementRules || this.overrideCommencementRules
              ? memberBenefits
              : [],
          MemberBenefitCOBs: memberBenefitCOBs,
          CoverageExpiryDate: this.reinstateItem.CoverageExpiryDate,
          CoverageExpiryReason: this.reinstateItem.CoverageExpiryReason,
        };

        if (payload.PersonalInfo.Title) {
          payload.PersonalInfo.TitleId = payload.PersonalInfo.Title.Id;
          delete payload.PersonalInfo.Title;
        }
        if (payload.PersonalInfo.Pronoun) {
          payload.PersonalInfo.PronounId = payload.PersonalInfo.Pronoun.Id;
          delete payload.PersonalInfo.Pronoun;
        }
        if (payload.PersonalInfo.Gender) {
          payload.PersonalInfo.GenderId = payload.PersonalInfo.Gender.Id;
          delete payload.PersonalInfo.Gender;
        }
        if (payload.PersonalInfo.MaritalStatus) {
          payload.PersonalInfo.MaritalStatusId =
            payload.PersonalInfo.MaritalStatus.Id;
          delete payload.PersonalInfo.MaritalStatus;
        }
        if (payload.PersonalInfo.ProvinceOfResidence) {
          payload.PersonalInfo.ProvinceOfResidenceId =
            payload.PersonalInfo.ProvinceOfResidence.Id;
          delete payload.PersonalInfo.ProvinceOfResidence;
        }
        if (payload.PersonalInfo.Suffix) {
          payload.PersonalInfo.SuffixId = payload.PersonalInfo.Suffix.Id;
          delete payload.PersonalInfo.Suffix;
        }
        if (payload.PersonalInfo.ProvinceOfEmployment) {
          payload.PersonalInfo.ProvinceOfEmploymentId =
            payload.PersonalInfo.ProvinceOfEmployment.Id;
          delete payload.PersonalInfo.ProvinceOfEmployment;
        }
        delete payload.PersonalInfo.Identity;

        payload.PersonalInfo.EffectiveDate = this.reinstateEffectiveDate;
        payload.PersonalInfo.IdentityId = this.id;
        payload.PersonalInfo.PlanIdentityId = this.selectedPlan.Id;

        if (payload.EmploymentInfo.Employer) {
          payload.EmploymentInfo.EmployerId =
            payload.EmploymentInfo.Employer.Id;
          delete payload.EmploymentInfo.Employer;
        }
        if (payload.EmploymentInfo.Store) {
          payload.EmploymentInfo.StoreId = payload.EmploymentInfo.Store.Id;
          delete payload.EmploymentInfo.Store;
        }
        if (payload.EmploymentInfo.EmploymentType) {
          payload.EmploymentInfo.EmploymentTypeId =
            payload.EmploymentInfo.EmploymentType.Id;
          delete payload.EmploymentInfo.EmploymentType;
        }
        if (payload.EmploymentInfo.EmploymentFrequency) {
          payload.EmploymentInfo.EmploymentFrequencyId =
            payload.EmploymentInfo.EmploymentFrequency.Id;
          delete payload.EmploymentInfo.EmploymentFrequency;
        }
        if (payload.EmploymentInfo.EarningsFrequency) {
          payload.EmploymentInfo.EarningsFrequencyId =
            payload.EmploymentInfo.EarningsFrequency.Id;
          delete payload.EmploymentInfo.EarningsFrequency;
        }
        if (payload.EmploymentInfo.IncomeType) {
          payload.EmploymentInfo.IncomeTypeId =
            payload.EmploymentInfo.IncomeType.Id;
          delete payload.EmploymentInfo.IncomeType;
        }
        if (payload.EmploymentInfo.SecondIncomeEarningsFrequency) {
          payload.EmploymentInfo.SecondIncomeEarningsFrequencyId =
            payload.EmploymentInfo.SecondIncomeEarningsFrequency.Id;
          delete payload.EmploymentInfo.SecondIncomeEarningsFrequency;
        }
        if (payload.EmploymentInfo.SecondIncomeType) {
          payload.EmploymentInfo.SecondIncomeTypeId =
            payload.EmploymentInfo.SecondIncomeType.Id;
          delete payload.EmploymentInfo.SecondIncomeType;
        }
        if (
          payload.EmploymentInfo.WeeklyHours !== null &&
          payload.EmploymentInfo.WeeklyHours !== undefined
        ) {
          const decimalValue = parseFloat(payload.EmploymentInfo.WeeklyHours);
          if (!isNaN(decimalValue)) {
            payload.EmploymentInfo.WeeklyHours = decimalValue;
          } else {
            delete payload.EmploymentInfo.WeeklyHours;
          }
        }
        delete payload.EmploymentInfo.Identity;

        payload.EmploymentInfo.EffectiveDate = this.reinstateEffectiveDate;
        payload.EmploymentInfo.IdentityId = this.id;
        payload.EmploymentInfo.PlanIdentityId = this.selectedPlan.Id;

        if (payload.MembershipStatus.MemberGroupIdentity) {
          payload.MembershipStatus.MemberGroupIdentityId =
            payload.MembershipStatus.MemberGroupIdentity.Current.IdentityId;
          delete payload.MembershipStatus.MemberGroupIdentity;
        }

        if (payload.MembershipStatus.DefaultCoverageStatus) {
          payload.MembershipStatus.DefaultCoverageStatusId =
            payload.MembershipStatus.DefaultCoverageStatus.Id;
          delete payload.MembershipStatus.DefaultCoverageStatus;
        }

        payload.MembershipStatus.IdentityId = this.id;
        payload.MembershipStatus.EffectiveDate = this.reinstateEffectiveDate;

        if (this.planIdentity.Current.HasBenefitYears) {
          payload.BenefitYearStartMonth =
            this.reinstateItem.CurrentMemberBenefitYear.StartMonth;
        }

        await this.reinstate({
          planIdentityId: this.selectedPlan.Id,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.reinstateItem = {};
        this.dialogs.reinstate = false;
        this.reinstateEffectiveDate = null;
        this.reloadMemberIdentity();
        this.reloadCoverage();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async createAccountHandler() {
      try {
        this.editedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: "$select=Email",
            dialogs: this.dialogs,
            dialog: "createAccount",
          },
          () => {
            this.dialogs.createAccount = false;
          }
        );
        this.dialogs.createAccount = true;
      } catch (error) {
        this.error = error;
      }
    },
    async tryCreateAccount() {
      try {
        this.saving = true;
        await this.createMemberPortalAccount({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
            Email: this.editedItem.Email,
          },
        });
        this.color = "warning";
        this.message = this.$t(
          "components.addmemberwizard.email_portal_warning"
        );
        this.snackbar = true;
        this.dialogs.createAccount = false;
        this.editedItem = {};
        this.reloadMemberIdentity();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async changeMemberEmailHandler() {
      // let query = "$expand=CurrentContactInformation($select=HomeEmail)";
      // if (this.memberIdentity.CurrentContactInformation.PrimaryEmail === "Work") {
      //   query = "$expand=CurrentContactInformation($select=WorkEmail)";
      // }
      try {
        this.editedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            // odataQuery: query,
            odataQuery: "$select=Email",
            dialogs: this.dialogs,
            dialog: "changeEmail",
          },
          () => {
            this.dialogs.changeEmail = false;
          }
        );
        this.dialogs.changeEmail = true;
      } catch (error) {
        this.error = error;
      }
    },
    async tryChangeMemberEmail() {
      try {
        this.saving = true;
        let resp = await this.changeMemberEmail({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
            Email: this.editedItem.Email,
          },
        });
        if (resp.data === 1) {
          this.color = "warning";
          this.message = this.$t(
            "New confirmation email message will be sent to the member"
          );
        } else if (resp.data === 2) {
          this.color = "warning";
          this.message = this.$t(
            "New registration email message will be sent to the member"
          );
        } else {
          this.color = "success";
          this.message = "globals.success";
        }

        this.snackbar = true;
        this.dialogs.changeEmail = false;
        this.editedItem = {};
        this.reloadMemberIdentity();
        // this.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async resendRegistrationEmail() {
      this.saving = true;
      try {
        await this.resendMemberRegistrationEmail({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
          },
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.editedItem = {};
        this.dialogs.resendEmail = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async resendConfirmationEmail() {
      this.saving = true;
      try {
        await this.resendMemberConfirmationEmail({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
          },
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.editedItem = {};
        this.dialogs.resendConfirmationEmail = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async deleteAccountHandler() {
      //console.log("delete----");
      try {
        this.editedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: "$select=Email",
            dialogs: this.dialogs,
            dialog: "deleteAccount",
          },
          () => {
            this.dialogs.deleteAccount = false;
          }
        );
        this.dialogs.deleteAccount = true;
      } catch (error) {
        this.error = error;
      }
    },
    async tryDeleteMemberPortalAccount() {
      try {
        this.saving = true;
        await this.deleteMemberPortalAccount({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
          },
        });
        this.dialogs.deleteAccount = false;
        this.reloadMemberIdentity();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async resetPasswordHandler() {
      //console.log("delete----");
      try {
        this.editedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: "$select=Email",
            dialogs: this.dialogs,
            dialog: "resetPassword",
          },
          () => {
            this.dialogs.resetPassword = false;
          }
        );
        this.dialogs.resetPassword = true;
      } catch (error) {
        this.error = error;
      }
    },
    async portalViewHandler() {
      console.log("portal-view----");
      try {
        this.saving = true;
        var token = (
          await this.memberPortalImpersonateToken({
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            adminEmail: this.user,
          })
        ).data;
        // this.dialogs.resetPassword = false;
        // this.reloadMemberIdentity();
        if (!token) {
          this.error = {
            customMessage: "Unable to get Member Identity Token",
          };
          this.saving = false;
          return;
        }
        console.log("member identity token", token);
        this.memberPortalViewImpersonate({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          adminEmail: this.user,
          token: token,
        });
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async tryResetMemberPortalPassword() {
      try {
        this.saving = true;
        await this.resetMemberPortalPassword({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
          },
        });
        this.dialogs.resetPassword = false;
        this.reloadMemberIdentity();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    viewEditCoverageHandler() {
      this.coverageEffectiveDate = null;
      this.dialogs.coverage = true;
      this.$nextTick(() => {
        if (this.$refs.coverageForm) {
          this.$refs.coverageForm.resetValidation();
        }
      });
    },
    async saveCoverage() {
      this.saving = true;
      try {
        let membershipStatusChanged = false;
        let terminatedChanged = false;
        // let memberGroupChanged = false;
        // let defaultCoverageChanged = false;
        // let optOutCoverageChanged = false;
        if (Object.keys(this.headersDictionary).indexOf("Class") > -1) {
          if (
            this.originalCoveragePayload.MembershipStatus.Class !==
            this.editedItemCoverage.CurrentMembershipStatus.Class
          ) {
            membershipStatusChanged = true;
          }
        }

        if (
          Object.keys(this.headersDictionary).indexOf("Termination Date") > -1
        ) {
          if (
            this.originalCoveragePayload.TerminationMembershipEvent
              .DateEffective !==
            this.editedItemCoverage.CurrentTerminationMembershipEvent
              .DateEffective
          ) {
            terminatedChanged = true;
          }
        }

        if (
          Object.keys(this.headersDictionary).indexOf("Termination Status") > -1
        ) {
          if (
            this.originalCoveragePayload.TerminationMembershipEvent
              .TerminationStatus !==
            this.editedItemCoverage.CurrentTerminationMembershipEvent
              .TerminationStatus
          ) {
            terminatedChanged = true;
          }
        }

        if (
          this.originalCoveragePayload.MembershipStatus.MemberGroupIdentity
            .Current.IdentityId !==
          this.editedItemCoverage.CurrentMembershipStatus.MemberGroupIdentity
            .Current.IdentityId
        ) {
          membershipStatusChanged = true;
          // memberGroupChanged = true;
        }

        if (
          this.editedItemCoverage.CurrentMembershipStatus
            .DefaultCoverageStatus &&
          this.originalCoveragePayload.MembershipStatus
            .DefaultCoverageStatusId !==
            this.editedItemCoverage.CurrentMembershipStatus
              .DefaultCoverageStatus.Id
        ) {
          membershipStatusChanged = true;
          // memberGroupChanged = true;
        }

        let membershipStatus = membershipStatusChanged
          ? JSON.parse(
              JSON.stringify(this.editedItemCoverage.CurrentMembershipStatus)
            )
          : JSON.parse(
              JSON.stringify(this.originalCoveragePayload.MembershipStatus)
            );

        let terminationEvent = terminatedChanged
          ? JSON.parse(
              JSON.stringify(
                this.editedItemCoverage.CurrentTerminationMembershipEvent
              )
            )
          : JSON.parse(
              JSON.stringify(
                this.originalCoveragePayload.TerminationMembershipEvent
              )
            );

        if (membershipStatus.MemberGroupIdentity) {
          membershipStatus.MemberGroupIdentityId =
            membershipStatus.MemberGroupIdentity.Current.IdentityId;
          delete membershipStatus.MemberGroupIdentity;
        }

        if (membershipStatus.DefaultCoverageStatus) {
          membershipStatus.DefaultCoverageStatusId =
            membershipStatus.DefaultCoverageStatus.Id;
          delete membershipStatus.DefaultCoverageStatus;
        }

        if (membershipStatusChanged) {
          membershipStatus.EffectiveDate = this.coverageEffectiveDate;
        }

        const memberBenefits = JSON.parse(
          JSON.stringify(this.benefitsProvider.items)
        ).concat(
          JSON.parse(JSON.stringify(this.nonCustomizedBenefitsProvider.items))
        );
        const memberBenefitCOBs = [];
        for (let c of memberBenefits) {
          if (c.CoverageIdentity) {
            c.CoverageIdentityId = c.CoverageIdentity.Id;
            delete c.CoverageIdentity;
          }
          if (c.CoverageStatus) {
            c.CoverageStatusId = c.CoverageStatus.Id;
            delete c.CoverageStatus;
          }
          c.MemberIdentityId = this.id;

          // delete c.cobBool;
          if (c.COB && Object.keys(c.COB).length === 0) {
            delete c.COB;
          } else if (c.COB) {
            const cob = JSON.parse(JSON.stringify(c.COB));
            cob.CoverageIdentityId = c.CoverageIdentityId;
            cob.MemberIdentityId = this.id;
            if (cob.CoverageStatus) {
              cob.CoverageStatusId = cob.CoverageStatus.Id;
              delete cob.CoverageStatus;
            }
            memberBenefitCOBs.push(cob);
            delete c.COB;
          }

          if (c.Dependants !== null && c.Dependants !== undefined) {
            c.DependantIdentities = [];
            const identities = [];
            console.log(this.dependantsProvider.items, c.Dependants);
            for (let dep of c.Dependants) {
              console.log(
                "--------------------",
                dep,
                this.dependantsProvider.items
              );
              let d;
              if (
                dep !== null &&
                dep !== undefined &&
                typeof dep === "object"
              ) {
                d = this.dependantsProvider.items.filter(
                  (o) => o.IdentityId === dep.IdentityId.toString()
                )[0];
              } else {
                d = this.dependantsProvider.items.filter(
                  (o) => o.IdentityId === dep.toString()
                )[0];
              }
              identities.push(d.Identity);
            }
            c.DependantIdentities = identities.map((o) => {
              return {
                Id: o.Id,
              };
            });
            delete c.Dependants;
          }
          if (membershipStatus.SourceOfInformation) {
            c.SourceOfInformationId = membershipStatus.SourceOfInformation.Id;
          }
        }
        for (let c of this.originalCoveragePayload.MemberBenefits) {
          if (
            memberBenefits.filter(
              (o) => o.CoverageIdentityId === c.CoverageIdentityId
            ).length === 0
          ) {
            //removed
            c.IsRemoved = true;
            c.EffectiveDate = this.coverageEffectiveDate;
            c.MemberIdentityId = this.id;
            delete c.CoverageIdentity;
            if (c.CoverageStatus) {
              c.CoverageStatusId = c.CoverageStatus.Id;
              delete c.CoverageStatus;
            }
            if (membershipStatus.SourceOfInformation) {
              c.SourceOfInformation = membershipStatus.SourceOfInformation.Id;
            }
            memberBenefits.push(c);
          }
        }

        membershipStatus.IdentityId = this.id;

        let customConfiguration = this.coverageConfiguration.filter(
          (o) =>
            memberBenefits.filter(
              (c) =>
                c.IsRemoved !== true &&
                c.CoverageIdentityId ===
                  o.ConfigurationParameterIdentity.Current.CoverageIdentityId
            ).length > 0
        );
        for (let cc of customConfiguration) {
          delete cc.ConfigurationParameterIdentity;
        }
        console.log(customConfiguration);
        membershipStatus.CustomConfigurationParameterValueIdentities =
          customConfiguration;
        if (membershipStatus.SourceOfInformation) {
          membershipStatus.SourceOfInformationId =
            membershipStatus.SourceOfInformation.Id;
          delete membershipStatus.SourceOfInformation;
        }
        console.log(memberBenefitCOBs, this.benefitYear);

        await this.updateMemberCoverage({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: {
            MemberBenefits: memberBenefits,
            MembershipStatus: membershipStatus,
            MemberBenefitCOBs: memberBenefitCOBs,
            TerminationMembershipEvent: terminationEvent,
            BenefitYear: this.benefitYear,
          },
        });

        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.editedItemCoverage = {
          CurrentMembershipStatus: {
            MemberGroupIdentity: {
              Current: {},
            },
          },
          CurrentMember: {},
        };
        this.dialogs.coverage = false;
        this.reloadCoverage();
        this.reloadMemberIdentity();
        this.benefitYear = null;
        if (this.planIdentity.HasEligibilityBank) {
          this.dialogs.eligibilityBankWarning = true;
        }
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async reloadCoverage() {
      let query =
        "$select=Id&$expand=CurrentTerminationMembershipEvent($select=Id,IsTerminated),CurrentMembershipStatus($select=Id;$expand=CustomConfigurationParameterValueIdentities($expand=ConfigurationParameterIdentity($select=Id;$expand=Current($select=CoverageIdentityId)))),CurrentMemberBenefits($select=Id,IsTerminated,CurrentPolicy,ActiveVolume,NoOfDependants,CoverageIdentityId,IsWaived,EffectiveDate;$expand=COB($expand=CoverageStatus($expand=Translations($select=LanguageCode,DisplayValue))),CoverageStatus($expand=Translations($select=LanguageCode,DisplayValue)),CoverageIdentity($expand=Current($expand=Translations($select=LanguageCode,Name))))";
      const resp = (
        await this.getMemberInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          odataQuery: query,
        })
      ).data;

      if (
        resp.CurrentMemberBenefits !== null &&
        resp.CurrentMemberBenefits !== undefined
      ) {
        let coverage = resp.CurrentMemberBenefits.sort((a, b) => {
          return (
            a.CoverageIdentity.Current.Order -
              b.CoverageIdentity.Current.Order ||
            a.CoverageIdentity.Current.Name.localeCompare(
              b.CoverageIdentity.Current.Name
            )
          );
        });
        const currentMembershipStatus = resp.CurrentMembershipStatus;
        for (let cov of coverage) {
          cov.HasCustomRates =
            currentMembershipStatus.CustomConfigurationParameterValueIdentities.filter(
              (o) =>
                o.ConfigurationParameterIdentity.Current.CoverageIdentityId ===
                cov.CoverageIdentityId
            ).length > 0;
        }
        if (this.coverageProvider) {
          this.coverageProvider.items = coverage;
          this.$refs.coverageTable.getDataAsync();
        } else {
          let terminationTimestamp = null;
          let hireDateTimestamp = null;
          if (
            this.memberIdentity &&
            this.memberIdentity.CurrentTerminationMembershipEvent &&
            this.memberIdentity.CurrentTerminationMembershipEvent.DateEffective
          ) {
            if (
              this.memberIdentity &&
              this.memberIdentity.CurrentEmploymentInformation &&
              this.memberIdentity.CurrentEmploymentInformation.HireDate
            ) {
              hireDateTimestamp = Date.parse(
                this.memberIdentity.CurrentEmploymentInformation.HireDate
              );

              terminationTimestamp = Date.parse(
                this.memberIdentity.CurrentTerminationMembershipEvent
                  .DateEffective
              );
              if (hireDateTimestamp > terminationTimestamp) {
                return this.$t("globals.no");
              }
            }
          }
          this.coverageProvider = new InMemoryProvider(
            coverage,
            getHeaders(terminationTimestamp, hireDateTimestamp)
          );
        }
      }
    },
    tracksDependantsByNumber(cov) {
      return cov.CoverageIdentity.Current.TracksDependants === false;
    },
    tracksDependantsByName(cov) {
      return cov.CoverageIdentity.Current.TracksDependants === true;
    },
    selectableNoOfDependants(coverageStatus) {
      switch (coverageStatus.Name) {
        case "Family":
          return [1, 2, 3, 4, 5, 6];
        case "Single Parent":
          return [1, 2, 3, 4, 5, 6];
        case "Couple":
          return [1];
        default:
          return [0];
      }
    },
    async getSelectableFamilyStatus(id) {
      try {
        let res = await ApiService.get("/settings/familyStatusHierarchy");
        //console.log(res.data);
        this.selectableFamilyStatuses = res.data[id];
      } catch (error) {
        this.error = error;
      }
    },
    createReinstateQuery(headers) {
      const select = ["Id"];
      const expand = [];
      const currentMember = {
        select: [],
        expand: [],
      };
      const identification = {
        select: [],
        expand: [],
      };
      const enrolment = {
        select: [],
        expand: [],
      };
      const currentEmploymentInformation = {
        select: [],
        expand: [],
      };
      const currentMembershipStatus = {
        select: [
          "Id",
          "Class",
          "EffectiveDate",
          "ActivityStatusId",
          "DefaultCoverageStatusId",
        ],
        expand: [
          "DefaultCoverageStatus($select=Id,Name,AllowDependants,AllowSpouse,AllowChild;$expand=Translations($select=LanguageCode,DisplayValue))",
          "MemberGroupIdentity($select=Id;$expand=Current($select=Id,Name,IdentityId;$expand=CoverageIdentities($select=Id;$expand=Current,CurrentCoverageEligibility($expand=CoverageStatuses)),Translations($select=LanguageCode,Name)))",
        ],
      };
      const currentMemberBenefits = {
        select: [
          "IsWaived",
          "CurrentPolicy",
          "Volume",
          "NoOfDependants",
          "CoverageIdentityId",
          "EffectiveDate",
        ],
        expand: [
          "COB,CoverageStatus($select=Id,Name,AllowDependants,AllowSpouse,AllowChild;$expand=Translations($select=LanguageCode,DisplayValue)),CoverageIdentity($expand=Current,CurrentCoverageEligibility($expand=CoverageStatuses($expand=Translations($select=LanguageCode,DisplayValue))))",
        ],
      };
      const currentTerminationMembershipEvent = {
        select: ["Id", "DateEffective", "TerminationStatus"],
      };

      if (
        headers.filter(
          (o) =>
            o.text === "First Name" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.select.push("FirstName");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Last Name" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.select.push("LastName");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Certificate" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        identification.select.push("Certificate");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Membership Id" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        identification.select.push("Membership Id");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "SIN" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        identification.select.push("SIN");
        identification.select.push("TemporarySIN");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Enrollement Signed At" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        enrolment.select.push("EnrollmentReceivedAt");
        enrolment.select.push("EnrollmentSignedAt");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Date Of Birth" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.select.push("DateOfBirth");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Tax Exemption" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.select.push("TaxExemption");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Gender" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.expand.push(
          "Gender($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Has Eligible Dependants" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.select.push("HasEligibleDependants");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Title" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.expand.push(
          "Title($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Middle Name" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.select.push("MiddleName");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Suffix" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.expand.push(
          "Suffix($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      currentMember.expand.push(
        "SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
      );
      if (
        headers.filter(
          (o) =>
            o.text === "Pronoun" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.expand.push(
          "Pronoun($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Marital Status" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.expand.push(
          "MaritalStatus($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "ProvinceOfResidence" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.expand.push(
          "ProvinceOfResidence($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "ProvinceOfEmployment" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.expand.push(
          "ProvinceOfEmployment($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Smoker" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentMember.select.push("IsSmoker");
      }

      if (
        headers.filter(
          (o) =>
            o.text === "Employer" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "Employer($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name),Stores($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name)))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Store" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "Store($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Hire Date" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("HireDate");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Earnings" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("Earnings");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Occupation" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("Occupation");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Employment Frequency" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "EmploymentFrequency($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Employment Type" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "EmploymentType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "WeeklyHours" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("WeeklyHours");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Employee Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("EmployeeNumber");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Employer Contribution" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("EmployerContribution");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Second Income Earnings Frequency" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "SecondIncomeEarningsFrequency($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Second Income Type" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.expand.push(
          "SecondIncomeType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Second Income Earnings" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        currentEmploymentInformation.select.push("SecondIncomeEarnings");
      }

      if (this.planIdentity.Current.HasBenefitYears) {
        expand.push("CurrentMemberBenefitYear($select=StartMonth)");
      }

      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }
      if (currentMember.select.length > 0 && currentMember.expand.length > 0) {
        expand.push(
          `CurrentMember($expand=${currentMember.expand.join(
            ","
          )};$select=${currentMember.select.join(",")})`
        );
      } else if (currentMember.select.length > 0) {
        expand.push(`CurrentMember($select=${currentMember.select.join(",")})`);
      } else if (currentMember.expand.length > 0) {
        expand.push(`CurrentMember($expand=${currentMember.expand.join(",")})`);
      }
      if (
        identification.select.length > 0 &&
        identification.expand.length > 0
      ) {
        expand.push(
          `MemberIdentification($expand=${identification.expand.join(
            ","
          )};$select=${identification.select.join(",")})`
        );
      } else if (identification.select.length > 0) {
        expand.push(
          `MemberIdentification($select=${identification.select.join(",")})`
        );
      } else if (identification.expand.length > 0) {
        expand.push(
          `MemberIdentification($expand=${identification.expand.join(",")})`
        );
      }
      if (enrolment.select.length > 0 && enrolment.expand.length > 0) {
        expand.push(
          `MemberEnrolment($expand=${enrolment.expand.join(
            ","
          )};$select=${enrolment.select.join(",")})`
        );
      } else if (enrolment.select.length > 0) {
        expand.push(`MemberEnrolment($select=${enrolment.select.join(",")})`);
      } else if (enrolment.expand.length > 0) {
        expand.push(`MemberEnrolment($expand=${enrolment.expand.join(",")})`);
      }
      if (
        currentEmploymentInformation.select.length > 0 &&
        currentEmploymentInformation.expand.length > 0
      ) {
        expand.push(
          `CurrentEmploymentInformation($expand=${currentEmploymentInformation.expand.join(
            ","
          )};$select=${currentEmploymentInformation.select.join(",")})`
        );
      } else if (currentEmploymentInformation.select.length > 0) {
        expand.push(
          `CurrentEmploymentInformation($select=${currentEmploymentInformation.select.join(
            ","
          )})`
        );
      } else if (currentEmploymentInformation.expand.length > 0) {
        expand.push(
          `CurrentEmploymentInformation($expand=${currentEmploymentInformation.expand.join(
            ","
          )})`
        );
      }

      if (
        currentMemberBenefits.select.length > 0 &&
        currentMemberBenefits.expand.length > 0
      ) {
        expand.push(
          `CurrentMemberBenefits($expand=${currentMemberBenefits.expand.join(
            ","
          )};$select=${currentMemberBenefits.select.join(",")})`
        );
      } else if (currentMemberBenefits.select.length > 0) {
        expand.push(
          `CurrentMemberBenefits($select=${currentMemberBenefits.select.join(
            ","
          )})`
        );
      } else if (currentMemberBenefits.expand.length > 0) {
        expand.push(
          `CurrentMemberBenefits($expand=${currentMemberBenefits.expand.join(
            ","
          )})`
        );
      }
      if (
        currentMembershipStatus.select.length > 0 &&
        currentMembershipStatus.expand.length > 0
      ) {
        expand.push(
          `CurrentMembershipStatus($expand=${currentMembershipStatus.expand.join(
            ","
          )};$select=${currentMembershipStatus.select.join(",")})`
        );
      } else if (currentMembershipStatus.select.length > 0) {
        expand.push(
          `CurrentMembershipStatus($select=${currentMembershipStatus.select.join(
            ","
          )})`
        );
      } else if (currentMembershipStatus.expand.length > 0) {
        expand.push(
          `CurrentMembershipStatus($expand=${currentMembershipStatus.expand.join(
            ","
          )})`
        );
      }
      if (currentTerminationMembershipEvent.select.length > 0) {
        expand.push(
          `CurrentTerminationMembershipEvent($select=${currentTerminationMembershipEvent.select.join(
            ","
          )})`
        );
      }
      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      let query = clauses.join("&");
      //console.log(query);

      return query;
    },
    createPersonalInfoQuery(headers) {
      const select = ["IdentityId"];
      const expand = [];
      const identification = {
        select: [],
      };
      const enrolment = {
        select: [],
      };
      const identity = {
        select: ["Id"],
        expand: [],
      };

      if (
        headers.filter(
          (o) =>
            o.text === "First Name" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("FirstName");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Last Name" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("LastName");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Certificate" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        identification.select.push("Certificate");
        // identification.select.push(
        //   "Identity($select=Id;$expand=MemberIdentification($select=Certificate))"
        // );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Drawbridge Id" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        identification.select.push("Certificate");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Membership Id" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        identification.select.push("PensionMembershipId");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "SIN" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        identification.select.push("SIN");
        identification.select.push("TemporarySIN");
        // expand.push(
        //   "Identity($select=Id;$expand=MemberIdentification($select=SIN))"
        // );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Date Of Birth" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("DateOfBirth");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Tax Exemption" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("TaxExemption");
      }
      expand.push(
        "SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
      );
      if (
        headers.filter(
          (o) =>
            o.text === "Gender" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "Gender($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Has Eligible Dependants" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("HasEligibleDependants");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Title" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "Title($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Middle Name" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("MiddleName");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Suffix" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "Suffix($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Pronoun" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "Pronoun($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Marital Status" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "MaritalStatus($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "ProvinceOfResidence" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "ProvinceOfResidence($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "ProvinceOfEmployment" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "ProvinceOfEmployment($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Smoker" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("IsSmoker");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Enrollement Signed At" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        enrolment.select.push("EnrollmentReceivedAt");
        enrolment.select.push("EnrollmentSignedAt");
        // expand.push(
        //   "Identity($select=EnrollmentReceivedAt,EnrollmentSignedAt)"
        // );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Union Initiation Date" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        identity.select.push("UnionInitiationDate");
      }
      // if (
      //   headers.filter(
      //     (o) =>
      //       o.text === "Enrollement Received At" && (o.onEdit === "View" || o.onEdit === "Edit")
      //   ).length > 0
      // ) {
      //   select.push("EnrollmentReceivedAt");
      // }

      // const clauses = [];

      // if (select.length > 0) {
      //   clauses.push(`$select=${select.join(",")}`);
      // }
      // if (expand.length > 0) {
      //   clauses.push(`$expand=${expand.join(",")}`);
      // }
      // return "?" + clauses.join("&");

      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }
      if (identification.select.length > 0) {
        identity.expand.push(
          `MemberIdentification($select=${identification.select.join(",")})`
        );
      }
      if (enrolment.select.length > 0) {
        identity.expand.push(
          `MemberEnrolment($select=${enrolment.select.join(",")})`
        );
      }

      if (identity.select.length > 0 && identity.expand.length > 0) {
        expand.push(
          `Identity($expand=${identity.expand.join(
            ","
          )};$select=${identity.select.join(",")})`
        );
      } else if (identity.select.length > 0) {
        expand.push(`Identity($select=${identity.select.join(",")})`);
      } else if (identity.expand.length > 0) {
        expand.push(`Identity($expand=${identity.expand.join(",")})`);
      }

      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }

      return "?" + clauses.join("&");
    },
    editPersonalInfoHandler() {
      this.personalInfoEffectiveDate = null;
      this.dialogs.personalInfo = true;
      this.$nextTick(() => {
        if (this.$refs.personalInfoForm) {
          this.$refs.personalInfoForm.resetValidation();
        }
      });
    },
    async savePersonalInfo() {
      this.saving = true;
      try {
        let member = JSON.parse(JSON.stringify(this.personalInfo));

        if (member.Title) {
          member.TitleId = member.Title.Id;
          delete member.Title;
        }
        if (member.Pronoun) {
          member.PronounId = member.Pronoun.Id;
          delete member.Pronoun;
        }
        if (member.Gender) {
          member.GenderId = member.Gender.Id;
          delete member.Gender;
        }
        // if (member.FamilyStatus) {
        //   member.FamilyStatusId = member.FamilyStatus.Id;
        //   delete member.FamilyStatus;
        // }
        if (member.MaritalStatus) {
          member.MaritalStatusId = member.MaritalStatus.Id;
          delete member.MaritalStatus;
        }
        if (member.ProvinceOfResidence) {
          member.ProvinceOfResidenceId = member.ProvinceOfResidence.Id;
          delete member.ProvinceOfResidence;
        }
        if (member.Suffix) {
          member.SuffixId = member.Suffix.Id;
          delete member.Suffix;
        }
        if (member.ProvinceOfEmployment) {
          member.ProvinceOfEmploymentId = member.ProvinceOfEmployment.Id;
          delete member.ProvinceOfEmployment;
        }
        delete member["@odata.context"];
        delete member.Identity.MemberIdentification;

        member.EffectiveDate = this.personalInfoEffectiveDate;
        member.IdentityId = this.id;
        member.PlanIdentityId = this.selectedPlan.Id;

        if (member.SourceOfInformation) {
          member.SourceOfInformationId = member.SourceOfInformation.Id;
          delete member.SourceOfInformation;
        }

        await this.updateMemberPersonalInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: member,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.personalInfo = {
          Identity: {
            MemberIdentification: {},
          },
        };
        this.dialogs.personalInfo = false;
        this.reloadMemberIdentity();
        this.reloadCoverage();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    createEmploymentInfoQuery(headers) {
      const select = ["IdentityId"];
      const expand = [];

      expand.push(
        "SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
      );
      if (
        headers.filter(
          (o) =>
            o.text === "Employer" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "Employer($select=Id;$expand=Stores($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name)),Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Store" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "Store($select=Id;$expand=Current($expand=Translations($select=LanguageCode,Name);$select=IdentityId,Name))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Hire Date" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("HireDate");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Earnings" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("Earnings");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Occupation" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("Occupation");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Employment Frequency" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "EmploymentFrequency($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Employment Type" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "EmploymentType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "WeeklyHours" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("WeeklyHours");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Employee Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("EmployeeNumber");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Employer Contribution" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("EmployerContribution");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Second Income Earnings Frequency" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "SecondIncomeEarningsFrequency($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Second Income Type" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "SecondIncomeType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Second Income Earnings" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("SecondIncomeEarnings");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Salary Evidence Provided" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("SalaryEvidenceProvided");
      }
      if (
        headers.filter(
          (o) => o.text === "Salary Evidence" && o.onEdit === "Edit"
        ).length > 0
      ) {
        expand.push(
          "SalaryEvidence($expand=FileSegments($select=PhysicalFileId))"
        );
      }

      expand.push(
        "Identity($select=Id;$expand=CurrentMemberBenefitYear,CurrentMember($select=HasEligibleDependants),CurrentMembershipStatus($expand=DefaultCoverageStatus($select=Id,Name,AllowDependants,AllowSpouse,AllowChild;$expand=Translations($select=LanguageCode,DisplayValue)),MemberGroupIdentity($select=Id;$expand=Current($select=Id,Name,IdentityId;$expand=CoverageIdentities($select=Id;$expand=Current,CurrentCoverageEligibility($expand=CoverageStatuses)),Translations($select=LanguageCode,Name)));$select=Id,Class,EffectiveDate,ActivityStatusId,DefaultCoverageStatusId),CurrentMemberBenefits($expand=COB,CoverageStatus($select=Id,Name,AllowDependants,AllowSpouse,AllowChild;$expand=Translations($select=LanguageCode,DisplayValue)),CoverageIdentity($expand=Current,CurrentCoverageEligibility($expand=CoverageStatuses($expand=Translations($select=LanguageCode,DisplayValue))));$select=IsWaived,CurrentPolicy,Volume,NoOfDependants,CoverageIdentityId,EffectiveDate))"
      );
      const clauses = [];
      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }
      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      return "?" + clauses.join("&");
    },
    async editEmploymentInfoHandler() {
      try {
        this.loadingMember = true;
        this.employers = (
            await this.getEmployersDropDown({
              plan: this.selectedPlan.Id,
              // url:
              //   "employers?$expand=Current($expand=Translations;$select=Name,IdentityId),Stores($expand=Current($expand=Translations;$select=Name,IdentityId,IsAssignable);$select=Id)&$select=Id",
            })
          ).data.sort((a, b) => {
            const translatedA = a.Current.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].Name;
            const translatedB = b.Current.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0].Name;
            console.log(translatedA, translatedB);
            return sortAlphanum(translatedA, translatedB);
          });
          this.employmentInfoEffectiveDate = null;
          this.dialogs.employmentInfo = true;
          this.$nextTick(() => {
            if (this.$refs.employmentInfoForm) {
              this.$refs.employmentInfoForm.resetValidation();
            }
          });
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingMember = false;
      }
    },
    async saveEmploymentInfo() {
      this.saving = true;
      try {
        let member = JSON.parse(JSON.stringify(this.employmentInfo));

        if (member.Employer) {
          member.EmployerId = member.Employer.Id;
          delete member.Employer;
        }
        if (member.Store) {
          member.StoreId = member.Store.Id;
          delete member.Store;
        }
        if (member.EmploymentType) {
          member.EmploymentTypeId = member.EmploymentType.Id;
          delete member.EmploymentType;
        }
        if (member.EmploymentFrequency) {
          member.EmploymentFrequencyId = member.EmploymentFrequency.Id;
          delete member.EmploymentFrequency;
        }
        if (member.EarningsFrequency) {
          member.EarningsFrequencyId = member.EarningsFrequency.Id;
          delete member.EarningsFrequency;
        }
        if (member.IncomeType) {
          member.IncomeTypeId = member.IncomeType.Id;
          delete member.IncomeType;
        }
        if (member.SecondIncomeEarningsFrequency) {
          member.SecondIncomeEarningsFrequencyId =
            member.SecondIncomeEarningsFrequency.Id;
          delete member.SecondIncomeEarningsFrequency;
        }
        if (member.SecondIncomeType) {
          member.SecondIncomeTypeId = member.SecondIncomeType.Id;
          delete member.SecondIncomeType;
        }
        if (member.WeeklyHours !== null && member.WeeklyHours !== undefined) {
          const decimalValue = parseFloat(member.WeeklyHours);
          if (!isNaN(decimalValue)) {
            member.WeeklyHours = decimalValue;
          } else {
            delete member.WeeklyHours;
          }
        }
        delete member["@odata.context"];
        delete member.Identity;

        member.EffectiveDate = this.employmentInfoEffectiveDate;
        member.IdentityId = this.id;
        member.PlanIdentityId = this.selectedPlan.Id;

        if (member.SourceOfInformation) {
          member.SourceOfInformationId = member.SourceOfInformation.Id;
          delete member.SourceOfInformation;
        }

        const payload = {
          EmploymentInfo: member,
        };

        let membershipStatus = JSON.parse(
          JSON.stringify(this.employmentInfo.Identity.CurrentMembershipStatus)
        );
        console.log(`membership status is: ${membershipStatus}`);
        console.log(
          `membership status is #2: ${JSON.stringify(
            this.employmentInfo.Identity.CurrentMembershipStatus
          )}`
        );
        if (this.employmentCoverage) {
          console.log(`save employment info #1`);
          if (membershipStatus.MemberGroupIdentity) {
            membershipStatus.MemberGroupIdentityId =
              membershipStatus.MemberGroupIdentity.Current.IdentityId;
            delete membershipStatus.MemberGroupIdentity;
          }

          if (membershipStatus.DefaultCoverageStatus) {
            membershipStatus.DefaultCoverageStatusId =
              membershipStatus.DefaultCoverageStatus.Id;
            delete membershipStatus.DefaultCoverageStatus;
          }
          membershipStatus.EffectiveDate = this.employmentInfoEffectiveDate;

          const memberBenefits = JSON.parse(
            JSON.stringify(this.benefitsProvider.items)
          ).concat(
            JSON.parse(JSON.stringify(this.nonCustomizedBenefitsProvider.items))
          );

          const memberBenefitCOBs = [];
          for (let c of memberBenefits) {
            if (c.CoverageIdentity) {
              c.CoverageIdentityId = c.CoverageIdentity.Id;
              delete c.CoverageIdentity;
            }
            if (c.CoverageStatus) {
              c.CoverageStatusId = c.CoverageStatus.Id;
              delete c.CoverageStatus;
            }
            c.MemberIdentityId = this.id;

            // delete c.cobBool;
            if (c.COB && Object.keys(c.COB).length === 0) {
              delete c.COB;
            } else if (c.COB) {
              const cob = JSON.parse(JSON.stringify(c.COB));
              cob.CoverageIdentityId = c.CoverageIdentityId;
              cob.MemberIdentityId = this.id;
              if (cob.CoverageStatus) {
                cob.CoverageStatusId = cob.CoverageStatus.Id;
                delete cob.CoverageStatus;
              }
              memberBenefitCOBs.push(cob);
              delete c.COB;
            }

            if (c.Dependants !== null && c.Dependants !== undefined) {
              c.DependantIdentities = [];
              const identities = [];
              console.log(this.dependantsProvider.items, c.Dependants);
              for (let dep of c.Dependants) {
                console.log(
                  "--------------------",
                  dep,
                  this.dependantsProvider.items
                );
                let d;
                if (
                  dep !== null &&
                  dep !== undefined &&
                  typeof dep === "object"
                ) {
                  d = this.dependantsProvider.items.filter(
                    (o) => o.IdentityId === dep.IdentityId.toString()
                  )[0];
                } else {
                  d = this.dependantsProvider.items.filter(
                    (o) => o.IdentityId === dep.toString()
                  )[0];
                }
                identities.push(d.Identity);
              }
              c.DependantIdentities = identities.map((o) => {
                return {
                  Id: o.Id,
                };
              });
              delete c.Dependants;
            }
            if (membershipStatus.SourceOfInformation) {
              c.SourceOfInformationId = membershipStatus.SourceOfInformation.Id;
            }
          }
          for (let c of this.originalMemberBenefits) {
            if (
              memberBenefits.filter(
                (o) => o.CoverageIdentityId === c.CoverageIdentityId
              ).length === 0
            ) {
              //removed
              c.IsRemoved = true;
              c.EffectiveDate = this.coverageEffectiveDate;
              c.MemberIdentityId = this.id;
              delete c.CoverageIdentity;
              if (c.CoverageStatus) {
                c.CoverageStatusId = c.CoverageStatus.Id;
                delete c.CoverageStatus;
              }
              if (membershipStatus.SourceOfInformation) {
                c.SourceOfInformation = membershipStatus.SourceOfInformation.Id;
              }
              memberBenefits.push(c);
            }
          }

          membershipStatus.IdentityId = this.id;

          let customConfiguration = this.coverageConfiguration.filter(
            (o) =>
              memberBenefits.filter(
                (c) =>
                  c.IsRemoved !== true &&
                  c.CoverageIdentityId ===
                    o.ConfigurationParameterIdentity.Current.CoverageIdentityId
              ).length > 0
          );
          for (let cc of customConfiguration) {
            delete cc.ConfigurationParameterIdentity;
          }
          console.log(customConfiguration);
          membershipStatus.CustomConfigurationParameterValueIdentities =
            customConfiguration;
          if (membershipStatus.SourceOfInformation) {
            membershipStatus.SourceOfInformationId =
              membershipStatus.SourceOfInformation.Id;
            delete membershipStatus.SourceOfInformation;
          }

          payload.MembershipStatus = membershipStatus;
          payload.MemberBenefits = memberBenefits;
          payload.MemberBenefitCOBs = memberBenefitCOBs;
        }

        await this.updateMemberEmploymentInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.employmentInfo = false;
        this.employmentInfo = null;

        this.employmentCoverage = false;
        this.reloadMemberIdentity();
        this.reloadCoverage();
        await this.loadUserPlans();
        await this.setPlanId(this.selectedPlan.Id);
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    createUnionLocalQuery(headers) {
      const select = ["IdentityId"];
      const expand = [];
      expand.push(
        "SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
      );
      if (
        headers.filter(
          (o) =>
            o.text === "Union Local Home" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "UnionLocalHome($select=Id;$expand=Current($expand=Translations($select=Id,LanguageCode,Name);$select=Name,IdentityId))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Union Local Work" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "UnionLocalWork($select=Id;$expand=Current($expand=Translations($select=Id,LanguageCode,Name);$select=Name,IdentityId))"
        );
      }

      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }
      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      return "?" + clauses.join("&");
    },
    createContactInfoQuery(headers) {
      const select = ["IdentityId"];
      const expand = [];
      expand.push(
        "SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
      );
      if (
        headers.filter(
          (o) =>
            o.text === "Country" && (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "Address($select=ContactInformationId,SuiteNumber,StreetNumber,StreetName,OtherProvince,PostalCode,OtherPostalCode,City,OtherCountry;$expand=Country($select=Id,IsOther,Name;$expand=Translations($select=LanguageCode,DisplayValue)),Province($select=Id,Code,Name;$expand=Translations($select=LanguageCode,DisplayValue)))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Phone Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("PhoneNumber");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "CommunicationPreference" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "CommunicationPreference($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "LanguageChoice" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "LanguageChoice($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      // if (
      //   !this.planIdentity.HasDrupalPortal ||
      //   this.planIdentity.MembersPortal === undefined ||
      //   this.planIdentity.MembersPortal === null ||
      //   !this.planIdentity.MembersPortal.IsActive
      // ) {
      //   if (
      //     headers.filter(
      //       (o) =>
      //         o.text === "Email" && (o.onEdit === "View" || o.onEdit === "Edit")
      //     ).length > 0
      //   ) {
      //     expand.push("Identity($select=Email)");
      //   }
      // }

      // if (
      //   headers.filter(
      //     (o) =>
      //       o.text === "Home Email" &&
      //       (o.onEdit === "View" || o.onEdit === "Edit")
      //   ).length > 0
      // ) {
        select.push("HomeEmail");
      // }
      if (
        headers.filter(
          (o) =>
            o.text === "Work Email" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("WorkEmail");
      }

      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }
      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      return "?" + clauses.join("&");
    },
    editContactInfoHandler() {
      let now = new Date();
      let day = now.getDate();
      let month = now.getMonth() + 1;
      if (day.toString().length === 1) day = "0" + day.toString();
      if (month.toString().length === 1) month = "0" + month.toString();

      this.contactInfoEffectiveDate =
        now.getFullYear() + "-" + month + "-" + day + "T00:00:00.000Z";
      this.dialogs.contactInfo = true;
      this.$nextTick(() => {
        if (this.$refs.contactInfoForm) {
          this.$refs.contactInfoForm.resetValidation();
        }
        // if (this.$refs.addressForm) {
        //   this.$refs.addressForm.resetValidation();
        // }
      });
    },
    async editUnionLocalHandler() {
      this.unionLocalEffectiveDate = null;
      this.dialogs.unionLocal = true;
      // this.$nextTick(() => {
      //   if (this.$refs.contactInfoForm) {
      //     this.$refs.contactInfoForm.resetValidation();
      //   }
      //   if (this.$refs.addressForm) {
      //     this.$refs.addressForm.resetValidation();
      //   }
      // });
    },
    async saveContactInfo() {
      this.saving = true;
      try {
        let member = JSON.parse(JSON.stringify(this.contactInfo));

        if (member.LanguageChoice) {
          member.LanguageChoiceId = member.LanguageChoice.Id;
          delete member.LanguageChoice;
        }
        if (member.CommunicationPreference) {
          member.CommunicationPreferenceId = member.CommunicationPreference.Id;
          delete member.CommunicationPreference;
        }
        if (member.Address) {
          if (Object.keys(member.Address).length > 0) {
            if (member.Address.Country) {
              member.Address.CountryId = member.Address.Country.Id;
              delete member.Address.Country;
            }
            if (member.Address.Province) {
              member.Address.ProvinceId = member.Address.Province.Id;
              delete member.Address.Province;
            }
            // member.Address.PostalCode = this.unmask(member.Address.PostalCode, this.postalCodeMask);
          } else {
            delete member.Address;
          }
        } else {
          delete member.Address;
        }

        // if (member.PhoneNumber!== null && member.PhoneNumber !== undefined) {
        //   member.PhoneNumber = this.unmask(member.PhoneNumber, this.telephoneMask);
        // }

        delete member["@odata.context"];
        // delete member.Identity;

        member.EffectiveDate = this.memberIdentity.PlanEntryDate;
        member.IdentityId = this.id;
        member.PlanIdentityId = this.selectedPlan.Id;

        if (member.SourceOfInformation) {
          member.SourceOfInformationId = member.SourceOfInformation.Id;
          delete member.SourceOfInformation;
        }

        await this.updateMemberContactInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: member,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.contactInfo = null;
        this.dialogs.contactInfo = false;
        this.contactInfoEffectiveDate = null;
        this.reloadMemberIdentity();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async saveUnionLocal() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.unionLocal));

        if (item.UnionLocalHome) {
          item.UnionLocalHomeId = item.UnionLocalHome.Id;
          delete item.UnionLocalHome;
        }
        if (item.UnionLocalWork) {
          item.UnionLocalWorkId = item.UnionLocalWork.Id;
          delete item.UnionLocalWork;
        }
        item.EffectiveDate = this.unionLocalEffectiveDate;

        // item.IdentityId = this.id;
        // member.PlanIdentityId = this.selectedPlan.Id;
        if (item.SourceOfInformation) {
          item.SourceOfInformationId = item.SourceOfInformation.Id;
          delete item.SourceOfInformation;
        }

        await this.updateMemberUnionLocal({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.unionLocal = {};
        this.dialogs.unionLocal = false;
        this.reloadMemberIdentity();
        if (this.$refs.unionLocalHistoryTable) {
          this.$refs.unionLocalHistoryTable.getDataAsync();
        }
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    createDirectDepositQuery(headers) {
      const select = ["IdentityId"];
      const expand = [];
      expand.push(
        "SourceOfInformation($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
      );
      if (
        headers.filter(
          (o) =>
            o.text === "Account Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("AccountNumber");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Transit Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("TransitNumber");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Institution Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("InstitutionNumber");
      }
      // if (
      //   headers.filter(
      //     (o) =>
      //       o.text === "Account Type" &&
      //       (o.onEdit === "View" || o.onEdit === "Edit")
      //   ).length > 0
      // ) {
      //   expand.push(
      //     "AccountType($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
      //   );
      // }
      if (
        headers.filter(
          (o) =>
            o.text === "Verify Direct Deposit" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("VerifyDirectDeposit");
      }

      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }
      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      return "?" + clauses.join("&");
    },
    editDirectDepositHandler() {
      let now = new Date();
      let day = now.getDate();
      let month = now.getMonth() + 1;
      if (day.toString().length === 1) day = "0" + day.toString();
      if (month.toString().length === 1) month = "0" + month.toString();

      this.directDepositEffectiveDate =
        now.getFullYear() + "-" + month + "-" + day + "T00:00:00.000Z";
      this.dialogs.directDeposit = true;
      this.$nextTick(() => {
        if (this.$refs.directDepositForm) {
          this.$refs.directDepositForm.resetValidation();
        }
      });
    },
    deleteDirectDepositHandler() {
      this.dialogs.deleteDirectDeposit = true;
    },
    async validateDirectDeposit() {
      if (this.directDeposit) {
        if (Object.keys(this.directDeposit).length > 0) {
          this.saving = true;
          try {
            const valid = (
              await this.validateBankAccount({
                payload: {
                  InstitutionNumber: this.directDeposit.InstitutionNumber,
                  TransitNumber: this.directDeposit.TransitNumber,
                },
              })
            ).data;

            if (!valid) {
              this.confirmBankAccountDialog = true;
            } else {
              await this.saveDirectDeposit();
            }
          } catch (error) {
            this.error = error;
          } finally {
            this.saving = false;
          }
        } else {
          this.saveDirectDeposit();
        }
      } else {
        this.saveDirectDeposit();
      }
    },
    async saveDirectDeposit() {
      this.saving = true;
      try {
        let bankAccount = JSON.parse(JSON.stringify(this.directDeposit));
        if (bankAccount) {
          // if (Object.keys(bankAccount).length > 0) {
          // if (bankAccount.AccountType) {
          //   bankAccount.AccountTypeId = bankAccount.AccountType.Id;
          //   delete bankAccount.AccountType;
          // }
          // } else {
          //   delete bankAccount;
          // }
        } else {
          // delete bankAccount;
        }
        delete bankAccount["@odata.context"];

        bankAccount.EffectiveDate = this.memberIdentity.PlanEntryDate;
        bankAccount.IdentityId = this.id;
        if (bankAccount.SourceOfInformation) {
          bankAccount.SourceOfInformationId =
            bankAccount.SourceOfInformation.Id;
          delete bankAccount.SourceOfInformation;
        }

        await this.updateMemberDirectDeposit({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          payload: bankAccount,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.directDeposit = {};
        this.dialogs.directDeposit = false;
        this.directDepositEffectiveDate = null;
        this.reloadMemberIdentity();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async tryDeleteDirectDeposit() {
      this.saving = true;
      try {
        await this.deleteMemberDirectDeposit({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.deleteDirectDeposit = false;
        this.reloadMemberIdentity();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async reloadActiveNotesCount() {
      this.activeNotesCount = (
        await this.getActiveNotesCount({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.id,
          odataQuery:
            "?$select=Id&$expand=Notes($top=0;$count=true;$filter=IsActive eq true)",
        })
      ).data["Notes@odata.count"];
    },
    countryChanged() {
      //console.log(this.contactInfo);
      if (this.contactInfo.Address.Country) {
        if (this.contactInfo.Address.Country.IsOther) {
          delete this.contactInfo.Address.Province;
          delete this.contactInfo.Address.PostalCode;
        } else {
          delete this.contactInfo.Address.OtherCountry;
          delete this.contactInfo.Address.OtherProvince;
          delete this.contactInfo.Address.OtherPostalCode;
        }
      } else {
        this.contactInfo.Address = {};
      }
      this.$forceUpdate();
    },
    createBenefitCardQuery(headers) {
      const select = ["IdentityId"];
      const expand = [];

      if (
        headers.filter(
          (o) =>
            o.text === "Account Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("AccountNumber");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Transit Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("TransitNumber");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Institution Number" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("InstitutionNumber");
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Account Type" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        expand.push(
          "Account Type($select=Id,Name;$expand=Translations($select=LanguageCode,DisplayValue))"
        );
      }
      if (
        headers.filter(
          (o) =>
            o.text === "Verify Direct Deposit" &&
            (o.onEdit === "View" || o.onEdit === "Edit")
        ).length > 0
      ) {
        select.push("Verify Direct Deposit");
      }

      const clauses = [];

      if (select.length > 0) {
        clauses.push(`$select=${select.join(",")}`);
      }
      if (expand.length > 0) {
        clauses.push(`$expand=${expand.join(",")}`);
      }
      return "?" + clauses.join("&");
    },
    async makeFile(item) {
      const res = (
        await axios.get(
          `${this.settings.DOCUMENTSERVICEURL + "api/UploadFiles"}/${item.Id}`
        )
      ).data;
      const blob = this.b64toBlob(res);
      return new File([blob], item.Name, { type: blob.type });
    },
    createDescription(item) {
      return (
        item.file.Name +
        "--" +
        new Date(Date.parse(item.file.DateCreated)).toLocaleString()
      );
    },
    async loadEmployer(v) {
      console.log("eeee is ", v);
      if (v) {
        let planDetails = (
          await this.getPlanDetailsByDate({
            plan: this.selectedPlan.Id,
            date: this.employmentInfoEffectiveDate,
          })
        ).data;
        let classes =
          planDetails && planDetails.Classes
            ? JSON.parse(planDetails.Classes)
            : [];
        if (v.Current && v.Current.Classes) {
          let employerClasses = JSON.parse(v.Current.Classes);
          classes = classes.filter((o) => employerClasses.some((e) => e === o));
          if (this.employmentInfo.Identity.CurrentMembershipStatus.Class) {
            if (
              !employerClasses.some(
                (e) =>
                  e ===
                  this.employmentInfo.Identity.CurrentMembershipStatus.Class
              )
            ) {
              this.employmentInfo.Identity.CurrentMembershipStatus.Class = null;
            }
          }
        }
        this.classes = classes;

        this.hasCoverageCommencementRules =
          await this.checkHasCoverageCommencementRules({
            planId: this.selectedPlan.Id,
            employerId: v.Id,
          });
        if (this.planOptions.HasStores) {
          if (v.Stores) {
            this.stores = v.Stores.filter(
              (o) =>
                o.Current !== null &&
                o.Current !== undefined &&
                o.Current.IsAssignable !== false
            );
          }
          if (
            !v.Stores ||
            v.Stores.filter((o) =>
              this.employmentInfo.Store
                ? o.Id === this.employmentInfo.Store.Id
                : false
            ).length === 0
          ) {
            this.employmentInfo.Store = null;
            this.employmentInfo.StoreId = null;
          }
        }
        console.log(`load employer #1: ${this.employmentInfo}`);
        if (
          !this.planIdentity.HasEligibilityBank &&
          !this.hasCoverageCommencementRulesPlan &&
          this.employmentInfo.Identity.CurrentMembershipStatus &&
          this.employmentInfo.Identity.CurrentMembershipStatus.Class
        ) {
          console.log("e is ", v);
          if (v.Current && v.Current.Classes) {
            let employerClasses = JSON.parse(v.Current.Classes);
            if (
              !employerClasses.some(
                (e) =>
                  e ===
                  this.employmentInfo.Identity.CurrentMembershipStatus.Class
              )
            ) {
              console.log("CLAsses");
              this.employmentCoverage = true;
            }
          }
        }
        if (
          !this.planIdentity.HasEligibilityBank &&
          !this.hasCoverageCommencementRulesPlan &&
          this.employmentInfo.Identity.CurrentMembershipStatus &&
          this.employmentInfo.Identity.CurrentMembershipStatus
            .MemberGroupIdentity &&
          this.employmentInfo.Identity.CurrentMembershipStatus
            .MemberGroupIdentity.Current
        ) {
          console.log(
            "mg is ",
            this.employmentInfo.Identity.CurrentMembershipStatus
              .MemberGroupIdentity.Current
          );
          if (!this.planIdentity.HasEligibilityBank && v.MemberGroups && v.MemberGroups.length > 0) {
            if (
              !v.MemberGroups.some(
                (o) =>
                  o.IdentityId ===
                  this.employmentInfo.Identity.CurrentMembershipStatus
                    .MemberGroupIdentity.Id
              )
            ) {
              console.log("member GRoup");
              this.employmentCoverage = true;
            }
          }
        }
      } else {
        this.stores = [];
        this.hasCoverageCommencementRules = true;
      }
    },
  },
  watch: {
    "editedUntrackedItem.MemberIdentification.SIN": {
      async handler(v) {
        await this.$nextTick();
        this.$refs.untrackedForm.validate();
      }
    },
    "editedUntrackedItem.MemberIdentification.TemporarySIN": {
      async handler(v) {
        await this.$nextTick();
        this.$refs.untrackedForm.validate();
      }
    },
    "selectedBenefit.CoverageStatus": {
      handler(v) {
        console.log(
          "selectedBenefit.CoverageStatus watcher: start of method",
          JSON.stringify(this.selectedBenefit),
          v
        );
        if (v.Name === "Single") {
          this.selectedBenefit.Dependants = [];
          if (
            (this.selectedBenefit.DependantIdentities &&
              this.tracksDependantsByName(this.selectedBenefit)) ||
            this.tracksDependantsByNumber(this.selectedBenefit)
          ) {
            this.selectedBenefit.NoOfDependants = 0;
          } else {
            this.selectedBenefit.NoOfDependants = null;
          }
          // this.selectedBenefit.NoOfDependants = 0;
        }
        console.log(
          "selectedBenefit.CoverageStatus watcher: end of method",
          JSON.stringify(this.selectedBenefit)
        );
      },
    },
    "contactInfo.Identity.Email": {
      handler() {
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.validate();
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    "contactInfo.HomeEmail": {
      handler() {
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.validate();
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    confirmHomeEmail: {
      handler() {
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.validate();
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    "contactInfo.WorkEmail": {
      handler() {
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.validate();
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    confirmWorkEmail: {
      handler() {
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.validate();
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    confirmEmail: {
      handler() {
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.validate();
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    "editedItem.Email": {
      handler() {
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.validate();
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
    id: {
      immediate: true,
      handler() {},
    },
    effectiveDate: {
      async handler(v) {
        console.log("eff dat: ", v);
        if (v) {
          try {
            if (this.activeDialog === "class") {
              console.log(
                "employer is ",
                this.memberIdentity.CurrentEmploymentInformation.Employer
              );
              let planDetails = (
                await this.getPlanDetailsByDate({
                  plan: this.selectedPlan.Id,
                  date: v,
                })
              ).data;
              let classes =
                planDetails && planDetails.Classes
                  ? JSON.parse(planDetails.Classes).sort((a, b) => {
                      return a.localeCompare(b);
                    })
                  : [];
              if (
                this.memberIdentity.CurrentEmploymentInformation.Employer &&
                this.memberIdentity.CurrentEmploymentInformation.Employer
                  .Current &&
                this.memberIdentity.CurrentEmploymentInformation.Employer
                  .Current.Classes
              ) {
                let employerClasses = JSON.parse(
                  this.memberIdentity.CurrentEmploymentInformation.Employer
                    .Current.Classes
                );
                classes = classes.filter((o) =>
                  employerClasses.some((e) => e === o)
                );
              }
              this.classes = classes;
            }

            if (this.lockId) {
              this.editedItem = (
                await this.getMembershipStatusByEffectiveDate({
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.activeOdataQuery,
                })
              ).data;
            } else {
              this.editedItem = await this.lock(
                this.getMembershipStatusByEffectiveDate,
                {
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.activeOdataQuery,
                  dialogs: this.dialogs,
                  dialog: this.activeDialog,
                },
                () => {
                  this.dialogs[this.activeDialog] = false;
                }
              );
            }
            this.editedItemExtensionOfBenefits =
              this.editedItem.ExtensionTerminationDate !== null &&
              this.editedItem.ExtensionTerminationDate !== undefined;
          } catch (error) {
            this.error = error;
          }
        }
      },
    },
    coverageEffectiveDate: {
      async handler(v) {
        if (
          v &&
          this.dialogs.reinstate === false &&
          this.dialogs.employmentInfo === false
        ) {
          this.loading = true;
          try {
            let planDetails = (
              await this.getPlanDetailsByDate({
                plan: this.selectedPlan.Id,
                date: v,
              })
            ).data;
            let classes =
              planDetails && planDetails.Classes
                ? JSON.parse(planDetails.Classes).sort((a, b) => {
                    return a.localeCompare(b);
                  })
                : [];
            if (
              this.memberIdentity.CurrentEmploymentInformation.Employer &&
              this.memberIdentity.CurrentEmploymentInformation.Employer
                .Current &&
              this.memberIdentity.CurrentEmploymentInformation.Employer.Current
                .Classes &&
              this.memberIdentity.CurrentEmploymentInformation.Employer.Current
                .Classes.length > 0
            ) {
              let employerClasses = JSON.parse(
                this.memberIdentity.CurrentEmploymentInformation.Employer
                  .Current.Classes
              );
              classes = classes.filter((o) =>
                employerClasses.some((e) => e === o)
              );
            }
            this.classes = classes;

            let memberGroups = (
              await this.getMemberGroupsWithDate({
                plan: this.selectedPlan.Id,
                date: v,
                url: `?$expand=Translations,Employers,CoverageIdentities($expand=CurrentCoverageEligibility($expand=CoverageStatuses),Current($expand=Translations))&$filter=(Employers/any(e: e/Id eq ${this.memberIdentity.CurrentEmploymentInformation.Employer.Id}) or Employers/any() eq false)`,
              })
            ).data.value;

            if (this.memberIdentity.CurrentEmploymentInformation.Employer) {
              let employerGroups = [];
              for (let mg of memberGroups) {
                if (mg.Employers && mg.Employers.length > 0) {
                  if (
                    mg.Employers.some(
                      (o) =>
                        o.Id ===
                        this.memberIdentity.CurrentEmploymentInformation
                          .Employer.Id
                    )
                  ) {
                    // console.log("employer: ", employer);
                    // console.log("mg: ", mg);
                    employerGroups.push(mg);
                  }
                }
              }
              if (employerGroups.length > 0) {
                this.memberGroups = JSON.parse(JSON.stringify(employerGroups));
              } else {
                this.memberGroups = JSON.parse(JSON.stringify(memberGroups));
              }
            }

            this.enableWatchers = false;

            if (this.lockId) {
              this.editedItemCoverage = (
                await this.getMemberCoverageByEffectiveDate({
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                })
              ).data;
            } else {
              this.editedItemCoverage = await this.lock(
                this.getMemberCoverageByEffectiveDate,
                {
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  dialogs: this.dialogs,
                  dialog: "coverage",
                },
                () => {
                  this.dialogs.coverage = false;
                }
              );
            }
            if (
              this.editedItemCoverage.CurrentMembershipStatus !== null &&
              this.editedItemCoverage.CurrentMembershipStatus !== undefined
            ) {
              this.coverageConfiguration =
                this.editedItemCoverage.CurrentMembershipStatus.CustomConfigurationParameterValueIdentities;

              await this.setCustomizableCoverages(v);

              const coverageStatus = this.editedItemCoverage
                .CurrentMembershipStatus.DefaultCoverageStatus
                ? this.editedItemCoverage.CurrentMembershipStatus
                    .DefaultCoverageStatus
                : {};
              this.getSelectableFamilyStatus(coverageStatus.Id);
            } else {
              this.editedItemCoverage.CurrentMembershipStatus = {};
            }
            if (
              this.editedItemCoverage.CurrentTerminationMembershipEvent ===
                null ||
              this.editedItemCoverage.CurrentTerminationMembershipEvent ===
                undefined
            ) {
              this.editedItemCoverage.CurrentTerminationMembershipEvent = {};
            }
            if (
              this.editedItemCoverage.CurrentMemberBenefitYear === null ||
              this.editedItemCoverage.CurrentMemberBenefitYear === undefined
            ) {
              this.editedItemCoverage.CurrentMemberBenefitYear = {};
            }
            this.originalCoveragePayload.MemberBenefits = JSON.parse(
              JSON.stringify(this.editedItemCoverage.CurrentMemberBenefits)
            );
            this.originalCoveragePayload.MembershipStatus = JSON.parse(
              JSON.stringify(this.editedItemCoverage.CurrentMembershipStatus)
            );
            this.originalCoveragePayload.TerminationMembershipEvent =
              JSON.parse(
                JSON.stringify(
                  this.editedItemCoverage.CurrentTerminationMembershipEvent
                )
              );
          } catch (error) {
            this.error = error;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.enableWatchers = true;
          });
        }
      },
    },
    "editedItemCoverage.CurrentMembershipStatus.MemberGroupIdentity.Current": {
      async handler(v) {
        if (this.enableWatchers && this.editedItemCoverage) {
          if (v) {
            this.customizedCoverages = [];
            this.loading = true;
            try {
              await this.setCustomizableCoverages(this.coverageEffectiveDate);
            } catch (error) {
              this.error = error;
            } finally {
              this.loading = false;
            }

            console.log("mg is ", v);
            // if (this.memberIdentity.CurrentEmploymentInformation && this.memberIdentity.CurrentEmploymentInformation.Employer) {
            //   console.log("e is ", this.memberIdentity.CurrentEmploymentInformation.Employer)
            //   if (this.memberIdentity.CurrentEmploymentInformation.Employer.MemberGroupHistory && this.memberIdentity.CurrentEmploymentInformation.Employer.MemberGroupHistory.length > 0) {
            //     if (!this.memberIdentity.CurrentEmploymentInformation.Employer.MemberGroupHistory.some(o=>o.Id===v.Id)) {
            //       this.dialogs.employmentCoverage = true;
            //     }
            //   }
            // }
          }
        }
      },
      immediate: true,
    },
    "reinstateItem.CurrentMembershipStatus.MemberGroupIdentity.Current": {
      async handler(v) {
        console.log(
          "reinstateItem.CurrentMembershipStatus.MemberGroupIdentity.Current",
          this.enableWatchers,
          v
        );
        if (this.enableWatchers && this.reinstateItem) {
          if (v) {
            this.customizedCoverages = [];
            this.loading = true;
            try {
              await this.setCustomizableCoverages(
                this.reinstateEffectiveDate,
                this.reinstateItem
              );
            } catch (error) {
              this.error = error;
            } finally {
              this.loading = false;
            }
          }
        }
      },
      immediate: true,
    },
    personalInfoEffectiveDate: {
      async handler(v) {
        if (v) {
          this.loading = true;
          try {
            let personalInfo;
            if (this.lockId) {
              personalInfo = (
                await this.getPersonalInfoByEffectiveDate({
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.personalInfoQuery,
                })
              ).data;
            } else {
              personalInfo = await this.lock(
                this.getPersonalInfoByEffectiveDate,
                {
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.personalInfoQuery,
                  dialogs: this.dialogs,
                  dialog: "personalInfo",
                },
                () => {
                  this.dialogs.personalInfo = false;
                }
              );
            }
            if (
              personalInfo.Identity.MemberEnrolment === null ||
              personalInfo.Identity.MemberEnrolment === undefined
            ) {
              personalInfo.Identity.MemberEnrolment = {};
            }
            this.personalInfo = personalInfo;
            this.originalSIN =
              this.personalInfo.Identity.MemberIdentification.SIN;
            this.originalTemporarySIN =
              this.personalInfo.Identity.MemberIdentification.TemporarySIN;
            this.originalEnrolmentSignedAt =
              this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt;
            this.originalEnrolmentReceivedAt =
              this.personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt;
            this.originalUnionInitiationDate = this.personalInfo.Identity.UnionInitiationDate;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
    },
    employmentInfoEffectiveDate: {
      async handler(v) {
        if (v) {
          this.loading = true;
          try {
            let employmentInfo;
            if (this.lockId) {
              employmentInfo = (
                await this.getEmploymentInfoByEffectiveDate({
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.employmentInfoQuery,
                })
              ).data;
            } else {
              employmentInfo = await this.lock(
                this.getEmploymentInfoByEffectiveDate,
                {
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.employmentInfoQuery,
                  dialogs: this.dialogs,
                  dialog: "employmentInfo",
                },
                () => {
                  this.dialogs.employmentInfo = false;
                }
              );
            }
            // if (this.employmentInfo.Identity.CurrentMemberBenefitYear===null || this.employmentInfo.Identity.CurrentMemberBenefitYear===undefined) {
            //   this.employmentInfo.Identity.CurrentMemberBenefitYear = {};
            // }
            this.salaryEvidenceIds = null;
            if (employmentInfo.SalaryEvidence) {
              this.salaryEvidenceIds =
                employmentInfo.SalaryEvidence.FileSegments.map(
                  (x) => x.PhysicalFileId
                );
            }

            let memberGroups = (
              await this.getMemberGroupsWithDate({
                plan: this.selectedPlan.Id,
                date: v,
                url: "?$expand=Employers,Translations,CoverageIdentities($expand=CurrentCoverageEligibility($expand=CoverageStatuses),Current($expand=Translations,PlanInsuranceCarrier($expand=PolicyIdentity($expand=Current))))",
              })
            ).data.value;

            for (let employer of this.employers) {
              let employerGroups = [];
              for (let mg of memberGroups) {
                if (mg.Employers && mg.Employers.length > 0) {
                  if (mg.Employers.some((o) => o.Id === employer.Id)) {
                    // console.log("employer: ", employer);
                    // console.log("mg: ", mg);
                    employerGroups.push(mg);
                  }
                }
              }
              if (employerGroups.length > 0) {
                employer.MemberGroups = JSON.parse(
                  JSON.stringify(employerGroups)
                );
              } else {
                employer.MemberGroups = JSON.parse(
                  JSON.stringify(this.memberGroups)
                );
              }
            }

            if (employmentInfo.Identity.CurrentMembershipStatus) {
              await this.setCustomizableCoverages(
                this.employmentInfoEffectiveDate,
                employmentInfo.Identity
              );

              const coverageStatus = employmentInfo.Identity
                .CurrentMembershipStatus.DefaultCoverageStatus
                ? employmentInfo.Identity.CurrentMembershipStatus
                    .DefaultCoverageStatus
                : {};
              this.getSelectableFamilyStatus(coverageStatus.Id);
            }
            this.originalMemberBenefits = JSON.parse(
              JSON.stringify(employmentInfo.Identity.CurrentMemberBenefits)
            );
            this.employmentInfo = employmentInfo;
            this.coverageEffectiveDate = v;
          } catch (error) {
            this.error = error;
          }
          this.loading = false;
        }
      },
    },
    "employmentInfo.Employer": {
      handler(v) {
        this.loadEmployer(v);
      },
    },
    "reinstateItem.CurrentEmploymentInformation.Employer": {
      async handler(v) {
        if (v) {
          this.hasCoverageCommencementRules =
            await this.checkHasCoverageCommencementRules({
              planId: this.selectedPlan.Id,
              employerId: v.Id,
            });
          if (this.planOptions.HasStores) {
            if (v.Stores) {
              this.stores = v.Stores.filter(
                (o) =>
                  o.Current !== null &&
                  o.Current !== undefined &&
                  o.Current.IsAssignable !== false
              );
            }
            if (
              !v.Stores ||
              v.Stores.filter((o) =>
                this.reinstateItem.CurrentEmploymentInformation.Store
                  ? o.Id ===
                    this.reinstateItem.CurrentEmploymentInformation.Store.Id
                  : false
              ).length === 0
            ) {
              this.reinstateItem.CurrentEmploymentInformation.Store = null;
              this.reinstateItem.CurrentEmploymentInformation.StoreId = null;
            }
          }
        } else {
          this.stores = [];
          this.hasCoverageCommencementRules = true;
        }
      },
    },
    contactInfoEffectiveDate: {
      async handler(v) {
        if (v) {
          this.loading = true;
          try {
            let contactInfo;
            if (this.lockId) {
              contactInfo = (
                await this.getContactInfoByEffectiveDate({
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.contactInfoQuery,
                })
              ).data;
            } else {
              contactInfo = await this.lock(
                this.getContactInfoByEffectiveDate,
                {
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.contactInfoQuery,
                  dialogs: this.dialogs,
                  dialog: "contactInfo",
                },
                () => {
                  this.dialogs.contactInfo = false;
                  this.contactInfoEffectiveDate = null;
                }
              );
            }
            //console.log(contactInfo);
            if (!contactInfo) {
              contactInfo = {
                // Address: {},
                // Identity: {},
              };
            }
            // if (
            //   contactInfo.Address === null ||
            //   contactInfo.Address === undefined
            // ) {
            //   contactInfo.Address = {};
            // }
            // if (
            //   contactInfo.Identity === null ||
            //   contactInfo.Identity === undefined
            // ) {
            //   contactInfo.Identity = {};
            // }
            if (
              contactInfo.HomeEmail != null &&
              contactInfo.HomeEmail !== undefined
            ) {
              this.confirmHomeEmail = contactInfo.HomeEmail;
            }
            if (
              contactInfo.WorkEmail != null &&
              contactInfo.WorkEmail !== undefined
            ) {
              this.confirmWorkEmail = contactInfo.WorkEmail;
            }
            this.contactInfo = contactInfo;
          } catch (error) {
            this.error = error;
          }
          this.loading = false;
        }
      },
    },
    unionLocalEffectiveDate: {
      async handler(v) {
        if (v) {
          this.loading = true;
          try {
            this.unionLocals = (
              await this.getUnionLocalsByEffectiveDate({
                planIdentityId: this.selectedPlan.Id,
                effectiveDate: v,
              })
            ).data.value.sort((a, b) => {
              const translatedA = a.Current.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
              const translatedB = b.Current.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
              return sortAlphanum(translatedA, translatedB);
            });

            let unionLocal;
            if (this.lockId) {
              unionLocal = (
                await this.getMemberUnionLocalByEffectiveDate({
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.unionLocalQuery,
                })
              ).data;
            } else {
              unionLocal = await this.lock(
                this.getMemberUnionLocalByEffectiveDate,
                {
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.unionLocalQuery,
                  dialogs: this.dialogs,
                  dialog: "unionLocal",
                },
                () => {
                  this.dialogs.unionLocal = false;
                }
              );
            }
            //console.log(contactInfo);
            if (!unionLocal) {
              unionLocal = {};
            }
            this.unionLocal = unionLocal;
          } catch (error) {
            this.error = error;
          }
          this.loading = false;
        }
      },
    },
    directDepositEffectiveDate: {
      async handler(v) {
        if (v) {
          this.loading = true;
          try {
            if (this.lockId) {
              this.directDeposit = (
                await this.getDirectDepositByEffectiveDate({
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.directDepositQuery,
                })
              ).data;
            } else {
              this.directDeposit = await this.lock(
                this.getDirectDepositByEffectiveDate,
                {
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.directDepositQuery,
                  dialogs: this.dialogs,
                  dialog: "directDeposit",
                },
                () => {
                  this.dialogs.directDeposit = false;
                }
              );
            }
            if (!this.directDeposit) {
              this.directDeposit = {};
            }
          } catch (error) {
            this.error = error;
          }
          this.loading = false;
        }
      },
    },
    reinstateEffectiveDate: {
      async handler(v) {
        if (v) {
          this.loading = true;
          try {
            let planDetails = (
              await this.getPlanDetailsByDate({
                plan: this.selectedPlan.Id,
                date: v,
              })
            ).data;
            this.classes =
              planDetails && planDetails.Classes
                ? JSON.parse(planDetails.Classes)
                : [];

            this.memberGroups = (
              await this.getMemberGroupsWithDate({
                plan: this.selectedPlan.Id,
                date: v,
                url: "?$expand=Translations,CoverageIdentities($expand=CurrentCoverageEligibility($expand=CoverageStatuses),Current($expand=Translations))",
              })
            ).data.value;

            this.enableWatchers = false;

            let reinstateItem;
            if (this.lockId) {
              reinstateItem = (
                await this.getMemberByEffectiveDate({
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.reinstateQuery,
                })
              ).data;
            } else {
              reinstateItem = await this.lock(
                this.getMemberByEffectiveDate,
                {
                  planIdentityId: this.selectedPlan.Id,
                  memberIdentityId: this.id,
                  effectiveDate: v,
                  odataQuery: this.reinstateQuery,
                  dialogs: this.dialogs,
                  dialog: "reinstate",
                },
                () => {
                  this.dialogs.reinstate = false;
                }
              );
              if (
                reinstateItem.MemberEnrolment === null ||
                reinstateItem.MemberEnrolment === undefined
              ) {
                reinstateItem.MemberEnrolment = {};
              }
              if (
                reinstateItem.CurrentMemberBenefitYear === null ||
                reinstateItem.CurrentMemberBenefitYear === undefined
              ) {
                reinstateItem.CurrentMemberBenefitYear = {};
              }
              console.log(
                Object.keys(this.headersDictionary).indexOf("Hire Date") > -1,
                this.memberIdentity.CurrentTerminationMembershipEvent
                  .TerminationStatus
              );
              if (
                Object.keys(this.headersDictionary).indexOf("Hire Date") > -1
              ) {
                if (this.isRehire) {
                  reinstateItem.CurrentEmploymentInformation.HireDate = v;
                }
              }

              this.reinstateItem = reinstateItem;
              console.log(JSON.stringify(this.reinstateItem));
              if (this.reinstateItem.CurrentMembershipStatus) {
                await this.setCustomizableCoverages(
                  this.reinstateEffectiveDate,
                  this.reinstateItem
                );

                const coverageStatus = this.reinstateItem
                  .CurrentMembershipStatus.DefaultCoverageStatus
                  ? this.reinstateItem.CurrentMembershipStatus
                      .DefaultCoverageStatus
                  : {};
                this.getSelectableFamilyStatus(coverageStatus.Id);
              }
            }
            this.coverageEffectiveDate = v;
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
            this.$nextTick(() => {
              this.enableWatchers = true;
            });
          }
        }
      },
    },
    "personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt": {
      handler() {
        if (
          this.personalInfo &&
          this.personalInfo.Identity &&
          this.personalInfo.Identity.MemberEnrolment &&
          this.personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt !==
            null &&
          this.personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt !==
            undefined
        ) {
          this.$refs.personalInfoForm &&
            this.$refs.personalInfoForm.resetValidation();
        }
      },
      immediate: true,
    },
    "personalInfo.Identity.MemberEnrolment.EnrollmentReceivedAt": {
      handler() {
        if (
          this.personalInfo &&
          this.personalInfo.Identity &&
          this.personalInfo.Identity.MemberEnrolment &&
          this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt !==
            null &&
          this.personalInfo.Identity.MemberEnrolment.EnrollmentSignedAt !==
            undefined
        ) {
          this.$refs.personalInfoForm &&
            this.$refs.personalInfoForm.resetValidation();
        }
      },
      immediate: true,
    },
    "editedItemCoverage.CurrentMembershipStatus.Class": {
      handler(v) {
        if (this.benefitsProvider || this.nonCustomizedBenefitsProvider) {
          this.refreshBenefits();
        }
      },
    },
    "editedItemCoverage.CurrentMembershipStatus.DefaultCoverageStatus": {
      async handler(v) {
        console.log(v);
        const coverageStatus = v ? v : {};
        await this.getSelectableFamilyStatus(coverageStatus.Id);
        if (this.benefitsProvider || this.nonCustomizedBenefitsProvider) {
          this.refreshBenefits();
        }
      },
    },
    "reinstateItem.CurrentMembershipStatus.Class": {
      handler(v) {
        if (this.benefitsProvider || this.nonCustomizedBenefitsProvider) {
          this.refreshBenefits(this.reinstateItem, this.reinstateEffectiveDate);
        }
      },
    },
    "reinstateItem.CurrentMembershipStatus.DefaultCoverageStatus": {
      async handler(v) {
        console.log(v, this.reinstateItem.CurrentMembershipStatus);
        if (this.reinstateItem.CurrentMembershipStatus) {
          const coverageStatus = v ? v : {};
          await this.getSelectableFamilyStatus(coverageStatus.Id);
          if (this.benefitsProvider || this.nonCustomizedBenefitsProvider) {
            this.refreshBenefits(
              this.reinstateItem,
              this.reinstateEffectiveDate
            );
          }
        }
      },
    },
    selectedPlan: {
      handler() {
        if (this.planIdentity !== null && this.planIdentity !== undefined) {
          console.log("plan identity: ", this.planIdentity);
          this.loadPlanData();
        }
      },
    },
    "editedUntrackedItemCoverage.CurrentEmploymentInformation.HireDate": {
      handler(v) {
        this.applyHireDate();
        this.$refs.untrackedCoverageForm &&
          this.$refs.untrackedCoverageForm.validate();
          this.$refs.correctPlanEntryDateForm &&
          this.$refs.correctPlanEntryDateForm.validate();
      },
      immediate: true,
    },
    waiveWaitingPeriod: {
      handler(v) {
        this.applyHireDate();
        this.$refs.untrackedCoverageForm &&
          this.$refs.untrackedCoverageForm.validate();
          this.$refs.correctPlanEntryDateForm &&
          this.$refs.correctPlanEntryDateForm.validate();
      },
      immediate: true,
    },
    planIdentity: {
      handler() {
        if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
          console.log("plan identity: ", this.planIdentity);
          this.loadPlanData();
        }
      },
    },
    "editedItem.TerminationStatus": {
      handler(v) {
        if (
          v !== "Retired" &&
          v !== "Permanent Lay Off" &&
          v !== "Quit" &&
          v !== "Dismissal"
        ) {
          this.editedItem.HasExtensions = false;
        } else if (v !== "Deceased") {
          this.editedItem.SurvivorBenefits = false;
        }
      },
    },
    "editedItem.HasExtensions": {
      handler(v, old) {
        if (!v && old) {
          this.editedItem.ExtensionClauses = [];
        }
      },
    },
    "editedItem.SurvivorBenefits": {
      handler(v, old) {
        if (!v && old) {
          this.editedItem.ExtensionClauses = [];
        }
      },
    },
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["language", "settings"]),
    ...mapGetters("plansMembers", ["options", "planIdentity", "planOptions"]),
    ...mapGetters("auth", ["role", "user"]),
    isRehire() {
      return (
        this.memberIdentity.CurrentTerminationMembershipEvent &&
        this.memberIdentity.CurrentTerminationMembershipEvent
          .TerminationStatus !== "Out-Of-Benefits" &&
        this.memberIdentity.CurrentTerminationMembershipEvent
          .TerminationStatus !== "Transfer"
      );
    },
    terminatedDate() {
      if (
        this.memberIdentity &&
        this.memberIdentity.CurrentTerminationMembershipEvent &&
        this.memberIdentity.CurrentTerminationMembershipEvent.DateEffective
      ) {
        if (
          this.memberIdentity &&
          this.memberIdentity.CurrentEmploymentInformation &&
          this.memberIdentity.CurrentEmploymentInformation.HireDate
        ) {
          const hireDateTimestamp = Date.parse(
            this.memberIdentity.CurrentEmploymentInformation.HireDate
          );

          const terminationTimestamp = Date.parse(
            this.memberIdentity.CurrentTerminationMembershipEvent.DateEffective
          );
          if (hireDateTimestamp > terminationTimestamp) {
            return "";
          }
        }
      }
      return this.formatDate(this.memberIdentity.TerminatedAt);
    },
    terminatedInfo() {
      if (
        this.memberIdentity &&
        this.memberIdentity.CurrentTerminationMembershipEvent &&
        this.memberIdentity.CurrentTerminationMembershipEvent.DateEffective
      ) {
        if (
          this.memberIdentity &&
          this.memberIdentity.CurrentEmploymentInformation &&
          this.memberIdentity.CurrentEmploymentInformation.HireDate
        ) {
          const hireDateTimestamp = Date.parse(
            this.memberIdentity.CurrentEmploymentInformation.HireDate
          );

          const terminationTimestamp = Date.parse(
            this.memberIdentity.CurrentTerminationMembershipEvent.DateEffective
          );
          if (hireDateTimestamp > terminationTimestamp) {
            return this.$t("globals.no");
          }
        }
      }
      return this.memberIdentity.CurrentTerminationMembershipEvent !== null &&
        this.memberIdentity.CurrentTerminationMembershipEvent !== undefined
        ? this.memberIdentity.CurrentTerminationMembershipEvent.IsTerminated
          ? this.$t("globals.yes")
          : this.$t("globals.no")
        : "";
    },
    eligibleTitle() {
      if (
        this.planIdentity &&
        this.planIdentity.TrackHours &&
        this.memberIdentity &&
        this.memberIdentity.CurrentTerminationMembershipEvent &&
        this.memberIdentity.CurrentTerminationMembershipEvent.DateEffective
      ) {
        if (
          this.memberIdentity &&
          this.memberIdentity.CurrentEmploymentInformation &&
          this.memberIdentity.CurrentEmploymentInformation.HireDate
        ) {
          const hireDateTimestamp = Date.parse(
            this.memberIdentity.CurrentEmploymentInformation.HireDate
          );

          const terminationTimestamp = Date.parse(
            this.memberIdentity.CurrentTerminationMembershipEvent.DateEffective
          );
          if (hireDateTimestamp > terminationTimestamp) {
            return (
              this.$t("components.memberview.coverage_information") +
              " - " +
              this.$t("components.memberview.not_eligible")
            );
          }
        }
      }

      return this.memberIdentity.IsEligible
        ? this.$t("components.memberview.coverage_information") +
            " - " +
            this.$t("components.memberview.eligible")
        : this.$t("components.memberview.coverage_information") +
            " - " +
            this.$t("components.memberview.not_eligible");
    },
    useDocumentsManagement() {
      var settings = SettingsService.settings;
      console.log("useDocumentsManagement", settings.UseDocumentsManagement);
      return settings.UseDocumentsManagement;
    },
    singleFamilyStatus() {
      return this.options.Models.FamilyStatus.filter(
        (o) => o.Name === "Single"
      )[0];
    },
    coupleFamilyStatus() {
      return this.options.Models.FamilyStatus.filter(
        (o) => o.Name === "Couple"
      )[0];
    },
    dependantUrl: function () {
      return (
        "plans/" +
        this.selectedPlan.Id +
        "/members/" +
        this.memberIdentity.Id +
        "/dependants"
      );
    },
    vieweditDependantsBtnTitle() {
      if (this.selectedPlan.PlanType === "Pension") {
        return this.memberIdentity.IsEditable !== false &&
          (this.role.indexOf("Broker Plan Manager") > -1 ||
            this.role.indexOf("Broker Plan Admin") > -1 ||
            this.role.indexOf("Employer Plan Admin") > -1)
          ? this.$t("components.memberview.viewedit_spouse_information")
          : this.$t("components.memberview.view_spouse_information");
      }
      return this.memberIdentity.IsEditable !== false &&
        (this.role.indexOf("Broker Plan Manager") > -1 ||
          this.role.indexOf("Broker Plan Admin") > -1 ||
          this.role.indexOf("Employer Plan Admin") > -1)
        ? this.$t("components.memberview.viewedit_dependants")
        : this.$t("components.memberview.view_dependants");
    },
  },
  mounted() {
    if (
      this.selectedPlan !== null &&
      this.selectedPlan !== undefined &&
      this.planIdentity !== null &&
      this.planIdentity !== undefined
    ) {
      this.loadPlanData();
      console.log("plan identity: ", this.planIdentity);
    }
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
.member-view /deep/ .v-list-group__items > .v-list-item {
  padding-left: 45px;
}
.text-white {
  color: white;
}
</style>
<style>
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: fit-content;
  background-color: white;
  color: black;
  text-align: center;
  /* border-radius: 6px; */
  padding: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 105%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
.member-expansion-panel-header {
  font-size: 15px;
  font-weight: 500;
  margin-left: 20px;
}
.member-expansion-panel-header-icon {
  font-size: 30px;
}
</style>
